import template from './modal.html'
import shipmentSelectionModalTemplate from './templates/shipmentSelection.html'
import confirmSupervisorTemplate from './templates/confirmSupervisor.html'
import checkedInAddBagTemplate from './templates/checkedInAddBag.html'
import checkedInAdHocCheckinTemplate from './templates/checkedInAdHocCheckin.html'
import checkedoutAddBagTemplate from './templates/checkedoutAddBag.html'
import surchargeDetailsTemplate from './templates/surchargeDetails.html'
import storedSurchargeDetailsTemplate from './templates/storedSurchargeDetails.html'
import surchargeHistoryTemplate from './templates/surchargeHistory.html'
import forceCheckingModalTemplate from './templates/forceCheckin.html'
import routeThrowShipmentListTemplate from './templates/routeThrowShipmentList.html'
import closeRouteTemplate from './templates/closeRoute.html'
import closeBagoutTemplate from './templates/closeBagout.html'
import selectDeliveryLocationTemplate from './templates/selectDeliveryLocation.html'
import forceCloseRouteTemplate from './templates/forceCloseRoute.html'
import itemNotDeliveredTemplate from './templates/itemNotDelivered.html'
import commitSuccessTemplate from './templates/commitSuccess.html'
import uploadedFileSelectionTemplate from './templates/uploadedFileSelection.html'
import addLocationTemplate from './templates/addLocation.html'
import verifyHoldShipmentsTemplate from './templates/verifyHoldShipments.html';
import forceCloseHoldTemplate from './templates/forceCloseHold.html';
import holdReleaseTemplate from './templates/verifyHoldRelease.html';
import itemHoldLogTemplate from './templates/itemHoldLog.html';
import cancelItemTemplate from './templates/verifyItemReturn.html';
import routeDetailsTemplate from './templates/routeDetails.html';
import routeMessengerTemplate from './templates/routeMessenger.html';
import locationHoldReleaseTemplate from './templates/locationHoldRelease.html';
import bulkVerifyCommentTemplate from './templates/bulkVerifyComment.html';
import audio from "../../../assets/audio/success_beep.mp3"
import successAudio from "../../../assets/audio/scanner_beep.mp3"
import routeTransferTemplate from './templates/routeTransfer.html'
import translateMessageTemplate from './templates/translateMessage.html';
import orderPackTemplate from './templates/orderPack.html';
import orderPackHoldTemplate from './templates/orderPackHold.html';
import orderPackReturnTemplate from './templates/orderPackReturn.html';
import checkoutAddItemsTemplate from './templates/checkoutAddItems.html'
import changePasswordTemplate from './templates/changePassword.html';
import timeoutCountdownTemplate from './templates/timeoutCountdown.html';
import residualCommentTemplate from './templates/residualComment.html';
import holdReasonTemplate from './templates/holdReason.html';
import convertToCrvTemplate from './templates/convertToCrv.html';
import deletedReasonTemplate from './templates/deletedReason.html';
import atmResidualReceiptTemplate from './templates/atmResidualReceipt.html';
import balanceSheetTemplate from './templates/balanceSheetInfo.html';
import routeDelivriesInfoTemplate from './templates/routeDelivriesInfoTemplate.html';
import coinShiptypeListTemplate from './templates/coinShiptypeList.html';
import routeStopTransferTemplate from './templates/stopTransfer.html';
import routeSequenceTemplate from './templates/routeSequence.html';
import remainingResidualTemplate from './templates/remainingResidual.html';
import remainingToThrowTemplate from './templates/remainingToThrow.html';
import routeCheckoutInfoTemplate from './templates/routeCheckoutInfo.html';
import routeCheckinInfoTemplate from './templates/routeCheckinInfo.html';
import remainingToPackTemplate from './templates/pendingPack.html';
import branchTransferTemplate from './templates/branchTransfer.html';
import internalDeliveryTemplate from './templates/internalDelivery.html';
import editTrackingIdTemplate from './templates/editTrackingId.html';
import depositPackingInfoTemplate from './templates/depositPackingInfo.html';
import lockStatusTemplate from './templates/lockStatus.html';
import ledgerTransactionLogTemplate from './templates/ledgerTransactionLog.html';
// import createCompanyTemplate from './templates/createCompany.html';
import atmCodesInfoTemplate from './templates/atmCodesInfo.html';
import moveShipmentTemplate from './templates/moveShipment.html';
import updateShipmentTrackingIdTemplate from './templates/updateShipmentTrackingId.html'
import autoOpenLocksTemplate from './templates/autoOpenLocks.html'
import checkInForceCloseRouteTemplate from './templates/checkinForceClose.html'
import shipmentNotPickedUpTemplate from './templates/shipmentNotPickedUp.html'
import bulkUpdateUserPermissionsTemplate from './templates/bulkUpdateUserPermissions.html';
import './modal.scss';
import AppConstant from '../../../config/app.constants';
import markAsDeliveredTemplate from './templates/markAsDelivered.html'
import holdShipmentTemplate from './templates/holdShipmentList.html'
import lastOrderDetailsTemplate from './templates/lastOrderInfo.html'
import serviceOrderDetailTemplate from './templates/serviceOrderDetails.html'
import serviceOrderNotesTemplate from './templates/serviceOrderNotes.html'
import undoPackedOrderTemplate from './templates/undoPackedOrder.html'
import serviceOrderStatusUpdateTemplate from './templates/serviceOrderStatusUpdate.html'
import serviceOrderAssignTemplate from './templates/serviceOrderAssign.html'
import serviceOrderCreateTemplate from './templates/serviceOrderCreate.html'
import shipmentListTemplate from './templates/shipmentList.html'
import routeStopListTemplate from './templates/routeStopList.html'
import createActionCodeTemplate from './templates/createActionCode.html'
import changeDestinationTemplate from './templates/changeDestination.html'
import serviceOrderActionsTemplate from './templates/serviceOrderActions.html'
import pendingCancelShipmentsTemplate from './templates/pendingCancelShipments.html'
import bagoutListTemplate from './templates/bagoutList.html'
import bulkCashAdjustCommentTemplate from './templates/bulkCashAdjustComment.html'
import shipmentImageTemplate from './templates/shipmentImage.html';
import bagoutsOnHoldTemplate from './templates/bagoutsOnHoldList.html'
import saveLocationLaterTemplate from './templates/saveLocationLater.html'
import saveRouteChangesLaterTemplate from './templates/saveRouteChangesLater.html'
import billingContractRulesTemplate from './templates/billingContractRules.html'
import approveBillingRecordsTemplate from './templates/approveBillingRecords.html'
import billableEventLogTemplate from './templates/billableEventLog.html'
import stopCommentsTemplate from './templates/stopComments.html'
import createLanguageMessageTemplate from './templates/createLanguageMessage.html'
import fuelSurchargeCustomersTemplate from './templates/createFuelSurchageCustomer.html'
import fuelSurchargeLocationTemplate from './templates/fuelSurchargeLocations.html'
import routesInfoTemplate from './templates/routesInfo.html';
import editDeliveryShipmentTemplate from './templates/editDeliveryShipment.html'
import editPickupShipmentTemplate from './templates/editPickupShipment.html'
import shipmentAssociateToTankerTemplate from './templates/shipmentAssociateToTanker.html'
import uploadFilesTemplate from './templates/uploadFiles.html'
import markUndeliveredWithCRVTemplate from './templates/markUndeliveredWithCRV.html'
import appLogoTemplate from './templates/appLogo.html'
import atmLoadShipmentTemplate from './templates/atmLoadShipment.html'
import pickupDeliveryShipmentTemplate from './templates/pickupDeliveryShipment.html'
import notDeliveredResolutionTemplate from './templates/notDeliveredResolution.html'
import pickupHoldReleaseTemplate from './templates/pickupHoldRelease.html'
import duplicateRouteStopTemplate from './templates/duplicateStopsInfo.html'
import branchMgmtBagoutCloseTemplate from './templates/branchMgmtCloseBagout.html'
import makeDeliverableTemplate from './templates/makeDeliverable.html'
import rescheduleDeliveriesTemplate from './templates/rescheduleDeliveries.html'
import logisticItemAssignTemplate from './templates/logisticItemAssign.html'
import logisticItemListTemplate from './templates/logisticItemList.html'
import logisticItemHoldReleaseTemplate from './templates/logisticItemHoldRelease.html'
import serviceTicketResolveImageTemplate from './templates/serviceTicketResolveImageTemplate.html';
import previewTicketPicturesTemplate from './templates/previewTicketPictures.html';
import uploadContractDocumentTemplate from './templates/uploadContractDocument.html';
import viewContractDocumentTemplate from './templates/viewContractDocument.html';
import updateBillingRecordsTemplate from './templates/updateBillingRecords.html';
import sendStopReceiptTemplate from './templates/sendStopReceipt.html';
import changeShiptypeTemplate from './templates/changeShiptype.html';
import bulkImportLocationTemplate from './templates/bulkImportLocation.html'
import itemHistoryTemplate from './templates/itemHistory.html';
import createServiceChecklistTemplate from './templates/createServiceChecklist.html'
import createAtmMakeTemplate from './templates/createAtmMake.html'
import createServiceActionPriorityTemplate from './templates/createServiceActionPriority.html'
// import scheduledATMShipmentTemplate from './templates/scheduledATMShipment.html'
import nextScheduledOccurencesTemplate from "./templates/nextScheduledOccurences.html"
import bagRemoveConfirmationTemplate from './templates/bagRemoveConfirmation.html'
import postBillingRecordTemplate from './templates/postBillingRecord.html'
import createBillingRecordsTemplate from './templates/createBillingRecords.html'
import locationLogsTemplate from './templates/locationLogs.html'
import branchFundingSourceDenominationsTemplate from './templates/branchFundingSourceDenominations.html';
import deliveryServiceTransactionTemplate from './templates/deliveryServiceTransaction.html';
import verifyBagoutCashCountTemplate from './templates/verifyBagoutCashCount.html';
import editScheduledOrdersTemplate from './templates/editScheduledOrders.html';
// import serviceOrderStatusHistoryEditTemplate from './templates/serviceOrderStatusHistoryEdit.html';
import pendingShipmentTransferTemplate from './templates/pendingShipmentTransfer.html';
import updateServiceHistoryTemplate from './templates/updateServiceHistory.html';
import denominationBreakdownTemplate from './templates/denominationBreakdown.html';
import routeServiceTicketsTemplate from './templates/routeServiceTickets.html';
import masterCashOrderDetailsTemplate from './templates/masterCashOrderDetails.html';
import markAllDeliveredListTemplate from './templates/markAllDeliveredList.html';
import uncoveredLocationsTemplate from './templates/uncoveredLocations.html';
const generateQueryForReason = (messageType) => {
  return {
    queryJSON: {
      rules: [
        {
          field: 'type',
          condition: 'IN',
          data: messageType
        }
      ],
      operator: 'AND'
    }
  };
};

const focusElementById = (id) => {
  const element = document.getElementById(id);
  if (element) {
    setTimeout(() => {
      element.focus();
    }, 800);
  }
};

const rejectModal = (modal, negative) => {
  modal.result.then((result) => {
    // console.log('client: resolved: ');
  }, function (reason) {
    negative({
      modal: null
    });
  })
};

const LIMIT = 10, MAXLIMIT = 1000;

let ModalFactory = function ($uibModal, $translate) {

  /**
   *  Example:
   *
   *  this.Modal.alert({header: 'Record Deleted', message: 'We have removed the branch', callback: ({modal}) => {
   *    modal.close()
   *  }})
   */
  let alert = (data) => {
    confirm({ ...data, buttons: ['common.ok'] })
  }

  /*
   *  Example:
   *
   *  this.Modal.confirm({header: 'Confirm Delete', message: `Are you sure you want to delete?`, callback: ({modal, $scope}) => {
   *
   *    $scope.loading = true;
   *    $scope.loadingMessage = 'Please wait...'
   *    $scope.errorMessage = 'Some error.'
   *
   *    setTimeout(() => {
   *      modal.close()
   *    }, 5000)
   *  }, size: 'md', type: 'danger'})
   */
  let confirm = ({ header, message, callback = ({ modal }) => { modal.close() }, autoClose = 'true', negative = ({ modal }) => { modal.close() }, size = 'md', buttons = ['common.ok', 'common.cancel'], type = 'primary' }) => {

    let modal = $uibModal.open({
      // keyboard: false,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: autoClose ? 'static' : 'true',
      template,
      size,
      controller: ['$scope', function ($scope) {

        $scope.header = header
        $scope.message = message
        $scope.buttons = buttons

        $scope.type = type;

        $scope.ok = () => {
          if ($scope.isLoading) return;
          $scope.isLoading = true;
          callback({
            modal,
            $scope: $scope
          })
        }

        $scope.cancel = () => {
          negative({
            modal,
            $scope
          })
          $scope.isLoading = false;
        }
      }]
    })
    modal.result.then(() => {
    }, function () {
      negative({
        modal: modal
      });
    })
  }

  let routeThrowShipmentListModal = (title, shipments, isThrown) => {
    return $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: routeThrowShipmentListTemplate,
      size: 'lg',
      controller: ['$scope', '$uibModalInstance', 'Navigation', '$state', function ($scope, $uibModalInstance, Navigation, $state) {
        $scope.title = title;
        $scope.shipments = shipments;
        $scope.isThrown = isThrown;
        $scope.close = () => {
          $uibModalInstance.dismiss('cancel');
        };
        $scope.goToShipment = (trackingId) => {
          $uibModalInstance.dismiss('cancel');
          $state.go('branchManagement.items', { id: trackingId });
        };
        $scope.goToServiceHistory = (data) => {
          return Navigation.goToServiceHistory(data.toLocationId, null, true, $uibModalInstance);
        }
        $scope.getLocationUrl = (data) => {
          return $state.href('branchManagement.locations', {
            locationId: data.toLocationId
          }, { absolute: true });
        };
        $scope.onLocationClick = (event, data) => {
          if (event.ctrlKey || event.metaKey || event.button === 1) {
            return;
          }
          event.preventDefault();
          $scope.goToServiceHistory(data);
        }
      }]
    }).result.catch(() => {});
  };

  // fuzzyMatching for route throw screen
  let routeThrowShipmentSelectionModal = (addBagStructure, choices, callback, negative) => {
    let selectionModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: shipmentSelectionModalTemplate,
      size: 'lg',
      controller: ['$scope', function ($scope) {

        $scope.choices = choices;
        $scope.selectedIndex = -1;
        $scope.displayAddBagButton = !!addBagStructure;
        $scope.loading = false;
        $scope.setSelected = (index) => {
          $scope.selectedIndex = index;
        }

        $scope.keyPressed = ($event) => {
          const ESC_KEY_CODE = 27;
          if ($event.keyCode === ESC_KEY_CODE) {
            negative({
              modal: selectionModal
            });
          }
        }

        $scope.selectItem = () => {
          if ($scope.loading) return;
          $scope.loading = true;
          confirmSupervisor('checkin-item-selected', ({ modal, supId }) => {
            callback({
              modal: selectionModal,
              selected: choices[$scope.selectedIndex],
              supervisorId: supId
            });
            modal.close()
          }, ({ modal }) => {
            $scope.loading = false;
            modal.close()
          })
        }

        $scope.cancel = () => {
          negative({
            modal: selectionModal
          });
        }

      }]
    })
  }

  let checkedInShipmentSelectionModal = (addBagStructure, choices, callback, negative) => {
    let selectionModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: shipmentSelectionModalTemplate,
      size: 'lg',
      controller: ['$scope', function ($scope) {
        $scope.loading = false;
        $scope.choices = choices;
        $scope.selectedIndex = -1;
        $scope.displayAddBagButton = !!addBagStructure;

        $scope.setSelected = (index) => {
          $scope.selectedIndex = index;
        }

        $scope.showAddBagModal = () => {
          if ($scope.loading) return;
          $scope.loading = true;
          checkedInForceAddBag(addBagStructure, ({ modal: addBagModal, $scope }) => {
            addBagModal.close();

            callback({
              modal: selectionModal,
              isCreated: true,
              selected: $scope.bag
            })
          }, ({ modal: addBagModal }) => {
            $scope.loading = false;
            if (addBagModal) addBagModal.close()
          })
        }

        focusElementById('tab0');
        $scope.selectItem = () => {
          if ($scope.itemSelected) {
            return;
          }
          $scope.itemSelected = true;
          confirmSupervisor('checkin-item-selected', ({ modal, supId }) => {
            callback({
              modal: selectionModal,
              selected: choices[$scope.selectedIndex],
              supervisorId: supId
            });
            modal.close()
          }, ({ modal }) => {
            $scope.itemSelected = false;
            modal.close()
          })
        }

        $scope.cancel = () => {
          $scope.itemSelected = false;
          negative({
            modal: selectionModal
          });
        }
      }]
    });
    rejectModal(selectionModal, negative)
  }

  // shipment selection modal for checkout
  let checkedOutShipmentSelectionModal = (addBagStructure, choices, callback, negative) => {
    let selectionModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: shipmentSelectionModalTemplate,
      size: 'lg',
      controller: ['$scope', function ($scope) {
        $scope.itemSelected = false;
        $scope.choices = choices;
        $scope.selectedIndex = -1;
        $scope.displayAddBagButton = !!addBagStructure;

        focusElementById('tab0');
        $scope.setSelected = (index) => {
          $scope.selectedIndex = index;
        }

        $scope.showAddBagModal = () => {
          if ($scope.loading) return;
          $scope.loading = true;
          checkedoutForceAddBag(addBagStructure, ({ modal: addBagModal, $scope }) => {
            addBagModal.close();
            $scope.loading = false;

            callback({
              modal: selectionModal,
              isCreated: true,
              selected: $scope.bag
            })
          }, ({ modal: addBagModal }) => {
            $scope.loading = false;
            addBagModal.close()
          })
        }

        $scope.selectItem = () => {
          // if ( $scope.loading) return;          
          $scope.itemSelected = true;
          confirmSupervisor('checkin-item-selected', ({ modal, supId }) => {
            modal.close()
            callback({
              modal: selectionModal,
              selected: choices[$scope.selectedIndex],
              supervisorId: supId
            });
          }, ({ modal }) => {
            $scope.itemSelected = false;
            modal.close()
          })
        }

        $scope.cancel = () => {
          negative({
            modal: selectionModal
          });
        }

      }]
    });

    rejectModal(selectionModal, negative)
  }

  let confirmSupervisor = (event, details, callback, negative) => {
    let modal = $uibModal.open({
      keyboard: false,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: confirmSupervisorTemplate,
      size: 'md',
      controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
        $scope.event = event;
        $scope.details = details;
        $scope.loading = false;
        $scope.ok = (supId, data, convertToPickup) => {
          $rootScope.supervisorIds = data;
          $scope.loading = true;
          callback({
            modal,
            supId,
            convertToPickup
          });
        }

        $scope.cancel = (err) => {
          if ($scope.loading) return;
          negative({
            modal
          });
        }

        $scope.keyPressed = ($event) => {
          const ESC_KEY_CODE = 27;
          if ($event.keyCode === ESC_KEY_CODE) {
            $event.preventDefault()
            if ($scope.loading) return;
            negative({
              modal
            });
          }
        }
      }]
    })
  }

  let checkedInAdHocCheckin = ({ branchId, windowId, routeId, date, supervisorScan, branchVaultDate, cancelSupervisorChallenge, pickupDate }, callback, negative) => {
    let modal = $uibModal.open({
      keyboard: false,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: checkedInAdHocCheckinTemplate,
      size: 'md',
      controller: ['$scope', 'LocationService', 'User', 'BatchService', 'CarrierService', 'RouteService', 'ShiptypeService', 'WindowService', '$q', '$translate', 'ShipmentService', 'DateUtil', 'BranchService', function ($scope, LocationService, User, BatchService, CarrierService, RouteService, ShiptypeService, WindowService, $q, $translate, ShipmentService, DateUtil, BranchService) {
        $scope.supervisor = {
          supId: ''
        }
        $scope.isSupervisorConfirmed = (supervisorScan === false);
        $scope.isCancelSupervisorChallange = cancelSupervisorChallenge;
        $scope.allowEditTrackingId = true;
        $scope.errorMessage = ''
        $scope.bag = {
          trackingId: '',
          quantity: 1,
          branchId,
          windowId
        }
        $scope.model = {
          branchId: User.getUser().branchId,
          pickupDate: '',
          pickupTime: '',
          currentTime: moment().format("HH:mm:ss"),
        }
        $scope.locations = [];
        $scope.shiptypes = [];
        $scope.carriers = [];
        $scope.batches = [];
        $scope.locationLists = [];
        $scope.allLocationLists = [];
        $scope.destinationLocationList = []
        $scope.sequenceLists = [];
        $scope.destinations = [];
        $scope.destinationLocations = [];
        $scope.showAllDestinationLocations = false;
        $scope.showAllFromLocations = true; 
        $scope.loadingLocations = {
          fromLocation: false,
          destination: false
        };
        $scope.loading = false;
        $scope.branchVaultDate = branchVaultDate;
        let searchKey;
        let offset;
        
        $scope.locationsSearchObj = (searchKey) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [{
                field: "branchId",
                condition: "=",
                data: $scope.model.branchId
              },
              {
                field: "active",
                condition: "=",
                data: true
              },
              {
                group: {
                  rules: [{
                    field: "locationType",
                    condition: "=",
                    data: "REGULAR"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "NO_SHIP_NO_GO"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "ATM"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "BANK"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "ON_CALL"
                  }
                  ],
                  operator: "OR"
                }
              },
              {
                group: {
                  rules: [{
                    field: 'id',
                    condition: 'like',
                    data: '%' + searchKey + '%'
                  },
                  {
                    field: 'name',
                    condition: 'like',
                    data: '%' + searchKey + '%'
                  }
                  ],
                  operator: 'OR'
                }
              }
              ],
              operator: "AND"
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        $scope.bankLocationsSearchObj = (searchKey) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: "locationType",
                  condition: "=",
                  data: "BANK"
                },
                {
                  field: 'centralBank',
                  condition: '=',
                  data: true
                },
                {
                  field: "branchId",
                  condition: "=",
                  data: $scope.model.branchId
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND',
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        $scope.supervisorConfirmed = (supId) => {
          $scope.supervisor.supId = supId
          $scope.isSupervisorConfirmed = true;
          $scope.errorMessage = ''
          init();
        }

        $scope.supervisorCancelled = () => {
          modal.close();
        }

        const getShiptypeSearchObj = (allowCoin, allowCash) => {
          if (allowCash && allowCoin) {
            const searchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'status',
                    condition: '=',
                    data: true
                  }
                ],
                operator: 'AND'
              }
            };
            return searchObj;
          }
          else {
            const searchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'coinFlag',
                    condition: '='
                  },
                  {
                    field: 'status',
                    condition: '=',
                    data: true
                  }
                ],
                operator: 'AND'
              }
            };

            if (allowCash) {
              searchObj.queryJSON.rules[0].data = 0
            }
            else if (allowCoin) {
              searchObj.queryJSON.rules[0].data = 1
            }
            else {
              return null;
            }

            return searchObj;
          }
        };

        const init = () => {
          $scope.loading = true;

          return $q.all([
            fetchFromLocations(searchKey, offset),
            BatchService.all(null, 0, 0),
            BranchService.getBranchSetup(branchId)
          ])
            .then((data) => {
              const batches = data[1].results;
              const branchSetup = data[2];

              $scope.branchTimeZone = branchSetup ? branchSetup.branch.timezone : null;

              $scope.batches = batches.map((batch) => ({
                id: batch.id,
                inputType: batch.inputType
              }))

              const searchObj = getShiptypeSearchObj(null, null);

              $scope.bag.pickupDate = moment($scope.branchVaultDate).toDate();
              $scope.bag.pickupTime = $scope.getTime($scope.model.currentTime);
              $scope.minVaultDate = {
                maxDate: $scope.bag.pickupDate
              }

              return ShiptypeService.all(searchObj, 0, 1000)
            })
            .then((res) => {
              const shiptypes = res.results;
              return $scope.shiptypes = shiptypes.map((shiptype) => {
                const mapped = {
                  id: shiptype.id,
                  title: shiptype.description,
                  amount: shiptype.amount,
                  amountFlag: shiptype.amountFlag,
                  coinFlag: shiptype.coinFlag
                };
                if (shiptype.id == 'C') {
                  if (shiptype.amountFlag) {
                    $scope.bag.qty = 1;
                  }
                  $scope.bag.shiptype = mapped;
                }
                return mapped;
              });
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        const clearDestinationLocData = () => {
          $scope.destinationLocationList = [];
          $scope.destinationAllLocationList = [];
          $scope.bag.toLocationId = "";
        }

        const clearFromLocationData = () => {
          $scope.locationLists = [];
          $scope.allLocationLists = []
          $scope.bag.fromLocationId = "";
        }

        $scope.toggleAllDestinationLocations = () => {
          $scope.showAllDestinationLocations = !$scope.showAllDestinationLocations;
          clearDestinationLocData()
          return fetchDestinations(searchKey, offset);
        }

        $scope.toggleAllFromLocations = () => {
          $scope.showAllFromLocations = !$scope.showAllFromLocations;
          clearFromLocationData()
          clearDestinationLocData()
          return fetchFromLocations(searchKey, offset);
        }

        const getDay = (dateString) => {
          const date = moment(dateString)
          const weekDays = {
            0: 'Sun',
            1: 'Mon',
            2: 'Tue',
            3: 'Wed',
            4: 'Thu',
            5: 'Fri',
            6: 'Sat',
          }

          if (date) {
            return weekDays[date.day()]
          }
          else {
            return null;
          }
        }

        $scope.reloadData = (searchKey, offset) => {
          return fetchFromLocations(searchKey, offset);
        }

        const fetchFromLocations = (searchKey, offset) => {
          let loadLocationDatas = $scope.locationsSearchObj(searchKey);

          if ($scope.showAllFromLocations) {
            LocationService.getAllLocation(loadLocationDatas, offset, AppConstant.defaultPageLimit)
              .then((res) => {
                if (offset === 0 || offset == undefined) {
                  $scope.alltotalRecords = res.total;
                  $scope.allLocationLists = $scope.mappingLocationDatas(res.results);
                }
                else {
                  const locations = $scope.mappingLocationDatas(res.results);
                  $scope.allLocationLists = $scope.allLocationLists.concat(locations);
                }
              })
          }
          else {
            RouteService.getActiveRouteSequence(routeId, branchId, getDay(date))
              .then((res) => {
                $scope.totalRecords = res.length;
                const sequences = $scope.mappingLocationDatas(res);
                $scope.locationLists = sequences;
              })
          }
        };

        $scope.mappingLocationDatas = (locations) => {
          return locations.map((location) => {
            const locationObj = {
              Key: location.id + ' | ' + location.name,
              Value: location.id
            };

            if (location.address) {
              locationObj.Key += ' | ' + location.address;
            }
            if (location.city) {
              locationObj.Key += ' | ' + location.city;
            }

            if (location.prefix) {
              locationObj.key = location.prefix + ' | ' + locationObj.text;
            }
            return locationObj;
          });
        }

        $scope.reloadDestinationData = (searchKey, offset) => {
          return fetchDestinations(searchKey, offset);
        }

        const fetchDestinations = (searchKey, offset) => { 
          if (!$scope.bag || !$scope.bag.fromLocationId) {
            return;
          }

          if ($scope.showAllDestinationLocations) {
            LocationService.centralBankLocation($scope.model.branchId)
              .then((res) => {
                $scope.totalAllDestinationLocation = res.length;
                const destinationLocList = $scope.mappingLocationDatas(res);
                $scope.destinationAllLocationList = destinationLocList;

                if ($scope.destinationAllLocationList.length && !$scope.bag.toLocationId) {
                  $scope.bag.toLocationId = $scope.destinationAllLocationList[0];
                }
              })
          }
          else {
            const fromLocId = $scope.bag.fromLocationId.Value || $scope.bag.fromLocationId;
            ShipmentService.getDestinationLocations(fromLocId, $scope.bag.shiptype.id, false)
              .then((res) => {
                $scope.totalDestinationLocation = res.length;
                const destinationLoc = $scope.mappingLocationDatas(res);
                $scope.destinationLocationList = destinationLoc;
                if ($scope.destinationLocationList.length && !$scope.bag.toLocationId) {
                  $scope.bag.toLocationId = $scope.destinationLocationList[0];
                }
              })
          }
        }

        $scope.reloadDestinations = function (e) {
          if (e && (e.keyCode === 38 || e.keyCode === 40)) {
            return
          }
          clearDestinationLocData()
          fetchDestinations(searchKey, offset);
        };

        $scope.focusOntoLocation = function (id) {
          setTimeout(() => {
            const el = document.getElementById(id);
            if (el) el.focus();
          }, 100);
        };

        $scope.quantityChanged = () => {
          if ($scope.bag.qty && $scope.bag.shiptype) {
            $scope.bag.amount = $scope.bag.shiptype.amount * $scope.bag.qty;
          }
        }

        $scope.shiptypeChanged = () => {
          $scope.showAllDestinationLocations = false;
          if ($scope.bag.shiptype.amountFlag) {
            $scope.bag.qty = 1;
          }
          if (!$scope.bag.qty) {
            $scope.bag.qty = 1;
          }
          if ($scope.bag.toLocationId) {
            fetchDestinations(searchKey, offset);
          }
          if ($scope.bag.fromLocationId) {
            fetchDestinations(searchKey, offset);
          }
          $scope.bag.amount = $scope.bag.qty * $scope.bag.shiptype.amount

          if ($scope.bag.shiptype.coinFlag == 0) {
            $scope.bag.amount = null;
          }
        }

        $scope.keyPressed = ($event) => {
          const ESC_KEY_CODE = 27;
          if ($event.keyCode === ESC_KEY_CODE) {
            negative({ modal });
          }
        }

        $scope.getTime = (time) => {
          if (!time) return time;
          time = time.split(':');
          let d = new Date();
          d.setHours(+time[0]);
          d.setMinutes(time[1]);
          d.setSeconds(0);
          d.setMilliseconds(0);
          return d;
        }

        $scope.ok = () => {
          if ($scope.loading) return;
          $scope.errorMessage = '';
          const requiredFields = ['shiptype', 'trackingId', 'qty', 'fromLocationId', 'toLocationId'];

          let isFormValid = requiredFields.every((field) => {
            return !!$scope.bag[field];
          });

          if ($scope.bag.amount == null && $scope.bag.shiptype.amountFlag) {
            return $scope.errorMessage = $translate.instant('addBagModal.requiredAmountError');
          }
          else if (!isFormValid) {
            return $scope.errorMessage = $translate.instant('addBagModal.requiredFieldsError');
          }
          $scope.loading = true;
          $scope.bag.routeId = routeId;
          $scope.bag.deliveryDate = date;
          $scope.bag.branchId = branchId;
          $scope.bag.coinFlag = $scope.bag.shiptype.coinFlag;
          $scope.bag.shiptypeId = $scope.bag.shiptype.id;
          $scope.bag.pickupFlag = true;
          $scope.bag.verified = true;
          $scope.bag.vaultDate = moment($scope.bag.deliveryDate).format('YYYY-MM-DD');
          $scope.bag.amount = $scope.bag.amount ? $scope.bag.amount : 0;
          $scope.bag.pickupDate = moment($scope.bag.pickupDate).format('YYYY-MM-DD');
          $scope.bag.pickupTime = moment($scope.bag.pickupTime).format('HH:mm:ss');
          $scope.bag.branchTimeZone = $scope.branchTimeZone;

          // Removed mutation here - extraction will be handled by the controller to preserve UI state on error

          callback({ modal, $scope });
        }

        $scope.cancel = () => {
          modal.close();
        }

        if ($scope.isSupervisorConfirmed || supervisorScan === false) {
          init();
        }
      }]
    })
    rejectModal(modal, negative)
  }

  // force add bag for checkin screen 
  let checkedInForceAddBag = ({ bagId, branchId, windowId, routeId, date, supervisorScan, branchVaultDate, cancelSupervisorChallenge }, callback, negative) => {
    let modal = $uibModal.open({
      keyboard: false,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: checkedInAddBagTemplate,
      size: 'md',
      controller: ['$scope', 'LocationService', 'User', 'BatchService', 'CarrierService', 'RouteService', 'ShiptypeService', 'WindowService', '$q', '$translate', 'ShipmentService', 'DateUtil', function ($scope, LocationService, User, BatchService, CarrierService, RouteService, ShiptypeService, WindowService, $q, $translate, ShipmentService, DateUtil) {
        $scope.supervisor = {
          supId: ''
        }
        $scope.isSupervisorConfirmed = (supervisorScan === false);
        $scope.isCancelSupervisorChallange = cancelSupervisorChallenge;
        $scope.errorMessage = ''
        $scope.bag = {
          trackingId: bagId,
          quantity: 1,
          branchId,
          windowId
        }
        $scope.model = {
          branchId: User.getUser().branchId,
          pickupDate: '',
          pickupTime: '',
          currentTime: moment().format("HH:mm:ss"),
        }
        $scope.locations = [];
        $scope.shiptypes = [];
        $scope.carriers = [];
        $scope.batches = [];
        $scope.locationLists = [];
        $scope.allLocationLists = [];
        $scope.destinationLocationList = []
        $scope.sequenceLists = [];
        $scope.destinations = [];
        $scope.destinationLocations = [];
        $scope.showAllDestinationLocations = false;
        $scope.showAllFromLocations = false;
        $scope.loadingLocations = {
          fromLocation: false,
          destination: false
        };
        $scope.loading = false;
        $scope.branchVaultDate = branchVaultDate;
        let searchKey;
        let offset;
        let fromLocationObjs = [] //holds the array of whole location objects
        let isLoadingAllLocations = false;

        const allLocationsSearchObj = {
          queryJSON: {
            rules: [
              {
                field: 'branchId',
                condition: '=',
                data: $scope.model.branchId
              },
              {
                group: {
                  rules: [
                    {
                      field: "locationType",
                      condition: "=",
                      data: "REGULAR"
                    },
                    {
                      field: "locationType",
                      condition: "=",
                      data: "NO_SHIP_NO_GO"
                    },
                    {
                      field: "locationType",
                      condition: "=",
                      data: "ATM"
                    },
                    {
                      field: "locationType",
                      condition: "=",
                      data: "BANK"
                    },
                    {
                      field: "locationType",
                      condition: "=",
                      data: "ON_CALL"
                    }
                  ],
                  operator: 'OR',
                }
              }
            ],
            operator: 'AND'
          }
        };
        $scope.locationsSearchObj = (searchKey) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [{
                field: "branchId",
                condition: "=",
                data: $scope.model.branchId
              },
              {
                field: "active",
                condition: "=",
                data: true
              },
              {
                group: {
                  rules: [{
                    field: "locationType",
                    condition: "=",
                    data: "REGULAR"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "NO_SHIP_NO_GO"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "ATM"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "BANK"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "ON_CALL"
                  }
                  ],
                  operator: "OR"
                }
              },
              {
                group: {
                  rules: [{
                    field: 'id',
                    condition: 'like',
                    data: '%' + searchKey + '%'
                  },
                  {
                    field: 'name',
                    condition: 'like',
                    data: '%' + searchKey + '%'
                  }
                  ],
                  operator: 'OR'
                }
              }
              ],
              operator: "AND"
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // it search for locationType == "BANK", centralBank == true and return location Branch vise  
        $scope.bankLocationsSearchObj = (searchKey) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: "locationType",
                  condition: "=",
                  data: "BANK"
                },
                {
                  field: 'centralBank',
                  condition: '=',
                  data: true
                },
                {
                  field: "branchId",
                  condition: "=",
                  data: $scope.model.branchId
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND',
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        $scope.supervisorConfirmed = (supId) => {
          $scope.supervisor.supId = supId
          $scope.isSupervisorConfirmed = true;
          $scope.errorMessage = ''
          init();
        }

        $scope.supervisorCancelled = (err) => {
          $scope.isSupervisorConfirmed = false;
          $scope.errorMessage = err.toString()
        }

        const getShiptypeSearchObj = (allowCoin, allowCash) => {
          if (allowCash && allowCoin) {
            const searchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'status',
                    condition: '=',
                    data: true
                  }
                ],
                operator: 'AND'
              }
            };
            return searchObj;
          }
          else {
            const searchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'coinFlag',
                    condition: '='
                  },
                  {
                    field: 'status',
                    condition: '=',
                    data: true
                  }
                ],
                operator: 'AND'
              }
            };

            if (allowCash) {
              searchObj.queryJSON.rules[0].data = 0
            }
            else if (allowCoin) {
              searchObj.queryJSON.rules[0].data = 1
            }
            else {
              return null;
            }

            return searchObj;
          }
        };

        const init = () => {
          $scope.loading = true;

          return $q.all([
            fetchFromLocations(searchKey, offset),
            WindowService.get(windowId),
            CarrierService.all(null, 0, 1000),
            BatchService.all(null, 0, 0)
          ])
            .then((data) => {
              const windowObj = data[1];
              const carriers = data[2].results;
              const batches = data[3].results;

              $scope.carriers = carriers.map((carrier) => ({
                id: carrier.id,
                description: carrier.description
              }));
              $scope.batches = batches.map((batch) => ({
                id: batch.id,
                inputType: batch.inputType
              }))

              const searchObj = getShiptypeSearchObj(windowObj.allowCoin, windowObj.allowCash);

              $scope.bag.pickupDate = DateUtil.convertToDate($scope.branchVaultDate);
              $scope.bag.pickupTime = $scope.getTime($scope.model.currentTime);
              $scope.minVaultDate = {
                maxDate: $scope.bag.pickupDate
              }

              return ShiptypeService.all(searchObj, 0, 1000)
            })
            .then((res) => {
              const shiptypes = res.results;
              return $scope.shiptypes = shiptypes.map((shiptype) => {
                if (shiptype.id == 'C') {
                  if (shiptype.amountFlag) {
                    $scope.bag.qty = 1;
                  }
                  focusElementById('shiptype-amount');
                  return $scope.bag.shiptype = {
                    id: shiptype.id,
                    title: shiptype.description,
                    amount: shiptype.amount,
                    amountFlag: shiptype.amountFlag,
                    coinFlag: shiptype.coinFlag
                  }
                }
                return {
                  id: shiptype.id,
                  title: shiptype.description,
                  amount: shiptype.amount,
                  amountFlag: shiptype.amountFlag,
                  coinFlag: shiptype.coinFlag
                }
              })
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        const clearDestinationLocData = () => {
          $scope.destinationLocationList = [];
          $scope.destinationAllLocationList = [];
          $scope.bag.toLocationId = "";
        }

        const clearFromLocationData = () => {
          $scope.locationLists = [];
          $scope.alllocationLists = []
          $scope.bag.fromLocationId = "";
        }

        $scope.toggleAllDestinationLocations = () => {
          $scope.showAllDestinationLocations = !$scope.showAllDestinationLocations;
          clearDestinationLocData()
          return fetchDestinations(searchKey, offset);
        }

        $scope.toggleAllFromLocations = () => {
          $scope.showAllFromLocations = !$scope.showAllFromLocations;
          clearFromLocationData()
          clearDestinationLocData()
          return fetchFromLocations(searchKey, offset);
        }

        const getDay = (dateString) => {
          const date = moment(dateString)
          const weekDays = {
            0: 'Sun',
            1: 'Mon',
            2: 'Tue',
            3: 'Wed',
            4: 'Thu',
            5: 'Fri',
            6: 'Sat',
          }

          if (date) {
            return weekDays[date.day()]
          }
          else {
            return null;
          }
        }

        $scope.reloadData = (searchKey, offset) => {
          return fetchFromLocations(searchKey, offset);
        }

        // fetch origin locations
        const fetchFromLocations = (searchKey, offset) => {

          let defer = $q.defer();
          // $scope.loadingLocations.fromLocation = true;

          let loadLocationDatas = '';
          // if (searchKey) {
          //   const searchObj = {
          //     queryText: '%' + searchKey + '%',
          //     isQuery: false
          //   }

          //   loadLocationDatas = searchObj;
          // } else {
          loadLocationDatas = $scope.locationsSearchObj(searchKey);
          // }

          if ($scope.showAllFromLocations) {
            LocationService.getAllLocation(loadLocationDatas, offset, AppConstant.defaultPageLimit)
              .then((res) => {
                if (offset === 0 || offset == undefined) {
                  $scope.alltotalRecords = res.total;
                  $scope.allLocationLists = $scope.mappingLocationDatas(res.results);
                }
                else {
                  const locations = $scope.mappingLocationDatas(res.results);
                  $scope.allLocationLists = $scope.allLocationLists.concat(locations);
                }
              })
          }
          else {
            RouteService.getActiveRouteSequence(routeId, branchId, getDay(date))
              .then((res) => {
                $scope.totalRecords = res.length;
                const sequences = $scope.mappingLocationDatas(res);
                $scope.locationLists = $scope.locationLists.concat(sequences);
              })
          }
        };

        $scope.mappingLocationDatas = (locations) => {
          return locations.map((location) => {
            const locationObj = {
              Key: location.id + ' | ' + location.name,
              Value: location.id
            };

            if (location.address) {
              locationObj.Key += ' | ' + location.address;
            }
            if (location.city) {
              locationObj.Key += ' | ' + location.city;
            }

            if (location.prefix) {
              locationObj.key = location.prefix + ' | ' + locationObj.text;
            }
            // $scope.loadingLocations.fromLocation = false;
            // $scope.loadingLocations.destination = false;
            return locationObj;
          });
        }

        $scope.reloadDestinationData = (searchKey, offset) => {
          return fetchDestinations(searchKey, offset);
        }

        const fetchDestinations = (searchKey, offset) => { // fetch destination location
          let promise;

          if (!$scope.bag || !$scope.bag.fromLocationId) {
            return;
          }

          // $scope.loadingLocations.destination = true;

          if ($scope.showAllDestinationLocations) {
            isLoadingAllLocations = true;

            let loadLocationDestination = '';
            // if (searchKey) {
            //   const searchObj = {
            //     queryText: '%' + searchKey + '%',
            //     isQuery: false
            //   }

            //   loadLocationDestination = searchObj;
            // } else {
            loadLocationDestination = $scope.bankLocationsSearchObj(searchKey);
            // }

            LocationService.centralBankLocation($scope.model.branchId)
              .then((res) => {
                $scope.totalAllDestinationLocation = res.length;
                const destinationLocList = $scope.mappingLocationDatas(res);
                $scope.destinationAllLocationList = $scope.destinationAllLocationList.concat(destinationLocList);

                if ($scope.destinationAllLocationList.length) {
                  $scope.bag.toLocationId = $scope.destinationAllLocationList[0];
                }
              })
          }
          else {
            const selectedFromLocation = fromLocationObjs.find((location) => {
              return location.id === $scope.bag.fromLocationId;
            });
            ShipmentService.getDestinationLocations($scope.bag.fromLocationId['Value'], $scope.bag.shiptype.id, false)
              .then((res) => {
                $scope.totalDestinationLocation = res.length;
                const destinationLoc = $scope.mappingLocationDatas(res);
                $scope.destinationLocationList = $scope.destinationLocationList.concat(destinationLoc);
                if ($scope.destinationLocationList.length) {
                  $scope.bag.toLocationId = $scope.destinationLocationList[0];
                }
              })
          }
        }

        $scope.reloadDestinations = function (e) {
          if (e && (e.keyCode === 38 || e.keyCode === 40)) {
            return
          }
          clearDestinationLocData()
          fetchDestinations(searchKey, offset);
        };

        $scope.focusOntoLocation = function (id) {
          focusElementById(id)
        };

        $scope.quantityChanged = () => {
          if ($scope.bag.qty) {
            $scope.bag.amount = $scope.bag.shiptype.amount * $scope.bag.qty;
          }

        }
        $scope.shiptypeChanged = () => {
          $scope.showAllDestinationLocations = false;
          if ($scope.bag.shiptype.amountFlag) {
            $scope.bag.qty = 1;
          }
          if (!$scope.bag.qty) {
            $scope.bag.qty = 1;
          }
          if ($scope.bag.toLocationId) {
            fetchDestinations(searchKey, offset);
          }
          if ($scope.bag.fromLocationId) {
            // fetchDestinations();
            fetchFromLocations(searchKey, offset);
            clearFromLocationData()
            clearDestinationLocData()
          }
          $scope.bag.amount = $scope.bag.qty * $scope.bag.shiptype.amount

          // set cash amount value as ZERO
          if ($scope.bag.shiptype.coinFlag == 0) {
            $scope.bag.amount = null;
          }
        }

        $scope.keyPressed = ($event) => {

          const ESC_KEY_CODE = 27;
          if ($event.keyCode === ESC_KEY_CODE) {
            negative({ modal });
          }
        }

        $scope.getTime = (time) => {
          if (!time) {
            return time;
          }

          time = time.split(':');

          let d = new Date();

          d.setHours(+time[0]);
          d.setMinutes(time[1]);
          d.setSeconds(0);
          d.setMilliseconds(0);

          return d;
        }

        $scope.ok = () => {
          if ($scope.loading) return;
          $scope.errorMessage = '';
          const requiredFields = ['shiptype', 'trackingId', 'qty', 'fromLocationId', 'toLocationId'];

          let isFormValid = requiredFields.every((field) => {
            $scope.allField = field
            return !!$scope.bag[$scope.allField];
          });

          // error check 
          if ($scope.bag.amount == null && $scope.bag.shiptype.amountFlag) {
            return $scope.errorMessage = $translate.instant('addBagModal.requiredAmountError');
          }
          else if (!isFormValid) {
            return $scope.errorMessage = $translate.instant('addBagModal.requiredFieldsError');
          }
          $scope.loading = true;
          $scope.bag.routeId = routeId
          // $scope.bag.pickupDate = date
          $scope.bag.deliveryDate = date
          $scope.bag.branchId = branchId
          $scope.bag.coinFlag = $scope.bag.shiptype.coinFlag
          $scope.bag.shiptypeId = $scope.bag.shiptype.id
          $scope.bag.pickupFlag = true;
          $scope.bag.verified = true;
          $scope.bag.fromLocationId = $scope.bag.fromLocationId.Value;
          $scope.bag.toLocationId = $scope.bag.toLocationId.Value;
          $scope.bag.vaultDate = moment($scope.bag.deliveryDate).format('YYYY-MM-DD');
          $scope.bag.amount = $scope.bag.amount ? $scope.bag.amount : 0;
          $scope.bag.pickupDate = moment($scope.bag.pickupDate).format('YYYY-MM-DD'),
            $scope.bag.pickupTime = moment($scope.bag.pickupTime).format('HH:mm:ss')

          callback({
            modal,
            $scope
          })
        }

        $scope.cancel = () => {
          negative({
            modal
          });
        }
        if ($scope.isSupervisorConfirmed || supervisorScan === false) {
          init();
        }
      }]
    });
    modal.result.then((result) => {
      // console.log('client: resolved: ' );
    }, function (reason) {
      negative({
        modal: null
      });
    })
  }

  // force add bag for checkout screen
  let checkedoutForceAddBag = ({ bagId, branchId, windowId, routeId, date, tankerId, supervisorScan, disabledBag, cancelSupervisorChallenge }, callback, negative) => {
    let modal = $uibModal.open({
      keyboard: false,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: checkedoutAddBagTemplate,
      size: 'md',
      controller: ['$scope', 'LocationService', 'User', 'BatchService', 'CarrierService', 'RouteService', 'ShiptypeService', 'WindowService', '$q', '$translate', function ($scope, LocationService, User, BatchService, CarrierService, RouteService, ShiptypeService, WindowService, $q, $translate) {
        $scope.supervisor = {
          supId: ''
        }
        $scope.isSupervisorConfirmed = (supervisorScan === false);
        $scope.errorMessage = '';
        $scope.isCancelSupervisorChallange = cancelSupervisorChallenge;
        $scope.bag = {
          trackingId: bagId,
          quantity: 1,
          branchId,
          windowId,
          tankerId,
          disabledBag: disabledBag
        }
        $scope.model = {
          branchId: User.getUser().branchId,
        }
        $scope.locations = [];
        $scope.shiptypes = [];
        $scope.carriers = [];
        $scope.batches = [];
        $scope.showAllDestinationLocations = false;
        $scope.showAllFromLocations = false;
        $scope.loadingLocations = {
          fromLocation: false,
          destination: false
        };
        $scope.loading = false;
        $scope.destinations = [];
        $scope.allDestinations = [];
        let fromLocationObjs = [] //holds the array of whole location objects
        let searchKey, offset;
        $scope.allLocationsSearchObj = (searchKey) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [{
                field: 'branchId',
                condition: '=',
                data: $scope.model.branchId
              },
              {
                field: 'active',
                condition: '=',
                data: true
              },
              {
                group: {
                  rules: [{
                    field: "locationType",
                    condition: "=",
                    data: "REGULAR"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "NO_SHIP_NO_GO"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "ATM"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "BANK"
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: "ON_CALL"
                  }
                  ],
                  operator: 'OR',
                }
              },
              {
                group: {
                  rules: [{
                    field: 'id',
                    condition: 'like',
                    data: '%' + searchKey + '%'
                  },
                  {
                    field: 'name',
                    condition: 'like',
                    data: '%' + searchKey + '%'
                  }
                  ],
                  operator: 'OR'
                }
              }
              ],
              operator: 'AND'
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // it search for locationType == "BANK" and centralBank == "TRUE" and return location Branch vise  
        $scope.bankLocationsSearchObj = (searchKey) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: "locationType",
                  condition: "=",
                  data: "BANK"
                },
                {
                  field: "centralBank",
                  condition: "=",
                  data: true
                },
                {
                  field: "branchId",
                  condition: "=",
                  data: $scope.model.branchId
                },
                {
                  field: "active",
                  condition: "=",
                  data: true
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND',
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // show locations as locationType == 'BANK' And active = true
        $scope.allBankLocationSearchObj = (searchKey) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: "locationType",
                  condition: "=",
                  data: "BANK"
                },
                {
                  field: "active",
                  condition: "=",
                  data: true
                },
                {
                  field: "branchId",
                  condition: "=",
                  data: $scope.model.branchId
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND',
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        $scope.supervisorConfirmed = (supId) => {
          $scope.supervisor.supId = supId
          $scope.isSupervisorConfirmed = true;
          $scope.errorMessage = ''
          init();
        }

        $scope.supervisorCancelled = (err) => {
          $scope.isSupervisorConfirmed = false;
          $scope.errorMessage = err.toString()
        }

        const getShiptypeSearchObj = (allowCoin, allowCash) => {
          if (allowCash && allowCoin) {
            const searchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'status',
                    condition: '=',
                    data: true
                  }
                ],
                operator: 'AND'
              }
            };
            return searchObj;
          }
          else {
            const searchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'coinFlag',
                    condition: '='
                  },
                  {
                    field: 'status',
                    condition: '=',
                    data: true
                  }
                ],
                operator: 'AND'
              }
            };

            if (allowCash) {
              searchObj.queryJSON.rules[0].data = 0
            }
            else if (allowCoin) {
              searchObj.queryJSON.rules[0].data = 1
            }
            else {
              return null;
            }

            return searchObj;
          }
        };

        const init = () => {
          $scope.loading = true;

          return $q.all([
            fetchFromLocations(searchKey, offset),
            WindowService.get(windowId),
            CarrierService.all(null, 0, 1000),
            BatchService.all(null, 0, 0),
            fetchDestinations(searchKey, offset),
          ])
            .then((data) => {
              const windowObj = data[1];
              const carriers = data[2].results;
              const batches = data[3].results;

              $scope.carriers = carriers.map((carrier) => ({
                id: carrier.id,
                description: carrier.description
              }));
              $scope.batches = batches.map((batch) => ({
                id: batch.id,
                inputType: batch.inputType
              }))

              const searchObj = getShiptypeSearchObj(windowObj.allowCoin, windowObj.allowCash);

              return ShiptypeService.all(searchObj, 0, 1000)
            })
            .then((res) => {
              const shiptypes = res.results;
              return $scope.shiptypes = shiptypes.map((shiptype) => {
                if (shiptype.id == 'C') {
                  if (shiptype.amountFlag) {
                    $scope.bag.qty = 1;
                  }
                  focusElementById('shiptype-amount');
                  return $scope.bag.shiptype = {
                    id: shiptype.id,
                    title: shiptype.description,
                    amount: shiptype.amount,
                    amountFlag: shiptype.amountFlag,
                    coinFlag: shiptype.coinFlag
                  }
                }
                return {
                  id: shiptype.id,
                  title: shiptype.description,
                  amount: shiptype.amount,
                  amountFlag: shiptype.amountFlag,
                  coinFlag: shiptype.coinFlag
                }
              })
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        $scope.toggleAllDestinationLocations = () => {
          $scope.showAllDestinationLocations = !$scope.showAllDestinationLocations;
          $scope.bag.toLocationId = "";
          return fetchDestinations(searchKey, offset);
        }

        $scope.toggleAllFromLocations = () => {
          $scope.showAllFromLocations = !$scope.showAllFromLocations;
          $scope.bag.fromLocationId = "";
          $scope.bag.toLocationId = "";
          return fetchFromLocations(searchKey, offset);
        }

        const getDay = (dateString) => {
          const date = moment(dateString)
          const weekDays = {
            0: 'Sun',
            1: 'Mon',
            2: 'Tue',
            3: 'Wed',
            4: 'Thu',
            5: 'Fri',
            6: 'Sat',
          }

          if (date) {
            return weekDays[date.day()]
          }
          else {
            return null;
          }
        }

        $scope.reloadOriginData = (searchKey, offset) => {
          return fetchFromLocations(searchKey, offset);
        }

        // fetch origin locations
        const fetchFromLocations = (searchKey, offset) => {
          let defer = $q.defer();
          // $scope.loadingLocations.fromLocation = true;
          // $scope.bag.toLocationId = "";
          let loadLocationDatas = '';
          // if (searchKey) {
          //   const searchObj = {
          //     queryText: '%' + searchKey + '%',
          //     isQuery: false
          //   }

          //   loadLocationDatas = searchObj;
          // } else {      
          if ($scope.showAllFromLocations) {
            loadLocationDatas = $scope.allBankLocationSearchObj(searchKey);

            LocationService.all(loadLocationDatas, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                // $scope.bag.fromLocationId = "";
                if (offset === 0 || offset == undefined) {
                  $scope.originTotalRecords = data.total;
                  $scope.fromLocations = $scope.mappingLocationDatas(data.results);
                }
                else {
                  const originLocations = $scope.mappingLocationDatas(data.results);
                  $scope.fromLocations = $scope.fromLocations.concat(originLocations);
                }
                // $scope.loadingLocations.fromLocation = false;
              })
          } else {
            LocationService.centralBankLocation($scope.model.branchId)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.originTotalRecords = data.length;
                  $scope.fromLocations = $scope.mappingLocationDatas(data);
                }
                else {
                  const originLocations = $scope.mappingLocationDatas(data);
                  $scope.fromLocations = $scope.fromLocations.concat(originLocations);
                }
                // $scope.loadingLocations.fromLocation = false;
              })
          }
        };

        $scope.reloadDestinationData = (searchKey, offset) => {
          return fetchDestinations(searchKey, offset);
        }

        const fetchDestinations = (searchKey, offset) => {
          let promise;
          let isLoadingAllLocations = false;


          // $scope.loadingLocations.destination = true;

          if ($scope.showAllDestinationLocations) {
            isLoadingAllLocations = true;
            let loadLocationDatas = '';
            // if (searchKey) {
            //   const searchObj = {
            //     queryText: '%' + searchKey + '%',
            //     isQuery: false
            //   }

            //   loadLocationDatas = searchObj;
            // } else {
            loadLocationDatas = $scope.allLocationsSearchObj(searchKey);
            // }
            promise = LocationService.getAllLocation(loadLocationDatas, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.totalAllRecords = data.total;
                  $scope.allDestinations = $scope.mappingLocationDatas(data.results);
                }
                else {
                  const destLocations = $scope.mappingLocationDatas(data.results);
                  $scope.allDestinations = $scope.allDestinations.concat(destLocations);
                }
                // $scope.loadingLocations.destination = false;
              })
              .then(() => {
                if (offset === 0 || offset == undefined) {
                  $scope.autoSelect();
                }
              })
          }
          else {
            promise = RouteService.getActiveRouteSequence(routeId, branchId, getDay(date))
              .then((data) => {
                const destinations = data;
                $scope.totalRecords = data.length;
                isLoadingAllLocations = true;
                $scope.destinations = $scope.mappingLocationDatas(destinations);
              })
              .then(() => {
                $scope.autoSelectDestination();
              })
          }
        }

        // Auto select first location from getActiveRouteSequence API
        $scope.autoSelectDestination = function (e) {
          if (e && (e.keyCode === 38 || e.keyCode === 40)) {
            return
          }
          if ($scope.bag.fromLocationId && !$scope.showAllDestinationLocations && $scope.destinations.length) {
            $scope.bag.toLocationId = $scope.destinations[0];
          }
          $scope.autoSelect();
        }

        // Auto select first location from getAllLocation API
        $scope.autoSelect = function () {
          if ($scope.bag.fromLocationId && $scope.showAllDestinationLocations && $scope.allDestinations.length) {
            $scope.bag.toLocationId = $scope.allDestinations[0];
          }
        }

        $scope.mappingLocationDatas = (locations) => {
          return locations.map((location) => {
            const locationObj = {
              Key: location.id + ' | ' + location.name,
              Value: location.id
            };

            if (location.address) {
              locationObj.Key += ' | ' + location.address;
            }
            if (location.city) {
              locationObj.Key += ' | ' + location.city;
            }

            if (location.prefix) {
              locationObj.key = location.prefix + ' | ' + locationObj.text;
            }

            return locationObj;
          });
        }

        $scope.reloadDestinations = function () {
          fetchDestinations(searchKey, offset);
        };

        $scope.focusOntoLocation = function (id) {
          focusElementById(id)
        };

        $scope.quantityChanged = () => {
          if ($scope.bag.qty) {
            $scope.bag.amount = $scope.bag.shiptype.amount * $scope.bag.qty;
          }

        }
        $scope.shiptypeChanged = () => {
          $scope.showAllDestinationLocations = false;
          if ($scope.bag.shiptype.amountFlag) {
            $scope.bag.qty = 1;
          }
          if (!$scope.bag.qty) {
            $scope.bag.qty = 1;
          }
          $scope.destinationLocationList = [];
          $scope.destinationAllLocationList = [];
          $scope.bag.toLocationId = "";
          $scope.locationLists = [];
          $scope.alllocationLists = []
          $scope.bag.fromLocationId = "";

          if ($scope.bag.toLocationId) {
            fetchDestinations(searchKey, offset);
          }
          if ($scope.bag.fromLocationId) {
            fetchFromLocations(searchKey, offset);
          }

          $scope.bag.amount = $scope.bag.qty * $scope.bag.shiptype.amount

          // set cash amount value as ZERO
          if ($scope.bag.shiptype.coinFlag == 0) {
            $scope.bag.amount = null;
          }
        }

        $scope.keyPressed = ($event) => {
          const ESC_KEY_CODE = 27;
          if ($event.keyCode === ESC_KEY_CODE) {
            negative({
              modal,
              disabledBag: false
            });
          }
        }

        $scope.ok = () => {
          $scope.errorMessage = '';
          if ($scope.loading) return;
          const requiredFields = ['shiptype', 'trackingId', 'qty', 'fromLocationId', 'toLocationId'];

          let isFormValid = requiredFields.every((field) => {
            $scope.allField = field
            return !!$scope.bag[$scope.allField];
          });

          // error check 
          if ($scope.bag.amount == null && $scope.bag.shiptype.amountFlag) {
            return $scope.errorMessage = $translate.instant('addBagModal.requiredAmountError');
          }
          else if (!isFormValid) {
            return $scope.errorMessage = $translate.instant('addBagModal.requiredFieldsError');
          }
          $scope.loading = true;
          $scope.bag.routeId = routeId
          $scope.bag.pickupDate = date
          $scope.bag.deliveryDate = date
          $scope.bag.branchId = branchId
          $scope.bag.coinFlag = $scope.bag.shiptype.coinFlag
          $scope.bag.shiptypeId = $scope.bag.shiptype.id
          $scope.bag.pickupFlag = false;
          $scope.bag.packedFlag = true;
          $scope.bag.verified = true;
          $scope.bag.tankerId = tankerId;
          $scope.bag.toLocationId = $scope.bag.toLocationId.Value;
          $scope.bag.fromLocationId = $scope.bag.fromLocationId.Value;
          $scope.bag.vaultDate = moment($scope.bag.deliveryDate).format('YYYY-MM-DD')
          $scope.bag.amount = $scope.bag.amount ? $scope.bag.amount : 0
          $scope.bag.disabledBag = false;
          callback({
            modal,
            $scope,
            disabledBag: $scope.bag.disabledBag
          })
        }

        $scope.cancel = () => {
          $scope.bag.disabledBag = false;
          negative({
            modal,
            disabledBag: $scope.bag.disabledBag
          });
        }
        if ($scope.isSupervisorConfirmed || supervisorScan === false) {
          init();
        }
      }]
    })
  }

  let forceCheckin = ({ bagId, branchId, windowId, routeId, checkinDate }, callback, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: forceCheckingModalTemplate,
      size: 'md',
      controller: ['$scope', '$translate', function ($scope) {

        $scope.model = {
          isBagAdded: false,
          bagId: bagId,
          scannedBagId: '',
          supervisor: '',
          error: ''
        };

        $scope.showAddBagModal = () => {
          checkedInForceAddBag({ bagId, branchId, windowId, routeId, checkinDate }, ({ modal: addBagModal, $scope: addBagModalScope }) => {
            addBagModal.close()
            $scope.model.supervisorId = addBagModalScope.supervisor.supId
            $scope.model.isBagAdded = true;
            focusElementById('bag-id');
          }, ({ modal: addBagModal }) => {
            addBagModal.close()
          })
        }

        $scope.fetchDetails = () => {
          if ($scope.model.scannedBagId === $scope.model.bagId) {
            callback({
              modal,
              $scope
            });
          }
          else {
            $scope.model.error = $translate.instant('error.90905') || 'abc'; //error which caused this modal to appear
          }
        }

        $scope.cancel = () => {
          negative({
            modal
          });
        }

      }]
    })
  }

  let itemNotDelivered = (trackingId, shipmentDetails, notDeliveredResolution, callback, negative) => {
    let itemNotDeliveredmodal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: itemNotDeliveredTemplate,
      size: 'md',
      controller: [
        '$scope',
        'MessageService',
        'User',
        'HoldService',
        'ShipmentService',
        '$location',
        '$q',
        'BranchService',
        'SetupService',
        'LocationService',
        'ShiptypeService',
        'DateUtil',
        function (
          $scope,
          MessageService,
          User,
          HoldService,
          ShipmentService,
          $location,
          $q,
          BranchService,
          SetupService,
          LocationService,
          ShiptypeService,
          DateUtil,
        ) {
          $scope.model = {
            loading: false,
            selectedReason: null,
            reasons: [],
            deliveryResolutions: [],
            trackingId: trackingId,
            updatedTrackingId: trackingId,
            originalTrackingId: trackingId,
            shipmentDetails: shipmentDetails,
            notDeliveredResolution: notDeliveredResolution,
            vaultDate: '',
            nextRouteData: '',
            nextRouteDetails: '',
            routeList: [],
            routeSequence: null,
            lastSelectedRoute: shipmentDetails.routeId || null,
            routeIds: '',
            routeId: shipmentDetails.routeId || null,
            routeInfo: null,
            totalRoutes: '',
            date: '',
            branchId: User.getUser().branchId,
            isReRoute: null,
            amount: shipmentDetails.amount || null,
            qty: shipmentDetails.qty || null,
            fromLocationListObj: {
              loading: false,
              fromLocationId:
                {
                  Key: `${shipmentDetails.fromLocation.id} | ${shipmentDetails.fromLocation.name}`,
                  Value: shipmentDetails.fromLocation.id,
                } || null,
              fromLocationOptions: [],
              totalRecords: 0,
              totalRecords: 0,
            },
            toLocationListObj:{
              loading: false,
              destinationId:
                {
                  Key: `${shipmentDetails.toLocation.id} | ${shipmentDetails.toLocation.name}`,
                  Value: shipmentDetails.toLocation.id,
                } || null,
              toLocationOptions: [],
              totalRecords: 0,
              totalRecords: 0,
            },
            shipTypeObj: { 
              loading: false,
              shiptypeId: {
              Key: shipmentDetails.shiptype.description,
              Value: shipmentDetails.shiptype.id,
              coinFlag: shipmentDetails.shiptype.coinFlag,
              unitValue: shipmentDetails.shiptype.unitValue,
            } || null, shipTypeList: [], totalShipTypes: 0, loading: false },
          }
          $scope.model.toLocationId = shipmentDetails.toLocationId ? shipmentDetails.toLocationId : null
          const loggedInUser = User.getUser()
         $scope.model.isItemNotDeliveredModal = true;
          const init = () => {
            $scope.model.loading = true
            const type =
              shipmentDetails.toLocation.stopProcess === 'L'
                ? ['R', 'NDR']
                : shipmentDetails.toLocation.stopProcess === 'D'
                ? ['D_R', 'NDR']
                : ['D_R', 'NDR']
            const searchObj = generateQueryForReason(type)
            MessageService.all(loggedInUser.languageId, searchObj, 0, 1000).then((data) => {
              if (data.results && data.results.length) {
                let reasons = data.results.filter((obj) => obj.type == 'R' || obj.type == 'D_R');
                reasons.sort((a, b) => {
                  return (b.defaultSelection === true) - (a.defaultSelection === true);
                });
                $scope.model.reasons = reasons;
                let defaultReason = reasons.find((item) => item.defaultSelection === true);
                if (!defaultReason && reasons.length) {
                  defaultReason = null;
                }
                $scope.model.selectedReason = defaultReason ? defaultReason.description : null;

                let deliveryResolutions = data.results.filter((obj) => obj.type == 'NDR');
                deliveryResolutions.sort((a, b) => {
                  return (b.defaultSelection === true) - (a.defaultSelection === true);
                });
                $scope.model.deliveryResolutions = deliveryResolutions;
                let defaultResolution = deliveryResolutions.find((item) => item.defaultSelection === true);
                if (!defaultResolution) {
                  defaultResolution = deliveryResolutions.find((item) => item.messageId === 'NDR.noTimeline');   // default "No Timeline"
                }
                $scope.model.deliveryResolution = defaultResolution ? defaultResolution.description : null;
                $scope.model.loading = false;
              } else {
                $scope.model.reasons = []
                $scope.model.deliveryResolutions = []
                $scope.model.selectedReason = null
                $scope.model.deliveryResolution = null
              }
              $scope.getLocationList()
              $scope.getShipmentDestinations()
              $scope.loadShipType()
              $scope.getNextVaultDate()
            })
          }
          $scope.$watch('model.toLocationListObj.destinationId', function (newVal, oldVal) {
            if (newVal !== oldVal) {
              $scope.getNextVaultDate();
            }
          });
          $scope.getNextVaultDate = () => {
            const dest = $scope.model.toLocationListObj.destinationId;
            if (!dest) return;
            const destinationId = dest.Value || dest;
            LocationService.getNextValutDateOfLocation(destinationId, $scope.model.branchId)
              .then((data) => {
                if (data.nextVaultDate) {
                  const utcMoment = moment.utc(data.nextVaultDate);
                  const year = utcMoment.year();
                  const month = utcMoment.month();
                  const day = utcMoment.date();
                  const dateObj = new Date(year, month, day, 0, 0, 0, 0);
                  $scope.model.date = dateObj;
                  $scope.model.vaultDate = dateObj;
                } else {
                  $scope.model.date = null;
                  $scope.model.vaultDate = null;
                }
                $scope.model.routeIdFromNextVaultDate = data.routeId ? data.routeId : null;
                $scope.model.routeId = data.routeId ? data.routeId : null;
                $scope.handleActionLable();
                $scope.loadRouteInfo()
                if (data.routeId) {
                  $scope.routeSequenceChanged();
                }
              });
          };
          
          $scope.getLocationList = (searchKey, offset) => {
            searchKey = searchKey || ''
            const locationSearchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'branchId',
                    condition: '=',
                    data: $scope.model.branchId,
                  },
                  {
                    group: {
                      rules: [
                        { field: 'id', condition: 'like', data: '%' + searchKey + '%' },
                        { field: 'name', condition: 'like', data: '%' + searchKey + '%' },
                      ],
                      operator: 'OR',
                    },
                  },
                ],
                operator: 'AND',
              },
            }

            $scope.model.fromLocationListObj.loading = true;
            return LocationService.all(locationSearchObj, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                if (!offset || offset === 0) {
                  $scope.model.fromLocationListObj.totalRecords = data.total
                  $scope.model.fromLocationListObj.fromLocationOptions = $scope.locationMapping(data.results)
                } else {
                  const location = $scope.locationMapping(data.results)
                  $scope.model.fromLocationListObj.fromLocationOptions = $scope.model.fromLocationListObj.fromLocationOptions.concat(location)
                }
                const selected = $scope.model.fromLocationListObj.fromLocationOptions.find(
                  (item) => item.Value == $scope.model.fromLocationListObj.fromLocationId,
                )
                if (selected) {
                  $scope.model.fromLocationListObj.fromLocationId = selected
                }
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  Modal.errorModal(err.data.message)
                }
              })
              .finally(() => {
                $scope.model.fromLocationListObj.loading = false
              })
          }

          $scope.getShipmentDestinations = (searchKey, offset) => {
            searchKey = searchKey || ''
            $scope.model.toLocationListObj.loading = true
            return LocationService.getShipmentDestinations(
                $scope.model.branchId,
                shipmentDetails.fromLocationId,
                searchKey,
                offset,
                AppConstant.defaultPageLimit
              )
              .then((data) => {
                if (!offset || offset === 0) {
                  $scope.model.toLocationListObj.totalRecords = data.total
                  $scope.model.toLocationListObj.toLocationOptions = $scope.locationMapping(data.results)
                } else {
                  const location = $scope.locationMapping(data.results)
                  $scope.model.toLocationListObj.toLocationOptions = $scope.model.toLocationListObj.toLocationOptions.concat(location)
                }
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  Modal.errorModal(err.data.message)
                }
              })
              .finally(() => {
                $scope.model.toLocationListObj.loading = false
              })
             }

          $scope.loadShipType = (searchKey, offset) => {
            searchKey = searchKey || ''
            const shipTypeSearchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'status',
                    condition: '=',
                    data: true,
                  },
                  {
                    group: {
                      rules: [
                        {
                          field: 'id',
                          condition: 'like',
                          data: '%' + searchKey + '%',
                        },
                        {
                          field: 'description',
                          condition: 'like',
                          data: '%' + searchKey + '%',
                        },
                      ],
                      operator: 'OR',
                    },
                  },
                ],
                operator: 'AND',
              },
            }

            $scope.model.shipTypeObj.loading = true
            return ShiptypeService.all(shipTypeSearchObj, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.shipTypeObj.totalShipTypes = data.total
                  $scope.model.shipTypeObj.shipTypeList = $scope.shipTypeDataMapping(data.results)
                } else {
                  const shipTypes = $scope.shipTypeDataMapping(data.results)
                  $scope.model.shipTypeObj.shipTypeList = $scope.model.shipTypeObj.shipTypeList.concat(shipTypes)
                }
                const selected = $scope.model.shipTypeObj.shipTypeList.find(
                  (item) => item.Value == $scope.model.shipTypeObj.shiptypeId.Value
                )
                if (selected) {
                  $scope.model.shipTypeObj.shiptypeId = selected
                }

              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  Modal.errorModal(err.data.message)
                }
              })
              .finally(() => {
                $scope.model.shipTypeObj.loading = false
              })
          }

          $scope.shipTypeDataMapping = (shipTypes) => {
            return shipTypes.map((shipType) => {
              return {
                Key: shipType.id + ' | ' + shipType.description,
                Value: shipType.id,
                faceValue : shipType.amountFlag ? shipType.amount : shipType.unitValue,
                coinFlag: shipType.coinFlag,
                unitValue: shipType.unitValue,
                amount : shipType.amount,
              }
            })
          }

          $scope.locationMapping = (location) => {
            return location.map((loc) => {
              return {
                Key: loc.id + ' | ' + loc.name,
                Value: loc.id,
              }
            })
          }
          $scope.loadRouteInfo = () => {
            if (!$scope.model.notDeliveredResolution) return
            SetupService.get($scope.model.branchId)
              .then((data) => {
                // $scope.model.vaultDate = moment.utc(data.currentVaultDate).format('YYYY-MM-DD')
                // $scope.minVaultDate = {
                //   minDate: $scope.model.vaultDate,
                // }
                return data
              })
              .then((data) => {
                return getNextAvailableRoutes(
                  ShipmentService,
                  $scope,
                  $scope.model.toLocationId,
                  $location,
                  $q,
                  BranchService,
                  data.holdRoute,
                  HoldService,
                )
              })
              .catch((err) => {
                console.log(err)
              })
          }
          $scope.routeSequenceChanged = () => {
            // $scope.model.routeSequence = null;
            const routeId = $scope.model.routeId ? $scope.model.routeId : $scope.model.lastSelectedRoute
            if($scope.model.totalRoutes){
               $scope.model.totalRoutes.map((data) => {
              $scope.model.routeSequence = data.routeId === routeId ? 0 : $scope.model.routeSequence
            })
            $scope.model.routeInfo = _.find($scope.model.totalRoutes, { routeId: routeId })
            }
          }

            $scope.handleActionLable = (msg) => {
            let selectedDeliveryResolution = $scope.model.deliveryResolutions.filter(
              (resolutionObj) => resolutionObj.description == $scope.model.deliveryResolution,
            )
            if (selectedDeliveryResolution && selectedDeliveryResolution.length) {
              $scope.model.isReRoute = selectedDeliveryResolution[0].messageId == 'NDR.noTimeline' ? false : true
            } 
            if (selectedDeliveryResolution[0].messageId === 'NDR.redeliverNextDay') {
              SetupService.get($scope.model.branchId).then((data) => {
                const branchVault = moment.utc(data.currentVaultDate).add(1, "day").format("YYYY-MM-DD");
                const nextVault = $scope.model.date ? moment($scope.model.date ).utc(true).format('YYYY-MM-DD')  : null;
                if (nextVault !== branchVault) {
                  $scope.model.vaultDate = branchVault;
                  $scope.model.date = branchVault;
                  $scope.model.routeId = null;
                  $scope.model.routeIdFromNextVaultDate = null;
                  $scope.model.routeList = [];
                  $scope.minVaultDate = {
                    minDate: branchVault,
                  }
                }
              });
            }
          }
         
           $scope.$watch('model.shipTypeObj.shiptypeId', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              $scope.validateLoadedAmount();
            }
          });

          $scope.validateLoadedAmount = () => {
            const selected = $scope.model.shipTypeObj.shiptypeId
            if (!selected) return

            let loadShipmentAmount = null

            if (selected.coinFlag) {
              const qty = Number($scope.model.qty) || 0
              loadShipmentAmount = qty * (selected.amount)
            } else {
              loadShipmentAmount = shipmentDetails.amount
              $scope.model.qty = 1
            }

            $scope.model.amount = loadShipmentAmount
          }
          init()
          $scope.ok = (err) => {
            const trackingChanged = $scope.model.updatedTrackingId !== $scope.model.originalTrackingId
            if (trackingChanged) {
              confirmSupervisor(
                'put-items-on-hold',
                { trackingId: $scope.model.updatedTrackingId },
                ({ modal, supId }) => {
                  $scope.model.supervisorId = supId
                  callback({
                    $scope,
                    modal: itemNotDeliveredmodal,
                    supervisorId: supId,
                  })
                  modal.close()
                },
                ({ modal }) => {
                  modal.close()
                },
              )
            } else {
              $scope.model.loading = true
              $scope.model.supervisorId = loggedInUser.id
              callback({
                $scope,
                modal: itemNotDeliveredmodal,
                supervisorId: loggedInUser.id,
              })
            }
          }

          $scope.cancel = () => {
            negative({
              modal: itemNotDeliveredmodal,
            })
          }

        }],
    })
    rejectModal(itemNotDeliveredmodal, negative)
  }

  let forceCloseRoute = (routeId, routeVerifyData, remainingToCoinCheckout, totalCoinShipmentOnRoute, coinCheckOut,
    isAllCoinVerified, remainingItemList, callback, negative, routeName) => {
    let forceCloseRouteModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: forceCloseRouteTemplate,
      size: 'lg',
      controller: ['$scope', '$translate', 'MessageService', 'User', '$q', 'ScanService', 'ShipmentService', ($scope, $translate, MessageService, User, $q, ScanService, ShipmentService) => {
        $scope.model = {
          routeId,
          routeName,
          loggedInUser: User.getUser(),
          remainingToCoinCheckout: remainingToCoinCheckout,
          totalCoinShipmentOnRoute: totalCoinShipmentOnRoute,
          reasonList: [],
          selectedReasonForCoin: null,
          cursor: 0,
          coinCheckOut: coinCheckOut,
          isAllCoinVerified: isAllCoinVerified,
          remainingItemList,
          logisticItemReason: []
        };
        $scope.loading = false;
        $scope.currentrouteId = routeId;

        const getErrorMessage = (err) => {
          if (err && err.data && err.data.message) {
            return $translate.instant('error.' + err.data.message) || err.data.message;
          }
          else {
            return err.toString();
          }
        }

        const init = () => {
          $scope.loading = true;
          // const loggedInUser = User.getUser()

          $scope.model.logisticItemReason.push({ title: 'logisticItems', messageIds: ['IM.barcodeDamaged', 'IM.notScannable'] });

          routeVerifyData.route.forEach((record, index) => {
            record.reasons = null;
          });

          MessageService.getReasons($scope.model.loggedInUser.languageId, [...routeVerifyData.route, ...$scope.model.logisticItemReason])
            .then((reasonObjList) => {
              $scope.model.reasonList = [{
                messageId: 'coinNotVerified',
                description: 'Coin Not Verified'
              }];

              routeVerifyData.route.forEach((record, index) => {
                record.reasons = reasonObjList.results.shipmentReason[index];
              });

              remainingItemList.forEach((record, index) => {
                record.reasons = reasonObjList.results.logisticItemReason;
              });

              $scope.model.routeVerifyResults = routeVerifyData.route
            })
            .catch(function (err) {
              console.error(err);
              $scope.model.error = getErrorMessage(err);
            })
            .finally(() => {
              $scope.loading = false;
            })
        }
        init();

        $scope.allowScan = (routeVerifyResult) => {
          return [
            'E_PICKUP_NOT_CHECKED_IN',
            'E_DELIVERY_NOT_DELIVERED',

            'E_DELIVERY_NOT_ON_HOLD'
          ].includes(routeVerifyResult.message);
        }

        // Update trackingId 
        $scope.updateTrackingId = (data) => {
          $scope.oldTrackingId = data.trackingId;
          editTrackingIdModal(data.trackingId, ({ modal, trackingId, comment, supervisorId }) => {
            $scope.newTrackingId = trackingId;
            ShipmentService.updateShipmentTrackingId(data.shipmentId, $scope.oldTrackingId, $scope.newTrackingId, $scope.model.loggedInUser.branchId, comment)
              .then((data) => {
                modal.close();
              })
              .then(() => {
                $scope.updateRouteVerifyResults(); // find and update existing array with new trackingId
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal("error." + err.data.message);
                }
              })
          }, ({ modal }) => {
            modal.close();
          })
        }

        // find and update existing array with new trackingId
        $scope.updateRouteVerifyResults = () => {
          let index = _.findIndex($scope.model.routeVerifyResults, { trackingId: $scope.oldTrackingId })
          const [x] = $scope.model.routeVerifyResults.splice(index, 1);
          x.trackingId = $scope.newTrackingId;
          $scope.model.routeVerifyResults.splice(index, 0, x);
        }

        $scope.selectedCoinReason = () => {
          routeVerifyData.route.forEach((record, index) => {
            if (record.coinFlag) record.selectedReason = $scope.model.selectedReasonForCoin;
          });
        }

        $scope.goToScan = (record) => {
          callback({
            modal: forceCloseRouteModal,
            action: 'scan',
            // scanValue: record.trackingId
          })
        }

        $scope.ok = (err) => {
          // $scope.loading = true;
          confirmSupervisor('force-close', null, ({ modal, supId }) => {
            $scope.model.supervisorId = supId
            // $scope.loading = false;
            callback({
              $scope,
              action: 'save',
              modal: forceCloseRouteModal
            });
            modal.close()
          }, ({ modal }) => {
            // $scope.loading = false;
            modal.close()
          })
        }

        $scope.cancel = () => {
          negative({
            modal: forceCloseRouteModal
          })
        }
      }]
    });
    rejectModal(forceCloseRouteModal, negative)
  }

  let shipmentNotPickedUp = (validShipment, callback, negative, isImmediateDeliveryTransfer = false) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: shipmentNotPickedUpTemplate,
      size: 'md',
      controller: ['$scope', 'ShipmentService', 'DateUtil', 'LocationService', '$location', '$q', 'BranchService', 'HoldService', 'SetupService', 'User', 'Modal', 'RouteService',
        function ($scope, ShipmentService, DateUtil, LocationService, $location, $q, BranchService, HoldService, SetupService, User, Modal, RouteService) {
          $scope.model = {
            shipmentInfo: [validShipment],
            branchId: validShipment.branchId,
            date: null,
            routeId: null,
            loading: false,
            isGettingRoutes: false,
            isGettingLocationRoutes: false,
            fromLocationId: validShipment.fromLocationId,
            toLocationId: validShipment.toLocationId,
            loggedInUser: User.getUser(),
            isShipmentNotPickedUpModal: true,
            isImmediateDeliveryTransfer,
            vaultDate: '',
            isInitializing: false,
            nextRouteData: '',
            nextRouteDetails: '',
            routeList: [],
            routeSequence: null,
            lastSelectedRoute: validShipment.routeId || null,
            routeIds: '',
            totalRoutes: '',
            note: '',
            routeTotalRecords: 0,
            routeOffset: 0,
            routeSearchKey: '',
          };

          const init = () => {
            if (validShipment.vaultDate) {
              const utcMoment = moment.utc(validShipment.vaultDate).add(1, 'day');
              const year = utcMoment.year();
              const month = utcMoment.month();
              const day = utcMoment.date();
              const dateObj = new Date(year, month, day, 0, 0, 0, 0);
              $scope.model.date = dateObj;
              $scope.model.vaultDate = dateObj;

              const vaultMoment = moment.utc(validShipment.vaultDate);
              const minDateObj = new Date(vaultMoment.year(), vaultMoment.month(), vaultMoment.date(), 0, 0, 0, 0);

              $scope.minVaultDate = {
                minDate: minDateObj
              };
              $scope.model.isInitializing = true;
              $scope.onVaultDateChange();
            }
          }



          $scope.mappingData = (arr, label, value) => {
            return arr.map(item => {
              const arrayObject = {
                Key: (item[value] || item.routeId || item.id) + " | " + (item[label] || item.routeName || item.name),
                Value: item[value] || item.routeId || item.id,
                dataObj: item,
              };

              return arrayObject;
            });
          }

          $scope.getLocationNextRoute = () => {
            const vaultDate = $scope.model.date ? moment($scope.model.date).format('YYYY-MM-DD') : null;
            if (!vaultDate) return;

            LocationService.getNextVaultDateRoute($scope.model.fromLocationId, $scope.model.branchId, vaultDate)
              .then((data) => {
                if (data.nextVaultDate) {
                  const apiDate = moment.utc(data.nextVaultDate).format('YYYY-MM-DD');
                  const currentDate = $scope.model.date ? moment($scope.model.date).format('YYYY-MM-DD') : null;

                  if (apiDate !== currentDate) {
                    if ($scope.model.isInitializing) {
                      const utcMoment = moment.utc(data.nextVaultDate);
                      const dateObj = new Date(utcMoment.year(), utcMoment.month(), utcMoment.date(), 0, 0, 0, 0);
                      $scope.model.date = dateObj;
                      $scope.model.vaultDate = dateObj;
                      lastVaultDate = apiDate;
                    } else {
                      $scope.model.routeId = null;
                      return;
                    }
                  }
                }

                const routeIdStr = data.routeId;
                if (routeIdStr && $scope.model.routeList && $scope.model.routeList.length > 0) {
                  const preSelected = _.find($scope.model.routeList, { Value: routeIdStr });
                  if (preSelected) {
                    $scope.model.routeId = preSelected;
                  }
                }
              })
              .catch(err => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.isInitializing = false;
              });
          }

          $scope.getActiveRoutes = (searchKey, offset) => {
            searchKey = searchKey || "";
            $scope.model.isGettingRoutes = true;
            const routeSearchObj = {
              queryJSON: {
                rules: [
                  {
                    field: "branchId",
                    condition: "IN",
                    data: [$scope.model.branchId],
                  },
                  {
                    field: "active",
                    condition: "=",
                    data: true,
                  },
                  {
                    field: "holdRoute",
                    condition: "=",
                    data: false,
                  },
                  {
                    group: {
                      rules: [
                        {
                          field: "id",
                          condition: "like",
                          data: "%" + searchKey + "%",
                        },
                        {
                          field: "name",
                          condition: "like",
                          data: "%" + searchKey + "%",
                        },
                      ],
                      operator: "OR",
                    },
                  },
                ],
                operator: "AND",
              },
            };

            return RouteService.all(routeSearchObj, offset, 20)
              .then(res => {
                const routes = $scope.mappingData(res.results, "name", "id");
                if (offset === 0 || offset === undefined) {
                  $scope.model.routeList = routes;
                  $scope.model.routeTotalRecords = res.total;
                } else {
                  $scope.model.routeList = $scope.model.routeList.concat(routes);
                }
              })
              .catch(err => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.isGettingRoutes = false;
              });
          }

          $scope.reloadRouteData = (searchKey, offset) => {
            $scope.model.routeOffset = offset;
            $scope.model.routeSearchKey = searchKey;
            $scope.getActiveRoutes(searchKey, offset);
          }

          let lastVaultDate = null;
          $scope.onVaultDateChange = () => {
            const currentDate = $scope.model.date ? moment($scope.model.date).format('YYYY-MM-DD') : null;
            if (currentDate && currentDate === lastVaultDate) return;
            lastVaultDate = currentDate;

            $scope.model.routeId = null;
            if ($scope.model.date) {
              $scope.model.vaultDate = $scope.model.date;
              $scope.getActiveRoutes("", 0)
                .then(() => {
                  $scope.getLocationNextRoute();
                });
            }
          }

          init();

          $scope.ok = () => {
            if ($scope.model.loading || !$scope.model.date || !$scope.model.routeId) return;
            $scope.model.loading = true;
            const destRouteDate = moment($scope.model.date).format('YYYY-MM-DD');
            const destRouteId = $scope.model.routeId.Value || $scope.model.routeId;

            ShipmentService.shipmentPickupsReRoute(
              $scope.model.branchId,
              validShipment.trackingId,
              validShipment.routeId,
              destRouteId,
              destRouteDate,
              $scope.model.loggedInUser.id,
              $scope.model.note
            ).then((data) => {
              callback({ modal });
            }).catch((err) => {
              if (err && err.data && err.data.message) {
                return Modal.errorModal('error.' + err.data.message)
              }
            }).finally(() => {
              $scope.model.loading = false;
            });
          }

          $scope.cancel = () => {
            negative({ modal });
          }

        }]
    });
    rejectModal(modal, negative);
  }

  let checkinForceCloseRoute = (routeId, routeVerifyData, remainingItemList, callback, negative, routeName, vaultDate) => {

    let checkInForceCloseRouteModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: checkInForceCloseRouteTemplate,
      size: 'lg',
      controller: ['$scope', '$translate', 'MessageService', 'User', '$q', 'ScanService', 'ShipmentService', 'CommonLayoutService', 'DateUtil', 'LocationService', 'RouteService', ($scope, $translate, MessageService, User, $q, ScanService, ShipmentService, CommonLayoutService, DateUtil, LocationService, RouteService) => {
        $scope.model = {
          routeId,
          routeName,
          vaultDate,
          loggedInUser: User.getUser(),
          remainingItemList,
          logisticItemReason: []
      };
        $scope.loading = false;
        $scope.currentrouteId = routeId;

        const getErrorMessage = (err) => {
          if (err && err.data && err.data.message) {
            return $translate.instant('error.' + err.data.message) || err.data.message;
          }
          else {
            return err.toString();
          }
        }

        const init = () => {
          $scope.loading = true;

          // const loggedInUser = User.getUser()
          $scope.model.logisticItemReason.push({ title: 'logisticItems', messageIds: ['IM.itemLost', 'IM.itemStolen', 'IM.itemDamaged'] });

          routeVerifyData.route.forEach((record, index) => {
            record.reasons = null;
          });

          MessageService.getReasons($scope.model.loggedInUser.languageId, [...routeVerifyData.route, ...$scope.model.logisticItemReason])
            .then((reasonObjList) => {

              routeVerifyData.route.forEach((record, index) => {
                record.reasons = reasonObjList.results.shipmentReason[index];
              });

              $scope.model.remainingItemList.forEach((record, index) => {
                record.reasons = reasonObjList.results.logisticItemReason;
              });

              $scope.model.routeVerifyResults = routeVerifyData.route
            })
            .catch(function (err) {
              console.error(err);
              $scope.model.error = getErrorMessage(err);
            })
            .finally(() => {
              $scope.loading = false;
            })
        }
        init();

        $scope.maskingString = (trackingId) => {
          return CommonLayoutService.maskingString(trackingId);
        }

        $scope.allowScan = (routeVerifyResult) => {
          return [
            'E_PICKUP_NOT_CHECKED_IN',
            'E_DELIVERY_NOT_DELIVERED',

            'E_DELIVERY_NOT_ON_HOLD'
          ].includes(routeVerifyResult.message);
        }

        $scope.hasRerouteItems = () => {
          return _.some($scope.model.routeVerifyResults, (item) => {
            return item.isRequiredPickup && !item.orderNo && !item.verified;
          });
        }

        // Update trackingId 
        $scope.updateTrackingId = (data) => {
          $scope.oldTrackingId = data.trackingId;
          editTrackingIdModal(data.trackingId, ({ modal, trackingId, comment, supervisorId }) => {
            $scope.newTrackingId = trackingId;
            ShipmentService.updateShipmentTrackingId(data.shipmentId, $scope.oldTrackingId, $scope.newTrackingId, $scope.model.loggedInUser.branchId, comment)
              .then((data) => {
                modal.close();
              })
              .then(() => {
                $scope.updateRouteVerifyResults(); // find and update existing array with new trackingId
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal("error." + err.data.message);
                }
              })
          }, ({ modal }) => {
            modal.close();
          })
        }

        // find and update existing array with new trackingId
        $scope.updateRouteVerifyResults = () => {
          let index = _.findIndex($scope.model.routeVerifyResults, { trackingId: $scope.oldTrackingId })
          const [x] = $scope.model.routeVerifyResults.splice(index, 1);
          x.trackingId = $scope.newTrackingId;
          $scope.model.routeVerifyResults.splice(index, 0, x);
        }

        $scope.reroute = (record) => {
           record.branchId = $scope.model.loggedInUser.branchId;
           record.vaultDate = $scope.model.vaultDate;
           shipmentNotPickedUp(record, ({ modal: rerouteModal }) => {
               rerouteModal.close();
               // Remove the item from the list
                let index = _.findIndex($scope.model.routeVerifyResults, { locationId: record.locationId, trackingId: record.trackingId });
                if (index > -1) {
                    $scope.model.routeVerifyResults.splice(index, 1);
                    if (record.isError) {
                      routeVerifyData.errorCount--;
                    }

                    if ($scope.model.routeVerifyResults.length === 0 && (!$scope.model.remainingItemList || $scope.model.remainingItemList.length === 0)) {
                      callback({
                        $scope,
                        action: 'save',
                        modal: checkInForceCloseRouteModal
                      });
                      checkInForceCloseRouteModal.close();
                    }
                }
           }, ({ modal: rerouteModal }) => {
               rerouteModal.close();
           });
        }

        $scope.goToScan = (record) => {
          callback({
            modal: checkInForceCloseRouteModal,
            action: 'scan',
            scanValue: record.trackingId
          })
        }

        $scope.ok = (err) => {
          // $scope.loading = true;
          confirmSupervisor('force-close', null, ({ modal, supId }) => {
            $scope.model.supervisorId = supId
            // $scope.loading = false;
            callback({
              $scope,
              action: 'save',
              modal: checkInForceCloseRouteModal
            });
            modal.close()
          }, ({ modal }) => {
            // $scope.loading = false;
            modal.close()
          })
        }

        $scope.cancel = () => {
          negative({
            modal: checkInForceCloseRouteModal
          })
        }
      }]
    });
    rejectModal(checkInForceCloseRouteModal, negative)
  }

  // common function for holdReleases and returnItems 'used to display next available route according to date'
  function getNextAvailableRoutes(ShipmentService, $scope, locationId, $location, $q, BranchService, branchUnassignedOrHoldRoute, HoldService) {
    const routeDefer = $q.defer();

    const vaultDate = $scope.model.vaultDate
      ? moment($scope.model.vaultDate).format('YYYY-MM-DD')
      : null;

    ShipmentService.locationNextRoute($scope.model.branchId, locationId, vaultDate, 0)
      .then((data) => {
        $scope.model.nextRouteData = data;
        $scope.model.nextRouteDetails = $scope.model.nextRouteData && $scope.model.nextRouteData[0] ? $scope.model.nextRouteData[0] : [];
        // $scope.model.routeId = $scope.model.nextRouteDetails.routeId;
        // $scope.model.date = moment.utc($scope.model.nextRouteDetails.date).format('YYYY-MM-DD');
        $scope.model.routeSequence = $scope.model.nextRouteDetails.routeSeq;
        routeDefer.resolve($scope.model)
      }).catch((err) => {
        $scope.errorMessage = $translate.instant('error.' + err.data.message);
        $scope.errCode = err.data.message;

        if (err && err.data && err.data.message == "91902") { // call if location has no routes 
          $scope.model.routeId = branchUnassignedOrHoldRoute.id;
          $scope.model.routeSequence = 0;
          return loadRouteList($scope.model, $scope, $location, $q, BranchService, branchUnassignedOrHoldRoute, HoldService)
        }
      })
    routeDefer.promise
      .then((routeDetails) => { // call if location has next available route, and display next available route details selected in table.
        return loadRouteList(routeDetails, $scope, $location, $q, BranchService, branchUnassignedOrHoldRoute, HoldService)
      })
  }

  // common function to `load routeList` for release item and return item
  function loadRouteList(routeDetails, $scope, $location, $q, BranchService, branchUnassignedOrHoldRoute, HoldService) {
    routeDetails.loadRouteList = true;
    // get routeList based on branchId and current vaultDate
    $scope.days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    $scope.generateSearchObj = () => {
      const baseDate = $scope.model.date || routeDetails.vaultDate;
      if (!baseDate) {
        return null;
      }

      const day = moment(baseDate).day();

      if (!day === undefined) {
        return null;
      }

      return {
        queryJSON: {
          rules: [
            {
              field: 'branchId',
              condition: '=',
              data: routeDetails.branchId
            },
            {
              field: 'defRoute' + $scope.days[day] + 'Id',
              condition: '!=',
              data: null
            }
          ],
          operator: 'AND'
        }
      };
    }

    $scope.loadRoutes = () => {
      $scope.model.lastSelectedRoute = $scope.model.routeId;
      routeDetails.date = $scope.model.date || routeDetails.date;
      routeDetails.vaultDate = $scope.model.date || routeDetails.vaultDate;

      const searchObj = $scope.generateSearchObj();
      // const formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
      if (!routeDetails.date) {
        return;
      }
      const formattedDate = moment(routeDetails.date).format('YYYY-MM-DD');
      routeDetails.routeList = [];

      let matchingNextRouteId = null;
      if ($scope.model.nextRouteData && $scope.model.nextRouteData.length && $scope.model.date) {
        const selectedDateStr = moment($scope.model.date).format('YYYY-MM-DD');
        const matchingRoute = _.find($scope.model.nextRouteData, (route) => {
          if (!route.date) return false;
          const routeDateStr = moment(route.date).utc(true).format('YYYY-MM-DD');
          return routeDateStr === selectedDateStr;
        });

        matchingNextRouteId = matchingRoute ? matchingRoute.routeId : null;
      }

      $scope.model.routeIdFromNextVaultDate = matchingNextRouteId;

      return HoldService.getAllRoutes(routeDetails.branchId, formattedDate)
        .then((res) => {
          routeDetails.totalRoutes = res.result;
          res.result.forEach((routes) => {
            routeDetails.routeList.push(routes);
          });
          const nextAvailableRoute = routeDetails.nextRouteDetails && routeDetails.nextRouteDetails.routeId ? routeDetails.nextRouteDetails.routeId : null;
          const isValidRoute = (routeId) => routeId && _.find(routeDetails.routeList, { 'routeId': routeId });
          
          let selectedRouteId = null;
          if ($scope.model.routeIdFromNextVaultDate && isValidRoute($scope.model.routeIdFromNextVaultDate)) {
            selectedRouteId = $scope.model.routeIdFromNextVaultDate;
          } else if (!$scope.model.routeIdFromNextVaultDate) {
            selectedRouteId = null;
            $scope.model.lastSelectedRoute = null;
          } else if (nextAvailableRoute && isValidRoute(nextAvailableRoute)) {
            selectedRouteId = nextAvailableRoute;
          }
          
          $scope.model.routeId = selectedRouteId;
          
          if (!$scope.model.routeIdFromNextVaultDate && routeDetails.routeList.length > 0 && $scope.model.isItemNotDeliveredModal) {
            $scope.model.routeId = null;
          }
          
          $scope.model.routeSequence = $scope.model.routeId === branchUnassignedOrHoldRoute.id ? 0 : (routeDetails.nextRouteDetails && routeDetails.nextRouteDetails.routeSeq ? routeDetails.nextRouteDetails.routeSeq : 0);
          $scope.model.routeInfo = _.find($scope.model.totalRoutes, { 'routeId': $scope.model.routeId })
        })
        .catch((err) => {
          $scope.model.routeId = null;
          console.log(err);
        });

      // if (!searchObj) {
      //   return;
      // }

      // return BranchService.getReleaseRoutes(routeDetails.branchId, formattedDate)
      //   .then((res) => {
      //     routeDetails.totalRoutes = res;
      //     const nextAvailableRoutes = routeDetails.nextRouteDetails
      //     if (branchHoldRoute && !_.find(res, { 'routeId': branchHoldRoute.id })) {
      //       res.push({
      //         'routeName': branchHoldRoute.name,
      //         'routeId': branchHoldRoute.id,
      //         'stops': 0,
      //         'routeSequence': 0
      //       });
      //     }
      //     if (nextAvailableRoutes && !_.find(res, { 'routeId': nextAvailableRoutes.routeId })) {
      //       res.push({
      //         'routeName': nextAvailableRoutes.routeId,
      //         'routeId': nextAvailableRoutes.routeId,
      //         'routeSequence': nextAvailableRoutes.routeSeq
      //       });
      //     }
      //     res.forEach((routes) => {
      //       routeDetails.routeList.push(routes);
      //     })
      //     const nextAvailableRoute = routeDetails.nextRouteDetails.routeId;
      //     $scope.model.routeId = !_.find(routeDetails.routeList, { 'routeId': nextAvailableRoute }) ? branchHoldRoute.id : nextAvailableRoute;
      //     $scope.model.routeSequence = $scope.model.routeId === branchHoldRoute.id ? 0 : routeDetails.nextRouteDetails.routeSeq;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   })
      //   .finally(() => {
      //     $scope.loading = false;
      //   });
    }

    // load routes on page load based on current vaultDate
    const queryParams = $location.search();
    const dateDefer = $q.defer();

    // queryParams.date = /\d{4}-\d{2}-\d{2}/.test(queryParams.date) ? queryParams.date : null;
    let year, month, day;
    
    if (!routeDetails.date && routeDetails.nextRouteDetails.date) {
      const utcMoment = moment.utc(routeDetails.nextRouteDetails.date);
      year = utcMoment.year();
      month = utcMoment.month();
      day = utcMoment.date();
    } else if (routeDetails.vaultDate) {
      if (routeDetails.vaultDate instanceof Date) {
        year = routeDetails.vaultDate.getFullYear();
        month = routeDetails.vaultDate.getMonth();
        day = routeDetails.vaultDate.getDate();
      } else {
        const utcMoment = moment.utc(routeDetails.vaultDate);
        year = utcMoment.year();
        month = utcMoment.month();
        day = utcMoment.date();
      }
    } else {
      dateDefer.resolve(null);
      return;
    }
    
    const dateObj = new Date(year, month, day, 0, 0, 0, 0);
    dateDefer.resolve(dateObj);
    dateDefer.promise
      .then((date) => {
        routeDetails.date = date;
        $scope.model.date = date;
      })
      .then(() => {
        $scope.loadRoutes();
      })
      .finally(() => {
        $scope.loading = false;
      });
  }

  // Release item from HOLD
  let holdReleases = (shipment, allowSupervisorScan, callback, negative) => {
    let itemReleaseModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: holdReleaseTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', '$location', 'SetupService', 'BranchService', 'MessageService', 'User', 'ShipmentService', '$q', 'HoldService', 'RouteStopService', ($scope, $translate, $location, SetupService, BranchService, MessageService, User, ShipmentService, $q, HoldService, RouteStopService) => {

        $scope.loading = false;
        $scope.model = {
          trackingId: '',
          holdDate: '',
          deliveryDate: '',
          shipments: '',
          toLocationRoute: '',
          fromLocationRoute: '',
          toLocationRouteId: '',
          toLocationRouteSeq: '',
          toLocationRouteDate: '',
          fromLocationRouteId: '',
          fromLocationRouteSeq: '',
          fromLocationRouteDate: '',
          branchId: shipment.branchId ? shipment.branchId : User.getUser().branchId,
          vaultDate: '',
          nextRouteData: '',
          nextRouteDetails: '',
          routeList: [],
          routeSequence: null,
          routeIds: '',
          totalRoutes: '',
          date: '',
          toLocationId: '',
          loadRouteList: false,
          routeTransfered: '',
          lastSelectedRoute: null,
          allowSupervisorScan: allowSupervisorScan,
          userDetails: User.getUser(),
          routeStop: []
        };

        $scope.model.trackingId = shipment.trackingId;
        $scope.model.shipment = shipment.toLocation;
        // $scope.model.toLocationId = shipment.toLocation ? shipment.toLocation.id : null;
        $scope.model.toLocationId = shipment.toLocationId ? shipment.toLocationId : null;

        const getErrorMessage = (err) => {
          if (err && err.data && err.data.message) {
            return $translate.instant('error.' + err.data.message) || err.data.message;
          }
          else {
            return err.toString();
          }
        }

        const init = () => {
          $scope.loading = true
          fetchBranchLocation($scope.model.branchId)
            .then((branchLoc) => {
              $scope.model.branchLocation = branchLoc
              return SetupService.get($scope.model.branchId)
            })
            .then((data) => {
              $scope.model.vaultDate = moment.utc(data.currentVaultDate).format('YYYY-MM-DD')
              $scope.minVaultDate = { minDate: $scope.model.vaultDate }
              return data;
            })
            .then((data) => {
              // get next available route based on branchId, VaultDate and toLocationId
              return getNextAvailableRoutes(ShipmentService, $scope, $scope.model.toLocationId, $location, $q, BranchService, data.unassignedRoute, HoldService)
            })
            
            .then(() => fetchRouteStops())
            .finally(() => {
              $scope.loading = false;
            })
        }
        
        $scope.routeSequenceChanged = () => {
          // $scope.model.routeSequence = null;
          const routeId = $scope.model.routeId ? $scope.model.routeId : $scope.model.lastSelectedRoute
        
          if ($scope.model.totalRoutes.length > 0) {
            $scope.model.totalRoutes.map((data) => {
              $scope.model.routeSequence = data.routeId === routeId ? 0 : $scope.model.routeSequence
            })
            $scope.model.routeInfo = _.find($scope.model.totalRoutes, { routeId: routeId })
          }
          fetchRouteStops();
        }

          $scope.map = null;
          $scope.model.canShowMap = false

          function updateReleaseHoldMap() {
            let bounds = []

            if ($scope.map) {
              $scope.map.remove()
              $scope.map = null
            }

            const branch = $scope.model.branchLocation
            const holdLoc = $scope.model.shipment
            const stops = $scope.model.routeStops || []
            $scope.model.canShowMap = !!(branch && branch.lat && branch.long)
            if (!$scope.model.canShowMap) return

            setTimeout(() => {
              $scope.map = L.map('release-hold-map', { zoomControl: true })
              L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap contributors',
              }).addTo($scope.map)

              // Branch marker
              if (branch.lat && branch.long) {
                const branchMarker = L.marker([branch.lat, branch.long], {
                  icon: new L.AwesomeNumberMarkers({ number: 'B', markerColor: 'black' }),
                }).addTo($scope.map)
                branchMarker.bindTooltip(
                  `<strong>${branch.branchId}</strong><br>${branch.address}<br>${branch.city}, ${branch.state} ${branch.zip}`,
                  { direction: 'top' },
                )
                bounds.push([branch.lat, branch.long])
              }

              // Hold location marker
              if (holdLoc && holdLoc.lat && holdLoc.long) {
                const holdMarker = L.marker([holdLoc.lat, holdLoc.long], {
                  icon: new L.AwesomeNumberMarkers({
                    number: 'H',
                    markerColor: 'cadetblue',
                  }),
                }).addTo($scope.map)
                holdMarker.bindTooltip(`<strong>${holdLoc.name} | ${shipment.trackingId}</strong><br>${holdLoc.address},${holdLoc.city}, ${holdLoc.state} ${holdLoc.zip}`, {
                  direction: 'top',
                })
                bounds.push([holdLoc.lat, holdLoc.long]) 
              }

              // Route stops
              if( stops && stops.length) {
                stops.forEach((stop, idx) => {
                  if (stop.lat && stop.long) {
                    const marker = L.marker([stop.lat, stop.long], {
                      icon: new L.AwesomeNumberMarkers({
                        number: idx + 1,
                        markerColor: 'green',
                      }),
                    }).addTo($scope.map)
                    marker.bindTooltip(`<strong>${stop.locationName}</strong><br>${stop.address}`, {
                      direction: 'top',
                    })
                    bounds.push([stop.lat, stop.long])
                  }
                })
  
              }
              if (bounds.length) $scope.map.fitBounds(bounds, { padding: [30, 30] })
              setTimeout(() => $scope.map.invalidateSize(), 200)
            }, 100)
          }

          function fetchBranchLocation(branchId) {
            return SetupService.get(branchId).then((data) => {
              return {
                branchId: branchId,
                address: data.address,
                city: data.city,
                state: data.state,
                zip: data.zip,
                lat: data.gpsLat,
                long: data.gpsLong,
              }
            })
          }

          function fetchRouteStops() {
            $scope.model.fetchRouteStops = true
            setTimeout(() => {
              if ($scope.model.routeId && $scope.model.date && $scope.model.branchId) {
                const formattedDate = moment($scope.model.date).format('YYYY-MM-DD')
                const payload = {
                  routeId: $scope.model.routeId,
                  date: formattedDate,
                  branch: $scope.model.branchId,
                }
                return RouteStopService.routeStopList(payload.routeId, payload.date, payload.branch)
                  .then((data) => {
                    $scope.model.routeStops = data && data.results ? data.results : []
                    updateReleaseHoldMap()
                  })
                  .catch((err) => {
                    $scope.model.routeStops = []
                    console.error('Error fetching route stops:', err)
                  })
                  .finally(() => {
                    $scope.model.fetchRouteStops = false
                  })
              } else {
                $scope.model.routeStops = []
                $scope.model.fetchRouteStops = false
              }
            $scope.$apply();
            }, 700)
          }

        $scope.removeMap = () => {
          if ($scope.map) {
            $scope.map.remove();
            $scope.map = null;
          }
        }

        $scope.cancel = () => {
          // itemReleaseModal.close();
          negative({
            modal: itemReleaseModal
          })
        }

        $scope.validateSupervisorScan = () => {
          if ($scope.model.allowSupervisorScan) {
            let errorMsg = $translate.instant('users.supervisor_scan_error', {
              firstName: $scope.model.userDetails.firstName,
              lastName: $scope.model.userDetails.lastName
            })

            return confirm({
              header: $translate.instant('errorModal.title'),
              message: $translate.instant(errorMsg),
              callback: ({
                modal,
              }) => {
                $scope.ok();
                modal.close();
              },
              type: 'danger',
              buttons: ['common.ok']
            })
          }
          else {
            $scope.ok();
          }
        }

        $scope.ok = (err) => {
          $scope.isLoading = true;
          // confirmSupervisor('hold-release', { trackingId: shipment.trackingId }, ({ modal, supId }) => {
          verifySupervisorScan('hold-release', { trackingId: shipment.trackingId }, $scope)
            .then((supervisorInfo) => {
              $scope.model.supervisorId = supervisorInfo ? supervisorInfo.supId : null
              $scope.model.loading = true;

              callback({
                supervisorId: supervisorInfo ? supervisorInfo.supId : null,
                comment: $scope.model.comment ? $scope.model.comment : null,
                shipmentAssignedTo: $scope.model.routeId,
                selectedDate: $scope.model.date,
                routeInfo: $scope.model.routeInfo,
                modal: itemReleaseModal
              });
              if (supervisorInfo) supervisorInfo.modal.close();
              // modal.close()

              // }, ({ modal }) => {
              //   $scope.isLoading = false;
              //   modal.close()
              // })
            })
        }
        init()
      }]
    })
    rejectModal(itemReleaseModal, negative)
  }

  // Cancel or return item from HOLD
  let returnItems = (shipment, callback, negative) => {
    let itemReturnModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: cancelItemTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', '$location', 'SetupService', 'BranchService', 'MessageService', 'User', 'ShipmentService', '$q', 'HoldService', ($scope, $translate, $location, SetupService, BranchService, MessageService, User, ShipmentService, $q, HoldService) => {

        $scope.loading = false;
        $scope.model = {
          trackingId: '',
          shipments: '',
          toLocationRoute: '',
          fromLocationRoute: '',
          toLocationRouteId: '',
          toLocationRouteSeq: '',
          toLocationRouteDate: '',
          fromLocationRouteId: '',
          fromLocationRouteSeq: '',
          fromLocationRouteDate: '',
          fromLocation: '',
          branchId: User.getUser().branchId,
          vaultDate: '',
          nextRouteData: '',
          nextRouteDetails: '',
          routeList: [],
          routeSequence: null,
          routeIds: '',
          totalRoutes: '',
          date: '',
          loadRouteList: false,
          lastSelectedRoute: null
        };

        $scope.model.trackingId = shipment.trackingId
        $scope.model.toLocationRoute = shipment.toLocation
        $scope.model.fromLocation = shipment.fromLocation ? shipment.fromLocation.id : null

        const getErrorMessage = (err) => {
          if (err && err.data && err.data.message) {
            return $translate.instant('error.' + err.data.message) || err.data.message;
          }
          else {
            return err.toString();
          }
        }

        const init = () => {
          $scope.loading = true;
          SetupService.get($scope.model.branchId)
            .then((data) => {
              $scope.model.vaultDate = moment.utc(data.currentVaultDate).format('YYYY-MM-DD');

              $scope.minVaultDate = {
                minDate: $scope.model.vaultDate
              }
              return data;
            })
            .then((data) => {
              // get next available route based on branchId, VaultDate and toLocationId
              return getNextAvailableRoutes(ShipmentService, $scope, $scope.model.fromLocation, $location, $q, BranchService, data.unassignedRoute, HoldService)
            })
            .finally(() => {
              $scope.loading = false;
            });

          // get route sequence based on routeId
          $scope.routeSequenceChanged = () => {
            // $scope.model.routeSequence = null;
            const routeId = $scope.model.routeId ? $scope.model.routeId : $scope.model.lastSelectedRoute;
            $scope.model.totalRoutes.map(data => {
              $scope.model.routeSequence = data.routeId === routeId ? 0 : $scope.model.routeSequence;
            });
          }
        }

        $scope.cancel = () => {
          // itemReturnModal.close();
          negative({
            modal: itemReturnModal
          })
        }

        $scope.ok = (err) => {
          $scope.isLoading = true;
          confirmSupervisor('return-items', { trackingId: $scope.model.trackingId }, ({ modal, supId }) => {
            $scope.model.supervisorId = supId
            $scope.model.loading = true;

            callback({
              supervisorId: supId,
              comment: $scope.model.comment ? $scope.model.comment : null,
              returnItemTo: $scope.model.routeId,
              selectedDate: $scope.model.date,
              modal: itemReturnModal
            });
            modal.close()

          }, ({ modal }) => {
            $scope.isLoading = false;
            modal.close()
          })
        }
        init()
      }]
    })
    rejectModal(itemReturnModal, negative)
  }

  let closeRoute = (remainingItems, callback, negative) => {

    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: closeRouteTemplate,
      size: 'md',
      controller: ['$scope', function ($scope) {

        $scope.remainingItems = remainingItems
        $scope.reasonCodes = ['Reason Code 1', 'Reason Code 2', 'Reason Code 3', 'Reason Code 4', 'Reason Code 5']
        $scope.model = {
          description: ''
        };

        $scope.isSupervisorConfirmed = false;
        $scope.errorMessage = '';

        $scope.supervisorConfirmed = (supervisorId) => {
          $scope.isSupervisorConfirmed = true;
          $scope.errorMessage = '';
          $scope.supervisor = supervisorId;
        }

        $scope.supervisorCancelled = () => {
          $scope.isSupervisorConfirmed = false;
          $scope.errorMessage = '';
        }

        $scope.ok = () => {
          callback({
            modal,
            supervisor,
            remainingItems: $scope.remainingItems,
            description: $scope.model.description
          });
        }

        $scope.cancel = () => {
          negative({
            modal
          });
        }

      }]
    })
  };

  let selectDeliveryLocation = (locationIds, callback, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: selectDeliveryLocationTemplate,
      size: 'md',
      controller: ['$scope', 'LocationService', '$q', ($scope, LocationService, $q) => {
        $scope.selectedLocationId = '';
        $scope.loading = false;

        const init = () => {
          $scope.loading = true;
          $q.all(
            locationIds.map((locationId) => {
              return LocationService.get(locationId);
            })
          )
            .then((locations) => {
              $scope.deliveryLocations = locations;
            })
            .catch((err) => {
              $scope.cancel(err);
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        $scope.setSelected = (deliveryLocation) => {
          $scope.selectedLocationId = deliveryLocation.id;
        }

        $scope.ok = () => {
          callback({
            $scope,
            modal
          });
        }

        $scope.cancel = (err) => {
          negative({
            modal
          });
        }

        init()
      }]
    })
  };

  let closeBagout = (callback, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: closeBagoutTemplate,
      size: 'sm',
      controller: ['$scope', 'BagoutService', '$state', '$location', '$translate', 'SetupService', 'User', ($scope, BagoutService, $state, $location, $translate, SetupService, User) => {
        $scope.model = {
          bagout: {
            id: ''
          },
          message: '',
          isError: false,
          audio: audio
        }

        // var currentBranchId = User.getUser().branchId;
        focusElementById('scan-bagout-seal');

        // SetupService.get(currentBranchId)
        //   .then((res) => {
        //     $scope.prefixes = res.prefixes;
        //   })

        $scope.cancel = (err) => {
          negative({
            modal
          });
        }

        $scope.playScannerBeep = () => {
          document.querySelector("#scanner_beep").play()
        }

        $scope.bagoutScanned = () => {
          if ($scope.model.bagout.id === "" || $scope.model.bagout.id == undefined) {
            return;
          }
          $scope.model.message = '';
          var finalBagoutData;
          finalBagoutData = $scope.model.bagout.id;
          $scope.loading = true;
          return BagoutService.getShipments(finalBagoutData)
            .then((res) => {
              modal.close();
              $scope.loading = false;
              $location.url('/app/bag-out-print?bagout=' + finalBagoutData);
            })
            .catch((err) => {
              $scope.model.isError = true;
              $scope.loading = false;
              if (err && err.data && err.data.message) {
                $scope.model.bagout.id = "";
                $scope.playScannerBeep();
                $scope.model.message = $translate.instant(err.data.message);
              }
              else {
                $scope.playScannerBeep();
                $scope.model.bagout.id = finalBagoutData;
                $scope.model.message = $translate.instant(error.UnableToLocateBagout);
              }
            });
        }

        $scope.view = () => {
          if ($scope.isLoading) return;
          $scope.isLoading = true;
          $scope.bagoutScanned()
        }
      }]
    });
    rejectModal(modal, negative)

  }

  let commitSuccessModal = (totalDollerAmount, totalEuroAmount, timeStamp, successMessage, transactionType, callback, currencySymbol) => {

    let modal = $uibModal.open({
      keyboard: false,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: commitSuccessTemplate,
      size: 'sm',
      windowClass: 'width-415',
      controller: ['$scope', '$translate', ($scope, $translate) => {
        $scope.model = {
          timeStamp,
          totalDollerAmount,
          totalEuroAmount,
          successMessage: successMessage,
          date: moment(timeStamp).format('ddd ,ll'),
          time: moment(timeStamp).format('HH:mm:ss UTC ZZ').replace('UTC', 'GMT'),
          transactionType: transactionType,
          currencySymbol: currencySymbol || '$'
        }

        $scope.ok = () => {
          callback({
            modal
          });
        }
      }]
    })
  };

  let errorModal = (errorCode, params) => {
    return confirm({
      header: $translate.instant('errorModal.title'),
      // message: $translate.instant(`error.${errorCode}`),
      message: $translate.instant(`${errorCode}`, params),
      callback: ({
        modal,
      }) => {
        modal.close()
      },
      type: 'danger',
      buttons: ['common.ok']
    })
  }

  let successModal = ({ header, message, callback, autoClose = 'true', negative = ({ modal }) => { modal.close() }, size = 'md', buttons = ['routeControl.route_throw', 'common.cancel'], type = 'success' }) => {

    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: autoClose ? 'static' : 'true',
      template,
      size,
      controller: ['$scope', function ($scope) {

        $scope.header = header
        $scope.message = message
        $scope.buttons = buttons
        $scope.type = type;

        $scope.ok = () => {
          callback({
            modal,
            $scope: $scope
          })
        }

        $scope.cancel = () => {
          negative({
            modal,
            $scope
          })
        }
      }]
    })
  }

  let uploadedFileSelection = (locations,locationOptions, batchMasters,branches, callback, negative, lastSelectedFile) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: uploadedFileSelectionTemplate,
      size: 'lg',
      controller: ['$scope', '$translate', 'RouteService', 'LocationService', '$q', 'SetupService', 'User', 'BatchService', ($scope, $translate, RouteService, LocationService, $q, SetupService, User, BatchService) => {
        $scope.todayDate = moment().hour(0).minutes(0).seconds(0).toDate();

        $scope.model = {
          selectedFile: '',
          uploadedFiles: [],
          currentVaultDate: null,
          error: '',
          pickupDate: null,
          deliveryDate: null,
          batchMaster: '',
          branch: locations.branchId,
          // branch: User.getUser().branchId,
          selected: ''
        };
        $scope.data = {
          uploadedFiles: [],
          locations: locationOptions,
          batchMasters: batchMasters,
        };
        $scope.offset = 0;


        var init = () => {
          $scope.loadingData = true;

          $q.all([
            $scope.getAllLocation('', 0),
            SetupService.get($scope.model.branch),
            RouteService.getUploadedFiles()
          ])
            .then((res) => {
              $scope.model.currentVaultDate = res[1].currentVaultDate;
              $scope.data.uploadedFiles = res[2].results;
              $scope.data.uploadedFiles = $scope.data.uploadedFiles
                .filter(file => file !== null && file !== undefined)
                .map(file => {
                  return { fileName: file };
                });
                
              if ($scope.data.uploadedFiles.length > 0) {
                $scope.data.uploadedFiles = $scope.mapData(res[2].results);
                $scope.model.totalRecords = $scope.data.uploadedFiles.length;
                $scope.model.batchFile = $scope.data.uploadedFiles[0];
              }
            })
            .then(() => {
              $scope.loadFileData();
            })
        }

        $scope.mapData = (arrayObj) => {
          return arrayObj.map((obj) => {
            return {
              Key: obj,
              Value: obj
            }
          });
        }

        $scope.loadFileData = () => {
          const nextIteration = $q.defer();
          const invalidIndexes = [];
          const validFiles = [];

          if (!$scope.model.batchFile) return;

          const fileIndex = _.findIndex($scope.data.uploadedFiles, { fileName: $scope.model.batchFile.Value })
          $scope.model.error = '';

          RouteService.getUploadFile($scope.model.batchFile.Value, locations.branchId)
          // RouteService.getUploadFile($scope.model.batchFile.Value, $scope.model.branch)
            .then((res) => {
              $scope.model.fileDatas = res;

              if ($scope.model.fileDatas.status) {
                validFiles.push($scope.model.fileDatas);
              }
              else {
                $scope.model.pickupDate = moment.utc($scope.model.currentVaultDate).add(1, 'second').format('YYYY-MM-DD hh:mm:ss'),
                $scope.model.deliveryDate = moment.utc($scope.model.currentVaultDate).add(1, 'day').format('YYYY-MM-DD hh:mm:ss'),
                $scope.model.error = res.message;
                invalidIndexes.push(fileIndex);
                console.error(res.message)
              }
            })
            .then(() => {
              for (let i = invalidIndexes.length - 1; i >= 0; i--) {
                $scope.data.uploadedFiles.splice(invalidIndexes[i], 1);
              }

              $scope.data.uploadedFiles

              return validFiles;
            })
            .then((fileData) => {
              const selectedFileData = [$scope.model.batchFile.Value].map((fileName, index) => {

                if (
                    fileData[index] && 
                    fileData[index].result && 
                    fileData[index].result.deliveryDate !== null && 
                    fileData[index].result.pickupDate !== null
                ) {
                  fileData[index].result.deliveryDate = moment.utc(fileData[index].result.deliveryDate).format('YYYY-MM-DD hh:mm:ss');
                  fileData[index].result.pickupDate = moment.utc(fileData[index].result.pickupDate).format('YYYY-MM-DD hh:mm:ss');
                }
                else {
                  if (!fileData[index]) {
                    fileData[index] = { result: {} };
                  }
                  fileData[index].result.pickupDate = moment.utc($scope.model.currentVaultDate).add(1, 'second').format('YYYY-MM-DD hh:mm:ss')
                  fileData[index].result.deliveryDate = moment.utc($scope.model.currentVaultDate).add(1, 'day').format('YYYY-MM-DD hh:mm:ss')
                }

                return Object.assign({}, {
                  fileName: fileName,
                  fileData: fileData[index].result,
                  status: fileData[index].status
                });
              });
              $scope.model.selectedFile = selectedFileData[0];

              return nextIteration.resolve();
            })
            .catch(function (err) {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
              console.error(err);
            })
            .finally(() => {
              $scope.loadingData = false;
            });
          return nextIteration.promise.then(() => {
            $scope.selectedFileChanged();
          })
        }

        // load locationType == INTERNAL, BANK data based on BranchID
        $scope.loadLocationData = () => {
          const searchObj = {
            queryJSON: {
              rules: [{
                field: 'branchId',
                condition: '=',
                data: branches.map(ele => ele.Value)
              },
              {
                group: {
                  rules: [
                    {
                      field: 'locationType',
                      condition: '=',
                      data: 'INTERNAL'
                    }, {
                      group: {
                        rules: [
                          {
                            field: 'locationType',
                            condition: '=',
                            data: 'BANK'
                          },
                          {
                            field: 'centralBank',
                            condition: '=',
                            data: true
                          }
                        ],
                        operator: 'AND'
                      }
                    }
                  ],
                  operator: 'OR',
                }
              }
              ],
              operator: 'AND'
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // load locationType == INTERNAL, BANK data based on BranchID With Search value
        $scope.loadLocationDataWithSearch = (searchKey) => {
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'branchId',
                  condition: '=',
                  data: branches.map(ele => ele.Value)
                },
                {
                  group: {
                    rules: [
                      {
                        field: 'locationType',
                        condition: '=',
                        data: 'INTERNAL'
                      }, {
                        group: {
                          rules: [
                            {
                              field: 'locationType',
                              condition: '=',
                              data: 'BANK'
                            },
                            {
                              field: 'centralBank',
                              condition: '=',
                              data: true
                            }
                          ],
                          operator: 'AND'
                        }
                      }
                    ],
                    operator: 'OR',
                  }
                },
                {
                  group: {
                    rules: [
                      {
                        field: "id",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "name",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      }
                    ],
                    operator: "OR"
                  }
                }
              ],
              operator: 'AND'
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        $scope.getAllLocation = (searchKey, offset) => {
          return
          let batchSearchObj = {
            branchId: branches.map(ele => ele.Value),
            queryText: '%%',
          };

          let loadLocationDatas = '';
          if (searchKey) {
            $scope.offset = 0;
            loadLocationDatas = $scope.loadLocationDataWithSearch(searchKey);
          } else {
            if (offset == 0) {
              $scope.offset = 0;
            }
            loadLocationDatas = $scope.loadLocationData();
          }

          $q.all([
            LocationService.getAllLocation(loadLocationDatas, $scope.offset, AppConstant.defaultPageLimit),
            BatchService.all(batchSearchObj, 0, MAXLIMIT)
          ])
            .then((data) => {
              const batchSourceIds = data[1].results
                .filter((batch) => !!batch.batchSourceId)
                .map((batch) => batch.batchSourceId);

              if ($scope.offset === 0) {
                $scope.totalLocationRecords = data[0].total;
                $scope.data.locations = $scope.mappingLocationDatas(data[0].results).filter((location) => batchSourceIds.includes(location.id));
                $scope.offset += 10;
                if ($scope.data.locations.length <= 10 && !searchKey) {
                  $scope.changeOffsetFlag = false;
                  $scope.getAllLocation('', this.offset)
                }
              }
              else {
                const locations = $scope.mappingLocationDatas(data[0].results).filter((location) => batchSourceIds.includes(location.id));
                $scope.data.locations = $scope.data.locations.concat(locations);
                $scope.offset += 10;
                if ($scope.data.locations.length <= 10) {
                  $scope.changeOffsetFlag = false;
                  if ($scope.totalLocationRecords > $scope.offset) {
                    $scope.getAllLocation('', $scope.offset)
                  }
                } else $scope.changeOffsetFlag = true
              }
            })
        }

        $scope.mappingLocationDatas = (locations) => {
          return locations.map((location) => {
            return _.merge({
              Key: location.id + " | " + location.name,
              Value: location.id
            }, location)
          });
        }

        $scope.fromLocationChanged = () => {
          if ($scope.model.location) {
            const selectedBatchType = batchMasters.find((batchMaster) => {
              return batchMaster.batchSourceId === $scope.model.location.id;
            });

            if ($scope.model.batchMaster !== selectedBatchType.inputType) {
              $scope.model.batchMaster = selectedBatchType.inputType;
            }
          }
        }

        // to check if pickupDate greater than deliveryDate then set pickupDate equal to deliveryDate
        $scope.dateChanged = () => {
          if ($scope.model.pickupDate > $scope.model.deliveryDate) {
            $scope.model.deliveryDate = $scope.model.pickupDate;
          }
        }

        $scope.selectedFileChanged = () => {

          // if(
          //     $scope.model.selectedFile && 
          //     $scope.model.selectedFile.fileData && 
          //     $scope.model.selectedFile.fileData.pickupDate < $scope.todayDate 
          // ) {
          //   $scope.model.error = $translate.instant('uploadedFileSelectionModal.pickupDateError');
          // }
          // else if($scope.model.selectedFile.fileData.deliveryDate < $scope.model.selectedFile.fileData.pickupDate ) {
          //   $scope.model.error = $translate.instant('uploadedFileSelectionModal.dateError');
          // }
          // else {
          // $scope.model.error = '';

          $scope.model.pickupDate = $scope.model.selectedFile.fileData.pickupDate;
          $scope.model.deliveryDate = $scope.model.selectedFile.fileData.deliveryDate;
          // }
        }

        $scope.ok = () => {
          $scope.loading = true;
          if (lastSelectedFile) {
            RouteService.unlockFile(lastSelectedFile)
              .then((res) => {
              });
          }
          RouteService.lockFile($scope.model.selectedFile.fileName)
            .then((res) => {
              if (res.status) {
                callback({
                  $scope,
                  modal
                });
              }
              else {
                errorModal(res.message);
              }
            });
        }

        $scope.cancel = () => {
          negative({ modal });
        }

        init();
      }]
    });
    rejectModal(modal, negative)
  }

  let addLocation = (model, callback, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: addLocationTemplate,
      size: 'lg',
      windowClass: 'add-location-modal',
      controller: ['$scope', '$translate', ($scope, $translate) => {
        $scope.model = model;

        $scope.ok = (data) => {
          setTimeout(() => {
            callback({
              modal,
              data
            });
          }, 1000)
        }

        $scope.cancel = (err) => {
          negative({
            modal,
            err
          })
        }
      }]
    })
  }

  let forceCloseHold = (holdShipments, callback, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: forceCloseHoldTemplate,
      size: 'lg',
      keyboard: false,
      controller: ['$scope', 'HoldService', 'MessageService', '$q', '$translate', 'User', 'CommonLayoutService', function ($scope, HoldService, MessageService, $q, $translate, User, CommonLayoutService) {
        $scope.model = {
          loading: false,
          error: false,
          holdShipments: holdShipments.slice(),
          loggedInUser: User.getUser(),
          forceCloseShipments: []
        };

        function init() {
          $scope.model.loading = true;
          const searchObj = {
            queryJSON: {
              rules: [{
                field: 'type',
                condition: '=',
                data: 'H'
              }],
              operator: 'AND'
            }
          };

          $scope.maskingString = (trackingId) => {
            return CommonLayoutService.maskingString(trackingId);
          }

          MessageService.all($scope.model.loggedInUser.languageId, searchObj, 0, 1000)
            .then((data) => {
              const reasons = data.results;

              $scope.model.holdShipments.forEach((holdShipment) => {
                holdShipment.reasons = reasons;
              });
            })
            .catch((err) => {
              $scope.model.error = err.toString();
            })
            .finally((err) => {
              $scope.model.loading = false;
            });
        }

        $scope.cancel = function () {
          negative({ modal })
        };

        $scope.ok = function () {
          const forceCloseDefer = $q.defer();
          $scope.model.loading = true;

          $scope.model.holdShipments.map((data) => { // collect force close data
            $scope.model.forceCloseShipments.push({
              trackingId: data.trackingId,
              selectedReason: data.selectedReason,
              status: data.status,
              branchId: data.branchId
            })
          });

          HoldService.forceClose($scope.model.forceCloseShipments)
            .then((data) => {
              $scope.model.loading = false;
              forceCloseDefer.resolve(data)
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                return errorModal('error.' + err.data.message)
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
          forceCloseDefer.promise
            .then(() => {
              callback({ modal, $scope });
            })
        };

        init();
      }]
    })
  };

  let verifyHoldShipments = (currentVaultDate, allowBulkHoldVerify, callback, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: verifyHoldShipmentsTemplate,
      size: 'lg',
      keyboard: false,
      controller: ['$scope', '$rootScope', 'HoldService', 'ShipmentService', '$q', 'SetupService', 'User', 'BagoutService', function ($scope, $rootScope, HoldService, ShipmentService, $q, SetupService, User, BagoutService) {
        $scope.model = {
          loading: false,
          verifying: false,
          trackingId: '',
          verifiedCount: 0,
          errorCode: null,
          holdShipmentsCount: 0,
          currentDate: currentVaultDate,
          verifiedShipments: [],
          lastProcessed: null,
          localDateTime: null,
          bulkVerified: false,
          branchId: User.getUser().branchId,
          holdShipmentIndex: null,
          allowBulkHoldVerify: allowBulkHoldVerify
        };

        let holdShipments = [];
        $scope.prefixes = null;

        function init() {
          $scope.loading = true;
          loadTankerData();
          getHoldShipmentCount()
            .then(({ results, total }) => {
              holdShipments = results;
              $scope.model.holdShipmentsCount = total;
              focusElementById('tracking-id');
              $scope.loading = false;
            }).catch((err) => {
              $scope.loading = false;
              console.log(err)
            })
        }

        const getHoldShipmentCount = function () {
          // const search = {
          //   queryJSON: {
          //     rules: [
          //       {
          //         field: 'branchId',
          //         condition: '=',
          //         data: $scope.model.branchId
          //       },
          //       {
          //         field: 'status',
          //         condition: '=',
          //         data: 'ON_HOLD'
          //       },
          //       {
          //         group: {
          //           rules: [
          //             {
          //               field: 'verifiedOn',
          //               condition: '=',
          //               data: null
          //             },
          //             {
          //               field: 'verifiedOn',
          //               condition: '!=',
          //               data: $scope.model.currentDate
          //             },
          //           ],
          //           operator: 'OR',
          //         }
          //       }
          //     ],
          //     operator: 'AND'
          //   }
          // }
          const
            branch = $scope.model.branchId,
            status = 'ON_HOLD',
            verifiedDate = $scope.model.currentDate;

          return HoldService.verifyItemHoldData(branch, status, verifiedDate);
        }

        // Get tankerId associate with branch
        const loadTankerData = function () {
          return SetupService.get($scope.model.branchId)
            .then((tankerData) => {
              $scope.model.tankerId = tankerData.tankerId;
              $scope.prefixes = tankerData.prefixes.bagout ? (tankerData.prefixes.bagout[0]).toLowerCase() : null;
            })
        }

        // common function for bulkVerify and verifyShipment
        const getShipments = function (trackingId) {
          if ($scope.model.holdShipmentIndex > -1) {
            const trackingIdDefer = $q.defer();
            if (trackingId.startsWith($scope.prefixes) || trackingId.toLowerCase().startsWith($scope.prefixes)) {
              let finaltrackingId = null;
              finaltrackingId = trackingId.slice(1)
              const bagOutsearchObj = {
                queryJSON: {
                  rules: [{
                    field: 'id',
                    condition: '=',
                    data: finaltrackingId,
                  }],
                  operator: 'AND'
                }
              };

              BagoutService.all(bagOutsearchObj, 0, 1000).then((bagOutData) => {
                if (bagOutData.results.length) {
                  trackingIdDefer.resolve(finaltrackingId);
                } else {
                  trackingIdDefer.resolve(trackingId);
                }
              }).catch((err) => {
                trackingIdDefer.resolve(trackingId);
              })
            } else {
              trackingIdDefer.resolve(trackingId);
            }

            trackingIdDefer.promise
              .then((trackingId) => {
                $scope.model.verifying = true;
                ShipmentService.get(trackingId)
                  .then((shipment) => {
                    const localDateTime = moment.utc().toDate();
                    const lastProcessed = moment(localDateTime).format('l h:mm:ss A');
                    shipment.lastProcessed = lastProcessed;
                    $scope.model.verifiedShipments.push(shipment);

                    $scope.model.verifiedCount++;
                    $scope.model.holdShipmentsCount--;

                    holdShipments.splice($scope.model.holdShipmentIndex, 1);
                  })
                  .catch((err) => {
                    $scope.model.errorCode = err && err.data && err.data.message
                    console.error(err);
                  })
                  .finally(() => {
                    $scope.model.trackingId = null;
                    $scope.model.verifying = false;
                    focusElementById('tracking-id');
                  });
              });
          }
          else {
            $scope.model.errorCode = 91201;
          }
        }

        $scope.verifyShipment = function () {
          $scope.model.errorCode = null;
          if ($scope.model.trackingId === null) {
            return;
          }
          $scope.model.holdShipmentIndex = holdShipments.findIndex((holdShipment) => {
            let id = $scope.model.trackingId.slice(1)
            return holdShipment.trackingId.toLowerCase() === $scope.model.trackingId.toLowerCase() || holdShipment.trackingId.toLowerCase() === id.toLowerCase();
          });
          getShipments($scope.model.trackingId);
        }

        // Use for verify items as bulk
        $scope.bulkVerify = () => {
          $scope.holdShipmentData = holdShipments;
          $scope.failedToVerify = [];
          $scope.model.loading = true;
          $scope.holdtrackingId = holdShipments.map((data => data.trackingId))

          HoldService.bulkVerify($scope.holdtrackingId)
            .then((res) => {
              const localDateTime = moment.utc().toDate();;
              const lastProcessed = moment(localDateTime).format('l h:mm:ss A');
              $scope.model.loading = false;
              $scope.holdShipmentData.forEach(data => {
                if (res.failed.data.includes(data.trackingId)) {
                  $scope.model.errorCode = $translate.instant('90619');
                  $scope.failedToVerify.push(data);
                } else {
                  $scope.model.bulkVerified = true;
                  data.lastProcessed = lastProcessed;
                  $scope.model.verifiedShipments.push(data)
                }
              });

              holdShipments.splice($scope.model.holdShipmentIndex, res.success);
              $scope.model.verifiedCount = $scope.model.verifiedCount + res.success;
              $scope.model.holdShipmentsCount = $scope.model.holdShipmentsCount - res.success;
              holdShipments = $scope.failedToVerify;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.forceClose = function () {
          if ($scope.allowOnlyOnce) return;
          $scope.allowOnlyOnce = true;
          forceCloseHold(holdShipments, ({ modal: forceCloseModal, $scope: modalScope }) => {
            forceCloseModal.close();
            holdShipments = [];
            $scope.model.holdShipmentsCount = 0;
          }, ({ modal: forceCloseModal }) => {
            $scope.allowOnlyOnce = false;
            forceCloseModal.close();
          });
        }

        // Call bulkVerify comment modal
        $scope.bulkVerifyComments = function () {
          bulkVerifyComment(holdShipments, ({ modal: bulkVerifyCommentModal, $scope: modalScope }) => {
            $scope.$on("bulkVerifyComment", function (event, args) {
              $scope.itemVerifyComments = args;
              return callback({
                modal, $scope,
                Verifycomments: $scope.itemVerifyComments ? $scope.itemVerifyComments : null
              });
            });
          });
        }

        $scope.ok = () => {
          if ($rootScope.allowOnlyOnce) return;
          $rootScope.allowOnlyOnce = true;
          return $scope.bulkVerifyComments();
        }

        $scope.cancel = (err) => {
          confirm({
            header: $translate.instant('verifyHoldShipments.forceClose'),
            message: $translate.instant(`verifyHoldShipments.forceCloseShipments`),
            callback: ({
              modal: confirmModal
            }) => {
              confirmModal.close();
              negative({ modal });
            },
            type: 'danger'
          })
        }

        init();
      }]
    })
  }

  let bulkVerifyComment = (modal, callback, negative) => {
    let bulkVerifyCommentModal = $uibModal.open({
      keyboard: false,
      template: bulkVerifyCommentTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$rootScope', 'HoldService', '$q', function ($scope, $rootScope, HoldService, $q) {

        $scope.model = {
        };

        const init = () => {
        }

        $scope.cancel = () => {
          $rootScope.allowOnlyOnce = false;
          bulkVerifyCommentModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: bulkVerifyCommentModal
          });
          $rootScope.allowOnlyOnce = false;
          bulkVerifyCommentModal.close();
          $rootScope.$broadcast("bulkVerifyComment", $scope.model.comment);
        }
        init()
      }]
    })
  }

  // return data of holdverify
  let itemHoldLogDetails = (trackingId, shipment, modal, callback, negative) => {
    let itemHoldLogModal = $uibModal.open({
      template: itemHoldLogTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$rootScope', 'HoldVerifyService', '$q', function ($scope, $rootScope, HoldVerifyService, $q) {

        $scope.model = {
          holdVerifyData: null,
          itemholdVerifyDataCount: [],
          errorCode: null,
        };

        const init = () => {
          $scope.id = trackingId
        }

        $scope.loading = true;
        HoldVerifyService.get(typeof shipment == 'object' ? shipment.id : shipment)
          .then((data) => {
            if (data) {
              $scope.model.holdVerifyData = data;
            }
            else {
              $scope.model.errorCode = $translate.instant('item_holds.errorMessage');
            }
          }).catch((err) => {
            console.error(err);
          }).finally(() => {
            $scope.loading = false;
          });

        // HoldVerifyService.all(null, 0, 1000)
        //   .then((data) => {
        //     if (data.total > 0) {
        //       $scope.model.itemholdVerifyDataCount = data;
        //     }
        //     else {
        //       $scope.model.errorCode = $translate.instant('item_holds.errorMessage');
        //     }
        //   }).catch((err) => {
        //     console.error(err);
        //   }).finally(() => {
        //     $scope.loading = false;
        //   });

        $scope.cancel = () => {
          negative({
            modal: itemHoldLogModal
          });
        }

        init()
      }]
    });
    rejectModal(itemHoldLogModal, negative)
  }

  // update VehicalID, MessengerID, DriverId for RouteDetails
  let routeDetails = (route, date, supervisorScan, callback, negative) => {
    let routeDetailsModal = $uibModal.open({
      template: routeDetailsTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', 'UsersService', 'User', 'RouteDetailService', 'TruckService', '$q', 'DateUtil', function ($scope, UsersService, User, RouteDetailService, TruckService, $q, DateUtil) {

        $scope.model = {
          routeId: '',
          lastReleasedDate: '',
          truck: null,
          messenger: null,
          driver: null,
          branchId: User.getUser().branchId,
          routeData: '',
          allowSupervisorScan: supervisorScan,
          leaveTime: '',
          arriveTime: '',
          begMiles: '',
          endMiles: '',
          currentTime: moment().format("HH:mm:ss"),
          curCheckoutTime: '',
          curLeaveTime: '',
          curArriveTime: '',
          curBegMiles: '',
          curEndMiles: '',
          leaveDate: '',
          arriveDate: '',
          curLeaveDate: '',
          curArriveDate: '',
          currentDate: moment(),
          restrictToTruck: false,
          restrictTruck: null,
        };

        $scope.model.routeId = route.routeId;
        $scope.model.routeDate = date;

        const userSearchObj = (searchKey, hideUser, displayAppUserOnly = undefined) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: "branchId",
                  condition: "=",
                  data: $scope.model.branchId
                },
                // {
                //   field: "downloadToHHT",
                //   condition: "=",
                //   data: true
                // },
                {
                  group: {
                    rules: [
                      {
                        field: "id",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "firstName",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "lastName",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      }
                    ],
                    operator: "OR"
                  }
                }
              ],
              operator: 'AND',
            }
          }
          if (hideUser) {
            searchObj.queryJSON.rules.push({
              field: "id",
              condition: "!=",
              data: hideUser
            });
          }
          if (searchKey) {
            searchObj.orderBy = {
              order: [
                ['id', 'ASC']
              ]
            }
          }
          if (displayAppUserOnly) {
            searchObj.queryJSON.rules.push({
              field: "downloadToHHT",
              condition: "=",
              data: true
            })
          }
          return searchObj.queryJSON.rules.length ? searchObj : null;
        };

        const routeSearchObj = {
          queryJSON: {
            rules: [
              {
                field: "branchId",
                condition: "=",
                data: $scope.model.branchId
              },
              {
                field: "routeId",
                condition: "=",
                data: $scope.model.routeId
              },
              {
                field: "routeDate",
                condition: "=",
                data: $scope.model.routeDate
              },
            ],
            operator: 'AND',
          }
        };

        const init = () => {
          $scope.loading = true;
          $q.all([
            RouteDetailService.all(routeSearchObj, 0, 1000)
          ])
          .then((data) => {
              $scope.routeDetailsData = data[0].results;
              $scope.routeDetailsData.forEach((routeData) => {
                $scope.model.routeData = routeData;
                $scope.model.restrictToTruck = routeData.route ? routeData.route.restrictToTruck : false;
                $scope.model.restrictTruck = routeData.route ? routeData.route.restrictTruck : null;
                const hasVehicle = routeData.vehicleId && routeData.vehicle;
                const hasRestrictTruck = $scope.model.restrictToTruck && $scope.model.restrictTruck && $scope.model.restrictTruck.id;

                if (hasVehicle && hasRestrictTruck && routeData.vehicleId.trim() === $scope.model.restrictTruck.id.trim()) {
                    // Both are available and the same — just map Key/Value as normal
                    routeData.vehicle.Key = routeData.vehicleId.trim() + " | " + routeData.vehicle.make;
                    routeData.vehicle.Value = routeData.vehicleId.trim();
                    $scope.model.truckMismatch = false;
                } else if (hasRestrictTruck && (!hasVehicle || routeData.vehicleId.trim() !== $scope.model.restrictTruck.id.trim())) {
                    // restrictToTruck is true but assigned truck differs (or is missing) — override and warn user to save
                    routeData.vehicle = {
                        Key: $scope.model.restrictTruck.id.trim() + " | " + $scope.model.restrictTruck.make,
                        Value: $scope.model.restrictTruck.id.trim()
                    };
                    $scope.model.truckMismatch = true;
                } else if (hasVehicle) {
                    // Normal case — no restriction, just map vehicle
                    routeData.vehicle.Key = routeData.vehicleId.trim() + " | " + routeData.vehicle.make;
                    routeData.vehicle.Value = routeData.vehicleId.trim();
                    $scope.model.truckMismatch = false;
                }
                $scope.model.truck = routeData.vehicle;
                $scope.model.messenger = mapData(routeData.messenger);
                $scope.model.lastReleasedDate = routeData.updatedAt;
                $scope.getTruckData('', 0);
                $scope.getMessangerData('', 0);
                $scope.model.driver = mapData(routeData.driver);
                $scope.getDriverData('', 0)
                $scope.getGuardData('', 0);
                $scope.model.guard = mapData(routeData.guard)
                $scope.model.curCheckoutTime = routeData.checkoutTime ? new Date(routeData.checkoutTime) : null;
                $scope.model.curLeaveTime = routeData.leaveTime ? new Date(routeData.leaveTime) : null;
                $scope.model.curArriveTime = routeData.arrTime ? new Date(routeData.arrTime) : null;
                $scope.model.curBegMiles = routeData.begMiles,
                  $scope.model.curEndMiles = routeData.endMiles
                $scope.model.leaveTime = $scope.model.curLeaveTime ? $scope.getTime(moment($scope.model.curLeaveTime).format('HH:mm:ss')) : null;
                $scope.model.arriveTime = $scope.model.curArriveTime ? $scope.getTime(moment($scope.model.curArriveTime).format('HH:mm:ss')) : null;
                $scope.model.begMiles = $scope.model.curBegMiles,
                  $scope.model.endMiles = $scope.model.curEndMiles,
                  $scope.model.leaveDate = $scope.model.curLeaveTime ? moment($scope.model.curLeaveTime) : null;
                $scope.model.arriveDate = $scope.model.curArriveTime ? moment($scope.model.curArriveTime) : null;
                $scope.model.checkOutDate = routeData.checkoutTime ? moment(routeData.checkoutTime).format('DD-MMM-YYYY') : null;
                $scope.model.checkOutTime = routeData.checkoutTime ? moment(routeData.checkoutTime).format('hh:mm A') : null;

                $scope.maxDate = {
                  maxDate: $scope.model.currentDate,
                  minDate: routeData.routeDate
                }
                $scope.model.requireDriver = routeData.requireDriver;
                $scope.model.requireGuard = routeData.requireGuard;
              })
            })
            .finally(() => {
              $scope.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        }
        const mapData = (item) => {
          if (item == null) return item;

          item.Key = item.id + " | " + item.firstName + ' ' + item.lastName;
          item.Value = item.id;
          return item;
        }

        const mappingUserData = (items, searchKey, model) => {
          let itemArray = [];
          items.map((item) => {
            item.Key = item.id + " | " + item.firstName + ' ' + item.lastName;
            item.Value = item.id;
            if (!searchKey) {
              if (model) {
                if (item.id !== model.Value) {
                  itemArray.push(item);
                }
              } else {
                itemArray.push(item);
              }
            } else {
              itemArray.push(item);
            }
          });
          return itemArray;
        }

        $scope.getMessangerData = (searchKey, offset) => {
          let searchObj = userSearchObj(searchKey, null, true);
          if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
            offset = offset - 1;
          }
          UsersService.all(searchObj, offset, AppConstant.defaultPageLimit)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.messangerTotalRecord = data.total;
                $scope.messangerData = mappingUserData(data.results, searchKey, $scope.model.messenger);
                if (!searchKey && $scope.model.messenger) {
                  $scope.messangerData.unshift($scope.model.messenger);
                }
              }
              else {
                const messanger = mappingUserData(data.results, searchKey, $scope.model.messenger);
                $scope.messangerData = $scope.messangerData.concat(messanger);
              }
            })
        }

        $scope.getDriverData = (searchKey, offset) => {
          let searchObj = userSearchObj(searchKey, $scope.model.messenger ? $scope.model.messenger.id : null, true);
          if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
            offset = offset - 1;
          }
          UsersService.all(searchObj, offset, AppConstant.defaultPageLimit)
            .then((data) => {
              $scope.userData = data.results;
              if (offset === 0 || offset == undefined) {
                $scope.driverTotalRecord = data.total;
                $scope.driverData = mappingUserData(data.results, searchKey, $scope.model.driver);
                if (!searchKey && $scope.model.driver) {
                  $scope.driverData.unshift($scope.model.driver);
                }
              }
              else {
                $scope.driverTotalRecord = data.total;
                const driver = mappingUserData(data.results, searchKey, $scope.model.driver);
                $scope.driverData = $scope.driverData.concat(driver);
              }
            })
        }

        $scope.getGuardData = (searchKey, offset) => {
          let searchObj = userSearchObj(searchKey, $scope.model.messenger ? $scope.model.messenger.id : null, true);
          if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
            offset = offset - 1;
          }
          UsersService.all(searchObj, offset, AppConstant.defaultPageLimit)
            .then((data) => {
              $scope.userData = data.results;
              if (offset === 0 || offset == undefined) {
                $scope.guardTotalRecord = data.total;
                $scope.guardData = mappingUserData(data.results, searchKey, $scope.model.guard);
                if (!searchKey && $scope.model.guard) {
                  $scope.guardData.unshift($scope.model.guard);
                }
              }
              else {
                $scope.guardTotalRecord = data.total;
                const guard = mappingUserData(data.results, searchKey, $scope.model.guard);
                $scope.guardData = $scope.guardData.concat(guard);
              }
            })
        }

        $scope.messengerSelected = () => {
          if ($scope.model.messenger == null) {
            $scope.model.driver = null;
          } else {
            if ($scope.model.messenger && $scope.model.driver) {
              if ($scope.model.messenger.id == $scope.model.driver.id) {
                $scope.model.driver = null;
              }
            }
            $scope.getDriverData()
          }
        }

        $scope.getTruckData = (searchKey, offset) => {
          searchKey = searchKey || '';


          if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
            offset = offset - 1;
          }
          TruckService.getAllTrucks(searchKey, $scope.model.branchId, $scope.model.routeId, $scope.model.routeDate, AppConstant.defaultPageLimit, offset)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.totalRecord = data.total;
                $scope.truckData = mappingTruckData(data.results, searchKey);
                if (!searchKey && $scope.model.truck) {
                  $scope.truckData.unshift($scope.model.truck);
                }
              }
              else {
                const truckData = mappingTruckData(data.results, searchKey);
                $scope.truckData = $scope.truckData.concat(truckData);
              }
            })
        }

        const mappingTruckData = (trucks, searchKey) => {
          let truckArray = [];
          trucks.map((truck) => {
            // if (truck.location.branchId === $scope.model.branchId) {
            truck.Key = truck.id + " | " + truck.make;
            truck.Value = truck.id;
            if (!searchKey) {
              if ($scope.model.truck) {
                if (truck.id !== $scope.model.truck.Value) {
                  truckArray.push(truck);
                }
              } else {
                truckArray.push(truck);
              }
            } else {
              truckArray.push(truck);
            }
            // }
          });
          return truckArray;
        }

        $scope.getTime = (time) => {
          if (!time) {
            return time;
          }

          time = time.split(':');

          let d = new Date();

          d.setHours(+time[0]);
          d.setMinutes(time[1]);
          d.setSeconds(0);
          d.setMilliseconds(0);

          return d;
        }

        $scope.cancel = () => {
          negative({
            modal: routeDetailsModal
          })
        }

        $scope.getLeaveTime = () => {
          if (!$scope.model.leaveTime) return;

          const lvTime = $scope.model.leaveTime ? moment($scope.model.leaveTime).format('HH:mm:ss') : null;
          const lvDate = $scope.model.leaveDate ? moment($scope.model.leaveDate).format('YYYY-MM-DD') : null;
          const dt = `${lvDate} ${lvTime}`;
          return dt;
        }

        $scope.getArriveTime = () => {
          if (!$scope.model.arriveTime) return;

          const arrTime = $scope.model.arriveTime ? moment($scope.model.arriveTime).format('HH:mm:ss') : null;
          const arrDate = $scope.model.arriveDate ? moment($scope.model.arriveDate).format('YYYY-MM-DD') : null;
          const arrDt = `${arrDate} ${arrTime}`;
          return arrDt;
        }

      $scope.validateLeaveTime = () => {
        let leaveDateTime = $scope.getLeaveTime();
        let arriveDateTime = $scope.getArriveTime();
        let leaveMoment = moment(leaveDateTime, 'YYYY-MM-DD HH:mm:ss').seconds(0).milliseconds(0)
        let checkoutMoment = moment($scope.model.curCheckoutTime).seconds(0).milliseconds(0)
        let leaveTime = leaveMoment.valueOf()
        let checkoutTime = checkoutMoment.valueOf()
        if (leaveTime < checkoutTime) {
          delete $scope.arriveTimeError
          $scope.leaveTimeError = $translate.instant('routeControl.leave_time_error')
        } else if ($scope.model.arriveTime && leaveTime > moment(arriveDateTime, 'YYYY-MM-DD HH:mm:ss').valueOf()) {
          delete $scope.arriveTimeError
          $scope.leaveTimeError = $translate.instant('routeControl.leave_time_greater_than_arrive_time_error')
        } else {
          delete $scope.leaveTimeError
        }

        if ($scope.model.arriveDate) $scope.validateArriveDate();
      }

        $scope.validateArriveTime = () => {
          let leaveDateTime = $scope.getLeaveTime();
          let arriveDateTime = $scope.getArriveTime();
          let curArriveTime = moment(arriveDateTime).valueOf();
          let leaveTime = moment(leaveDateTime).valueOf();

          if ($scope.model.arriveTime && curArriveTime < leaveTime) {
            delete $scope.leaveTimeError;
            $scope.arriveTimeError = $translate.instant('routeControl.arrive_time_error');
          }
          else delete $scope.arriveTimeError;
        }

        $scope.validateMileage = () => {
          // let begMiles = $scope.model.curBegMiles ? $scope.model.curBegMiles : $scope.model.begMiles;
          // let endMiles = $scope.model.curEndMiles ? $scope.model.curEndMiles : $scope.model.endMiles;
          let begMiles = $scope.model.begMiles;
          let endMiles = $scope.model.endMiles;

          if ((endMiles !== undefined && endMiles !== null) && endMiles < begMiles) $scope.mileageError = $translate.instant('routeControl.miles_error');
          else delete $scope.mileageError;
        }

        $scope.validateLeaveDate = () => {
          if (!$scope.model.leaveDate) return;

          let checkoutDate = moment($scope.model.curCheckoutTime).format('YYYY-MM-DD');
          let leaveDate = moment($scope.model.leaveDate).format('YYYY-MM-DD');

          if (leaveDate < checkoutDate) $scope.leaveDateError = $translate.instant('routeControl.leave_date_error');
          else delete $scope.leaveDateError;
          $scope.validateLeaveTime();
        }

        $scope.validateArriveDate = () => {
          if (!$scope.model.arriveDate) return;

          let curArriveDate = moment($scope.model.arriveDate).format('YYYY-MM-DD');
          let leaveDate = moment($scope.model.leaveDate).format('YYYY-MM-DD');

          if (!$scope.model.curLeaveTime && !$scope.model.leaveTime) return;
          else if (curArriveDate < leaveDate) $scope.arriveDateError = $translate.instant('routeControl.arrive_date_error');
          else delete $scope.arriveDateError;
          $scope.validateArriveTime();
        }

        $scope.isError = () => {
          return $scope.leaveTimeError || $scope.arriveTimeError || $scope.mileageError || $scope.leaveDateError || $scope.arriveDateError
        }

        $scope.validateRouteDetailForm = () => {
          return (($scope.model.leaveDate && !$scope.model.leaveTime) || ($scope.model.arriveDate && !$scope.model.arriveTime) ||
            ($scope.model.arriveDate && !$scope.model.leaveDate) || ($scope.model.arriveTime && !$scope.model.leaveTime) ||
            ($scope.model.requireDriver && !$scope.model.driver) || ($scope.model.requireGuard && !$scope.model.guard) ||
            ($scope.model.arriveDate && $scope.model.arriveTime && !$scope.model.endMiles)
            || ($scope.model.leaveDate && $scope.model.leaveTime && !$scope.model.truck))
        }

        $scope.ok = (err) => {
          const leaveDate = $scope.model.leaveDate && $scope.model.leaveTime ? moment($scope.model.leaveDate).format('YYYY-MM-DD') : null;
          let leaveTime = $scope.model.leaveDate && $scope.model.leaveTime ? moment($scope.model.leaveTime).format('HH:mm:ss') : null;
          const arriveDate = $scope.model.arriveDate && $scope.model.arriveTime ? moment($scope.model.arriveDate).format('YYYY-MM-DD') : null;
          let arriveTime = $scope.model.arriveDate && $scope.model.arriveTime ? moment($scope.model.arriveTime).format('HH:mm:ss') : null;

          if (leaveDate && leaveTime && $scope.model.curCheckoutTime) {
            const leaveMoment = moment(`${leaveDate} ${leaveTime}`, 'YYYY-MM-DD HH:mm:ss')
            const checkoutMoment = moment($scope.model.curCheckoutTime)
            if ( leaveMoment.isValid() && checkoutMoment.isValid() && leaveMoment.format('YYYY-MM-DD HH:mm') === checkoutMoment.format('YYYY-MM-DD HH:mm')) {
              leaveMoment.seconds(checkoutMoment.seconds())
              leaveTime = leaveMoment.format('HH:mm:ss')
            }
          }

          if (arriveDate && arriveTime && leaveDate && leaveTime) {
            const arriveMoment = moment(`${arriveDate} ${arriveTime}`, 'YYYY-MM-DD HH:mm:ss')
            const leaveMoment = moment(`${leaveDate} ${leaveTime}`, 'YYYY-MM-DD HH:mm:ss')
            if ( arriveMoment.isValid() && leaveMoment.isValid() && arriveMoment.format('YYYY-MM-DD HH:mm') === leaveMoment.format('YYYY-MM-DD HH:mm') && arriveMoment.seconds() === 0) {
              arriveMoment.seconds(leaveMoment.seconds())
              arriveTime = arriveMoment.format('HH:mm:ss')
            }
          }

          const leaveDateTime = `${leaveDate} ${leaveTime}`;
          const arriveDateTime = `${arriveDate} ${arriveTime}`;
          const UTCLeaveTime = $scope.model.leaveDate && $scope.model.leaveTime ? moment(leaveDateTime).utc().format('YYYY-MM-DD HH:mm:ss') : null;
          const UTCArriveTime = $scope.model.arriveDate && $scope.model.arriveTime ? moment(arriveDateTime).utc().format('YYYY-MM-DD HH:mm:ss') : null;

          $scope.isLoading = true;
          verifySupervisorScan('route-details', null, $scope)
            .then((supervisorInfo) => {
              $scope.loading = true;
              callback({
                truck: $scope.model.truck ? $scope.model.truck.Value : $scope.model.truck,
                messenger: $scope.model.messenger ? $scope.model.messenger.Value : $scope.model.messenger,
                driver: $scope.model.driver ? $scope.model.driver.Value : $scope.model.driver,
                guard: $scope.model.guard ? $scope.model.guard.Value : $scope.model.guard,
                leaveTime: UTCLeaveTime,
                arriveTime: UTCArriveTime,
                begMiles: !$scope.model.curBegMiles ? $scope.model.begMiles : null,
                endMiles: !$scope.model.curEndMiles ? $scope.model.endMiles : null,
                modal: routeDetailsModal
              });
              $scope.isLoading = false;
              if (supervisorInfo) supervisorInfo.modal.close();
            })
        }
        init()
      }]
    })
    routeDetailsModal.result.then(() => {
    }, function () {
      negative({
        modal: routeDetailsModal
      });
    })
  }

  let routeMessenger = (route, date, callback, negative) => {
    let routeMessengerModal = $uibModal.open({
      template: routeMessengerTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', 'UsersService', 'User', 'RouteDetailService', '$q', function ($scope, UsersService, User, RouteDetailService, $q) {
        $scope.loading = false;
        $scope.model = {
          routeId: route.routeId,
          routeDate: date,
          messenger: null,
          branchId: User.getUser().branchId,
        };

        const userSearchObj = (searchKey, displayAppUserOnly = undefined) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: "branchId",
                  condition: "=",
                  data: $scope.model.branchId
                },
                {
                  group: {
                    rules: [
                      {
                        field: "id",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "firstName",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "lastName",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      }
                    ],
                    operator: "OR"
                  }
                }
              ],
              operator: 'AND',
            }
          };
          if (searchKey) {
            searchObj.orderBy = {
              order: [
                ['id', 'ASC']
              ]
            };
          }
          if (displayAppUserOnly) {
            searchObj.queryJSON.rules.push({
              field: "downloadToHHT",
              condition: "=",
              data: true
            });
          }
          return searchObj;
        };

        const mapData = (item) => {
          if (item == null) return item;
          item.Key = item.id + " | " + item.firstName + ' ' + item.lastName;
          item.Value = item.id;
          return item;
        };

        const mappingUserData = (items, searchKey, model) => {
          let itemArray = [];
          items.map((item) => {
            item.Key = item.id + " | " + item.firstName + ' ' + item.lastName;
            item.Value = item.id;
            if (!searchKey) {
              if (model) {
                if (item.id !== model.Value) {
                  itemArray.push(item);
                }
              } else {
                itemArray.push(item);
              }
            } else {
              itemArray.push(item);
            }
          });
          return itemArray;
        };

        const routeSearchObj = {
          queryJSON: {
            rules: [
              {
                field: "branchId",
                condition: "=",
                data: $scope.model.branchId
              },
              {
                field: "routeId",
                condition: "=",
                data: $scope.model.routeId
              },
              {
                field: "routeDate",
                condition: "=",
                data: $scope.model.routeDate
              },
            ],
            operator: 'AND',
          }
        };

        const init = () => {
          $scope.loading = true;
          RouteDetailService.all(routeSearchObj, 0, 1000)
            .then((data) => {
              if (data && data.results && data.results.length > 0) {
                const routeData = data.results[0];
                $scope.model.messenger = mapData(routeData.messenger);
              }
              $scope.getMessangerData('', 0);
            })
            .finally(() => {
              $scope.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        };

        $scope.getMessangerData = (searchKey, offset) => {
          let searchObj = userSearchObj(searchKey, true);
          if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
            offset = offset - 1;
          }
          UsersService.all(searchObj, offset, AppConstant.defaultPageLimit)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.messangerTotalRecord = data.total;
                $scope.messangerData = mappingUserData(data.results, searchKey, $scope.model.messenger);
                if (!searchKey && $scope.model.messenger) {
                  $scope.messangerData.unshift($scope.model.messenger);
                }
              }
              else {
                const messanger = mappingUserData(data.results, searchKey, $scope.model.messenger);
                $scope.messangerData = $scope.messangerData.concat(messanger);
              }
            });
        };

        $scope.messengerSelected = () => {
        };

        $scope.getMessengerAddress = () => {
          const m = $scope.model.messenger;
          if (m && (m.address || m.city || m.state || m.zip)) {
            return `${m.address || ''}, ${m.city || ''}, ${m.state || ''} ${m.zip || ''}`;
          }
          return null;
        };

        $scope.cancel = () => {
          negative({
            modal: routeMessengerModal
          });
        };

        $scope.ok = () => {
          callback({
            messengerId: $scope.model.messenger ? $scope.model.messenger.Value : null,
            modal: routeMessengerModal
          });
        };

        init();
      }]
    });
    routeMessengerModal.result.then(() => {}, function () {
      negative({
        modal: routeMessengerModal
      });
    });
  };

  // release location from Hold
  let locationHoldRelease = (heldLocation, allowSupervisorScan, callback, negative) => {
    let locationHoldReleaseModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: locationHoldReleaseTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', '$location', 'MessageService', 'User', '$q', ($scope, $translate, $location, MessageService, User, $q) => {

        $scope.loading = false;
        $scope.model = {
          locationId: '',
          branchId: User.getUser().branchId,
          supervisorId: '',
          comment: '',
          selectedReason: '',
          allowSupervisorScan: allowSupervisorScan,
          userDetails: User.getUser()
        };

        $scope.model.locationId = heldLocation.locationId || '';

        const getErrorMessage = (err) => {
          if (err && err.data && err.data.message) {
            return $translate.instant('error.' + err.data.message) || err.data.message;
          }
          else {
            return err.toString();
          }
        }

        const init = () => {
          $scope.loading = true;
          const loggedInUser = User.getUser();
          if ($scope.model.locationId) {
            const searchObj = generateQueryForReason(['NP']);

            MessageService.all(loggedInUser.languageId, searchObj, 0, 1000).then((reasonObjList) => {
              $scope.model.selectedReason = heldLocation.reason
              heldLocation.reasons = reasonObjList.results;
              $scope.results = reasonObjList.results.map((m) => m.description);
            })
              .catch(function (err) {
                console.error(err);
                $scope.model.error = getErrorMessage(err);
              })
              .finally(() => {
                $scope.loading = false;
              })
          } else {
            $scope.loading = false;
          }

        }

        $scope.cancel = () => {
          // locationHoldReleaseModal.close();
          negative({
            modal: locationHoldReleaseModal
          })
        }

        $scope.validateSupervisorScan = () => {
          if ($scope.model.allowSupervisorScan) {
            let errorMsg = $translate.instant('users.supervisor_scan_error', {
              firstName: $scope.model.userDetails.firstName,
              lastName: $scope.model.userDetails.lastName
            })

            return confirm({
              header: $translate.instant('errorModal.title'),
              message: $translate.instant(errorMsg),
              callback: ({
                modal,
              }) => {
                $scope.ok();
                modal.close();
              },
              type: 'danger',
              buttons: ['common.ok']
            })
          }
          else {
            $scope.ok();
          }
        }

        $scope.ok = (err) => {
          $scope.isLoading = true;
          // confirmSupervisor('location-hold-release', null, ({ modal, supId }) => {
          verifySupervisorScan('location-hold-release', null, $scope)
            .then((supervisorInfo) => {
              $scope.model.supervisorId = supervisorInfo ? supervisorInfo.supId : null;
              $scope.model.loading = true;
              callback({
                supervisorId: supervisorInfo ? supervisorInfo.supId : null,
                comment: $scope.model.comment,
                modal: locationHoldReleaseModal
              });
              // modal.close()
              if (supervisorInfo) supervisorInfo.modal.close();
              $scope.isLoading = false;
              // }, ({ modal }) => {
              //   $scope.isLoading = false;
              //   modal.close()
              // })
            })
        }
        init()
      }]
    })
    rejectModal(locationHoldReleaseModal, negative)
  }

  let translateMessage = (messageId, messageType, callback, negative) => {
    let translateMessageModal = $uibModal.open({
      template: translateMessageTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$rootScope', 'MessageService', 'LanguageService', 'User', '$q', '$translate', function ($scope, $rootScope, MessageService, LanguageService, User, $q, $translate) {

        $scope.model = {
          message: null,
          messageId: messageId,
          messageType: messageType
        };
        $scope.toggleSwitchUI = {
          size: 'small',
          label: {
            on: $translate.instant('common.yes'),
            off: $translate.instant('common.no')
          },
          onColor: 'success',
          offColor: 'danger'
        };
        const loggedInUser = User.getUser();
        const init = () => {
          $scope.model.loading = true;
          MessageService.getMessageByMessageId(loggedInUser.languageId, $scope.model.messageId, $scope.model.messageType)
            .then((data) => {
              $scope.model.message = data.results;
              $scope.model.message.defaultSelection = !!$scope.model.message.defaultSelection;
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                translateMessageModal.close();
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.cancel = () => {
          translateMessageModal.close();
        }

        $scope.ok = () => {
          callback({
            updatedMessages: $scope.model.message,
            modal: translateMessageModal
          });
          translateMessageModal.close();
        }
        init();
      }]
    })
    rejectModal(translateMessageModal, negative)
  }

  // route transfer view
  let routeTransfer = (routeId, day, vaultDate, callback, negative) => {

    let routeTransferModal = $uibModal.open({
      template: routeTransferTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', 'RouteService', '$q', '$translate', 'BranchService', 'RouteDetailService', 'User', '$state', function ($scope, RouteService, $q, $translate, BranchService, RouteDetailService, User, $state) {

        $scope.model = {

          days: [

            { label: $translate.instant('location.sun'), value: 'Sun' },
            { label: $translate.instant('location.mon'), value: 'Mon' },
            { label: $translate.instant('location.tues'), value: 'Tue' },
            { label: $translate.instant('location.wed'), value: 'Wed' },
            { label: $translate.instant('location.thurs'), value: 'Thu' },
            { label: $translate.instant('location.fri'), value: 'Fri' },
            { label: $translate.instant('location.sat'), value: 'Sat' },
            { label: $translate.instant('location.hol'), value: 'Hol' }
          ],

          routeDay: [

            { label: $translate.instant('location.sun'), value: 'Sun' },
            { label: $translate.instant('location.mon'), value: 'Mon' },
            { label: $translate.instant('location.tues'), value: 'Tue' },
            { label: $translate.instant('location.wed'), value: 'Wed' },
            { label: $translate.instant('location.thurs'), value: 'Thu' },
            { label: $translate.instant('location.fri'), value: 'Fri' },
            { label: $translate.instant('location.sat'), value: 'Sat' },
            { label: $translate.instant('location.hol'), value: 'Hol' }
          ],

          selectedDay: 'Mon',
          selectedDayForMapTwo: 'Mon',

          routeSequenceLocations: [],
          routeSequenceLocationData: [],
          routeSequenceData: [],
          locationListForMap: [],
          locationListForSecondMap: [],
          routeSequenceLocData: [],
          routesList: [],
          actualLong: "",
          actualLat: "",
          locationInfo: "",
          map: "",
          rawId: "",
          branch: "",
          route: null,
          loadingRouteSequence: false,
          loadroutes: true,
          routePosition: 0,
          routePositionForSecondMap: 0,
          branch: "",
          routeChange: [],
          dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        };
        $scope.isLocDuplicate = {
          isLocDuplicate: false,
          message: ''
        };
        const init = () => {
          $scope.model.selectedDay = day;
          $scope.model.selectedDayForMapTwo = day;
          $scope.selectedDayOne = true;
          $scope.selectedDayTwo = true;

          setTimeout(() => {

            // Default Map
            $scope.mapOne = L.map('mapOne', {
              center: [39.68649209557518, -101.48273981764913],
              zoom: 4
            });

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
              attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo($scope.mapOne);

            // Second Map
            $scope.mapTwo = L.map('mapTwo', {
              center: [39.68649209557518, -101.48273981764913],
              zoom: 4
            });

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
              attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo($scope.mapTwo);

            // Get route info for default map 
            RouteService.get(routeId)
              .then((data) => {
                $scope.model.rawId = data.id
                $scope.model.branch = data.branchId
                $scope.loadRouteSequence($scope.model.rawId, $scope.model.branch, $scope.model.selectedDay)
                loadRoutes();
              })

          }, 100)
        }

        // Load route list branch vise 
        const loadRoutes = () => {
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'branchId',
                  condition: '=',
                  data: $scope.model.branch
                },
              ],
              operator: 'AND'
            }
          }

          return RouteService.all(searchObj, 0, 1000)
            .then((routes) => {
              $scope.model.routesList = routes;
            })
            .catch((err) => {
              $scope.loading = false;
            })
        }
        // get last released date of route
        const getRouteReleasedData = (routeId) => {
          const routeSearchObj = {
            queryJSON: {
              rules: [
                {
                  field: "routeId",
                  condition: "=",
                  data: routeId
                },
                {
                  field: "routeDate",
                  condition: "=",
                  data: vaultDate
                },
              ],
              operator: 'AND',
            }
          }

          return RouteDetailService.all(routeSearchObj, 0, 1000)
            .then((routeDetails) => {
              $scope.lastReleasedDay = routeDetails.results[0].routeDate;
              $scope.day = new Date($scope.lastReleasedDay)
              $scope.lastReleasedDayName = $scope.model.dayOfWeek[$scope.day.getDay()]
            })
            .catch((err) => {
              $scope.loading = false;
            })
        }

        // Get route sequence for route
        const getRouteSequence = (routeId, branchId, selectedDay) => {
          $scope.loadingRouteSequence = true;
          RouteService.getRouteSequence(routeId, branchId, selectedDay)
            .then((routeSequenceLocations) => {
              $scope.loadingRouteSequence = false;

              if ($scope.model.loadroutes == true) {
                $scope.model.routeSequenceLocationData = routeSequenceLocations;
                $scope.model.routeSequenceData = $scope.model.routeSequenceLocationData

                $scope.routeSequenceDataCount = $scope.model.routeSequenceLocationData.length;
                $scope.isFlag = true;
                $scope.model.locationListForMap = []

                setMarkers($scope.model.routeSequenceData, $scope.model.routePosition, $scope.actualLat, $scope.actualLong,
                  $scope.locationInfo, $scope.mapOne, $scope.model.locationListForMap)
              }
              else {
                $scope.model.routeSequenceForMapTwo = routeSequenceLocations;
                $scope.model.routeSequenceLocData = $scope.model.routeSequenceForMapTwo

                $scope.routeSequenceLocDataCount = $scope.model.routeSequenceLocData.length;
                $scope.isFlag = false;
                $scope.model.locationListForSecondMap = []

                setMarkers($scope.model.routeSequenceLocData, $scope.model.routePositionForSecondMap, $scope.actualLatitude, $scope.actualLongitute,
                  $scope.locationInfoForSecondMap, $scope.mapTwo, $scope.model.locationListForSecondMap)
              }
            })
            .catch((err) => {
              $scope.loadingRouteSequence = false;
              console.log(err);
            })
            .finally(() => {
              $scope.loadingRouteSequence = false;
            })
        }

        // load routes sequence for default map
        $scope.loadRouteSequence = (routeId, branchId, selectedDay) => {
          $scope.lastReleasedDayName = null;
          $scope.model.loadingRouteSequence = true;
          $scope.model.loadroutes = true;
          $scope.model.locationListForMap.forEach((id) => {
            $scope.mapOne.removeLayer(id)
          });
          getRouteSequence(routeId, branchId, selectedDay)
          getRouteReleasedData($scope.model.rawId)
        }

        // load routes sequence for selected route
        $scope.routeChange = (route, branchId, selectedDayForMapTwo) => {
          $scope.lastReleasedDayName = null;
          $scope.model.loadingRouteSequence = true;
          $scope.model.loadroutes = false;
          $scope.model.locationListForSecondMap.forEach((id) => {
            $scope.mapTwo.removeLayer(id)
          });
          getRouteSequence(route, branchId, selectedDayForMapTwo)
          getRouteReleasedData($scope.model.route)
        }

        // reRender map on route transfer
        $scope.refreshMap1 = () => {
          $scope.model.locationListForMap.forEach((ids, index) => {
            $scope.mapOne.removeLayer(ids)
          });
          $scope.model.locationListForMap = [];

          setMarkers($scope.model.routeSequenceData, $scope.model.routePosition, $scope.actualLat, $scope.actualLong,
            $scope.locationInfo, $scope.mapOne, $scope.model.locationListForMap)
        }

        // reRender map on route transfer
        $scope.refreshMap2 = () => {
          $scope.model.locationListForSecondMap.forEach((ids, index) => {
            $scope.mapTwo.removeLayer(ids);
          });

          $scope.model.locationListForSecondMap = [];

          setMarkers($scope.model.routeSequenceLocData, $scope.model.routePositionForSecondMap, $scope.actualLatitude, $scope.actualLongitute,
            $scope.locationInfoForSecondMap, $scope.mapTwo, $scope.model.locationListForSecondMap)
        }

        // Set markers for map
        const setMarkers = (routeSequenceData, routePosition, actualLat, actualLong, locationInfo, mapFor, locationListForMap) => {

          routePosition = routePosition || 0

          setTimeout(() => {
            routeSequenceData.forEach((sequenceData) => {

              if (sequenceData && sequenceData.lat && sequenceData.long) {
                routePosition += 1;
                actualLat = sequenceData.lat;
                actualLong = sequenceData.long;

                locationInfo = '<strong>' + sequenceData.name + '</strong>' + '<br>' + sequenceData.address + ' - ' + sequenceData.zip +
                  '<br>' + sequenceData.city + ', ' + sequenceData.state;

                const id = L.marker([actualLat, actualLong],
                  {
                    icon: new L.AwesomeNumberMarkers({
                      number: routePosition,
                      markerColor: "blue"
                    })
                  })
                  .addTo(mapFor)
                  .bindPopup(locationInfo)

                id.on('mouseover', function () {
                  id.openPopup();
                });

                id.on('mouseout', function () {
                  id.closePopup();
                });

                locationListForMap.push(id);
              }
            })

            if ($scope.routeSequenceDataCount !== $scope.model.routeSequenceData.length
              || $scope.routeSequenceLocDataCount !== $scope.model.routeSequenceLocData.length) {

              $scope.routeSequenceDataCount = $scope.model.routeSequenceData.length;
              $scope.routeSequenceLocDataCount = $scope.model.routeSequenceLocData.length;
              if (!$scope.isFlag) {
                $scope.isFlag = true;
                $scope.refreshMap1();
                $scope.refreshMap2();
              }
            }
          }, 100)
        }

        // Load route sequence based on day (mapOne)
        $scope.selectDay = (day) => {
          if (day.label === $scope.lastReleasedDayName) return;

          $scope.model.locationListForMap.forEach((id) => {
            $scope.mapOne.removeLayer(id)
          });
          $scope.model.locationListForMap = [];
          $scope.model.routeChange = [];
          $scope.model.selectedDay = day.value;
          $scope.selectedDayOne = true;
          $scope.loadRouteSequence($scope.model.rawId, $scope.model.branch, $scope.model.selectedDay)
        }

        // Load route sequence based on day (mapTwo)
        $scope.selectDayForMapTwo = (routeDay) => {
          if (routeDay.label === $scope.lastReleasedDayName) return;

          $scope.model.locationListForSecondMap.forEach((id) => {
            $scope.mapTwo.removeLayer(id)
          });
          $scope.model.locationListForSecondMap = [];
          $scope.model.selectedDayForMapTwo = routeDay.value;
          $scope.model.routeChange = [];
          $scope.selectedDayTwo = true;
          $scope.routeChange($scope.model.route, $scope.model.branch, $scope.model.selectedDayForMapTwo)
        }

        // change route sequences
        $scope.routeSequenceLocationMoved = (index, routeSeq, routePosition, actualLat, actualLong, locationInfo, map, locationListForMap, pick) => {
          $scope.isFlag = false
          $scope.isLocDuplicate.isDuplicate = false;
          $scope.isLocDuplicate.message = '';
          const data = {
            id: routeSeq[index].id
          };

          data.branchId = routeSeq[index].branchId;

          if (pick === 'one') {
            var valueArr = $scope.model.routeSequenceLocData.map((item) => { return item.id });
            var isDuplicate = valueArr.some((item, idx) => {
              return valueArr.indexOf(item) != idx
            });
            if (isDuplicate) {
              showDuplicateMsg(routeSeq[index].id);
              $scope.model.routeSequenceLocData = Object.values($scope.model.routeSequenceLocData.reduce((acc, cur) => Object.assign(acc, { [cur.id]: cur }), {}))
              return;
            }
            data.transferredFrom = $scope.model.rawId;
            data.transferredTo = $scope.model.route;
            data[`defRoute${$scope.model.selectedDay}Id`] = null;
            data[`defRoute${$scope.model.selectedDayForMapTwo}Id`] = $scope.model.route;
            if ($scope.model.routeChange.length > 0) {
              var isCheck = $scope.model.routeChange.some((routeChange) => {
                return routeChange.id == routeSeq[index].id && routeChange[`defRoute${$scope.model.selectedDay}Id`] == $scope.model.rawId;
              })
              if (!isCheck) {
                $scope.model.routeChange.push(data);
              }
            } else {
              $scope.model.routeChange.push(data);
            }
          } else {
            var valueArr = $scope.model.routeSequenceData.map((item) => { return item.id });
            var isDuplicate = valueArr.some((item, idx) => {
              return valueArr.indexOf(item) != idx
            });
            if (isDuplicate) {
              showDuplicateMsg(routeSeq[index].id);
              $scope.model.routeSequenceData = Object.values($scope.model.routeSequenceData.reduce((acc, cur) => Object.assign(acc, { [cur.id]: cur }), {}))
              return;
            }
            data.transferredFrom = $scope.model.route;
            data.transferredTo = $scope.model.rawId;
            data[`defRoute${$scope.model.selectedDayForMapTwo}Id`] = null;
            data[`defRoute${$scope.model.selectedDay}Id`] = $scope.model.rawId;
            if ($scope.model.routeChange.length > 0) {
              var isCheck = $scope.model.routeChange.some((routeChange) => {
                return routeChange.id == routeSeq[index].id && routeChange[`defRoute${$scope.model.selectedDayForMapTwo}Id`] == $scope.model.route;
              })
              if (!isCheck) {
                $scope.model.routeChange.push(data);
              }
            } else {
              $scope.model.routeChange.push(data);
            }
          }

          routeSeq.splice(index, 1);
          setMarkers(routeSeq, routePosition, actualLat, actualLong, locationInfo, map, locationListForMap)
        }

        const showDuplicateMsg = (locationId) => {
          $scope.isLocDuplicate.isDuplicate = true;
          $scope.isLocDuplicate.message = locationId;
          setTimeout(() => {
            $scope.isLocDuplicate.isDuplicate = false;
            $scope.isLocDuplicate.message = '';
            $scope.$digest();
          }, 2000)
        }
        $scope.ok = () => {
          callback({
            modal: routeTransferModal,
            routeChangeData: $scope.model.routeChange,
            routeChangeSequence: $scope.model.routeSequenceLocData,
            routeDay: $scope.selectedDayOne == true ? $scope.model.selectedDay : $scope.model.selectedDay,
            routeDay: $scope.selectedDayTwo == true ? $scope.model.selectedDayForMapTwo : $scope.model.selectedDayForMapTwo,
            routeSequence: $scope.model.routeSequenceData,
          })
          routeTransferModal.close();
        }

        $scope.cancel = () => {
          // routeTransferModal.close();
          negative({
            modal: routeTransferModal
          })
        }

        init()
      }]
    })
    rejectModal(routeTransferModal, negative)
  }

  let changePassword = (model, callback, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: changePasswordTemplate,
      size: 'md',
      controller: ['$scope', function ($scope) {
        $scope.modelDetails = model;
        $scope.ok = (userId, data) => {
          callback({
            modal
          });
        }

        $scope.cancel = (err) => {
          negative({
            modal
          });
        }
      }]
    })
  }

  let timeoutCountdown = (model, callback, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: timeoutCountdownTemplate,
      size: 'md',
      controller: ['$scope', function ($scope) {
        $scope.modelDetails = model;
        $scope.ok = (userId, data) => {
          callback({
            modal
          })
        }

        $scope.cancel = (err) => {
          negative({
            modal
          })
        }
      }]
    })

    const events = ['click', 'touchstart', 'mousemove', 'keypress', 'keydown'];

    const closeModal = () => {
      events.forEach(event => {
        window.removeEventListener(event, closeModal);
      });
      modal.close();
    };

    events.forEach(event => {
      window.addEventListener(event, closeModal);
    });
  }

  let orderPack = (orderShipment, branchId, branchFundingSourceId, account, orderData, deliveryToShipmentTypes, callback, negative, currencySymbol) => {
    let orderPackModal = $uibModal.open({
      template: orderPackTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$translate', 'BranchService', 'SetupService', 'BulkCashService', 'OrderPackingService', 'ShipmentService', 'User', '$q', 'DateUtil', 'Sound', '$state', 'CommonLayoutService',
        function ($scope, $translate, BranchService, SetupService, BulkCashService, OrderPackingService, ShipmentService, User, $q, DateUtil, Sound, $state, CommonLayoutService) {
          $scope.loading = false;
          $scope.checkOnlyOnce = false;
          $scope.checkLength = 0;
          $scope.routeLists = [];
          $scope.bagScanError = "";
          $scope.toLocationId = orderShipment.toLocationId;
          $scope.duplicateTrackingIds = [];
          const orderTypeOpt = (CommonLayoutService.orderTypes() || []).find(o => o.value === orderShipment.orderType);
          $scope.model = {
            routeId: null,
            vaultDate: orderShipment.vaultDate ? DateUtil.convertToDate(orderShipment.vaultDate) : null,
            total: orderShipment.amount,
            sourceType: orderShipment.sourceType,
            orderId: orderShipment.id,
            orderNo: orderData.orderNo,
            orderTypeLabel: orderTypeOpt ? orderTypeOpt.key : (orderShipment.orderType || ''),
            deliveryTrackingIds: [], 
            multiDenomPackableDenoms: [], 
            singleDenomPackableDenoms: [],
            atmSingleDenomShipments: [],
            isPackableOrder: orderShipment.sourceType === 'PackableOrder',
            packCoinSeparately: !!(orderShipment.toLocation && orderShipment.toLocation.packCoinSeparately),
            hasCoinMultiDenom: false,
            hasCashMultiDenom: false,
            toLocation: orderShipment.toLocation.name,
            toAddress: orderShipment.toLocation.address + ", " + orderShipment.toLocation.city + orderShipment.toLocation.state + ", " + orderShipment.toLocation.zip,
            denomIcon: orderShipment.denominationId,
            denomAmount: orderShipment.amount,
            trackingIdDelivery: '',
            deliveryToShipmentTypes: deliveryToShipmentTypes,
            trackingIdResidual: '',
            shipmentData: orderShipment.toLocation,
            multipleDenoms: orderData.validDenominations,
            invalidDenominations: orderData.invalidDenominations,
            branch: User.getUser().branchId,
            supervisorId: User.getUser().id,
            valutDate: '',
            ledgerTransaction: [],
            shipmentsValutDate: DateUtil.getUTCDate(orderShipment.vaultDate),
            unassignedRouteId: '',
            shipment: orderShipment,
            scanLimit: '',
            lastScannedResidualId: '',
            lastScannedLoadId: '',
            isAutoGenerateResidualId: false,
            isAutoGenerateLoadId: false,
            residualSuffix: 'R',
            loadSuffix: 'L',
            branchVaultDate: '',
            routeList: [],
            routeId: orderShipment.routeId,
            gettingRoutes: false,
            acl: {},
            hasACL: {},
            permissionKey: 'order_packing',
            currencySymbol: currencySymbol || '$',
            isAtmSingleDenomOnly: false,
            useAtmCassetteMode: false,
            maxCassettes: null,
            usedCassettes: 0,
            remainingCassettes: null,
            noCassettesAvailable: false,
            atmCassetteCapacityError: false
            // successAudio: Sound.successBeep(),
            // errorSound: Sound.errorBeep(),
            // audio: audio,
            // successAudio: successAudio
          }

          $scope.model.ledgerTransaction.push({
            currencyIcon: orderShipment.denomination.currencyId,
            denominations: [{
              icon: orderShipment.denomination.id,
              amount: orderShipment.coinFlag ? -Math.abs(orderShipment.amount) : -Math.abs(parseInt(orderShipment.amount)),
              faceValue: orderShipment.denomination.faceValue,
              orderPack: true,
              orderNo: orderShipment.orderNo
            }],
            ledger: account
          })

          const getAtmCassetteCount = () => {
            const loc = orderShipment && orderShipment.toLocation ? orderShipment.toLocation : null;
            const isAtmCassetteOn = loc && (loc.scanATMCassette === true || loc.scanATMCassette === 1);
            const maxCassettes = loc && loc.maxCassettes != null && loc.maxCassettes !== '' ? parseInt(loc.maxCassettes, 10) : null;
            if (!isAtmCassetteOn || !maxCassettes || maxCassettes < 1) return null;
            return Math.min(maxCassettes, 6);
          };

          const getSplitFaceValue = (item) => {
            if (item && item.faceValue != null && Number(item.faceValue) > 0) return Number(item.faceValue);
            const denom = item && item.shipment && item.shipment.denomination ? item.shipment.denomination : null;
            const faceValue = denom && denom.faceValue != null ? Number(denom.faceValue) : null;
            return faceValue && faceValue > 0 ? faceValue : null;
          };

          const parseCassetteAmount = (value) => {
            if (value === null || value === undefined || value === '') return null;
            const amount = Number(String(value).replace(/[$,\s]/g, ''));
            return isFinite(amount) ? amount : null;
          };

          const getAtmDenomId = (item) => {
            if (!item || !item.shipment) return null;
            return item.shipment.denominationId || (item.shipment.denomination && item.shipment.denomination.id) || null;
          };

          // ATM Cassette on toLocation forces single-denom packing (CARD 7038), ignoring BFSD multi-denom
          const isAtmCassetteOn = !!(orderShipment.toLocation
            && (orderShipment.toLocation.scanATMCassette === true || orderShipment.toLocation.scanATMCassette === 1));

          const loadAtmCassetteUsageSnapshot = () => {
            $scope.model.usedCassettes = 0;
            $scope.model.remainingCassettes = null;
            $scope.model.noCassettesAvailable = false;
            if ($scope.model.sourceType !== 'ATMLoad' || !isAtmCassetteOn) return Promise.resolve();
            const toLocationId = orderShipment.toLocationId || (orderShipment.toLocation && orderShipment.toLocation.id);
            if (!orderData.orderNo || !toLocationId) return Promise.resolve();
            return OrderPackingService.getOrderCassetteUsage(orderData.orderNo, toLocationId)
              .then((usage) => {
                $scope.model.usedCassettes = Number(usage && usage.usedCassettes) || 0;
                if (usage && usage.maxCassettes != null) {
                  $scope.model.maxCassettes = Math.max(Number(usage.maxCassettes), 0);
                }
                if (usage && usage.remainingCassettes != null) {
                  $scope.model.remainingCassettes = Math.max(Number(usage.remainingCassettes), 0);
                }
              })
              .catch(() => Promise.resolve());
          };

          const initializeAtmSingleDenomShipments = () => {
            $scope.model.atmSingleDenomShipments = [];
            $scope.model.atmCassetteRows = [];
            $scope.model.useAtmCassetteMode = false;
            $scope.model.atmCassetteCapacityError = false;
            $scope.model.noCassettesAvailable = false;
            if ($scope.model.sourceType !== 'ATMLoad') return;
            const cassetteCount = getAtmCassetteCount();
            $scope.model.useAtmCassetteMode = !!cassetteCount;
            // Prefer fresh snapshot max when available; otherwise use location max.
            if ($scope.model.maxCassettes == null) {
              $scope.model.maxCassettes = cassetteCount;
            }
            // Snapshot remaining (if present) only controls available rows for this pack.
            const remainingCassettes = $scope.model.remainingCassettes != null
              ? Math.max(Number($scope.model.remainingCassettes), 0)
              : cassetteCount;
            $scope.model.remainingCassettes = remainingCassettes;
            $scope.model.noCassettesAvailable = !!cassetteCount && remainingCassettes <= 0;
            const shipmentList = $scope.model.shipment && Array.isArray($scope.model.shipment.shipments)
              ? $scope.model.shipment.shipments
              : ($scope.model.shipment && ($scope.model.shipment.shipmentId || $scope.model.shipment.id) ? [$scope.model.shipment] : []);
            shipmentList.forEach((s) => {
              const isMultiDenomPackable = s.multiDenomPackable === 1 || s.multiDenomPackable === true;
              // ATM Cassette ON = single-denom; + maxCassettes = cassette UI
              if (!isAtmCassetteOn && isMultiDenomPackable) return;
              const totalAmount = Number(s.amount || 0);
              const maxLoad = (s.maxLoad != null && s.maxLoad !== '') ? Number(s.maxLoad) : null;
              const denom = s.denomination || {};
              const splits = [];
              // Shared pool (maxCassettes): rows built below; legacy mode auto-chunks per-denom splits here.
              if (!cassetteCount) {
                if (maxLoad != null && maxLoad > 0 && totalAmount > maxLoad) {
                  let remaining = totalAmount;
                  while (remaining > 0) {
                    const chunk = Math.min(remaining, maxLoad);
                    splits.push({ amount: chunk, trackingId: '', trackingIdResidual: '' });
                    remaining -= chunk;
                  }
                } else {
                  splits.push({ amount: totalAmount, trackingId: '', trackingIdResidual: '' });
                }
              }
              $scope.model.atmSingleDenomShipments.push({
                shipment: s,
                amount: totalAmount,
                denomIcon: s.denominationId || denom.id,
                denomLabel: (denom.currencyId || '') + (denom.faceValue != null ? (' $' + denom.faceValue) : ''),
                faceValue: denom.faceValue != null ? Number(denom.faceValue) : null,
                maxLoad,
                useCassetteMode: !!cassetteCount,
                splits
              });
            });

            if (cassetteCount) {
              // Shared cassette pool: sum of ceil(amount/maxLoad) per denom must fit remaining cassettes.
              const totalCassettesNeeded = $scope.model.atmSingleDenomShipments.reduce((sum, item) => {
                if (!item.maxLoad || item.maxLoad <= 0) return sum + 1;
                return sum + Math.ceil(item.amount / item.maxLoad);
              }, 0);
              $scope.model.atmCassetteCapacityError = totalCassettesNeeded > remainingCassettes;
              $scope.model.atmCassetteRows = Array.from({ length: remainingCassettes }, () => ({
                denominationId: null,
                amount: null,
                trackingId: '',
                trackingIdResidual: '',
                lastAutoResidual: ''
              }));
              if ($scope.model.atmSingleDenomShipments.length === 1 && $scope.model.atmCassetteRows.length) {
                const denomId = getAtmDenomId($scope.model.atmSingleDenomShipments[0]);
                if (denomId) $scope.model.atmCassetteRows[0].denominationId = denomId;
              }
            }
          };

          $scope.getAtmCassetteDenomLabel = (item) => {
            if (!item) return '';
            if (item.denomLabel) return item.denomLabel;
            const denom = item.shipment && item.shipment.denomination ? item.shipment.denomination : null;
            if (!denom) return item.denomIcon || '';
            return (denom.currencyId || '') + (denom.faceValue != null ? (' $' + denom.faceValue) : '');
          };

          $scope.getAtmCassetteRowDenom = (row) => {
            if (!row || !row.denominationId) return null;
            return ($scope.model.atmSingleDenomShipments || []).find((item) => getAtmDenomId(item) === row.denominationId) || null;
          };

          $scope.selectAtmCassetteRowDenom = (row, denomItem) => {
            if (!row || !denomItem) return;
            const denomId = getAtmDenomId(denomItem);
            if (row.denominationId !== denomId) {
              row.denominationId = denomId;
              const isDecash = $scope.model.shipment && ($scope.model.shipment.orderType === 'P' || $scope.model.shipment.orderType === 'T');
              row.amount = isDecash ? 0 : null;
              row.trackingId = '';
              row.trackingIdResidual = '';
              row.lastAutoResidual = '';
            }
            row.denomPopoverOpen = false;
            $scope.checkDuplicateTrackingIds();
          };

          $scope.isAtmCassetteSplitActive = (row) => {
            if (!$scope.model.useAtmCassetteMode || !row) return false;
            const denomItem = $scope.getAtmCassetteRowDenom(row);
            if (!denomItem) return false;
            const isDecash = $scope.model.shipment && ($scope.model.shipment.orderType === 'P' || $scope.model.shipment.orderType === 'T');
            // T/P: once denom is selected, unlock residual (amount stays $0 / greyed)
            if (isDecash) {
              if (row.amount == null || row.amount === '') row.amount = 0;
              return true;
            }
            const amount = parseCassetteAmount(row.amount);
            if (amount == null || amount <= 0) return false;
            const faceValue = getSplitFaceValue(denomItem) || denomItem.faceValue;
            if (faceValue && Math.round(amount * 100) % Math.round(faceValue * 100) !== 0) return false;
            if (denomItem.maxLoad != null && denomItem.maxLoad > 0 && amount > denomItem.maxLoad) return false;
            return true;
          };

          $scope.onAtmCassetteAmountChange = (row) => {
            if (!row) return;
            if (!$scope.isAtmCassetteSplitActive(row)) {
              row.trackingId = '';
              row.trackingIdResidual = '';
              row.lastAutoResidual = '';
            }
            $scope.checkDuplicateTrackingIds();
          };

          // T/P: residual drives load ID (same pattern as autoGenerateLoadId)
          $scope.onAtmCassetteResidualChange = (row) => {
            if (!row || !$scope.model.isAutoGenerateLoadId) return;
            const residual = row.trackingIdResidual ? String(row.trackingIdResidual).trim() : '';
            row.trackingId = residual ? residual.concat($scope.model.loadSuffix) : '';
          };

          $scope.atmCassetteDenomErrors = () => {
            if (!$scope.model.useAtmCassetteMode || !Array.isArray($scope.model.atmCassetteRows)) return [];
            const labels = new Set();
            $scope.model.atmCassetteRows.forEach((row) => {
              const denomItem = $scope.getAtmCassetteRowDenom(row);
              if (!denomItem) return;
              const amount = parseCassetteAmount(row.amount);
              if (amount != null && amount > 0 && denomItem.maxLoad != null && denomItem.maxLoad > 0 && amount > denomItem.maxLoad) {
                labels.add($scope.getAtmCassetteDenomLabel(denomItem));
              }
            });
            return Array.from(labels);
          };

          $scope.isAtmCassettePackReady = () => {
            if (!$scope.model.useAtmCassetteMode) return true;
            if ($scope.model.noCassettesAvailable || $scope.model.atmCassetteCapacityError) return false;
            if (!$scope.model.atmSingleDenomShipments || !$scope.model.atmSingleDenomShipments.length) return false;
            if ($scope.atmCassetteDenomErrors().length) return false;

            const rows = $scope.model.atmCassetteRows || [];
            // Any cassette with an amount entered must be fully valid (denom, amount rules, both tracking IDs)
            for (let i = 0; i < rows.length; i++) {
              const row = rows[i];
              const hasAmountEntry = row.amount !== null && row.amount !== undefined && row.amount !== '';
              if (!hasAmountEntry) continue;
              if (!$scope.isAtmCassetteSplitActive(row)) return false;
              const loadId = row.trackingId ? String(row.trackingId).trim() : '';
              const residualId = row.trackingIdResidual ? String(row.trackingIdResidual).trim() : '';
              if (!loadId || !residualId) return false;
            }

            return $scope.model.atmSingleDenomShipments.every((item) => {
              const denomId = getAtmDenomId(item);
              const activeRows = rows.filter((row) => row.denominationId === denomId && $scope.isAtmCassetteSplitActive(row));
              if (!activeRows.length) return false;
              const enteredTotal = activeRows.reduce((sum, row) => sum + parseCassetteAmount(row.amount), 0);
              return Math.round(enteredTotal * 100) === Math.round(Number(item.amount || 0) * 100);
            });
          };

          $scope.onAtmSingleDenomSplitLoadChange = (split) => {
            if (!split) return;
            const loadTrackingId = split.trackingId ? String(split.trackingId).trim() : '';
            const currentResidual = split.trackingIdResidual ? String(split.trackingIdResidual).trim() : '';
            const autoResidual = loadTrackingId ? loadTrackingId.concat($scope.model.residualSuffix) : '';
            if (!loadTrackingId) {
              split.trackingIdResidual = '';
              return;
            }
            if (!currentResidual || currentResidual === autoResidual || currentResidual === split.lastAutoResidual) {
              split.trackingIdResidual = autoResidual;
            }
            split.lastAutoResidual = autoResidual;
          };

          const initializeDenominations = () => {
            if ($scope.model.multipleDenoms && $scope.model.shipment && Array.isArray($scope.model.shipment.shipments)) {
              const forceSingleDenom = $scope.model.sourceType === 'ATMLoad' && isAtmCassetteOn;

              $scope.model.multiDenomPackableDenoms = forceSingleDenom ? [] : $scope.model.multipleDenoms
                .filter(d => {
                  const matchingShipment = $scope.model.shipment.shipments.find(shipment => shipment.denominationId === d.id);
                  return matchingShipment && matchingShipment.multiDenomPackable === 1;
                })
                .map(d => {
                  const matchingShipment = $scope.model.shipment.shipments.find(shipment => shipment.denominationId === d.id);
                  return { ...d, multiDenomPackable: matchingShipment.multiDenomPackable };
                });
              $scope.model.multipleDenoms = $scope.model.multipleDenoms
                .map(d => {
                  const matchingShipment = $scope.model.shipment.shipments.find(shipment => shipment.denominationId === d.id);
                  return { 
                    ...d, 
                    multiDenomPackable: forceSingleDenom ? 0 : Number(matchingShipment.multiDenomPackable),
                    willDebitOnPack: matchingShipment.willDebitOnPack || false
                  };
                });
              $scope.model.singleDenomPackableDenoms = $scope.model.multipleDenoms
                .filter(d => {
                  const matchingShipment = $scope.model.shipment.shipments.find(shipment => shipment.denominationId === d.id);
                  return matchingShipment && (forceSingleDenom || matchingShipment.multiDenomPackable === 0);
                })
                .map(d => {
                  const matchingShipment = $scope.model.shipment.shipments.find(shipment => shipment.denominationId === d.id);
                  return { 
                    ...d, 
                    multiDenomPackable: forceSingleDenom ? 0 : matchingShipment.multiDenomPackable,
                    willDebitOnPack: matchingShipment.willDebitOnPack || false
                  };
                });
              $scope.model.hasCoinMultiDenom = $scope.model.multiDenomPackableDenoms.some(d => d.coinFlag === true || d.coinFlag === 1);
              $scope.model.hasCashMultiDenom = $scope.model.multiDenomPackableDenoms.some(d => d.coinFlag !== true && d.coinFlag !== 1);
            }
          };

          const updateAtmSingleDenomOnlyFlag = () => {
            // Cassette mode uses per-cassette load/residual IDs for all ATM denoms (single + multi).
            if ($scope.model.useAtmCassetteMode && $scope.model.atmSingleDenomShipments && $scope.model.atmSingleDenomShipments.length > 0) {
              $scope.model.isAtmSingleDenomOnly = true;
              return;
            }
            $scope.model.isAtmSingleDenomOnly =
              $scope.model.sourceType === 'ATMLoad'
              && Array.isArray($scope.model.atmSingleDenomShipments)
              && $scope.model.atmSingleDenomShipments.length > 0
              && Array.isArray($scope.model.multiDenomPackableDenoms)
              && $scope.model.multiDenomPackableDenoms.length === 0;
          };

          const init = () => {
            loadAtmCassetteUsageSnapshot()
              .then(() => {
                initializeAtmSingleDenomShipments();
                initializeDenominations();
                updateAtmSingleDenomOnlyFlag();
                return SetupService.get(branchId);
              })
              .then((setup) => {
                $scope.model.branchVaultDate = moment.utc(setup.currentVaultDate).format('YYYY-MM-DD');
                $scope.model.packSlip = setup.packSlip;
                $scope.model.unassignedRouteId = setup.unassignedRouteId;
                $scope.model.scanLimit = setup.packCharLength;
                $scope.model.isAutoGenerateResidualId = (orderShipment.orderType === 'I') || (orderShipment.toLocation.packResidual === 0 && orderShipment.orderType !== 'T' && orderShipment.orderType !== 'P');
                $scope.model.isAutoGenerateLoadId = ($scope.model.shipment.orderType == 'P' || $scope.model.shipment.orderType == 'T');
                $scope.model.printPackLabel = setup.printPackLabel;

                if (!$scope.model.vaultDate) {
                  $scope.model.vaultDate = DateUtil.convertToDate(setup.currentVaultDate);
                }
                $scope.minVaultDate = {
                  minDate: DateUtil.convertToDate(setup.currentVaultDate)
                };
              })
              .then(() => {
                $scope.loadPermission();
                if ($scope.model.hasACL[$scope.model.permissionKey]['editRoute']) {
                  $scope.getOrderPackRoutes();
                }
                $scope.setFocus();
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal('error.' + err.data.message);
                }
              });
          }

          $scope.getAllPackableOrderTrackingIds = (pack=false) => {
            let trackingIds = [];        

            if ($scope.model.multiDenomTrackingId) {
              trackingIds.push($scope.model.multiDenomTrackingId);
            }

            if ($scope.model.packCoinSeparately && $scope.model.hasCashMultiDenom && $scope.model.hasCoinMultiDenom && $scope.model.multiDenomCoinTrackingId) {
              trackingIds.push($scope.model.multiDenomCoinTrackingId);
            }
            $scope.model.singleDenomPackableDenoms.forEach(denom => {
              if (!denom.multiDenomPackable && denom.trackingId) {
                trackingIds.push(denom.trackingId);
              }
            });

            if(!pack){
            $scope.model.deliveryToShipmentTypes.forEach(type => {
              if (type.trackingId) {
                trackingIds.push(type.trackingId);
              }
            });
          }

            return trackingIds;
          }

          $scope.getOrderPackRoutes = () => {
            $scope.model.gettingRoutes = true;

            OrderPackingService.getOrderPackRoutes(branchId, moment($scope.model.vaultDate).format('YYYY-MM-DD'))
              .then((data) => {
                $scope.model.routeList = data.results;
                $scope.model.routeId = orderShipment.routeId;
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal(err.data.message);
                }
              })
              .finally(() => {
                $scope.model.gettingRoutes = false;
              })
          }

          $scope.loadPermission = () => {
            $scope.model.acl[$scope.model.permissionKey] = User.getACL($scope.model.permissionKey);
            $scope.model.hasACL[$scope.model.permissionKey] = {};
            $scope.model.acl[$scope.model.permissionKey].forEach((permission) => {
              $scope.model.hasACL[$scope.model.permissionKey][permission] = true;
            });
          }
          $scope.onVaultDateChange = () => {
            $scope.model.routeId = null;
            $scope.model.routeList = [];

            const key = $scope.model && $scope.model.permissionKey;
            const hasACLMap = $scope.model && $scope.model.hasACL && key && $scope.model.hasACL[key];
            const aclArray = $scope.model && $scope.model.acl && key && $scope.model.acl[key];
            const canEditRoute = !!(
              (hasACLMap && $scope.model.hasACL[key]['editRoute']) ||
              (Array.isArray(aclArray) && (aclArray.indexOf('editRoute') !== -1))
            );

            if (canEditRoute) {
              $scope.getOrderPackRoutes();
            }
          };

          $scope.scanLimit = (trackingId, $event) => {
            const ENTER_KEY_CODE = 13;
            
            if ($scope.model.sourceType === 'PackableOrder') {
              $scope.model.lastScannedLoadId = trackingId;
            } else {
              $scope.model.lastScannedResidualId = $scope.model.trackingIdResidual;
              $scope.model.lastScannedLoadId = $scope.model.trackingIdDelivery;
            }
            $scope.bagScanLimitExceed = false;
            if ($event.keyCode === ENTER_KEY_CODE && trackingId && $scope.model.scanLimit > 0) {
              if (trackingId.length > $scope.model.scanLimit && (!$scope.checkOnlyOnce || trackingId.length !== $scope.checkLength)) {
                $scope.checkOnlyOnce = true
                $scope.bagScanLimitExceed = true;
                $scope.checkLength = trackingId.length;
                if ($scope.model.sourceType === 'PackableOrder') {
                  if ($scope.model.multiDenomTrackingId === trackingId) {
                    $scope.model.multiDenomTrackingId = null;
                  } else {
                    $scope.model.multipleDenoms.forEach(denom => {
                      if (denom.trackingId === trackingId) {
                        denom.trackingId = null;
                      }
                    });
                  }
                } else {
                  if ($scope.model.lastScannedLoadId === trackingId && $scope.model.isAutoGenerateResidualId) {
                    $scope.resetData();
                  }
                  else if ($scope.model.lastScannedResidualId === trackingId && $scope.model.isAutoGenerateLoadId) {
                    $scope.resetData();
                  }
                  else if ($scope.model.lastScannedLoadId === trackingId) {
                    $scope.model.trackingIdDelivery = null;
                  }
                  else {
                    $scope.model.trackingIdResidual = null;
                  }
                }    
                return $scope.bagScanError = $translate.instant('common.scan_error')
              }
              else {
                delete $scope.bagScanError
                $scope.checkLength = trackingId.length > $scope.model.scanLimit ? trackingId.length : $scope.model.scanLimit;
              }
            }
          }

          $scope.focusToDeliveryId = ($event) => {
            const ENTER_KEY_CODE = 13;
            if ($event.keyCode === ENTER_KEY_CODE && $scope.model.trackingIdDelivery && $scope.model.trackingIdResidual
              && ($scope.model.trackingIdDelivery != $scope.model.trackingIdResidual) &&
              ($scope.model.shipment.routeId === $scope.model.unassignedRouteId) && !$scope.bagScanError) {
              return $scope.packAndHold();
            }
            else if ($event.keyCode === ENTER_KEY_CODE && $scope.model.trackingIdDelivery && !$scope.bagScanError && $scope.model.isAutoGenerateResidualId) {
              focusElementById('pack-btn');
            }
            else if ($event.keyCode === ENTER_KEY_CODE && $scope.model.trackingIdDelivery && !$scope.bagScanError) {
              focusElementById('trackingIdResidual');
            }
          }

          $scope.focuseToPackBtn = ($event) => {
            const ENTER_KEY_CODE = 13;
            if ($event.keyCode === ENTER_KEY_CODE && $scope.model.trackingIdResidual && !$scope.bagScanError) {
              focusElementById('pack-btn');
            }
          }

          $scope.focuseToPackAndHoldBtn = ($event) => {
            const ENTER_KEY_CODE = 13;
            if ($event.keyCode === ENTER_KEY_CODE && $scope.model.trackingIdResidual &&
              ($scope.model.trackingIdDelivery != $scope.model.trackingIdResidual) &&
              ($scope.model.shipment.routeId === $scope.model.unassignedRouteId) && !$scope.bagScanError) {
              // focusElementById('packAndHoldBtn');
              return $scope.packAndHold();
            }
          }

          // $scope.playErrorBeep = () => {
          //   document.querySelector("#scanner_beep").play()
          // }

          // $scope.playSuccessBeep = () => {
          //   document.querySelector("#success_beep").play()
          // }

          const mappingRouteDatas = (routes) => {
            return routes.map((route) => {
              return {
                Key: route.routeId + " | " + route.routeName,
                Value: route.routeId
              }
            });
          }
          const getRouteData = (valutDate) => {
            BranchService.getReleaseRoutes(branchId, valutDate)
              .then((res) => {
                $scope.routeLists = mappingRouteDatas(res);
                $scope.totalRouteRecords = res.length;
              })
              .catch((err) => {
                if (!err.data.success) {
                  errorModal('error.' + err.data.message);
                }
              });
          }
          $scope.cancel = () => {
            // orderPackModal.close();
            negative({
              modal: orderPackModal
            });
          }

          $scope.orderPack = () => {
            // Single entry point to call the API once per Pack click.
            const runOnePack = (shipmentId, trackingIdDelivery, amount, denominationId, deliveryToShipTypes, singleDenomShipments) => {
              // ATM cassette / single-denom paths carry load+residual on shipment arrays; parent IDs stay null.
              const residualTrackingId = ($scope.model.sourceType === 'ATMLoad' && $scope.model.isAtmSingleDenomOnly)
                ? null
                : $scope.model.trackingIdResidual;
              const loadTrackingId = ($scope.model.sourceType === 'ATMLoad' && $scope.model.isAtmSingleDenomOnly)
                ? null
                : $scope.model.trackingIdDelivery;

              return OrderPackingService.orderPackingPack(
                branchFundingSourceId,
                shipmentId,
                loadTrackingId,
                residualTrackingId,
                $scope.model.routeId,
                orderShipment.toLocationId,
                amount,
                denominationId,
                account,
                branchId,
                orderShipment.orderNo,
                $scope.model.supervisorId,
                moment($scope.model.vaultDate).format("YYYY-MM-DD"),
                orderShipment.deliveryDate,
                deliveryToShipTypes || [],
                singleDenomShipments
              );
            };
            const handlePackErr = (err) => {
              $scope.isPack = false;
              if (err && err.data && err.data.message) {
                Sound.PlayErrorBeep("#scanner_beep");
                confirm({
                  header: $translate.instant('common.error'),
                  message: $translate.instant('error.' + err.data.message),
                  callback: ({ modal }) => { modal.close(); callback({ modal: orderPackModal, data: [], status: true }); },
                  negative: ({ modal }) => { modal.close(); callback({ modal: orderPackModal, data: [], status: true }); },
                  type: 'danger',
                  buttons: ['common.ok']
                });
                orderPackModal.close();
              }
            };
            if ($scope.model.atmSingleDenomShipments && $scope.model.atmSingleDenomShipments.length > 0) {
              const items = $scope.model.atmSingleDenomShipments;
              let singleDenomShipments = [];

              if ($scope.model.useAtmCassetteMode) {
                // Shared cassette pool: group the flat row list by the denomination picked on each row,
                // then build the same per-denom singleDenomShipments shape the backend already expects.
                items.forEach((item) => {
                  const denomId = item.shipment.denominationId || (item.shipment.denomination && item.shipment.denomination.id);
                  if (!denomId) return;
                  const activeRows = ($scope.model.atmCassetteRows || [])
                    .filter((row) => row.denominationId === denomId && $scope.isAtmCassetteSplitActive(row));
                  if (!activeRows.length) return;

                  const trackingIds = activeRows.map(row => row.trackingId);
                  const amounts = activeRows.map((row) => parseCassetteAmount(row.amount));
                  const perSplitResiduals = activeRows
                    .filter(row => row && row.trackingId && row.trackingIdResidual)
                    .map(row => ({
                      trackingId: row.trackingId,
                      trackingIdResidual: row.trackingIdResidual
                    }));
                  const maxLoad = (item.shipment.maxLoad != null && item.shipment.maxLoad !== '') ? Number(item.shipment.maxLoad) : null;
                  singleDenomShipments.push({
                    denominationId: denomId,
                    maxLoad,
                    amounts,
                    trackingIds,
                    trackingIdResidual: null,
                    perSplitResiduals
                  });
                });
                singleDenomShipments = singleDenomShipments.filter(s => s.denominationId && s.trackingIds && s.trackingIds.length > 0);
              } else {
                singleDenomShipments = items.map((item) => {
                  const denomId = item.shipment.denominationId || (item.shipment.denomination && item.shipment.denomination.id);
                  const trackingIds = (item.splits || []).map(s => s.trackingId).filter(id => id);
                  const perSplitResiduals = (item.splits || [])
                    .filter(s => s && s.trackingId && s.trackingIdResidual)
                    .map(s => ({
                      trackingId: s.trackingId,
                      trackingIdResidual: s.trackingIdResidual
                    }));
                  const maxLoad = (item.shipment.maxLoad != null && item.shipment.maxLoad !== '') ? Number(item.shipment.maxLoad) : null;
                  return {
                    denominationId: denomId,
                    maxLoad,
                    trackingIds,
                    trackingIdResidual: null,
                    perSplitResiduals
                  };
                }).filter(s => s.denominationId && s.trackingIds && s.trackingIds.length > 0);
              }

              const shipmentIdsCsv = items
                .map(item => item.shipment.shipmentId || item.shipment.id)
                .join(',');

              return runOnePack(
                shipmentIdsCsv,
                $scope.model.trackingIdDelivery,
                $scope.model.total,
                null,
                $scope.model.deliveryToShipmentTypes,
                singleDenomShipments.length ? singleDenomShipments : null
              )
                .then((detail) => {
                  callback({ modal: orderPackModal, data: detail || {}, status: true });
                  return detail;
                })
                .catch((err) => { handlePackErr(err); return $q.reject(err); });
            }

            const selectedIds = orderData.shipments.map(s => s.shipmentId).join(',');
            return new Promise((resolve, reject) => {
              // Non-ATM / non-single-denom path: keep payload as before (no single-denom trackingIds array)
              runOnePack(
                selectedIds,
                $scope.model.trackingIdDelivery,
                orderShipment.amount,
                orderShipment.denominationId,
                $scope.model.deliveryToShipmentTypes,
                null
              )
                .then((detail) => {
                  callback({ modal: orderPackModal, data: detail, status: true });
                  resolve(detail);
                })
                .catch((err) => { handlePackErr(err); reject(err); });
            });
          }

          // pack an order
          $scope.pack = () => {
            $scope.isPack = true;
            const q = $q.defer();
            $scope.verifyTrackingId()
              .then((result) => {
            if ($scope.model.sourceType === "PackableOrder") {
              const trackingIds = $scope.getAllPackableOrderTrackingIds(true);
              return OrderPackingService.packableOrderPack(
                branchFundingSourceId,
                orderShipment.orderNo,
                $scope.model.supervisorId,
                $scope.model.routeId,
                orderShipment.defRouteSequence,
                trackingIds.join(","),
                $scope.model.deliveryToShipmentTypes,
                moment($scope.model.vaultDate).format("YYYY-MM-DD")
              ).then((data) => {
                if (data && data.finishedAt) {
                  $scope.model.shipmentPackedDate = data.finishedAt;
                }
                callback({
                  modal: orderPackModal,
                  data: data,
                  status: true,
                });
                q.resolve(data);
              });
            } else {
                return $scope.orderPack().then(data => {
                  if (data && data.finishedAt) {
                    $scope.model.shipmentPackedDate = data.finishedAt;
                  }
                  q.resolve(data);
                });
              }
              })
              .catch((err) => {
                $scope.errorMessage = '';
                
                if (err && err.errorCode && err.responseData) {
                  const allTrackingIds = err.responseData.trackingId || [];
                  const userEnteredIds = err.userEnteredIds || [];
                  
                  const conflictingIds = allTrackingIds.filter(id => userEnteredIds.includes(id));
                  
                  if (conflictingIds.length > 0) {
                    const idsList = conflictingIds.join(', ');
                    const message = conflictingIds.length === 1 
                      ? `The following ID ${idsList} is already in use`
                      : `The following IDs ${idsList} are already in use`;
                    errorModal(message);
                  } else {
                    errorModal('error.' + err.errorCode);
                  }
                }
                else if (!err.data) {
                  errorModal('error.' + err);
                }
                else if (err && err.data && err.data.errors) {
                  err.data.errors.map((e) => {
                    $scope.errorMessage += e.message + '<br/>'
                  })
                  errorModal($scope.errorMessage);
                }
                else if (err && err.data && err.data.message) {
                  if (err.data.message === '95507' && err.data.trackingId) {
                    errorModal('error.95507', { trackingId: err.data.trackingId });
                  } else {
                    errorModal('error.' + err.data.message);
                  }
                }
                else {
                  errorModal(err);
                }
                $scope.isPack = false;
                Sound.PlayErrorBeep("#scanner_beep");
              })
            return q.promise;
          }

          $scope.verifyTrackingId = () => {
            return new Promise((resolve, reject) => {
                  if ($scope.model.sourceType === 'PackableOrder') {
                      let trackingIds = [];
                      if ($scope.model.multiDenomTrackingId) {
                          trackingIds.push($scope.model.multiDenomTrackingId);
                      }
                      if ($scope.model.packCoinSeparately && $scope.model.hasCashMultiDenom && $scope.model.hasCoinMultiDenom && $scope.model.multiDenomCoinTrackingId) {
                          trackingIds.push($scope.model.multiDenomCoinTrackingId);
                      }
                      $scope.model.singleDenomPackableDenoms.forEach(denom => {
                          if (denom.trackingId) {
                              trackingIds.push(denom.trackingId);
                          }
                      });
                      $scope.model.deliveryToShipmentTypes.forEach(type => {
                          if (type.trackingId) {
                              trackingIds.push(type.trackingId);
                          }
                      });
                      trackingIds = trackingIds.filter(id => id);
          
                      if (trackingIds.length === 0) {
                          resolve();
                          return;
                      }
          
                      OrderPackingService.verifyTrackingIds(trackingIds)
                          .then((res) => {
                              if (res.data && res.data.trackingId && res.data.trackingId.length > 0) {
                                  reject({ errorCode: 93504, responseData: res.data, userEnteredIds: trackingIds });
                              } else if (res.data && res.data.shipmentInfo && res.data.shipmentInfo.length > 0) {
                                  const hasPickupFlag = res.data.shipmentInfo.some(info => info.pickupFlag);
                                  if (hasPickupFlag) {
                                      reject(93503);
                                  }
                              } else {
                                  resolve(res);
                              }
                          })
                          .catch((error) => {
                              console.error('Error verifying tracking IDs:', error);
                              reject(error);
                          });
                  } else {
                      let deliveryToIds = ($scope.model.deliveryToShipmentTypes || []).map(shipment => shipment.trackingId);
                      let userEnteredTrackingIds = [];
                      let residualIds = [];
                      if ($scope.model.useAtmCassetteMode && $scope.model.atmCassetteRows && $scope.model.atmCassetteRows.length) {
                        $scope.model.atmCassetteRows.forEach((row) => {
                          if (row.trackingId) userEnteredTrackingIds.push(String(row.trackingId).trim());
                          if (row.trackingIdResidual) {
                            userEnteredTrackingIds.push(String(row.trackingIdResidual).trim());
                            residualIds.push(String(row.trackingIdResidual).trim());
                          }
                        });
                      } else if ($scope.model.atmSingleDenomShipments && $scope.model.atmSingleDenomShipments.length > 0) {
                        $scope.model.atmSingleDenomShipments.forEach((item) => {
                          (item.splits || []).forEach((split) => { if (split.trackingId) userEnteredTrackingIds.push(String(split.trackingId).trim()); });
                          (item.splits || []).forEach((split) => {
                            if (split.trackingIdResidual) {
                              userEnteredTrackingIds.push(String(split.trackingIdResidual).trim());
                              residualIds.push(String(split.trackingIdResidual).trim());
                            }
                          });
                        });
                      }
                      if ($scope.model.trackingIdDelivery) userEnteredTrackingIds.push(String($scope.model.trackingIdDelivery).trim());
                      if (!($scope.model.sourceType === 'ATMLoad' && $scope.model.isAtmSingleDenomOnly) && $scope.model.trackingIdResidual) {
                        userEnteredTrackingIds.push(String($scope.model.trackingIdResidual).trim());
                        residualIds.push(String($scope.model.trackingIdResidual).trim());
                      }
                      userEnteredTrackingIds.push(...deliveryToIds.filter((id) => id));
                      userEnteredTrackingIds = userEnteredTrackingIds.filter(id => id);
                      const hasAtmPerSplitIds = ($scope.model.useAtmCassetteMode && $scope.model.atmCassetteRows && $scope.model.atmCassetteRows.length)
                        || ($scope.model.atmSingleDenomShipments && $scope.model.atmSingleDenomShipments.length > 0);
                      const loadTrackingIds = hasAtmPerSplitIds
                        ? userEnteredTrackingIds.filter(id => id && residualIds.indexOf(id) === -1 && deliveryToIds.indexOf(id) === -1)
                        : ($scope.model.trackingIdDelivery ? [String($scope.model.trackingIdDelivery).trim()] : []);
                      const checkShipmentId = ($scope.model.shipment && $scope.model.shipment.shipments && $scope.model.shipment.shipments[0])
                        ? $scope.model.shipment.shipments[0].shipmentId : orderShipment.shipmentId;
                      ShipmentService.chechTrackingIds(userEnteredTrackingIds, checkShipmentId)
                          .then((res) => {
                              if (res.data && (res.data.id).indexOf(orderShipment.shipmentId) == -1) {
                    reject(93502);
                  } else if (res.data && res.data.shipmentInfo && res.data.shipmentInfo.length && _.find(res.data.shipmentInfo, { id: orderShipment.shipmentId }).pickupFlag) {
                    reject(93503)
                  } else if (res.data && res.data.trackingId && loadTrackingIds.some((id) => (res.data.trackingId).indexOf(id.toString()) >= 0)) {
                    reject({ errorCode: 93504, responseData: res.data, userEnteredIds: userEnteredTrackingIds })
                  } else if (res.data && residualIds.length && residualIds.some((id) => (res.data.trackingId).indexOf(id.toString()) >= 0)) {
                    reject({ errorCode: 93505, responseData: res.data, userEnteredIds: userEnteredTrackingIds })
                  } else if (res.data && deliveryToIds && deliveryToIds.some((id) => (res.data.trackingId).indexOf(id.toString()) >= 0)) {
                    reject({ errorCode: 93511, responseData: res.data, userEnteredIds: userEnteredTrackingIds }); 
                  } else {
                    resolve(res)
                  }
                }).catch((error) => {
                      console.error('Error checking tracking IDs:', error);
                      reject(error);
                    });
                  }
              });
          };

          $scope.checkDuplicateTrackingIds = function () {
            let allTrackingIds = [];
            $scope.duplicateTrackingIds = [];
            if ($scope.model.sourceType === 'PackableOrder') {
              allTrackingIds = $scope.getAllPackableOrderTrackingIds();
            } else {
              if ($scope.model.trackingIdDelivery) allTrackingIds.push(String($scope.model.trackingIdDelivery).trim());
              if ($scope.model.useAtmCassetteMode && $scope.model.atmCassetteRows && $scope.model.atmCassetteRows.length) {
                $scope.model.atmCassetteRows.forEach((row) => {
                  if (row.trackingId) allTrackingIds.push(String(row.trackingId).trim());
                  if (row.trackingIdResidual) allTrackingIds.push(String(row.trackingIdResidual).trim());
                });
              } else if ($scope.model.atmSingleDenomShipments && $scope.model.atmSingleDenomShipments.length > 0) {
                $scope.model.atmSingleDenomShipments.forEach((item) => {
                  (item.splits || []).forEach((split) => { if (split.trackingId) allTrackingIds.push(String(split.trackingId).trim()); });
                  (item.splits || []).forEach((split) => { if (split.trackingIdResidual) allTrackingIds.push(String(split.trackingIdResidual).trim()); });
                });
              }
              // Global residual ID is only used when we are not in ATM single‑denom‑only mode
              if (!($scope.model.sourceType === 'ATMLoad' && $scope.model.isAtmSingleDenomOnly) && $scope.model.trackingIdResidual) {
                allTrackingIds.push(String($scope.model.trackingIdResidual).trim());
              }
              ($scope.model.deliveryToShipmentTypes || []).forEach((t) => { if (t.trackingId) allTrackingIds.push(String(t.trackingId).trim()); });
            }
            allTrackingIds = allTrackingIds.filter((id) => id);
            $scope.duplicateTrackingIds = allTrackingIds.filter((id, index, arr) => arr.indexOf(id) !== index && id);
          };
          // put shipment on hold after successfully packed
          $scope.putOnHold = (supId) => {
            let holdShipmentDetails = new Promise(
              function (resolve, reject) {
                if ($scope.model.sourceType === 'PackableOrder') {
                  // Get all tracking IDs for packable order
                  const trackingIds = $scope.getAllPackableOrderTrackingIds(true);
                  
                  // Use the new endpoint for multiple shipments
                  ShipmentService.holdMultipleShipments(
                    $scope.model.branch, 
                    trackingIds, 
                    $scope.model.routeId, 
                    $scope.model.shipmentsValutDate, 
                    supId, 
                    'Put On Hold', 
                    'Hold'
                  )
                    .then((holdShipments) => {
                      callback({
                        modal: orderPackModal,
                        data: holdShipments,
                      });
                      resolve(holdShipments);
                    })
                    .catch((err) => {
                      if (err && err.data && err.data.message) {
                        Sound.PlayErrorBeep("#scanner_beep");
                        errorModal('error.' + err.data.message);
                        $scope.isPack = false;
                      }
                    });
                } else {
                  let trackingId = $scope.model.trackingIdDelivery;
                  let holdTrackingIds = [];
                  if ($scope.model.sourceType === 'ATMLoad' && $scope.model.useAtmCassetteMode && $scope.model.atmCassetteRows && $scope.model.atmCassetteRows.length) {
                    holdTrackingIds = $scope.model.atmCassetteRows
                      .filter((row) => row.trackingId && String(row.trackingId).trim())
                      .map((row) => String(row.trackingId).trim());
                    if (holdTrackingIds.length) trackingId = holdTrackingIds[0];
                  } else if ($scope.model.sourceType === 'ATMLoad' && $scope.model.atmSingleDenomShipments &&
                             $scope.model.atmSingleDenomShipments.length && $scope.model.atmSingleDenomShipments[0].splits &&
                             $scope.model.atmSingleDenomShipments[0].splits.length) {
                    trackingId = $scope.model.atmSingleDenomShipments[0].splits[0].trackingId;
                    if (trackingId) holdTrackingIds = [String(trackingId).trim()];
                  }
                  const holdCall = ($scope.model.useAtmCassetteMode && holdTrackingIds.length > 1)
                    ? ShipmentService.holdMultipleShipments(
                      $scope.model.branch,
                      holdTrackingIds,
                      $scope.model.routeId,
                      $scope.model.shipmentsValutDate,
                      supId,
                      'Put On Hold',
                      'Hold'
                    )
                    : ShipmentService.holdShipment($scope.model.branch, trackingId, $scope.model.routeId, $scope.model.shipmentsValutDate, supId, 'Put On Hold', 'Hold');
                  holdCall
                  .then((holdShipment) => {
                    callback({
                      modal: orderPackModal,
                      data: holdShipment,
                    });
                    resolve(holdShipment)
                  })
                  .catch((err) => {
                    if (err && err.data && err.data.message) {
                      Sound.PlayErrorBeep("#scanner_beep");
                      errorModal('error.' + err.data.message);
                      $scope.isPack = false;
                      // reject(err)
                    }
                  })
                }
              })
            return holdShipmentDetails;
          }

          $scope.packAndHold = () => {
            $scope.isPack = true;
            confirmSupervisor('pack-and-Hold', { trackingId: orderShipment.trackingId }, ({ modal, supId }) => {
              $scope.pack(modal)
                .then(function () {
                  focusElementById('pack-btn');
                  $scope.putOnHold(supId);
                  modal.close();
                })
                .catch((err) => {
                  $scope.isPack = false;
                  $scope.loading = false;
                })
                .finally(() => {
                  $scope.loading = false;
                })
              modal.close();
            }, ({ modal }) => {
              $scope.isPack = false;
              modal.close()
            })
          }

          $scope.autoGenerateResidualId = (loadTrackingId) => {
            if ($scope.model.isAutoGenerateResidualId) {
              if (loadTrackingId) $scope.model.trackingIdResidual = loadTrackingId.concat($scope.model.residualSuffix)
              else $scope.model.trackingIdResidual = null;
            }
          }

          $scope.autoGenerateLoadId = (residualTrackingId) => {
            if ($scope.model.isAutoGenerateLoadId) {
              if (residualTrackingId) $scope.model.trackingIdDelivery = residualTrackingId.concat($scope.model.loadSuffix)
              else $scope.model.trackingIdDelivery = null;
            }
          }

          $scope.setFocus = () => {
            if ($scope.model.isAutoGenerateLoadId) focusElementById('trackingIdResidual');
            else focusElementById('trackingIdDelivery');
          }

          $scope.resetData = () => {
            $scope.model.trackingIdDelivery = null;
            $scope.model.trackingIdResidual = null;
          }

          $scope.packAndPrint = () => {
            $scope.model.packedShipmentDetails = [];

            return $scope.pack()
              .then(() => {
                if ($scope.model.sourceType === 'PackableOrder') {
                  // Handle multi-denom packable bag if exists
                  if ($scope.model.multiDenomTrackingId) {
                    $scope.model.packedShipmentDetails.push({
                      trackingId: $scope.model.multiDenomTrackingId,
                      isLoadTrackingId: true,
                      locationInfo: {
                        id: $scope.model.shipment.toLocationId || null,
                        name: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.name : null,
                        address: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.address : null,
                        city: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.city : null,
                        state: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.state : null,
                        zip: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.zip : null,
                      },
                      orderType: $scope.model.shipment.orderType,
                      routeId: $scope.model.routeId,
                      deliveryDate: $scope.model.shipment.deliveryDate,
                      amount: $scope.model.multiDenomPackableDenoms.reduce((sum, denom) => sum + denom.amount, 0),
                      denominationId: null, // Multi-denom doesn't have a single denomination
                      vaultDate: moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),
                      defRouteSequence: $scope.model.shipment.defRouteSequence,
                      shiptypeId: $scope.model.shipment.shiptypeId,
                    });
                  }

                  // Handle single denomination packable bags
                  $scope.model.singleDenomPackableDenoms.forEach(denom => {
                    if (denom.trackingId) {
                      $scope.model.packedShipmentDetails.push({
                        trackingId: denom.trackingId,
                        isLoadTrackingId: true,
                        locationInfo: {
                          id: $scope.model.shipment.toLocationId || null,
                          name: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.name : null,
                          address: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.address : null,
                          city: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.city : null,
                          state: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.state : null,
                          zip: $scope.model.shipment.toLocation ? $scope.model.shipment.toLocation.zip : null,
                        },
                        orderType: $scope.model.shipment.orderType,
                        routeId: $scope.model.routeId,
                        deliveryDate: $scope.model.shipment.deliveryDate,
                        amount: denom.amount,
                        denominationId: denom.denominationId,
                        vaultDate: moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),
                        defRouteSequence: $scope.model.shipment.defRouteSequence,
                        shiptypeId: $scope.model.shipment.shiptypeId,
                      });
                    }
                  });
                } else {
                  // Existing logic for Shipment orders
                $scope.model.packedShipmentDetails.push({
                  trackingId: $scope.model.trackingIdDelivery,
                  isLoadTrackingId: true,
                  locationInfo: {
                    id: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocationId : null,
                    name: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.name : null,
                    address: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.address : null,
                    city: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.city : null,
                    state: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.state : null,
                    zip: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.zip : null,
                  },
                  orderType: $scope.model.shipment.orderType,
                  routeId: $scope.model.shipment.routeId,
                  deliveryDate: $scope.model.shipment.deliveryDate,
                  amount: $scope.model.shipment.amount,
                  denominationId: $scope.model.shipment.denominationId,
                  vaultDate: moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),
                  defRouteSequence: $scope.model.shipment.defRouteSequence,
                  shiptypeId: $scope.model.shipment.shiptypeId,
                }, {
                  trackingId: $scope.model.trackingIdResidual,
                  isLoadTrackingId: false,
                  locationInfo: {
                    id: $scope.model.shipment.fromLocationId ? $scope.model.shipment.fromLocationId : null,
                    name: $scope.model.shipment.fromLocationId ? $scope.model.shipment.fromLocation.name : null,
                    address: $scope.model.shipment.fromLocationId ? $scope.model.shipment.fromLocation.address : null,
                    city: $scope.model.shipment.fromLocationId ? $scope.model.shipment.fromLocation.city : null,
                    state: $scope.model.shipment.fromLocationId ? $scope.model.shipment.fromLocation.state : null,
                    zip: $scope.model.shipment.fromLocationId ? $scope.model.shipment.fromLocation.zip : null,
                  },
                  orderType: $scope.model.shipment.orderType,
                  routeId: $scope.model.shipment.routeId,
                  pickupDate: $scope.model.shipment.pickupDate,
                  amount: 0,
                  denominationId: $scope.model.shipment.denominationId,
                  vaultDate: moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),
                  defRouteSequence: $scope.model.shipment.defRouteSequence,
                  shiptypeId: $scope.model.shipment.shiptypeId,
                });
                }
                $scope.model.deliveryToShipmentTypes.forEach((shipmentType) => {
                  if (shipmentType.trackingId) {
                    $scope.model.packedShipmentDetails.push({
                      trackingId: shipmentType.trackingId,
                      isLoadTrackingId: false,
                      locationInfo: {
                        id: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocationId : null,
                        name: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.name : null,
                        address: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.address : null,
                        city: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.city : null,
                        state: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.state : null,
                        zip: $scope.model.shipment.toLocationId ? $scope.model.shipment.toLocation.zip : null,
                      },
                      orderType: null,
                      routeId: $scope.model.shipment.routeId,
                      pickupDate: null,
                      amount: 0,
                      shiptypeId: shipmentType.shiptypeId,
                      denominationId: null,
                      vaultDate: moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),
                      defRouteSequence: $scope.model.shipment.defRouteSequence,
                    });
                  }
                });
                if($scope.model.packSlip) {
                  $scope.printPackSlip();
                } else {
                  $scope.printBarcodes();
                }
              });
          }

          $scope.printBarcodes = () => {
            const obj = {
              shipmentDetails: $scope.model.packedShipmentDetails,
              isPrePackPrint: false
            };
            const path = $state.href('printBarcodes');
            window.w = window.open(path, '_blank');
            window.w.printData = obj;
          }
          $scope.printPackSlip = () => {
            const routeId = $scope.model.routeId || 'NA';
            const vaultDate = $scope.model.vaultDate;
            const shipmentPackedDate = $scope.model.shipmentPackedDate;
            const locationId = $scope.model.shipment.toLocationId;
            const obj = {
              shipmentData: $scope.model.shipment.shipments ? $scope.model.shipment.shipments : [],
              shipmentDetails: $scope.model.packedShipmentDetails,
              routeId: routeId,
              vaultDate: vaultDate,
              locationId: locationId,
              shipmentPackedDate: shipmentPackedDate,
              orderNo: $scope.model.shipment.orderNo
            };
            const path = $state.href('printPackSlip');
            window.w = window.open(path, '_blank');
            window.w.printData = obj;
          }

          $scope.hasDuplicateTrackingIds = () => {
            if ($scope.model.sourceType === 'PackableOrder') {
                let trackingIds = [];
                
                // Add multiDenom tracking ID if exists
                if ($scope.model.multiDenomTrackingId) {
                    trackingIds.push($scope.model.multiDenomTrackingId);
                }
                
                // Add all single denom tracking IDs
                $scope.model.singleDenomPackableDenoms.forEach(denom => {
                    if (denom.trackingId) {
                        trackingIds.push(denom.trackingId);
                    }
                });
                $scope.model.deliveryToShipmentTypes.forEach(shipType => {
                    if (shipType.trackingId) {
                        trackingIds.push(shipType.trackingId);
                    }
                });
                // Filter out empty/null values and check for duplicates
                trackingIds = trackingIds.filter(id => id);
                return trackingIds.length !== new Set(trackingIds).size;
            }

            let trackingIds = [];
            if ($scope.model.trackingIdDelivery) trackingIds.push(String($scope.model.trackingIdDelivery).trim());
            if ($scope.model.useAtmCassetteMode && $scope.model.atmCassetteRows && $scope.model.atmCassetteRows.length) {
              $scope.model.atmCassetteRows.forEach((row) => {
                if (row.trackingId) trackingIds.push(String(row.trackingId).trim());
                if (row.trackingIdResidual) trackingIds.push(String(row.trackingIdResidual).trim());
              });
            } else if ($scope.model.atmSingleDenomShipments && $scope.model.atmSingleDenomShipments.length > 0) {
              $scope.model.atmSingleDenomShipments.forEach((item) => {
                (item.splits || []).forEach((split) => {
                  if (split.trackingId) trackingIds.push(String(split.trackingId).trim());
                  if (split.trackingIdResidual) trackingIds.push(String(split.trackingIdResidual).trim());
                });
              });
            }
            if (!($scope.model.sourceType === 'ATMLoad' && $scope.model.isAtmSingleDenomOnly) && $scope.model.trackingIdResidual) {
              trackingIds.push(String($scope.model.trackingIdResidual).trim());
            }
            ($scope.model.deliveryToShipmentTypes || []).forEach((shipType) => {
              if (shipType.trackingId) trackingIds.push(String(shipType.trackingId).trim());
            });
            trackingIds = trackingIds.filter((id) => id);
            return trackingIds.length !== new Set(trackingIds).size;
          };

          init();
        }]
    })
    rejectModal(orderPackModal, negative)
  }

  let holdReason = (trackingId, allowSupervisorScan, callback, negative) => {
    let holdReasonModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: holdReasonTemplate,
      size: 'md',
      controller: ['$scope', '$translate', '$location', 'MessageService', 'User', '$q', ($scope, $translate, $location, MessageService, User, $q) => {
        $scope.loading = false;
        $scope.model = {
          reasonToClose: '',
          trackingId: trackingId,
          allowSupervisorScan: allowSupervisorScan,
          userDetails: User.getUser()
        };
        const init = () => {
          // $scope.loading = true;
          // $scope.loading = false;
        }
        $scope.cancel = () => {
          holdReasonModal.close();
        }
        $scope.validateSupervisorScan = () => {
          if ($scope.model.allowSupervisorScan) {
            let errorMsg = $translate.instant('users.supervisor_scan_error', {
              firstName: $scope.model.userDetails.firstName,
              lastName: $scope.model.userDetails.lastName
            })
            return confirm({
              header: $translate.instant('errorModal.title'),
              message: $translate.instant(errorMsg),
              callback: ({
                modal,
              }) => {
                $scope.ok();
                modal.close();
              },
              type: 'danger',
              buttons: ['common.ok']
            })
          }
          else {
            $scope.ok();
          }
        }
        $scope.ok = (err) => {
          // confirmSupervisor('force-to-hold', { trackingId: $scope.model.trackingId }, ({ modal, supId }) => {
          verifySupervisorScan('force-to-hold', { trackingId: $scope.model.trackingId }, $scope)
            .then((supervisorInfo) => {
              $scope.model.supervisorId = supervisorInfo ? supervisorInfo.supId : null
              $scope.model.loading = true;
              callback({
                // supervisorId: supId,
                supervisorId: supervisorInfo ? supervisorInfo.supId : null,
                reason: $scope.model.reasonToClose,
                modal: holdReasonModal
              });
              // modal.close()
              if (supervisorInfo) supervisorInfo.modal.close();
              // }, ({ modal }) => {
              //   modal.close()
              // })
            })
        }
        init()
      }]
    })
  }

  let convertToCrv = (shipment, allowSupervisorScan, showError, callback, negative) => {
    let convertToCrvModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: convertToCrvTemplate,
      size: 'md',

      controller: ['$scope', '$translate', '$location', 'MessageService', 'User', '$q', 'HoldService', ($scope, $translate, $location, MessageService, User, $q, HoldService) => {

        $scope.loading = false;
        $scope.model = {
          shipmentData: shipment,
          trackingIdResidual: '',
          allowSupervisorScan: allowSupervisorScan,
          userDetails: User.getUser(),
          showError: showError
        };

        const init = () => {
          focusElementById('residual-trackingId');
        }

        $scope.cancel = () => {
          // convertToCrvModal.close();
          negative({
            modal: convertToCrvModal
          })
        }

        $scope.validateSupervisorScan = () => {
          if ($scope.model.allowSupervisorScan && $scope.model.showError) {
            let errorMsg = $translate.instant('users.supervisor_scan_error', {
              firstName: $scope.model.userDetails.firstName,
              lastName: $scope.model.userDetails.lastName
            })

            return confirm({
              header: $translate.instant('errorModal.title'),
              message: $translate.instant(errorMsg),
              callback: ({
                modal,
              }) => {
                $scope.ok();
                modal.close();
              },
              type: 'danger',
              buttons: ['common.ok']
            })
          }
          else {
            $scope.ok();
          }
        }

        $scope.ok = (err) => {
          $scope.isLoading = true;
          // confirmSupervisor('shipment-hold-convert-CRV', { trackingId: $scope.model.trackingIdResidual }, ({ modal, supId }) => {
          verifySupervisorScan('shipment-hold-convert-CRV', { trackingId: $scope.model.trackingIdResidual }, $scope)
            .then((supervisorInfo) => {
              HoldService.verifyAtmResidual($scope.model.trackingIdResidual)
                .then((response) => {
                  if (response.status) {
                    callback({
                      supervisor: supervisorInfo ? supervisorInfo.supId : null,
                      trackingIdResidual: $scope.model.trackingIdResidual,
                      modal: convertToCrvModal
                    });
                    // modal.close();
                    if (supervisorInfo) supervisorInfo.modal.close();
                  }
                  else {
                    errorModal(response.message)
                    callback({
                      supervisor: supervisorInfo ? supervisorInfo.supId : null,
                      trackingIdResidual: '',
                      modal: convertToCrvModal
                    });
                    // modal.close();
                    if (supervisorInfo) supervisorInfo.modal.close();
                  }
                })
                .catch((err) => {
                  $scope.isLoading = false;
                  console.log(err)
                })
              // }, ({ modal }) => {
              //   $scope.isLoading = false;
              //   modal.close()
              // })
            })
        }
        init()
      }]
    })
    rejectModal(convertToCrvModal, negative)
  }

  let deletedReason = (shipment, callback, negative) => {
    let deletedReasonModal = $uibModal.open({
      template: deletedReasonTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$rootScope', '$q', 'MessageService', 'User', function ($scope, $rootScope, $q, MessageService, User) {

        $scope.model = {
          reason: "",
          loading: false,
          trackingId: shipment.orderNo,
          loggedInUser: User.getUser(),
          messageType: 'DS',
          reasons: [],
          selectedReasonCode: null
        };
     
        $scope.combineReasonAndComment = function (selectedReasonCode, comment) {
          if (selectedReasonCode && comment) return selectedReasonCode + ' | ' + comment;
          else if (selectedReasonCode) return selectedReasonCode;
          else if (comment) return comment;
          else return '';
        };

        const init = () => {
          MessageService.shipmentDeleteReason($scope.model.messageType, $scope.model.loggedInUser.languageId)
            .then((data) => {
              const id = document.getElementById('comment');
              if (id) focusElementById('comment');
              $scope.model.reasons =  data.results;
            })
            .catch((err) => {
              console.log(err)
            })
        }

        $scope.ok = () => {
          $scope.isLoading = true;
          confirmSupervisor('verify-delete-shipment', { trackingId: $scope.model.trackingId }, ({ modal, supId }) => {
            $scope.model.supervisorId = supId;
            $scope.model.loading = true;

            callback({
              supervisorId: supId,
              reason: $scope.combineReasonAndComment($scope.model.selectedReasonCode, $scope.model.reason),
              modal: deletedReasonModal
            });
            modal.close()

          }, ({ modal }) => {
            $scope.isLoading = false;
            modal.close()
          })
        }

        $scope.cancel = () => {
          // deletedReasonModal.close();
          negative({
            modal: deletedReasonModal
          });
        }

        init();
      }]
    })
    rejectModal(deletedReasonModal, negative)
  }

  // Order Packing Hold
  let orderPackHold = (orderShipment, modal, callback) => {
    let orderPackHoldModal = $uibModal.open({
      template: orderPackHoldTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', function ($scope, $q) {
        $scope.model = {
          trackingId: ''
        };
        const init = () => {
          $scope.model.trackingId = orderShipment.trackingId;
        }
        $scope.ok = () => {
        }
        $scope.cancel = () => {
          orderPackHoldModal.close();
        }
        init()
      }]
    })
    rejectModal(deletedReasonModal, negative)
  }

  let atmResidualReceipt = (shipments, modal, callback) => {
    let atmResidualReceiptModal = $uibModal.open({
      template: atmResidualReceiptTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', function ($scope, $q) {
        // $scope.loading = false;
        $scope.model = {
          shipmentData: shipments,
          trackingId: shipments.trackingId
        };

        $scope.zoomLevel = 350;
        $scope.maxZoom = 600;
        $scope.minZoom = 200;
  
        $scope.zoomIn = function () {
          if ($scope.zoomLevel < $scope.maxZoom) {
            $scope.zoomLevel += 50;
          }
        };
  
        $scope.zoomOut = function () {
          if ($scope.zoomLevel > $scope.minZoom) {
            $scope.zoomLevel -= 50;
          }
        };

        const init = () => {
          const TYPED_ARRAY = new Uint8Array(shipments);
          const STRING_CHAR = TYPED_ARRAY.reduce((data, byte) => { return data + String.fromCharCode(byte); }, '');
          $scope.base64String = window.btoa(STRING_CHAR);
        }

        $scope.ok = () => {
          callback({
            modal: atmResidualReceiptModal
          })
          atmResidualReceiptModal.close();
        }

        $scope.cancel = () => {
          atmResidualReceiptModal.close();
        }

        init()
      }]
    })
  }
  // Add items model for checkout screen
  let checkoutAddItems = (modal, callback) => {
    let checkoutAddItemsModal = $uibModal.open({
      template: checkoutAddItemsTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', function ($scope, $q) {

        $scope.model = {
          trackingId: '',
          description: '',
          comment: ''
        }

        const init = () => {
        }

        $scope.ok = () => {
        }

        $scope.cancel = () => {
          checkoutAddItemsModal.close();
        }

        $scope.clearScan = () => {
          $scope.model.trackingId = '';
        }

        init()
      }]
    })
  }

  //  If there is a variance then present an optional comment window for user to provide reason
  let residualComments = (shipments, callback, negative) => {
    let residualCommentModal = $uibModal.open({
      template: residualCommentTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', function ($scope, $q) {

        $scope.model = {
          comment: '',
          trackingId: shipments.trackingId
        };

        const init = () => {
          focusElementById('variance-comment');
        }

        $scope.ok = () => {
          $scope.model.loading = true;
          callback({
            modal: residualCommentModal,
            comments: $scope.model.comment,
          });
          residualCommentModal.close();
        }

        $scope.cancel = () => {
          // residualCommentModal.close();
          negative({
            modal: residualCommentModal
          })
        }

        init()
      }]
    })
    rejectModal(residualCommentModal, negative)
  }
  // Order Packing Return
  let orderPackReturn = (orderShipment, modal, callback) => {
    let orderPackReturnModal = $uibModal.open({
      template: orderPackReturnTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', function ($scope, $q) {

        $scope.model = {
          trackingId: ''
        };

        const init = () => {
          $scope.model.trackingId = orderShipment.trackingId;
        }

        $scope.ok = () => {
        }

        $scope.cancel = () => {
          orderPackReturnModal.close();
        }

        init()
      }]
    })
  }

  let balanceSheetInfo = (sheetInfo, currency, title, data, modal, callback) => {
    let balanaceSheetModal = $uibModal.open({
      template: balanceSheetTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', 'DailyBalanceSheetService', 'DataCounter', '$state', function ($scope, DailyBalanceSheetService, DataCounter, $state) {
        $scope.loading = true;
        $scope.label = title;
        $scope.currency = currency;
        $scope.model = {
          sheetInfo: sheetInfo,
          data: data,
          dvbDetails: [],
          mapping: [],
          isExist: false,
          showLocId: false,
          fields: {
            'amountLoadRequested': 'amountLoadRequested',
            'amount': 'amount',
            'totalAmount': 'totalAmount',
            'amountCounted': 'amountCounted',
            'amountLoadActual': 'amountLoadActual',
          },
          amountField: ''
        }

        $scope.model.mapping = ['ordersPackedAlltime', 'pendingResidualCount', 'residualsDeposited', 'actualResidualsCounted', 'actualCashLoaded',
                                'pendingCrvDepositAll', 'ordersPacked', 'depositsPendingRelease', 'depositsPendingCount', 'packableOrdersPacked',
                                'packableOrdersPackedAlltime', 'receivedBulkCash', 'actualDepositsCounted'];

        const init = () => {
          $scope.loading = false;
          $scope.model.isExist = $scope.model.mapping.includes(data.infoFor)
          $scope.extraDetails();
        }

        $scope.extraDetails = () => {
          if ($scope.model.isExist) {
            $scope.loading = true;
            DailyBalanceSheetService.allDVBDetails(data.branchId, data.fundingSourceId, data.currencyId, data.denominationId, data.account, data.vaultDate, data.infoFor)
              .then((res) => {
                $scope.model.dvbDetails = res.results;
                $scope.model.dvbDetails.map((d) => {
                  if (d.hasOwnProperty('locationId')) $scope.model.showLocId = true;
                  else $scope.model.showLocId = false;
                  d.showGroupCells = true;
                  d.groupRowSpan = 1;
                })
                if (data.infoFor === 'pendingResidualCount' && res.denomSummary) {
                  $scope.setPendingResidualDenomSummary(res.denomSummary, res.results);
                }
                if (data.infoFor === 'actualDepositsCounted') {
                  $scope.groupDvbDetailsByKey((row) => row.locationId + '|' + row.trackingId);
                }
                else if (data.infoFor === 'receivedBulkCash') {
                  $scope.groupDvbDetailsByKey((row) => row.transactionId);
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }
        }

        // Per-denom cards come from Denom STC captured at pickup; whatever the table total has beyond that
        // (residuals without STC) is shown as one "not captured" card so the cards still add up to the total.
        $scope.setPendingResidualDenomSummary = (summary, rows) => {
          const symbol = (rows[0] && rows[0].symbol) || currency;
          const cards = summary.map((d) => ({
            denominationId: d.denominationId,
            value: Number(d.amount),
            coinFlag: d.coinFlag,
            symbol: d.symbol || symbol,
            sortOrder: Number(d.sortOrder),
            faceValue: Number(d.faceValue)
          }));
          const total = rows.reduce((sum, r) => sum + Number(r.amount || 0), 0);
          // Any non-zero gap is shown (negative = cards exceed the table), never hidden.
          const notCaptured = Math.round((total - cards.reduce((sum, c) => sum + c.value, 0)) * 100) / 100;
          if (notCaptured !== 0) cards.push({ denominationId: null, notCaptured: true, value: notCaptured, coinFlag: false, symbol });
          $scope.model.sheetInfo = cards;
        }

        $scope.groupDvbDetailsByKey = (getKey) => {
          let details = $scope.model.dvbDetails || [];
          let groupStartIndex = 0;

          details.forEach((row, index) => {
            if (index === 0 || getKey(row) !== getKey(details[index - 1])) {
              groupStartIndex = index;
              row.showGroupCells = true;
              row.groupRowSpan = 1;
            }
            else {
              row.showGroupCells = false;
              details[groupStartIndex].groupRowSpan++;
            }
          })
        }

        $scope.exportData = () => {
          if ($scope.model.isExist) {
            $scope.exporting = true;
            DailyBalanceSheetService.exportData(data.branchId, data.fundingSourceId, data.currencyId, data.denominationId, data.account, data.vaultDate, data.infoFor)
              .then((res) => {
                if (['receivedBulkCash', 'actualDepositsCounted'].includes(data.infoFor)) {
                  $scope.generateExcelFile(res, data.infoFor);
                }
                else {
                  $scope.generateFile(res.reportData, res.fileName);
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.exporting = false;
              })
          }
        }

        $scope.generateFile = (reportData, fileName) => {
          let a = document.createElement("a");
          let name = fileName.concat('_', $scope.model.data.vaultDate, '.csv');
          document.body.appendChild(a);
          let file = new Blob([reportData], {
            type: 'application/csv'
          });
          let fileURL = window.URL.createObjectURL(file);
          a.href = fileURL;
          a.download = name;
          a.click();
        }

        $scope.generateExcelFile = (arrayBuffer, fileName) => {
          let a = document.createElement("a");
          let name = fileName.concat('_', $scope.model.data.vaultDate, '.xlsx');
          document.body.appendChild(a);
          let file = new Blob([arrayBuffer], {
            type: 'application/xlsx'
          });
          let fileURL = window.URL.createObjectURL(file);
          a.href = fileURL;
          a.download = name;
          a.click();
        }

        $scope.findAmount = (data) => {
          let keys = Object.keys(data);
          keys.map((key) => { if ($scope.model.fields[key]) return $scope.model.amountField = $scope.model.fields[key] })
          return data[$scope.model.amountField]
        }

        $scope.goToServiceHistory = (locationId) => {
          balanaceSheetModal.close();
          const obj = {
            locationId: locationId,
            isRedirected: true
          }
          DataCounter.setData(obj);
          $state.go('branchManagement.locations');
        }

        $scope.goToItemOrDepositPackHistory = (trackingId) => {
          balanaceSheetModal.close();

          if ($scope.model.data.infoFor === 'residualsDeposited') {
            const obj = {
              trackingId: trackingId,
              isRedirected: true,
              fundingSourceId: data.fundingSourceId
            }
            DataCounter.setData(obj);
            $state.go('branchManagement.items');
          }
          else {
            $state.go('branchManagement.items', {
              id: trackingId,
            });
          }
        }

        $scope.goToOrderHistory = (orderNo) => {
          balanaceSheetModal.close();
          const info = $scope.model.data.infoFor;
          const obj = {
            orderNo: orderNo,
            isRedirected: true,
            isCounted: (info === 'actualResidualsCounted' || info === 'pendingCrvDepositAll') ? true : false,
            isInProcess: (info === 'actualCashLoaded' || info === 'ordersPackedAlltime' || info === 'ordersPacked' ||
              info === 'pendingResidualCount') ? true : false,
            fundingSourceId: $scope.model.data.fundingSourceId
          }
          DataCounter.setData(obj);
          $state.go('branchManagement.orders');
        }

        $scope.cancel = () => {
          balanaceSheetModal.close();
        }
        init();
      }]
    })
  }

  let deliveryRouteInfo = (data, routeId, vaultDate, flag, timezone, branchId,routeDetails, modal, callback) => {
    let routeDelivriesModal = $uibModal.open({
      template: routeDelivriesInfoTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$state', 'RouteService', 'DataCounter', 'Navigation','$translate', 'Modal', function ($scope, $state, RouteService, DataCounter, Navigation, $translate, Modal) {
        $scope.loading = false;
        $scope.title = '',
          $scope.flag = '',
          $scope.routeId = routeId;
        $scope.model = {
          routesInfo: data,
          timezone: timezone
        }
        $scope.newEmail = '';
        $scope.emailList = [];
        $scope.sending = false;

        const init = () => {
          $scope.validateUI();
        }
        $scope.addEmail = () => {
          if ($scope.newEmail && 
              /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($scope.newEmail) && 
              !$scope.emailList.includes($scope.newEmail)) {
              $scope.emailList.push($scope.newEmail);
              $scope.newEmail = '';
          }
      };

      // Remove email from the list
      $scope.removeEmail = (index, $event) => {
          if ($event) {
              $event.preventDefault();
              $event.stopPropagation();
          }
          $scope.emailList.splice(index, 1);
      };

  $scope.sendEmail = () => {
    if ($scope.emailList.length > 0) {
        $scope.sending = true;

        const emailData = {
            routeId: routeId,
            vaultDate: vaultDate,
            title: $scope.title,
            flag: $scope.flag,
            receiverEmails: $scope.emailList,
            reportData: data,
            branchId: branchId
        };

        RouteService.pickupReportEmail(emailData)
            .then((response) => {
                Modal.confirm({
                    header: $translate.instant('successModal.title'),
                    message: $translate.instant('common.email_sent_success'),
                    callback: (({ modal }) => {
                        modal.close();
                    }),
                    buttons: ['common.ok'],
                    type: 'success'
                });
                
                // Clear the email list and input
                $scope.emailList = [];
                $scope.newEmail = '';
            })
            .catch((error) => {
                let errorMessage = (error && error.data && error.data.message) 
                    ? error.data.message 
                    : $translate.instant('common.something_went_wrong');
                Modal.error({
                    title: $translate.instant('common.error'),
                    message: errorMessage
                });
            })
            .finally(() => {
                $scope.sending = false;
            });
    }
};
        let totals;
        if (data.length > 0) {
          totals = data.reduce((acc, d) => {
            acc.totalAmount += d.amount
            d.coinFlag ? acc.totalCoin++ : acc.totalBag++
            return acc
          },
            { totalAmount: 0, totalCoin: 0, totalBag: 0 },
          )
        }

        $scope.print = () => {
          let new_path = $state.href('printRoutes');
          window.w = window.open(new_path, '_blank');
          window.w.printData = {
            'routeId': routeId,
            'vaultDate': vaultDate,
            'title': $scope.title,
            'data': data,
            'flag': $scope.flag,
            'timezone': $scope.model.timezone,
            'totals': totals,
            'routeDetails': routeDetails
          }
        }
        $scope.exportToCSV = () => {
          $scope.loading = true;
          RouteService.exportCSV(routeId, vaultDate, $scope.flag, $scope.model.timezone)
            .then((data) => {
              this.date = moment.utc().format('DDMMYY');
              this.fileName = (`${routeId}_${$scope.flag}`).concat('_', this.date, '.csv');
              let a = document.createElement("a");
              document.body.appendChild(a);
              let file = new Blob([data.reportData.data], {
                type: 'application/csv'
              });
              let fileURL = window.URL.createObjectURL(file);
              a.href = fileURL;
              a.download = this.fileName;
              a.click();
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.loading = false;
            })
        }
        $scope.goToServiceHistory = (locationId) => {
          routeDelivriesModal.close();
          const obj = {
            locationId: locationId,
            isRedirected: true
          }
          DataCounter.setData(obj);
          $state.go('branchManagement.locations');
        }
        $scope.goToItemHistory = (trackingId) => {
          routeDelivriesModal.close();
          $state.go('branchManagement.items', {
            id: trackingId,
          });
        }
        $scope.validateUI = () => {
          if (flag === 'delivery') {
            $scope.flag = 'delivery';
            $scope.title = $translate.instant('branch_mgmt.route_deliveries');
          }
          else if (flag === 'pickups') {
            $scope.flag = 'pickups';
            $scope.title = $translate.instant('branch_mgmt.route_pickups');
          }
          else if (flag === 'holdDeliveries') {
            $scope.flag = 'holdDeliveries';
            $scope.title = $translate.instant('branch_mgmt.not_delivered');
          }
          else if (flag === 'holdPickups') {
            $scope.flag = 'holdPickups';
            $scope.title = $translate.instant('branch_mgmt.not_pickUp');
          }
        }
        $scope.goToItemHold = (trackingId) => {
          return Navigation.goToItemHold(trackingId, true);
        }
        $scope.cancel = () => {
          routeDelivriesModal.close();
        }
        init();
      }]
    })
  }

  // list of all coin shiptypes 
  let coinShiptypeList = (routeId, vaultDate,branch, callback) => {
    let coinShiptypeListModal = $uibModal.open({
      template: coinShiptypeListTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', 'ShipmentService', '$q', 'ScanService', '$translate', 'Sound', 'Modal', function ($scope, ShipmentService, $q, ScanService, $translate, Sound, Modal) {

        $scope.model = {
          loading: false,
          shipTypeList: [],
          routeId: routeId,
          date: vaultDate,
          branchId: branch,
          shiptype: {},
          branchFundingSourceId: null,
          inventoryBulkCoin: null,
          allCoins: [],
          shipTypeIds: [],
          coinVerifiedMsg: ''
        };
        $scope.coinShiptypeList = {};

        const init = () => {
          $scope.model.loading = true;
          ScanService.verifyCoin($scope.model.routeId, $scope.model.date)
            .then((data) => {
              if (data && data.results) {
                $scope.model.allCoins = data.results.allCoins;
                $scope.model.shipTypeList = data.results.groupedCoins;
                $scope.model.isCodInventoryBulkCoin = $scope.model.allCoins.some(
                  item => item.inventoryBulkCoin === 1 && item.codInputValue > 0
                );
                $scope.model.shipTypeList.map((d) => {
                  $scope.model.shipTypeIds.push(d.shiptypeId);
                  $scope.coinShiptypeList[d.shiptypeId] = {
                    'inputValue': d.inputValue
                  }
                })
              }
              else {
                $scope.model.coinVerifiedMsg = $translate.instant('checkout.' + data.message)
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.verifyCoin = () => {
          $scope.incorrectCoins = {}
          let verify = _.map($scope.model.shipTypeList, function (d) {
            if ($scope.model.shiptype[d.shiptypeId]) {
              const isCorrect = $scope.model.shiptype[d.shiptypeId].qty == $scope.coinShiptypeList[d.shiptypeId].inputValue
              if (!isCorrect) {
                $scope.incorrectCoins[d.shiptypeId] = true
              }
              return isCorrect
            }
          })
          if (verify.indexOf(false) >= 0 || verify.indexOf() !== -1) return $scope.isValid = false;
          else return $scope.isValid = true;
        }

        $scope.ok = () => {
          let validCoins =[];
          let invalidCoins = [];
          // Filter coins with COD amount > 0 and use COD amount for ledger check
          const coinsToCheck = $scope.model.allCoins
            .filter(c => c.inventoryBulkCoin && Number(c.codAmount) > 0)
            .map(c => ({
              shiptypeId: c.shiptypeId,
              branchFundingSourceId: c.branchFundingSourceId,
              amount: c.codAmount,
              fundingSourceName: c.fundingSourceName
          }));
          
          if (coinsToCheck.length === 0) {
            return callback({ modal: coinShiptypeListModal, isCodInventoryBulkCoin: $scope.model.isCodInventoryBulkCoin, coinIds: $scope.model.shipTypeIds });
          }
          
         ScanService.getCurrentDenomLedgerBalance($scope.model.branchId,'Regular', coinsToCheck, $scope.model.routeId, $scope.model.date)
         .then((data) => {
          if (data) {
    
            coinsToCheck.forEach((shipType) => {
              const matchingDenomination = data.find(
                (denom) => denom.denominationId === shipType.shiptypeId && denom.branchFundingSourceId === shipType.branchFundingSourceId
              );
    
              if (matchingDenomination) {
                if (matchingDenomination.alreadyDebited === true) {
                  validCoins.push(shipType);
                } else if (Number(shipType.amount) <= matchingDenomination.balance) {
                  validCoins.push(shipType);
                } else {
                  invalidCoins.push(shipType);
                }
              } else {
                // If denominationId is not present in data
                invalidCoins.push(shipType);
              }
            });

            if(invalidCoins.length > 0) {
              Sound.PlayErrorBeep("#scanner_beep");
              const message = $translate.instant('orderPacking.insufficient_coin', {
                Denomination: invalidCoins[0].shiptypeId,
                BranchFundingSource: invalidCoins[0].fundingSourceName
            });

              errorModal(message);
            } else {
              callback({
                modal: coinShiptypeListModal,
                isCodInventoryBulkCoin: $scope.model.isCodInventoryBulkCoin,
                coinIds: $scope.model.shipTypeIds
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          if (err && err.data && err.data.message) {
            return Modal.errorModal(err.data.message);
          }
        });
        }
        $scope.cancel = () => {
          coinShiptypeListModal.close();
        }
        init()
      }]
    })
  }

  let routeStopTransfer = (vaultDate, date, branchVaultDate, selectedRoutes, branch, routeCheckoutInfo, callback, negative) => {
    let routeStopTransferModal = $uibModal.open({
      template: routeStopTransferTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',

      controller: ['$scope', '$q', 'RouteService', 'Modal', 'BranchService', 'SetupService', '$timeout', 'RouteStopService', function ($scope, $q, RouteService, Modal, BranchService, SetupService, $timeout, RouteStopService) {

        $scope.model = {
          loading: false,
          vaultDate: date,
          routeDate: vaultDate,
          branchId: branch,
          selectedRoutes: selectedRoutes,
          branchVaultDate: branchVaultDate,
          days: [
            { label: $translate.instant('location.sun'), value: 'Sun' },
            { label: $translate.instant('location.mon'), value: 'Mon' },
            { label: $translate.instant('location.tues'), value: 'Tue' },
            { label: $translate.instant('location.wed'), value: 'Wed' },
            { label: $translate.instant('location.thurs'), value: 'Thu' },
            { label: $translate.instant('location.fri'), value: 'Fri' },
            { label: $translate.instant('location.sat'), value: 'Sat' },
            { label: $translate.instant('location.hol'), value: 'Hol' }
          ],
          selectedDay: 'Mon',
          dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          currentDay: "",
          routeStopList: [],
          routePosition: 0,
          originRoute: [],
          destinationRoute: [],
          actualLat: "",
          actualLong: "",
          locationInfo: "",
          originStopCount: [],
          destinationStopCount: [],
          transferredStops: [],
          destSequenceInput: [],
          fromRouteId: selectedRoutes[0],
          toRouteId: selectedRoutes[1],
          destinationRouteLength: "",
          movedObj: {},
          isMapInitialized: true,
          isSourceMapInitialized: true,
          allRoutes: [],
          fromRouteDate: date,
          sourceRoutes: [],
          isUpdating: false,
          isRouteCheckout: routeCheckoutInfo[0],
          releaseRouteStatus: '',
          isPreviousVaultDate: false,
          destinationRouteIsReleased: false,
          needsRefresh: false,
          totalTransferredStops: 0,
          totalTransferredShipments: 0,
          requireThrow: false
        };

        $scope.stopList = [];
        $scope.destinationRouteLatLong = [];
        $scope.sourceRouteLatLong = [];

        $scope.loadImage = (image) => {
          $scope.icon = {
            'REGULAR': 'regular.png',
            'ATM': 'atm.png',
            'BANK': 'bank.png',
            'NO_SHIP_NO_GO': 'nsng.png',
            'INTERNAL': 'internal.png',
            'TRUCK': 'truck.png',
            'TANKER': 'tanker.png',
            'WINDOW': 'window.png',
            'CARRIER': 'carrier.png',
            'ON_CALL': 'oncall.png',
            'LOCKER': 'locker.png',
            'VAULT': 'vault.png',
            'DELIVERY': 'delivery.png'
          }

          let imgURL = $scope.icon[image]
          return require('../../../assets/images/' + imgURL);
        }

        const applyStopTransferDisability = (stops) => {
          stops.forEach((stop) => {
            stop.disabledStopTransfer = false;
            stop.disableReason = '';
            const stopStatus = (stop.stopStatus || '').toUpperCase();
            const isCompleted = stopStatus !== '';
            const hasCheckedOutDelivery = (stop.shipmentInfo || []).some(info => info.checkedOut === 1);
            const hasAnyShipment = (stop.shipmentInfo || []).some(
              info => info && (info.trackingId || info.orderType || info.checkedOut !== null)
            );
            const isCantStop = stopStatus === 'CANT';
            const isRequiredPickup = (stop.isRequiredPickup === 1 || stop.isRequiredPickup === true);
            if (hasCheckedOutDelivery) {
              stop.disabledStopTransfer = true;
              stop.disableReason = 'Stop has checked out shipments. Shipments cannot be transferred';
            }
            else if (isCompleted && !isCantStop && !isRequiredPickup) {
              stop.disabledStopTransfer = true;
              stop.disableReason = 'Completed stops cannot be transferred.';
            }
            else if (isCantStop && hasAnyShipment) {
              stop.disabledStopTransfer = true;
              stop.disableReason = 'CANT stop with shipments cannot be transferred.';
            }
          });
        };

        const init = () => {
          // get current vaultDate day
          $scope.model.loading = true;
          const today = $scope.model.vaultDate.getDay();
          $scope.model.currentDay = $scope.model.dayOfWeek[today];
          $scope.model.selectedDay = $scope.model.currentDay;
          $scope.date = moment($scope.model.vaultDate).format('YYYY-MM-DD');
          $scope.minVaultDate = {
            minDate: $scope.model.branchVaultDate
          }
          $scope.model.isPreviousVaultDate = $scope.date < moment($scope.model.branchVaultDate).format('YYYY-MM-DD');
          $scope.loadDestinationRoutes();
          $scope.loadSourceRoutes();

          $q.all([
            SetupService.get($scope.model.branchId),
            $scope.getRouteStops($scope.model.fromRouteId, $scope.model.toRouteId, $scope.date, $scope.model.branchId)
          ])
            .then((data) => {
              $scope.model.branchInfo = data[0];
              const routeStopDetails = data[1];
              $scope.model.fromRouteStops = routeStopDetails.resultOne;
              $scope.model.destinationRouteStops = routeStopDetails.resultTwo;
              $scope.model.destinationRouteLength = routeStopDetails.resultTwo.length;
              refreshDestSequenceInputs();
              if ($scope.model.toRouteId) {
                const selectedRoute = $scope.model.allRoutes.find(route => route.routeId === $scope.model.toRouteId);
                $scope.model.destinationRouteIsReleased = selectedRoute ? (selectedRoute.isReleased || selectedRoute.lastReleasedAt) : false;
              }
              $scope.model.loading = false;

              // if ($scope.model.isRouteCheckout) {
                applyStopTransferDisability($scope.model.fromRouteStops);
              // }

              $scope.getDestinationRouteLatLong();
              $scope.getSourceRouteLatLong();

              loadMap(routeStopDetails);
              if ($scope.model.toRouteId) $scope.loadSecondMap(routeStopDetails);
            })
        }

        $scope.getRouteStops = (fromRouteId, toRouteId, date, branchId) => {
          const defer = $q.defer();
          const fromVaultDate = moment($scope.model.fromRouteDate || $scope.model.vaultDate).format('YYYY-MM-DD');
          const toVaultDate = moment(date || $scope.model.vaultDate).format('YYYY-MM-DD');

          RouteService.routeStopTransferList(fromRouteId, toRouteId, fromVaultDate, toVaultDate, branchId)
            .then((data) => {
              defer.resolve(data);
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                return Modal.errorModal('error.' + err.data.message);
              }
              defer.reject(err);
            })
          return defer.promise;
        }

        $scope.loadRouteStops = () => {
          $scope.model.isMapInitialized = true;
          const formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
          $scope.model.releaseRouteStatus = '';

          $scope.getRouteStops(null, $scope.model.toRouteId, formattedDate, $scope.model.branchId)
            .then((data) => {
              $scope.model.destinationRouteStops = data.resultTwo;
              $scope.model.destinationRouteLength = data.resultTwo.length;
              refreshDestSequenceInputs();
              $scope.model.loading = false;
              $scope.getDestinationRouteLatLong();
              $scope.loadSecondMap(data);
            })
        }

        $scope.changeRoute = () => { // load destination routes 
          $scope.model.isMapInitialized = false;
          if ($scope.mapTwo) {
            $scope.mapTwo.remove();
            $scope.stopList.forEach((id) => {
              $scope.mapTwo.removeLayer(id)
            });
          }
          const selectedRoute = $scope.model.allRoutes.find(route => route.routeId === $scope.model.toRouteId);
          $scope.model.destinationRouteIsReleased = selectedRoute ? (selectedRoute.isReleased || selectedRoute.lastReleasedAt) : false;
          $scope.reloadMap();
          $scope.loadRouteStops();
        }

        $scope.reloadMap = () => {
          if ($scope.model.transferredStops.length > 0) {
            $scope.model.transferredStops = [];
            $scope.mapOne.remove();
            $scope.stopList.forEach((id) => {
              $scope.mapOne.removeLayer(id)
            });

            $scope.getRouteStops($scope.model.fromRouteId, null, moment($scope.model.fromRouteDate).format('YYYY-MM-DD'), $scope.model.branchId)
              .then((data) => {
                $scope.model.fromRouteStops = data.resultOne;
                $scope.model.loading = false;
                applyStopTransferDisability($scope.model.fromRouteStops);
                $scope.getSourceRouteLatLong();
                loadMap(data);
              })
          }
        }

        const loadMap = (data) => {
          setTimeout(() => {
            // First Map
            if ($scope.model.isSourceMapInitialized) {
              $scope.mapOne = L.map('mapOne', {
                // center: [39.68649209557518, -101.48273981764913],
                // zoom: 4
              });

              $scope.mapOne.fitBounds($scope.sourceRouteLatLong.length ? $scope.sourceRouteLatLong : [[$scope.model.branchInfo.gpsLat, $scope.model.branchInfo.gpsLong]]);

              L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              }).addTo($scope.mapOne);
            }

            setMarkers(data.resultOne, 0, $scope.mapOne, $scope.model.originRoute); // set marker position for origin route
          }, 100)
        }

        $scope.loadSecondMap = (data) => {
          setTimeout(() => {
            // Second Map
            if ($scope.model.isMapInitialized) {
              $scope.mapTwo = L.map('mapTwo', {
                // center: [39.68649209557518, -101.48273981764913],
                // zoom: 4
              });

              $scope.mapTwo.fitBounds($scope.destinationRouteLatLong.length ? $scope.destinationRouteLatLong : [[$scope.model.branchInfo.gpsLat, $scope.model.branchInfo.gpsLong]]);

              L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              }).addTo($scope.mapTwo);
            }

            setMarkers(data.resultTwo, 0, $scope.mapTwo, $scope.model.destinationRoute); // set marker position for destination route
          }, 100)
        }

        $scope.selectDay = (day) => {
          if (day.value != $scope.model.currentDay) return;
          $scope.model.selectedDay = day.value;
        }

        $scope.locationMoved = (index) => {
          if (!$scope.model.fromRouteStops[index] || $scope.model.fromRouteStops[index].disabledStopTransfer || ($scope.model.toRouteId && !$scope.model.destinationRouteIsReleased)) {
            return;
          }
          $scope.refreshFirstMap();
          $scope.refreshSecondMap();
          $scope.locations = $scope.model.fromRouteStops[index];
          $scope.model.movedObj = Object.assign(
            {
              locationId: $scope.locations.locationId,
              routeDate: moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),
              fromRouteId: $scope.model.fromRouteId,
              toRouteId: $scope.model.toRouteId,
              toRouteDate: moment($scope.model.vaultDate).format('YYYY-MM-DD'),
              shipmentInfo: $scope.locations.shipmentInfo
            })

          if ($scope.model.destinationRouteStops.length == $scope.model.destinationRouteLength + 1) {
            $scope.model.destinationRouteLength += 1;
            $scope.model.transferredStops.push($scope.model.movedObj)
          }
          $scope.model.fromRouteStops.splice(index, 1);
          refreshDestSequenceInputs();
        }

        $scope.routeStopMoved = (index) => {
          $scope.model.destinationRouteStops.splice(index, 1);
        }

        $scope.arrayFormat = (trackingIds) => {
          let data = trackingIds;
          return data.join(", ");
          //  return trackingIds.toString();
        }

        $scope.isMoveAllStopsDisabled = () => {
          if (!$scope.model.fromRouteStops || !$scope.model.fromRouteStops.length) return true;
          return $scope.model.fromRouteStops.every(stop => stop.disabledStopTransfer) || !$scope.model.toRouteId || ($scope.model.toRouteId && !$scope.model.destinationRouteIsReleased);
        };

        $scope.moveAllStops = () => {
          if ($scope.isMoveAllStopsDisabled()) return;

          const stopsToMove = $scope.model.fromRouteStops.filter(stop => !stop.disabledStopTransfer);
          const stopsToKeep = $scope.model.fromRouteStops.filter(stop => stop.disabledStopTransfer);

          stopsToMove.forEach(stop => {
            const movedObj = Object.assign({
              locationId: stop.locationId,
              routeDate: moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),
              fromRouteId: $scope.model.fromRouteId,
              toRouteId: $scope.model.toRouteId,
              toRouteDate: moment($scope.model.vaultDate).format('YYYY-MM-DD'),
              shipmentInfo: stop.shipmentInfo
            });
            $scope.model.transferredStops.push(movedObj);
            $scope.model.destinationRouteStops.push(stop);
          });

          $scope.model.destinationRouteLength += stopsToMove.length;
          $scope.model.fromRouteStops = stopsToKeep;
          refreshDestSequenceInputs();

          $scope.refreshFirstMap();
          $scope.refreshSecondMap();
        };

        $scope.isTransferDisabled = (location) => {
          return !location || location.disabledStopTransfer || !$scope.model.toRouteId || !$scope.model.destinationRouteIsReleased
            || $scope.model.isUpdating || $scope.model.isUpdateOptimizing || $scope.model.isOptimizing;
        };

        $scope.transferStop = (index) => {
          const stop = $scope.model.fromRouteStops[index];
          if ($scope.isTransferDisabled(stop)) return;

          const movedObj = Object.assign({
            locationId: stop.locationId,
            routeDate: moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),
            fromRouteId: $scope.model.fromRouteId,
            toRouteId: $scope.model.toRouteId,
            toRouteDate: moment($scope.model.vaultDate).format('YYYY-MM-DD'),
            shipmentInfo: stop.shipmentInfo
          });

          $scope.model.transferredStops.push(movedObj);
          $scope.model.destinationRouteStops.push(stop); 
          $scope.model.destinationRouteLength += 1;
          $scope.model.fromRouteStops.splice(index, 1);
          refreshDestSequenceInputs();

          $scope.refreshFirstMap();
          $scope.refreshSecondMap();
        };

        const refreshDestSequenceInputs = () => {
          $scope.model.destSequenceInput = $scope.model.destinationRouteStops.map((stop, position) => position + 1);
        };

        const moveDestStopToIndex = (index, targetIndex) => {
          const list = $scope.model.destinationRouteStops;
          if (targetIndex < 0 || targetIndex >= list.length || targetIndex === index) {
            return refreshDestSequenceInputs();
          }

          list.splice(targetIndex, 0, list.splice(index, 1)[0]);
          refreshDestSequenceInputs();
          $scope.refreshSecondMap();
        };

        $scope.moveDestStop = (index, offset) => {
          moveDestStopToIndex(index, index + offset);
        };

        $scope.destSequenceTyped = (index) => {
          const typed = $scope.model.destSequenceInput[index];
          if (!angular.isNumber(typed) || isNaN(typed)) return refreshDestSequenceInputs();
          moveDestStopToIndex(index, Math.round(typed) - 1);
        };

        $scope.optimizeRoute = () => {
          if (!$scope.model.toRouteId) return;
          $scope.model.isOptimizing = true;
          RouteStopService.autoOptimizeRouteStops(moment($scope.model.vaultDate).format('YYYY-MM-DD'), $scope.model.toRouteId)
            .then(res => {
              if (res.status || res) {
                return $scope.getRouteStops($scope.model.fromRouteId, $scope.model.toRouteId, moment($scope.model.vaultDate).format('YYYY-MM-DD'), $scope.model.branchId).then(data => {
                  $scope.model.destinationRouteStops = data.resultTwo;
                  refreshDestSequenceInputs();
                  $scope.refreshSecondMap();
                });
              }
            })
            .catch(err => {
              if (err && err.data && err.data.message) {
                Modal.errorModal('error.' + err.data.message);
              } else {
                Modal.errorModal('An error occurred during route optimization.');
              }
            })
            .finally(() => {
              $scope.model.isOptimizing = false;
            });
        };

        $scope.updateAndOptimize = () => {
          if (!$scope.model.transferredStops.length) return;
          $scope.model.isUpdateOptimizing = true;

          $scope.model.transferredStops.forEach((obj) => {
            obj.toRouteSequence = _.findIndex($scope.model.destinationRouteStops, { locationId: obj.locationId }) + 1;
          });

          RouteService.updateStopsAndShipments($scope.model.transferredStops, $scope.model.transferredStops, $scope.model.branchId, false)
            .then(res => {
              if (res && res.status !== false) {
                if (res.requireThrow) $scope.model.requireThrow = true;

                $scope.model.transferredStops.forEach((t) => {
                  t.shipmentInfo.forEach((s) => {
                    if (s.trackingId) $scope.model.totalTransferredShipments++;
                    else $scope.model.totalTransferredStops++;
                  });
                });

                let selectedRoutes = [
                  { routeId: $scope.model.fromRouteId, date: moment($scope.model.fromRouteDate).format('YYYY-MM-DD') },
                  { routeId: $scope.model.toRouteId, date: moment($scope.model.vaultDate).format('YYYY-MM-DD') }
                ];

                $scope.model.transferredStops = [];

                return RouteService.routeStopTransfered(selectedRoutes, $scope.model.branchId).then(() => {
                  const performRefresh = () => {
                    return $scope.getRouteStops($scope.model.fromRouteId, $scope.model.toRouteId, moment($scope.model.vaultDate).format('YYYY-MM-DD'), $scope.model.branchId).then(data => {
                      $scope.model.fromRouteStops = data.resultOne;
                      $scope.model.destinationRouteStops = data.resultTwo;
                      refreshDestSequenceInputs();
                      applyStopTransferDisability($scope.model.fromRouteStops);
                      $scope.refreshFirstMap();
                      $scope.refreshSecondMap();
                      $scope.model.needsRefresh = true;
                    });
                  };

                  return RouteStopService.autoOptimizeRouteStops(moment($scope.model.vaultDate).format('YYYY-MM-DD'), $scope.model.toRouteId)
                    .then(() => performRefresh())
                    .catch((err) => {
                      return performRefresh().then(() => $q.reject(err));
                    });
                });
              } else {
                return $q.reject(res);
              }
            })
            .catch(err => {
              if (err && err.data && err.data.message) {
                Modal.errorModal('error.' + err.data.message);
              } else if (err && err.message) {
                Modal.errorModal('error.' + err.message);
              } else {
                Modal.errorModal('An error occurred during update and optimize.');
              }
            })
            .finally(() => {
              $scope.model.isUpdateOptimizing = false;
            });
        };

        $scope.update = () => {
          $scope.model.isUpdating = true;
          $scope.model.transferredStops.map((obj) => {
            obj.toRouteSequence = _.findIndex($scope.model.destinationRouteStops, { locationId: obj.locationId }) + 1
          });
          callback({
            modal: routeStopTransferModal,
            transferredStops: $scope.model.transferredStops,
            fromRoutesData: $scope.model.fromRouteStops,
            destinationRoutesData: $scope.model.destinationRouteStops,
            fromRouteId: $scope.model.fromRouteId,
            fromRouteDate: moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),
            toRouteId: $scope.model.toRouteId,
            toRouteDate: moment($scope.model.vaultDate).format('YYYY-MM-DD'),
            $scope: $scope
          });
        };

        const setMarkers = (data, routePosition, mapFor, stopList) => {
          routePosition = routePosition || 0
          $scope.stopList = stopList;
          setTimeout(() => {
            data.forEach((sequenceData) => {

              if (sequenceData && sequenceData.lat && sequenceData.long) {
                routePosition += 1;
                $scope.model.actualLat = sequenceData.lat;
                $scope.model.actualLong = sequenceData.long;

                $scope.model.locationInfo = '<strong>' + sequenceData.locationName + '</strong>' + '<br>' + sequenceData.address + ' - ' + sequenceData.zip +
                  '<br>' + sequenceData.city + ', ' + sequenceData.state;

                const id = L.marker([$scope.model.actualLat, $scope.model.actualLong],
                  {
                    icon: new L.AwesomeNumberMarkers({
                      number: routePosition,
                      markerColor: "blue"
                    })
                  })
                  .addTo(mapFor)
                  .bindPopup($scope.model.locationInfo)

                id.on('mouseover', function () {
                  id.openPopup();
                });

                id.on('mouseout', function () {
                  id.closePopup();
                });

                stopList.push(id);
              }
            })
          }, 100)
        }

        // reRender map on route transfer
        $scope.refreshFirstMap = () => {
          $scope.model.originRoute.forEach((id, index) => {
            $scope.mapOne.removeLayer(id)
          });
          $scope.model.originRoute = [];
          setTimeout(() => {
            setMarkers($scope.model.fromRouteStops, 0, $scope.mapOne, $scope.model.originRoute)
          }, 500)
        }

        // reRender map on route transfer
        $scope.refreshSecondMap = () => {
          $scope.model.destinationRoute.forEach((id, index) => {
            $scope.mapTwo.removeLayer(id);
          });
          $scope.model.destinationRoute = [];
          setTimeout(() => {
            setMarkers($scope.model.destinationRouteStops, 0, $scope.mapTwo, $scope.model.destinationRoute)
          }, 500)
        }

        $scope.loadDestinationRoutes = () => {
          const formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
          RouteService.getRoutes($scope.model.branchId, formattedDate)
            .then((data) => {
              $scope.model.allRoutes = data.results;
              if ($scope.model.toRouteId) {
                const selectedRoute = $scope.model.allRoutes.find(route => route.routeId === $scope.model.toRouteId);
                $scope.model.destinationRouteIsReleased = selectedRoute ? (selectedRoute.isReleased || selectedRoute.lastReleasedAt) : false;
              }
            })
            .catch((err) => {
              console.log(err);
            })
        }

        $scope.loadNextdayRoutes = () => {
          $scope.model.toRouteId = null;
          $scope.model.destinationRouteStops = [];
          $scope.model.releaseRouteStatus = '';
          $scope.model.destinationRouteIsReleased = false;
          const formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
          $scope.model.isPreviousVaultDate = formattedDate < moment($scope.model.branchVaultDate).format('YYYY-MM-DD');
          $scope.reloadMap();
          $scope.loadDestinationRoutes();
        }

        $scope.reloadDestinationMap = () => {
          if ($scope.model.transferredStops.length > 0) {
            $scope.model.transferredStops = [];
            $scope.mapTwo.remove();
            $scope.stopList.forEach((id) => {
              $scope.mapTwo.removeLayer(id)
            });

            $scope.getRouteStops(null, $scope.model.toRouteId, moment($scope.model.vaultDate).format('YYYY-MM-DD'), $scope.model.branchId)
              .then((data) => {
                $scope.model.destinationRouteStops = data.resultTwo;
                $scope.model.destinationRouteLength = data.resultTwo.length;
                refreshDestSequenceInputs();
                $scope.model.loading = false;
                $scope.getDestinationRouteLatLong();
                $scope.loadSecondMap(data);
              })
          }
        }

        $scope.loadSourceRoutes = () => { // load source route list
          const formattedDate = moment($scope.model.fromRouteDate).format('YYYY-MM-DD');
          // console.log("formattedDate", formattedDate);
          RouteService.getRoutes($scope.model.branchId, formattedDate)
            .then((data) => {
              $scope.model.sourceRoutes = data.results;
            })
            .catch((err) => {
              console.log(err);
            })
        }

        $scope.changeSourceRoutes = () => {
          $scope.model.isSourceMapInitialized = false;
          if ($scope.mapOne) {
            $scope.mapOne.remove();
            $scope.stopList.forEach((id) => {
              $scope.mapOne.removeLayer(id)
            });
          }
          $scope.reloadDestinationMap();
          $scope.loadSourceRouteStops();
        }

        $scope.loadSourceRouteStops = () => {
          $scope.model.isSourceMapInitialized = true;
          const formattedDate = moment($scope.model.fromRouteDate).format('YYYY-MM-DD');
          // console.log("formattedDate", formattedDate);
          $scope.getRouteStops($scope.model.fromRouteId, null, formattedDate, $scope.model.branchId)
            .then((data) => {
              $scope.model.fromRouteStops = data.resultOne;
              $scope.loading = false;
              applyStopTransferDisability($scope.model.fromRouteStops);
              $scope.getSourceRouteLatLong();
              loadMap(data);
            })
        }

        $scope.getSourceRoute = () => {
          $scope.model.fromRouteId = null;
          $scope.model.fromRouteStops = [];
          $scope.reloadDestinationMap();
          $scope.loadSourceRoutes();
        }

        $scope.getSourceRouteLatLong = () => {
          $scope.sourceRouteLatLong = [];
          $scope.model.fromRouteStops.forEach((d) => {
            if (d.lat && d.long) {
              $scope.sourceRouteLatLong.push(new Array(d.lat, d.long));
            }
          })
        }

        $scope.getDestinationRouteLatLong = () => {
          $scope.destinationRouteLatLong = [];
          $scope.model.destinationRouteStops.forEach((d) => {
            if (d.lat && d.long) {
              $scope.destinationRouteLatLong.push(new Array(d.lat, d.long));
            }
          })
        }

        $scope.ok = () => {
          $scope.model.isUpdating = true;
          $scope.model.transferredStops.map((obj) => {
            obj.toRouteSequence = _.findIndex($scope.model.destinationRouteStops, { locationId: obj.locationId }) + 1
          })
          callback({
            modal: routeStopTransferModal,
            transferredStops: $scope.model.transferredStops,
            fromRoutesData: $scope.model.fromRouteStops,
            destinationRoutesData: $scope.model.destinationRouteStops,
            fromRouteId: $scope.model.fromRouteId,
            fromRouteDate: moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),
            toRouteId: $scope.model.toRouteId,
            toRouteDate: moment($scope.model.vaultDate).format('YYYY-MM-DD'),
            $scope: $scope
          });
        }

        $scope.cancel = () => {
          negative({
            modal: routeStopTransferModal,
            needsRefresh: $scope.model.needsRefresh,
            totalTransferredStops: $scope.model.totalTransferredStops,
            totalTransferredShipments: $scope.model.totalTransferredShipments,
            requireThrow: $scope.model.requireThrow
          });
        }

        $scope.isDestinationRouteNotReleased = () => {
          return $scope.model.toRouteId && !$scope.model.destinationRouteIsReleased;
        }

        $scope.releaseDestinationRoute = () => {
          if (!$scope.model.toRouteId) return;
          
          $scope.model.releaseRouteStatus = 'processing';
          const formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
          
          RouteService.releaseRoute($scope.model.toRouteId, formattedDate, $scope.model.branchId, 'route_control')
            .then((res) => {
              if (res.status) {
                $scope.model.releaseRouteStatus = 'success';
                $scope.model.destinationRouteIsReleased = true;
                const selectedRoute = $scope.model.allRoutes.find(route => route.routeId === $scope.model.toRouteId);
                if (selectedRoute) {
                  selectedRoute.isReleased = true;
                  selectedRoute.lastReleasedAt = new Date();
                }
                $scope.model.transferredStops = []; 
                if ($scope.mapTwo) {
                  $scope.model.destinationRoute.forEach((id) => {
                    $scope.mapTwo.removeLayer(id);
                  });
                  $scope.mapTwo.remove();
                  $scope.mapTwo = null;
                }
                if ($scope.mapOne) {
                  $scope.model.originRoute.forEach((id) => {
                    $scope.mapOne.removeLayer(id);
                  });
                  $scope.mapOne.remove();
                  $scope.mapOne = null;
                }
                $scope.model.destinationRoute = [];
                $scope.model.originRoute = [];
                $scope.model.isMapInitialized = true;
                $scope.model.isSourceMapInitialized = true;
                
                return $q.all([
                  $scope.getRouteStops($scope.model.fromRouteId, null, moment($scope.model.fromRouteDate).format('YYYY-MM-DD'), $scope.model.branchId),
                  $scope.getRouteStops(null, $scope.model.toRouteId, formattedDate, $scope.model.branchId)
                ]);
              }
            })
            .then((data) => {
              if (data) {
                // Reload source route stops to restore dragged items
                $scope.model.fromRouteStops = data[0].resultOne;
                applyStopTransferDisability($scope.model.fromRouteStops);
                $scope.getSourceRouteLatLong();
                loadMap(data[0]);
                
                // Reload destination route stops
                $scope.model.destinationRouteStops = data[1].resultTwo;
                $scope.model.destinationRouteLength = data[1].resultTwo.length;
                refreshDestSequenceInputs();
                $scope.getDestinationRouteLatLong();
                $scope.loadSecondMap(data[1]);
              }
            })
            .catch((err) => {
              $scope.model.releaseRouteStatus = 'error';
              if (err && err.data && err.data.message) {
                Modal.errorModal('error.' + err.data.message);
              }
            })
            .finally(() => {
              $timeout(() => {
                $scope.model.releaseRouteStatus = '';
              }, 3000);
            });
        }

        init();
      }]
    })
  }

  let routeSequenceModal = (date, route, branch, branchInfo, callback, negative) => {
    let routeSequenceModal = $uibModal.open({
      template: routeSequenceTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',

      controller: ['$scope', '$q', 'RouteService', 'RouteStopService', 'Modal', 'LocationService', 'RouteProgressService', function ($scope, $q, RouteService, RouteStopService, Modal, LocationService, RouteProgressService) {

        $scope.model = {
          loading: false,
          vaultDate: date,
          branchId: branch,
          route: route,
          selectedDay: 'Mon',
          dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          currentDay: "",
          routeStopList: [],
          sequenceInput: [],
          routeData: [],
          isInitialized: true,
          lat: 0,
          long: 0,
          totalLatLongLocations: 0,
          centerLattitude: 0,
          centerLongitude: 0,
          branchInfo: branchInfo
        };

        $scope.loadImage = (image) => {
          $scope.icon = {
            'REGULAR': 'regular.png',
            'ATM': 'atm.png',
            'BANK': 'bank.png',
            'NO_SHIP_NO_GO': 'nsng.png',
            'INTERNAL': 'internal.png',
            'TRUCK': 'truck.png',
            'TANKER': 'tanker.png',
            'WINDOW': 'window.png',
            'CARRIER': 'carrier.png',
            'ON_CALL': 'oncall.png',
            'LOCKER': 'locker.png',
            'VAULT': 'vault.png',
            'DELIVERY': 'delivery.png'
          }

          let imgURL = $scope.icon[image]
          return require('../../../assets/images/' + imgURL);
        }

        const init = () => {
          // get current vaultDate day
          const today = $scope.model.vaultDate.getDay();
          $scope.model.currentDay = $scope.model.dayOfWeek[today];

          // load Route Stops
          $scope.loadRouteStop()
        }

        $scope.loadRouteStop = () => {
          $scope.model.loading = true;
          $scope.locationLatLong = [];
          const defer = $q.defer();

          const searchObj = {
            queryJSON: {
              rules: [{
                field: "routeId",
                condition: "=",
                data: $scope.model.route
              },
              {
                field: "routeDate",
                condition: "=",
                data: moment($scope.model.vaultDate).format('YYYY-MM-DD')
              },
              ],
              operator: 'AND',
            }
          }

          const formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');

          $q.all([
            RouteStopService.all(searchObj, 0, 1000),
            RouteProgressService.getRouteOriginationCoordinates($scope.model.route, formattedDate).catch((err) => {
              console.log('Error loading route progress stops coordinates:', err);
              return { truckCoordinatesInfo: [], userCoordinatesInfo: [] };
            })
          ])
            .then(([routeStopData, routeProgressData]) => {
              $scope.model.loading = false;
              $scope.model.routeStopList = routeStopData.results;
              refreshSequenceInputs();
              $scope.model.truckCoordinatesInfo = routeProgressData.truckCoordinatesInfo || [];
              $scope.model.userCoordinatesInfo = routeProgressData.userCoordinatesInfo || [];

              const userCoordinatesInfo = routeProgressData.userCoordinatesInfo || [];
              const truckCoordinatesInfo = routeProgressData.truckCoordinatesInfo || [];

              const isUserOriginMismatch = userCoordinatesInfo.length > 0 && userCoordinatesInfo[0].userOrigin && userCoordinatesInfo[0].userOrigin !== 'USER';
              const hasUserNoCoordinates = userCoordinatesInfo.length > 0 && (!userCoordinatesInfo[0].lat || !userCoordinatesInfo[0].long);
              const hasTruckNoCoordinates = truckCoordinatesInfo.length > 0 && (!truckCoordinatesInfo[0].lat || !truckCoordinatesInfo[0].long);

              if (isUserOriginMismatch) {
                $scope.model.originationError = 'message.originationUserMismatchError';
              } else if (hasUserNoCoordinates) {
                $scope.model.originationError = 'message.originationUserError';
              } else if (hasTruckNoCoordinates) {
                $scope.model.originationError = 'message.originationTruckError';
              } else {
                $scope.model.originationError = null;
              }
              $scope.locationIds = $scope.model.routeStopList.map(loc => loc.locationId);
              if ($scope.model.routeStopList.length) {
                $scope.model.routeStopList.forEach((d, index) => {
                  if (d.location.lat && d.location.long) {
                    $scope.locationLatLong.push(new Array(d.location.lat, d.location.long));
                    $scope.model.totalLatLongLocations += 1; // locations which had lat, long value counted as totalLatLongLocations
                    $scope.model.lat += d.location.lat; // sum of Lattitude value of location 
                    $scope.model.long += d.location.long; //  sum of Longitude value of location 
                  }
                })
              }
              defer.resolve(routeStopData);
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
          defer.promise.then((data) => {
            setMarkers(data.results) // set marker position based on location's lat long value
          })
        }

        const setMarkers = (data) => {
          $scope.routePosition = 0;

          setTimeout(() => {
            if ($scope.model.isInitialized) {
              $scope.model.centerLattitude = $scope.model.lat / $scope.model.totalLatLongLocations || 39.68649209557518;
              $scope.model.centerLongitude = $scope.model.long / $scope.model.totalLatLongLocations || -101.48273981764913;

              $scope.map = L.map('map', {
                // center: [$scope.model.centerLattitude, $scope.model.centerLongitude],
                // zoom: 11
              });

              let fallbackLatLong = null;
              const branchInfo = $scope.model.branchInfo || {};
              if (branchInfo.gpsLat && branchInfo.gpsLong) {
                fallbackLatLong = [branchInfo.gpsLat, branchInfo.gpsLong];
              }
              const truckCoordinatesInfo = ($scope.model.truckCoordinatesInfo && $scope.model.truckCoordinatesInfo[0]) || {};
              const userCoordinatesInfo = ($scope.model.userCoordinatesInfo && $scope.model.userCoordinatesInfo[0]) || {};
              if (truckCoordinatesInfo.lat && truckCoordinatesInfo.long) {
                fallbackLatLong = [truckCoordinatesInfo.lat, truckCoordinatesInfo.long];
              } else if (userCoordinatesInfo.lat && userCoordinatesInfo.long && userCoordinatesInfo.userOrigin === 'USER') {
                fallbackLatLong = [userCoordinatesInfo.lat, userCoordinatesInfo.long];
              }

              if ($scope.locationLatLong.length) {
                $scope.map.fitBounds($scope.locationLatLong);
              } else if (fallbackLatLong) {
                $scope.map.fitBounds([fallbackLatLong]);
              }

              L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              }).addTo($scope.map);
            }

            // Stops sharing the exact same lat/long would otherwise stack into one
            // unclickable pin -- fan duplicates out in a tiny circle so each stays visible.
            const coordCounts = {}, coordSeen = {};
            data.forEach((s) => {
              if (s && s.location && s.location.lat && s.location.long) {
                const key = s.location.lat + ',' + s.location.long;
                coordCounts[key] = (coordCounts[key] || 0) + 1;
              }
            });

            data.forEach((sequenceData) => {
              if (sequenceData && sequenceData.location && sequenceData.location.lat && sequenceData.location.long) {
                $scope.routePosition = _.findIndex(data, { locationId: sequenceData.locationId }) + 1;
                $scope.model.actualLat = parseFloat(sequenceData.location.lat);
                $scope.model.actualLong = parseFloat(sequenceData.location.long);

                const coordKey = sequenceData.location.lat + ',' + sequenceData.location.long;
                const stopsAtCoord = coordCounts[coordKey];
                if (stopsAtCoord > 1) {
                  const seenIndex = coordSeen[coordKey] = (coordSeen[coordKey] || 0) + 1;
                  const angle = (2 * Math.PI * (seenIndex - 1)) / stopsAtCoord;
                  const offset = 0.00008;
                  $scope.model.actualLat += offset * Math.cos(angle);
                  $scope.model.actualLong += offset * Math.sin(angle);
                }

                $scope.model.locationInfo = '<strong>' + sequenceData.location.name + '</strong>' + '<br>' + sequenceData.location.address + ' - ' + sequenceData.location.zip +
                  '<br>' + sequenceData.location.city + ', ' + sequenceData.location.state;

                const id = L.marker([$scope.model.actualLat, $scope.model.actualLong],
                  {
                    icon: new L.AwesomeNumberMarkers({
                      number: $scope.routePosition,
                      markerColor: "blue"
                    })
                  })
                  .addTo($scope.map)
                  .bindPopup($scope.model.locationInfo)

                id.on('mouseover', function () {
                  id.openPopup();
                });

                id.on('mouseout', function () {
                  id.closePopup();
                });

                $scope.model.routeData.push(id);
              }
            })
            $scope.addBranchDetails();
          }, 100)
        }

        $scope.selectDay = (day) => {
          if (day.value != $scope.model.currentDay) return;
          $scope.model.selectedDay = day.value;
        }

        const refreshSequenceInputs = () => {
          $scope.model.sequenceInput = $scope.model.routeStopList.map((stop, position) => position + 1);
        }

        $scope.locationMoved = (index) => {
          $scope.model.isInitialized = false;
          $scope.model.routeStopList.splice(index, 1);
          refreshSequenceInputs();
          setMarkers($scope.model.routeStopList)
        }

        const moveStopToIndex = (index, targetIndex) => {
          const list = $scope.model.routeStopList;
          if (targetIndex < 0 || targetIndex >= list.length || targetIndex === index) {
            return refreshSequenceInputs();
          }

          $scope.model.isInitialized = false;
          list.splice(targetIndex, 0, list.splice(index, 1)[0]);
          refreshSequenceInputs();
          setMarkers(list);
        }

        $scope.moveStop = (index, offset) => {
          moveStopToIndex(index, index + offset);
        }

        $scope.sequenceTyped = (index) => {
          const typed = $scope.model.sequenceInput[index];

          if (!angular.isNumber(typed) || isNaN(typed)) return refreshSequenceInputs();

          moveStopToIndex(index, Math.round(typed) - 1);
        }

        $scope.autoOptimizeRouteStop = () => {
          $scope.loading = true;
          $scope.model.isInitialized = true;
          const routeDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');

          RouteStopService.autoOptimizeRouteStops(routeDate, $scope.model.route)
            .then((data) => {
              $scope.loadRouteStop(); // refresh data after route stop optimized
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message)
              }
              console.log(err);
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        // Add branch, truck and user details marker on map
        $scope.addBranchDetails = () => {
          let locationLat, locationLong, iconNumber, iconColor, locationInfo;
          const truckCoordinatesInfo = ($scope.model.truckCoordinatesInfo && $scope.model.truckCoordinatesInfo[0]) || {};
          const userCoordinatesInfo = ($scope.model.userCoordinatesInfo && $scope.model.userCoordinatesInfo[0]) || {};

          const isUserOriginMismatch = userCoordinatesInfo.id && userCoordinatesInfo.userOrigin && userCoordinatesInfo.userOrigin !== 'USER';

          if (truckCoordinatesInfo.id) {
            locationLat = truckCoordinatesInfo.lat;
            locationLong = truckCoordinatesInfo.long;
            iconNumber = 'T';
            iconColor = 'black';
            locationInfo = '<strong>' + truckCoordinatesInfo.id + '</strong><br>' + truckCoordinatesInfo.address + ' - ' + truckCoordinatesInfo.zip +
              '<br>' + truckCoordinatesInfo.city + ', ' + truckCoordinatesInfo.state;
          } else if (userCoordinatesInfo.id && !isUserOriginMismatch) {
            locationLat = userCoordinatesInfo.lat;
            locationLong = userCoordinatesInfo.long;
            iconNumber = 'U';
            iconColor = 'black';
            locationInfo = '<strong>' + userCoordinatesInfo.id + '</strong><br>' + userCoordinatesInfo.address + ' - ' + userCoordinatesInfo.zip +
              '<br>' + userCoordinatesInfo.city + ', ' + userCoordinatesInfo.state;
          } else if ($scope.model.branchInfo) {
            locationLat = $scope.model.branchInfo.gpsLat;
            locationLong = $scope.model.branchInfo.gpsLong;
            iconNumber = 'B';
            iconColor = 'black';
            locationInfo = '<strong>' + $scope.model.branchInfo.branchId + '</strong><br>' + $scope.model.branchInfo.address + ' - ' + $scope.model.branchInfo.zip +
              '<br>' + $scope.model.branchInfo.city + ', ' + $scope.model.branchInfo.state;
          }

          if (locationLat && locationLong) {
            const id = L.marker([locationLat, locationLong],
              {
                icon: new L.AwesomeNumberMarkers({
                  number: iconNumber,
                  markerColor: iconColor
                })
              })
              .addTo($scope.map)
              .bindPopup(locationInfo)

            id.on('mouseover', function () {
              id.openPopup();
            });

            id.on('mouseout', function () {
              id.closePopup();
            });
          }
        }

        $scope.fixLocationGeoCode = () => {
          $scope.model.updatingLocGeoCode = true;
          LocationService.fixGeocoding($scope.model.branchId, $scope.locationIds)
            .then(() => {
              $scope.loadRouteStop();
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.updatingLocGeoCode = false;
            })
        }

        $scope.ok = () => {
          callback({
            modal: routeSequenceModal,
            routeSequence: $scope.model.routeStopList
          });
        }

        $scope.cancel = () => {
          routeSequenceModal.close();
        }

        init();
      }]
    })
  }

  let remainingResiduals = (residualShipments, locationId, branch, callback, negative) => {
    let remainingResidualModal = $uibModal.open({
      template: remainingResidualTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$q', '$translate', 'DataCounter', '$state', 'DateUtil', 'AtmResidualService', 'CommonLayoutService', 'Navigation',
        function ($scope, $q, $translate, DataCounter, $state, DateUtil, AtmResidualService, CommonLayoutService, Navigation) {
        $scope.model = {
          shipment: '',
          locationId: '',
          sortColumn: "vaultDate",
          reverseSort: false,
          routeList: [],
          route: null,
          messengerIdList: [],
          messengerId: null,
          customerList: [],
          selectedCustomers: [],
          vaultDate: null,
          branchId: branch,
          amount: 0
        };
        $scope.exportLoading = false;
        $scope.dateOptions = {
          showWeeks: false,
        };
        const init = () => {
          $scope.model.shipment = residualShipments.result;
          $scope.model.amount = residualShipments.amount;
          $scope.model.locationId = locationId;
          $scope.model.routeList = $scope.getRoutes();
          $scope.model.messengerIdList = $scope.getMessengerIds();
          $scope.model.customerList = $scope.getCustomers();
          $scope.model.selectedCustomers = $scope.model.customerList.slice();
        }
        $scope.getOrderType = (shiptype, type) => {
          if (shiptype == "C" && type !== null) {
            return $translate.instant('atm_residual.order_type_' + type);
          }
          else if (shiptype == "C" && type == null) {
            return shiptype.toUpperCase();
          }
          else {
            return shiptype.toUpperCase();
          }
        }

        $scope.maskingString = (trackingId) => {
          return CommonLayoutService.maskingString(trackingId);
        }

        $scope.scanBagId = (trackingId) => {
          callback({
            modal: remainingResidualModal,
            trackingId: trackingId
          });
          remainingResidualModal.close();
        }

        $scope.goToRouteTab = (data) => {
          remainingResidualModal.close();
          const obj = {
            routeId: data.routeId,
            vaultDate: data.vaultDate,
            isRedirected: true
          }
          DataCounter.setData(obj);
          $state.go('branchManagement.routes');
        }

        $scope.goToUserTab = (messengerId) => {
          if (!messengerId) return;
          Navigation.goToUserTab(messengerId, remainingResidualModal);
        }

        $scope.goToCustomerTab = (customerId) => {
          if (!customerId) return;
          remainingResidualModal.close();
          $state.go('customer.edit', { id: customerId });
        }

        $scope.sortData = (column) => {
          // if(column=='type'){
            $scope.model.shipment.forEach((s)=>{
              s.type=$scope.getOrderType(s.shiptype, s.orderType)
            })
          // }
          $scope.model.reverseSort = ($scope.model.sortColumn == column) ? !$scope.model.reverseSort : false;
          $scope.model.sortColumn = column;
        }

        $scope.goToServiceHistory = (data) => {
          remainingResidualModal.close();
          const obj = {
            locationId: data.fromLocationId,
            vaultDate: null,
            isRedirected: true
          }
          DataCounter.setData(obj);
          $state.go('branchManagement.locations');
        }

        $scope.goToOrderHistory = (data) => {
          remainingResidualModal.close();
          const obj = {
            orderNo: data.orderNo,
            vaultDate: data.vaultDate,
            isRedirected: true,
            isInProcess: true,
            fundingSourceId: $scope.model.locationId.Id
          }
          DataCounter.setData(obj);
          $state.go('branchManagement.orders');
        }

        $scope.cancel = () => {
          negative({
            modal: remainingResidualModal
          })
        }

        $scope.getRoutes = () => {
          const grouped = _.groupBy($scope.model.shipment, 'routeId');
          return Object.keys(grouped);;
        }

        $scope.getMessengerIds = () => {
          let path = 'messengerId';
          let grouped = _($scope.model.shipment)
            .filter(object => !!object[path])
            .groupBy(path)
            .value();
          return Object.keys(grouped)
        }

        $scope.getCustomers = () => {
          let grouped = _.groupBy($scope.model.shipment.filter(row => row.customerId), 'customerId');
          let list = Object.keys(grouped).map(key => {
            const row = grouped[key][0];
            return {
              customerId: row.customerId,
              customerName: row.customerName,
              customerLabel: row.customerId + ' | ' + row.customerName,
              ticked: true
            };
          });
          return _.sortBy(list, 'customerLabel');
        }

        $scope.selectAllCustomers = () => {
          $scope.model.customerList.forEach(c => c.ticked = true);
          $scope.model.selectedCustomers = $scope.model.customerList.slice();
        };

        $scope.selectNoCustomers = () => {
          $scope.model.customerList.forEach(c => c.ticked = false);
          $scope.model.selectedCustomers = [];
        };

        function filterByRouteId(row) {
          if ($scope.model.route) return row['routeId'] && row['routeId'].indexOf($scope.model.route) > -1
          else return row;
        }

        function filterByMessengerId(row) {
          if ($scope.model.messengerId) return row['messengerId'] && row['messengerId'] == $scope.model.messengerId; // && row['messengerId'].indexOf($scope.model.messengerId) > -1
          else return row;
        }

        function filterByVaultDate(row) {
          if ($scope.model.vaultDate) {
            let date = moment($scope.model.vaultDate).format('YYYY-MM-DD');
            return row['vaultDate'] && moment.utc(row['vaultDate']).format('YYYY-MM-DD') == date;
          }
          return row;

        }

        function getTickedCustomers() {
          return $scope.model.customerList.filter(c => c.ticked);
        }

        function filterByCustomer(row) {
          const selected = getTickedCustomers();
          if (!selected.length) return true;
          return selected.some(c => c.customerId === row['customerId']);
        }

        $scope.filterData = () => {
          return (row) => {
            return filterByRouteId(row) && filterByMessengerId(row) && filterByVaultDate(row) && filterByCustomer(row);
          }
        };

        $scope.hasFilteredData = () => {
          return $scope.model.shipment.some($scope.filterData());
        };

        $scope.exportRemainingResiduals = () => {
          if ($scope.exportLoading) return;
          $scope.exportLoading = true;
          let date = $scope.model.vaultDate ? moment($scope.model.vaultDate).format('YYYY-MM-DD') : null;
          let tickedCustomers = getTickedCustomers();
          let customerIds = tickedCustomers.length ? tickedCustomers.map(c => c.customerId) : null;
          AtmResidualService.exportRemainingResiduals(
            $scope.model.route, date, $scope.model.messengerId, locationId.Id, branch, customerIds)
            .then((result) => {
              $scope.exportLoading = false;
              if (result.reportData && result.reportData.length) {
                $scope.downloadFile('Remaining_Residual_' + ' ' + locationId.Value, result.reportData)
              }
            })
            .catch(err => {
              $scope.exportLoading = false;
              console.log(err)
            })
        }
        $scope.downloadFile = (filename, reportData) => {
          const fileName = filename.concat('.csv');
          const a = document.createElement("a");
          document.body.appendChild(a);
          const file = new Blob([reportData], { type: 'application/csv' });
          const fileURL = window.URL.createObjectURL(file);
          a.href = fileURL;
          a.download = fileName;
          a.click();
        };

        $scope.generatePrint = () => {
          let shipments = $scope.model.shipment.filter(row => filterByRouteId(row) && filterByMessengerId(row) && filterByVaultDate(row) && filterByCustomer(row))
          const obj = {
            route: $scope.model.route,
            branchId: $scope.model.branchId,
            fundingSource: $scope.model.locationId.Key,
            pendingATMResiduals: shipments, //$scope.model.route ? $scope.model.shipment.filter(shp => shp.routeId === $scope.model.route) : $scope.model.shipment,
            doPrint: true,
            amount: $scope.model.amount
          }
          obj.pendingATMResiduals = $scope.sortByKey(obj.pendingATMResiduals, $scope.model.sortColumn);
          const path = $state.href('atmCountPrint');
          window.w = window.open(path, '_blank');
          window.w.printData = obj;
        }

        $scope.sortByKey = (array, key) => {
          let order = $scope.model.reverseSort ? 'desc' : 'asc';
          return _.orderBy(array, [key], [order]);
        }

        init()
      }]
    })
  }

  // let remainingToThrow = (routeId, vaultDate, branchId, isCoinCheckOut, callback, negative) => {
  let remainingToThrow = (routeId, formattedDate, vaultDate, branchId, isCoinCheckOut, callback, negative) => {
    let remainingToThrowModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: remainingToThrowTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'ShipmentService', '$q', '$location', 'DataCounter', 'Navigation', ($scope, $translate, ShipmentService, $q, $location, DataCounter, Navigation) => {

        $scope.model = {
          remainingToThrow: [],
          routeId: routeId,
          loading: false,
          isCoinCheckOut: isCoinCheckOut
        };

        const init = () => {
          $scope.model.loading = true;
          ShipmentService.remainingToThrowShipments(routeId, formattedDate, branchId, isCoinCheckOut)
            .then((data) => {
              $scope.model.loading = false;
              $scope.model.remainingToThrow = data.results;
            })
            .catch((err) => {
              console.log(err)
            })
        }

        // redirect to route throw screen
        $scope.redirectToRouteThrow = () => {
          remainingToThrowModal.close();
          const data = {
            vaultDate: vaultDate,
            isRedirected: true
          }
          DataCounter.setData(data);
          $location.url('/app/route-throw');
        }

        $scope.cancel = () => {
          remainingToThrowModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: remainingToThrowModal
          });
          modal.close()
        }

        $scope.goToItemHistory = (trackingId) => {
          return Navigation.goToItemHistory(trackingId, remainingToThrowModal);
        }

        init()
      }]
    })
  }

  let routeCheckoutInfo = (isShpCheckedOut, routeId, vaultDate, branchId, remainingToCheckedout, field, isCoinVerified, status, callback) => {
    let routeCheckoutInfoModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: routeCheckoutInfoTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'ShipmentService', ($scope, $translate, ShipmentService) => {
        $scope.model = {
          loading: false,
          isShpCheckedOut: isShpCheckedOut,
          routeId: routeId,
          shipmentInfo: [],
          field: field,
          isCoinVerified: isCoinVerified,
          status: status
        }

        if ($scope.model.isShpCheckedOut) {
          $scope.shipmentSearchObj = () => {
            const searchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'branchId',
                    condition: '=',
                    data: branchId
                  },
                  {
                    field: 'routeId',
                    condition: '=',
                    data: $scope.model.routeId
                  },
                  {
                    field: 'vaultDate',
                    condition: '=',
                    data: vaultDate
                  },
                  {
                    field: 'checkedOut',
                    condition: '=',
                    data: $scope.model.isShpCheckedOut
                  },
                  {
                    field: 'deleted',
                    condition: '=',
                    data: false
                  },
                  {
                    field: 'bagSeal',
                    condition: '=',
                    data: null 
                  }
                ],
                operator: 'AND'
              }
            }

            if ($scope.model.field) {
              searchObj.queryJSON.rules.push({
                field: 'coinFlag',
                condition: '=',
                data: ($scope.model.field === 'cash') ? false : true
              });
            }

            return searchObj.queryJSON.rules.length ? searchObj : null;
          }
        }

        const init = () => {
          if ($scope.model.isShpCheckedOut) {
            $scope.model.loading = true;
            const searchObj = $scope.shipmentSearchObj();
            ShipmentService.all(searchObj, 0, 1000)
              .then((data) => {
                $scope.model.loading = false;
                $scope.model.shipmentInfo = data.results;
              })
              .catch((err) => {
                console.log(err)
              })
          }
          else {
            if ($scope.model.field) {
              remainingToCheckedout.filter((data) => {
                if (data.coinFlag && $scope.model.field === 'coin' && !$scope.model.isCoinVerified && $scope.model.status == 'remaining') $scope.model.shipmentInfo.push(data);
                else if (data.coinFlag && $scope.model.field === 'coin' && $scope.model.isCoinVerified && $scope.model.status == 'completed') $scope.model.shipmentInfo.push(data);
                else if (!data.coinFlag && $scope.model.field === 'cash' && ['E_DELIVERY_NOT_ON_HOLD'].includes(data.message)) $scope.model.shipmentInfo.push(data);
              })
            }
            else $scope.model.shipmentInfo = remainingToCheckedout.filter((record) => record.message === 'E_DELIVERY_NOT_ON_HOLD');
          }
        }

        $scope.cancel = () => {
          routeCheckoutInfoModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: routeCheckoutInfoModal
          });
          modal.close()
        }
        init()
      }]
    })
  }

  let routeCheckinInfo = (isShpCheckedIn, routeId, vaultDate, branchId, remainingToCheckin, callback, negative) => {
    let routeCheckinInfoModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: routeCheckinInfoTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'ShipmentService', ($scope, $translate, ShipmentService) => {
        $scope.model = {
          loading: false,
          isShpCheckedIn: isShpCheckedIn,
          routeId: routeId,
          shipmentInfo: []
        }

        if ($scope.model.isShpCheckedIn) {
          $scope.shipmentSearchObj = () => {
            const searchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'branchId',
                    condition: '=',
                    data: branchId
                  },
                  {
                    field: 'bagSeal',
                    condition: '=',
                    data: null
                  },
                  {
                    field: 'routeId',
                    condition: '=',
                    data: $scope.model.routeId
                  },
                  {
                    field: 'vaultDate',
                    condition: '=',
                    data: vaultDate
                  },
                  {
                    field: 'checkedIn',
                    condition: '=',
                    data: $scope.model.isShpCheckedIn
                  },
                  {
                    field: 'deleted',
                    condition: '=',
                    data: false
                  }
                ],
                operator: 'AND'
              }
            }
            return searchObj.queryJSON.rules.length ? searchObj : null;
          }
        }

        const init = () => {
          if ($scope.model.isShpCheckedIn) {
            $scope.model.loading = true;
            const searchObj = $scope.shipmentSearchObj();
            ShipmentService.all(searchObj, 0, 1000)
              .then((data) => {
                $scope.model.loading = false;
                $scope.model.shipmentInfo = data.results;
              })
              .catch((err) => {
                console.log(err)
              })
          }
          else {
            $scope.model.shipmentInfo = remainingToCheckin;
          }
        }

        $scope.cancel = () => {
          routeCheckinInfoModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: routeCheckinInfoModal
          })
          modal.close()
        }
        init()
      }]
    })
  }


  let remainingToPack = (routeId, vaultDate, branchId, isCoinCheckOut, callback, negative) => {
    let remainingToPackModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: remainingToPackTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'ShipmentService', '$q', '$location', '$rootScope', 'DataCounter', ($scope, $translate, ShipmentService, $q, $location, $rootScope, DataCounter) => {

        $scope.model = {
          pendingPack: [],
          routeId: routeId,
          loading: false
        };

        const init = () => {
          $scope.model.loading = true;
          ShipmentService.remainingToPackShipments(routeId, vaultDate, branchId, isCoinCheckOut)
            .then((data) => {
              $scope.model.loading = false;
              $scope.model.pendingPack = data.results;
            })
            .catch((err) => {
              console.log(err)
            })
        }

        $scope.redirectToOrderPack = () => {
          remainingToPackModal.close();
          const data = {
            routeId: $scope.model.routeId,
            vaultDate: vaultDate,
            locationId: $scope.model.pendingPack[0].fromLocationId,
            isRedirected: true
          }
          DataCounter.setPendingPackData(data);
          $location.url('/app/order-packing');
        }

        $scope.cancel = () => {
          remainingToPackModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: remainingToPackModal
          });
          modal.close()
        }
        init()
      }]
    })
  }

  let branchTransferModal = (shipmentData, callback, negative) => {
    let branchTransfer = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: branchTransferTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'ShipmentService', 'BranchService', 'SetupService', 'RouteService', ($scope, $translate, ShipmentService, BranchService, SetupService, RouteService) => {
        $scope.model = {
          selectedBranch: null,
          allBranch: [],
          trackingId: '',
          comment: '',
          loading: false,
          loadingRoutes: false,
          shipmentData: shipmentData,
          date: null,
          vaultDate: null,
          routeId: null,
          routeList: [],
          sameTransferError: false,
          dateOptions: { minDate: new Date() },
          isGettingRoutes: false,
          isGettingLocationRoutes: false,
          isInitializing: false,
          routeTotalRecords: 0,
          routeOffset: 0,
          routeSearchKey: '',
        }

        const formatDate = (d) => {
          if (!d) return null;
          return (typeof d === 'string') ? moment.utc(d).format('YYYY-MM-DD') : moment(d).format('YYYY-MM-DD');
        }

        const init = () => {
          $scope.model.loading = true;
          BranchService.all(null, 0, 100)
            .then((data) => {
              $scope.model.loading = false;
              $scope.model.allBranch = data.results;
            })
            .catch((err) => {
              console.log(err);
            })
        }

        $scope.mappingData = (arr, label, value) => {
          return arr.map(item => {
            const arrayObject = {
              Key: (item[value] || item.routeId || item.id) + " | " + (item[label] || item.routeName || item.name),
              Value: item[value] || item.routeId || item.id,
              dataObj: item,
            };
            return arrayObject;
          });
        }

        $scope.getActiveRoutes = (searchKey, offset) => {
          searchKey = searchKey || "";
          $scope.model.isGettingRoutes = true;
          return RouteService.getAvailableRoutes($scope.model.selectedBranch, formatDate($scope.model.vaultDate), offset, 20, searchKey)
            .then(res => {
              const routes = $scope.mappingData(res.results, "name", "id");
              if (offset === 0 || offset === undefined) {
                $scope.model.routeList = routes;
                $scope.model.routeTotalRecords = res.total;
              } else {
                $scope.model.routeList = $scope.model.routeList.concat(routes);
              }
            })
            .catch(err => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.isGettingRoutes = false;
            });
        }

        $scope.reloadRouteData = (searchKey, offset) => {
          $scope.model.routeOffset = offset;
          $scope.model.routeSearchKey = searchKey;
          $scope.getActiveRoutes(searchKey, offset);
        }


        $scope.onBranchChange = () => {
          $scope.model.loading = true;
          $scope.model.date = null;
          $scope.model.vaultDate = null;
          $scope.model.routeId = null;
          $scope.model.routeList = [];
          $scope.model.sameTransferError = false;
          $scope.model.isGettingRoutes = false;
          $scope.model.isGettingLocationRoutes = false;
          $scope.model.isInitializing = false;
          if ($scope.model.selectedBranch) {
            SetupService.get($scope.model.selectedBranch)
              .then((setup) => {
                if (setup && setup.currentVaultDate) {
                  const utcMoment = moment.utc(setup.currentVaultDate);
                  const dateObj = new Date(utcMoment.year(), utcMoment.month(), utcMoment.date(), 0, 0, 0, 0);
                  $scope.model.date = dateObj;
                  $scope.model.vaultDate = dateObj;
                  $scope.minVaultDate = {
                    minDate: dateObj
                  };
                  $scope.model.minVaultDate = $scope.minVaultDate;
                  $scope.model.isInitializing = true;
                  $scope.onVaultDateChange();
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.loading = false;
              });
          } else {
            $scope.model.loading = false;
          }
        }

        let lastVaultDate = null;
        $scope.onVaultDateChange = () => {
          const currentDate = $scope.model.date ? moment($scope.model.date).format('YYYY-MM-DD') : null;
          if (currentDate && currentDate === lastVaultDate) return;
          lastVaultDate = currentDate;

          $scope.model.routeId = null;
          $scope.model.sameTransferError = false;
          if ($scope.model.date) {
            $scope.model.vaultDate = $scope.model.date;
            $scope.getActiveRoutes("", 0)
          }
        }

        $scope.validateTransfer = () => {
          const sd = shipmentData;
          const selectedDate = $scope.model.vaultDate ? formatDate($scope.model.vaultDate) : null;
          const currentDate = sd.date ? formatDate(sd.date) : sd.vaultDate ? formatDate(sd.vaultDate) : null;
          const selectedRouteId = $scope.model.routeId ? ($scope.model.routeId.Value || $scope.model.routeId) : null;
          $scope.model.sameTransferError = (
            $scope.model.selectedBranch == sd.branchId &&
            selectedDate === currentDate &&
            selectedRouteId === sd.routeId
          );
        }

        $scope.$watchGroup(['model.selectedBranch', 'model.vaultDate', 'model.routeId'], () => {
          $scope.validateTransfer();
        });

        $scope.cancel = () => {
          branchTransfer.close();
        }

        $scope.ok = () => {
          const destRouteId = $scope.model.routeId ? ($scope.model.routeId.Value || $scope.model.routeId) : null;
          confirmSupervisor('shipment-branch-transfer', { trackingId: $scope.model.shipmentData.trackingId }, ({ modal, supId }) => {
            callback({
              modal: branchTransfer,
              selectedBranch: $scope.model.selectedBranch,
              selectedDate: formatDate($scope.model.vaultDate),
              selectedRoute: destRouteId,
              comment: $scope.model.comment || null,
              fromBranchId: $scope.model.shipmentData.branchId,
              supervisorId: supId
            });
            modal.close();
          }, ({ modal }) => {
            modal.close();
          })
        }

        init();
      }]
    })
  }

  let internalDeliveryModal = (shipmentData, callback, negative) => {
    let internalDelivery = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: internalDeliveryTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'ShipmentService', 'LocationService', 'User', ($scope, $translate, ShipmentService, LocationService, User) => {

        $scope.model = {
          branch: User.getUser().branchId,
          locations: [],
          comment: '',
          totalLocation: 0,
          shipmentData: shipmentData,
          location: ''
        }

        $scope.locationSearchObj = (searchKey) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [{
                field: "branchId",
                condition: "=",
                data: $scope.model.branch
              },
              {
                field: "active",
                condition: "=",
                data: true
              },
              {
                group: {
                  rules: [{
                    field: "locationType",
                    condition: "=",
                    data: 'BANK'
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: 'REGULAR'
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: 'ATM'
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: 'INTERNAL'
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: 'ON_CALL'
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: 'DELIVERY'
                  },
                  {
                    field: "locationType",
                    condition: "=",
                    data: 'NO_SHIP_NO_GO'
                  }],
                  operator: 'OR'
                }
              },
              {
                group: {
                  rules: [{
                    field: 'id',
                    condition: 'like',
                    data: '%' + searchKey + '%'
                  },
                  {
                    field: 'name',
                    condition: 'like',
                    data: '%' + searchKey + '%'
                  }
                  ],
                  operator: 'OR'
                }
              }],
              operator: "AND"
            }
          };
          return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        $scope.mappingLocations = (locations) => {
          return locations.map((data) => {
            return {
              Key: data.id + " | " + data.name,
              Value: data.id
            }
          });
        }

        const init = () => {
          $scope.model.loading = true;
          $scope.loadInternalLocations('', 0)
        }

        $scope.loadInternalLocations = (searchKey, offset) => {
          const searchObj = $scope.locationSearchObj(searchKey);

          LocationService.all(searchObj, offset, AppConstant.defaultPageLimit)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.totalLocation = data.total;
                $scope.model.locations = $scope.mappingLocations(data.results);
              }
              else {
                const Locations = $scope.mappingLocations(data.results);
                $scope.model.locations = $scope.model.locations.concat(Locations);
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.cancel = () => {
          internalDelivery.close();
        }

        $scope.ok = () => {
          confirmSupervisor('internal-delivery', { trackingId: $scope.model.shipmentData.trackingId }, ({ model, supId }) => {
            callback({
              modal: internalDelivery,
              comment: $scope.model.comment || null,
              locationId: $scope.model.location.Value,
              supervisorId: supId
            });
            modal.close();
          }, ({ modal }) => {
            modal.close();
          })
        }

        init();
      }]
    })
  }

  let editTrackingIdModal = (trackingId, callback, negative) => {
    let editTrackingId = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: editTrackingIdTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'ShipmentService', ($scope, $translate, ScanService) => {
        $scope.model = {
          trackingId: trackingId,
          oldTrackingId: trackingId,
          comment: ''
        }

        const init = () => {
        }

        $scope.cancel = () => {
          editTrackingId.close();
        }

        $scope.ok = () => {
          confirmSupervisor('update-shipment-trackingId', { trackingId: $scope.model.trackingId }, ({ modal, supId }) => {
            callback({
              modal: editTrackingId,
              trackingId: $scope.model.trackingId,
              comment: $scope.model.comment,
              supervisorId: supId
            });
            modal.close();
          }, ({ modal }) => {
            modal.close();
          })
        }

        init();
      }]
    })
  }

  // let createCompanyModal = (callback, negative) => {
  //   let createCompany = $uibModal.open({
  //     animation: true,
  //     ariaLabelledBy: 'modal-title-top',
  //     ariaDescribedBy: 'modal-body-top',
  //     backdrop: 'static',
  //     template: createCompanyTemplate,
  //     size: 'md',

  //     controller: ['$scope', '$translate', ($scope, $translate) => {

  //       $scope.modes = [
  //         {
  //           label: 'Route',
  //           value: 'Route'
  //         },
  //         {
  //           label: 'FLM',
  //           value: 'FLM'
  //         },
  //       ]

  //       $scope.model = {
  //         status: true,
  //         mode: $scope.modes[0].value
  //       }

  //       $scope.toggleSwitchUI = {
  //         size: 'small',
  //         label: {
  //           on: $translate.instant('common.yes'),
  //           off: $translate.instant('common.no'),
  //         },
  //         onColor: 'success',
  //         offColor: 'danger'
  //       }

  //       const init = () => {

  //       }

  //       $scope.cancel = () => {
  //         createCompany.close()
  //       }

  //       $scope.ok = () => {
  //         callback({
  //           modal: createCompany
  //         });
  //         modal.close()
  //       }
  //     }]
  //   })
  // }

  let depositPackingInfoModal = (data, callback, negative) => {
    let depositPackingInfo = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: depositPackingInfoTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'Modal', 'AtmResidualDepositService', 'Navigation', ($scope, $translate, Modal, AtmResidualDepositService, Navigation) => {
        $scope.model = {
          trackingId: data.trackingId,
          contents: []
        }

        $scope.pagination = {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        };

        const init = () => {
          $scope.loadContents();
        }

        $scope.loadContents = () => {
          $scope.model.loading = true;
          AtmResidualDepositService.contents(data.id, $scope.pagination.pageLimit, ($scope.pagination.page - 1) * $scope.pagination.pageLimit)
            .then((res) => {
              $scope.model.loading = false;
              $scope.model.contents = res;
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                return Modal.errorModal(err.data.message)
              }
            })
        }

        $scope.cancel = () => {
          depositPackingInfo.close();
        }

        $scope.ok = () => {
          callback({
            modal: depositPackingInfo,
          });
          modal.close();
        }

        $scope.pageChange = () => {
          $scope.loadContents();
        }

        $scope.goToItemHistory = (trackingId) => {
          Navigation.goToItemHistory(trackingId, depositPackingInfo);
        }

        $scope.goToServiceHistory = (data) => {
          Navigation.goToServiceHistory(data.locationId, null, true, depositPackingInfo);
        }

        init();
      }]
    })
    rejectModal(depositPackingInfo, negative);
  }

  let lockStatusModal = (routeId, branch, date, isAutoOpenATMs, messengerId, callback, negative) => {
    let lockStatus = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: lockStatusTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'AtmCodesManagementService', 'Modal', '$q', 'UsersService', ($scope, $translate, AtmCodesManagementService, Modal, $q, UsersService) => {
        $scope.model = {
          routeId: routeId,
          branch: branch,
          date: date,
          isAutoOpenATMs: isAutoOpenATMs,
          lockStatusData: [],
          messengerId: messengerId,
          userData: ""
        }

        const init = () => {
          $scope.model.loading = true;

          $q.all([
            $scope.getUser(),
            AtmCodesManagementService.getLockStatus($scope.model.routeId, $scope.model.branch, $scope.model.date, $scope.model.isAutoOpenATMs)
          ])
            .then((res) => {
              $scope.model.lockStatusData = res[1].results;
            })
            .catch((err) => {
              console.log(err);
              if (err && err.data && err.data.message) {
                return Modal.errorModal(err.data.message)
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.getUser = () => {
          if ($scope.model.messengerId) {
            UsersService.get($scope.model.messengerId)
              .then((res) => {
                $scope.model.userData = res;
              })
              .catch((err) => {
                console.log(err);
              })
          }
        }

        $scope.cancel = () => {
          lockStatus.close();
        }

        $scope.ok = () => { }

        init();
      }]
    })
  }

  let ledgerTransactionLogModal = (data, callback, negative) => {
    let ledgerTransactionLog = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: ledgerTransactionLogTemplate,
      size: 'lg',

      controller: ['$scope', 'BulkCashService', 'Modal', '$translate', 'DataCounter', '$state', 'Navigation', ($scope, BulkCashService, Modal, $translate, DataCounter, $state, Navigation) => {
        $scope.model = {
          loading: false,
          transactionData: data,
          logs: [],
          vaultDate: '',
          ledgerEntry: {},
          isValid: false
        }

        const init = () => {
          $scope.model.loading = true;
          $scope.modifyString($scope.model.transactionData.comment);
          BulkCashService.ledgerTransactionLog(data.id, data.branchId)
            .then((data) => {
              $scope.model.logs = data;
              $scope.model.vaultDate = moment.utc(data.ledgerTransaction.vaultDate).format('YYYY-MM-DD');
              $scope.model.ledgerEntry = _.find($scope.model.logs.results, { 'denominationId': null });
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                return Modal.errorModal(err.data.message)
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.goToOrderHistory = (data) => {
          ledgerTransactionLog.close();
          const obj = {
            orderNo: data.orderNo,
            vaultDate: data.vaultDate,
            isRedirected: true,
            isInProcess: true,
            fundingSourceId: $scope.model.transactionData.branchFundingSourceId
          }
          DataCounter.setData(obj);
          $state.go('branchManagement.orders');
        }

        $scope.modifyString = (data) => {
          if (data) {
            $scope.model.isValid = data.startsWith('Residual count:');
            if ($scope.model.isValid) {
              $scope.splitString = data.split(',');
              $scope.trackingId = $scope.splitString[0].split(':')[1].trim();
            }
          }
        }

        $scope.goToAtmCount = () => {
          return Navigation.goToAtmCount($scope.trackingId, true, ledgerTransactionLog, $scope.model.transactionData.branchFundingSourceId);
        }

        $scope.cancel = () => {
          ledgerTransactionLog.close();
        }

        init();
      }]
    })
  }

  let atmCodesInfoModal = (cacheKey, callback, negative) => {
    let atmCodesInfo = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: atmCodesInfoTemplate,
      size: 'md',

      controller: ['$scope', 'ResetAtmCodeService', ($scope, ResetAtmCodeService) => {

        $scope.model = {
          cacheKey: cacheKey,
          loading: false,
          atmCodeValue: ''
        }

        const init = () => {
          $scope.model.loading = true;
          ResetAtmCodeService.getAtmCode($scope.model.cacheKey)
            .then((data) => {
              $scope.model.atmCodeValue = data.results;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.cancel = () => {
          atmCodesInfo.close();
        }

        init()
      }]
    })
  }

  let moveShipmentModal = (data, branchId, callback, negative) => {
    let moveShipment = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: moveShipmentTemplate,
      size: 'md',

      controller: ['$scope', 'RouteService', 'SetupService', '$q', 'DateUtil', ($scope, RouteService, SetupService, $q, DateUtil) => {

        $scope.model = {
          branch: branchId,
          totalRecord: 0,
          allRoutes: [],
          date: '',
          route: '',
          shipmentData: data
        }

        $scope.pagination = {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }

        const init = () => {
          $q.all([
            SetupService.get($scope.model.branch),
            $scope.loadRoutes('', 0)
          ])
            .then((data) => {
              const date = DateUtil.convertToDate(data[0].currentVaultDate);
              $scope.model.date = date;
              $scope.vaultDate = moment($scope.model.date).format('YYYY-MM-DD');
              $scope.minVaultDate = {
                minDate: $scope.vaultDate
              }
            })
        }

        $scope.loadRoutes = (searchKey, offset) => {

          searchKey = searchKey || '';

          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'branchId',
                  condition: '=',
                  data: $scope.model.branch
                },
                {
                  group: {
                    rules: [
                      {
                        field: "id",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "name",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      }
                    ],
                    operator: "OR"
                  }
                }
              ],
              operator: 'AND'
            }
          };

          RouteService.all(searchObj, offset, $scope.pagination.pageLimit)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.totalRecord = data.total;
                $scope.model.allRoutes = $scope.mapData(data.results);
              } else {
                const routes = $scope.mapData(data.results);
                $scope.model.allRoutes = $scope.model.allRoutes.concat(routes)
              }
            })
            .catch((err) => {
              console.log(err);
            })
        }

        $scope.mapData = (routes) => {
          return routes.map((route) => {
            return {
              Key: route.id + ' | ' + route.name,
              Value: route.id
            }
          });
        }

        $scope.ok = () => {
          callback({
            modal: moveShipment,
            toRoute: $scope.model.route,
            date: moment($scope.model.date).format('YYYY-MM-DD'),
          });
          moveShipment.close();
        }

        $scope.ok = () => {
          confirmSupervisor('move-shipment', ({ modal, supId }) => {
            callback({
              modal: moveShipment,
              toRoute: $scope.model.route,
              date: moment($scope.model.date).format('YYYY-MM-DD'),
              supervisorId: supId
            });
            modal.close();
          }, ({ modal }) => {
            modal.close();
          })
        }

        $scope.cancel = () => {
          moveShipment.close();
        }

        init()
      }]
    })
  }

  let updateShipmentTrackingId = (oldTrackingId, supervisorScan, callback, customerId, negative) => {
    let updateTrackingId = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: updateShipmentTrackingIdTemplate,
      size: 'md',

      controller: ['$scope', 'ShipmentService', ($scope, ShipmentService) => {

        $scope.model = {
          oldTrackingId: oldTrackingId,
          newTrackingId: '',
          isDuplicate: false,
          allowSupervisorScan: supervisorScan,
          customerId: customerId
        }

        const init = () => {
          focusElementById('new-tracking-id');
        }

        $scope.assertTrackingId = () => {
          if (($scope.model.newTrackingId && $scope.model.newTrackingId.toUpperCase()) === $scope.model.oldTrackingId.toUpperCase()) {
            $scope.model.isDuplicate = true;
          }
          else {
            $scope.model.isDuplicate = false;
          }
        }

        $scope.ok = () => {
          if ($scope.model.customerId) {
            confirm({
              header: $translate.instant('common.confirm_title'),
              message: 'Are you sure you want to change the Tracking ID?',
              callback: ({ modal }) => {
                callback({
                  modal: updateTrackingId,
                  newTrackingId: $scope.model.newTrackingId,
                  supervisorId: null
                });
                modal.close();
              },
              negative: ({ modal }) => {
                modal.close();
              },
              type: 'success'
            });
          } else {
            verifySupervisorScan('update-shipment-trackingId', { trackingId: $scope.model.newTrackingId }, $scope)
              .then((supervisorInfo) => {
                callback({
                  modal: updateTrackingId,
                  newTrackingId: $scope.model.newTrackingId,
                  supervisorId: supervisorInfo ? supervisorInfo.supId : null
                })
                if (supervisorInfo) supervisorInfo.modal.close();
              })
          }
        }

        $scope.cancel = () => {
          updateTrackingId.close();
        }

        init()
      }]
    })
  }

  let changeShiptypeId = (shipmentData, customerId, callback, negative) => {
    let changeShiptypeId = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: changeShiptypeTemplate,
      size: 'md',
      controller: ['$scope', 'ShiptypeService', 'LocationService', ($scope, ShiptypeService, LocationService) => {
        $scope.model = {
          shipmentData,
          shiptypeList: [],
          totalShiptypes: 0,
          customerId: customerId
        }

        const init = () => {
          $scope.model.loading = true;
          $scope.loadShipType('', 0);
        }

        $scope.loadShipType = (searchKey, offset) => {
          searchKey = searchKey || '';
          if ($scope.model.customerId) {
            return $scope.getDeliveryToLocationsAndShiptypes(searchKey, offset);
          }
          const shipTypeSearchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'status',
                  condition: '=',
                  data: true
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'description',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND'
            }
          };

          return ShiptypeService.all(shipTypeSearchObj, offset, 100)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.totalShiptypes = data.total;
                $scope.model.shiptypeList = $scope.shipTypeDataMapping(data.results);
              } else {
                const shipTypes = $scope.shipTypeDataMapping(data.results);
                $scope.model.shiptypeList = $scope.model.shiptypeList.concat(shipTypes);
              }

              if (!$scope.model.shiptype) {
                $scope.model.shiptype = $scope.model.shiptypeList.find((item) => {
                  return item.Key == $scope.model.shipmentData.shiptype;
                })
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                Modal.errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }
        $scope.getDeliveryToLocationsAndShiptypes = (searchKey, offset) => {
          LocationService.getDeliveryToLocationsAndShiptypes(shipmentData.toLocationId, searchKey)
            .then((data) => {
              const shipTypes = data.results.shipTypeData;

              if (!offset || offset === 0) {
                const currentShipExists = shipTypes.find(d => d.id === shipmentData.shiptypeId);
                let totalShiptypes = data.totalRecords.shipTypeCount;
                if (!currentShipExists && !searchKey) {
                  shipTypes.unshift({
                    id: shipmentData.shiptype,
                    description: shipmentData.shiptype
                  });
                  totalShiptypes++;
                }
                $scope.model.totalShiptypes = totalShiptypes;
                $scope.model.shiptypeList = $scope.shipTypeDataMapping(shipTypes)
              } else {
                const newShipTypes = $scope.shipTypeDataMapping(shipTypes);
                $scope.model.shiptypeList = $scope.model.shiptypeList.concat(newShipTypes);
              }

              if (!$scope.model.shiptype) {
                $scope.model.shiptype = $scope.model.shiptypeList.find((item) => {
                  return item.Key == $scope.model.shipmentData.shiptype;
                })
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message)
              }
            })
            .finally(() => {
              $scope.model.loading = false
            })
        }
        $scope.shipTypeDataMapping = (shipTypes) => {
          return shipTypes.map((shipType) => {
            return {
              Key: shipType.description,
              Value: shipType.id
            }
          });
        }

        $scope.cancel = () => {
          negative({
            modal: changeShiptypeId
          });
        }

        $scope.ok = () => {
          if ($scope.model.customerId) {
             confirm({
                header: $translate.instant('common.confirm_title'),
                message: 'Are you sure you want to change the shiptype?',
                callback: ({ modal }) => {
                  callback({
                    modal: changeShiptypeId,
                    shiptype: $scope.model.shiptype.Value,
                    supervisorId: null
                  });
                  modal.close();
                },
                negative: ({ modal }) => {
                  modal.close();
                },
                type: 'success'
             })
          } else {
            confirmSupervisor('change-shiptype', { trackingId: $scope.model.shipmentData.trackingId }, ({ model, supId }) => {
              callback({
                modal: changeShiptypeId,
                shiptype: $scope.model.shiptype.Value,
                supervisorId: supId
              });
              modal.close();
            }, ({ modal }) => {
              modal.close();
            })
          }
        }
        init()
      }]
    })
    rejectModal(changeShiptypeId, negative)
  }

  let autoOpenLocksModal = (routeId, branchId, formattedDate, isAutoOpenATMs, messengerId, performedById, callback, negative) => {
    let autoOpenLocks = $uibModal.open({
      keyboard: false,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: autoOpenLocksTemplate,
      size: 'md',
      controller: ['$scope', 'AtmCodesManagementService', 'Modal', ($scope, AtmCodesManagementService, Modal) => {
        $scope.model = {
          routeId: routeId,
          branchId: branchId,
          isAutoOpenATMs: isAutoOpenATMs,
          messengerId: messengerId,
          performedById: performedById,
          autoOpenLocksResult: [],
          currentDate: moment.utc().format(),
          failedToOpen: 0,
          totalOpened: 0
        }
        const init = () => {
          $scope.model.loading = true;
          AtmCodesManagementService.autoOpenLocks(routeId, branchId, formattedDate, isAutoOpenATMs, messengerId, performedById)
            .then((res) => {
              $scope.model.autoOpenLocksResult = res.results;
              res.results.filter((lock) => {
                if (lock.result == 1) $scope.model.failedToOpen++;
                if (lock.result == 0) $scope.model.totalOpened++;
              })
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                return Modal.errorModal(err.data.message)
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }
        $scope.removeCharacter = (message) => {
          if (message) return AtmCodesManagementService.removeCharacter(message);
        }
        $scope.ok = () => {
          callback({
            modal: autoOpenLocks,
          });
          autoOpenLocks.close();
        }
        $scope.cancel = () => {
          autoOpenLocks.close();
        }
        init()
      }]
    })
  }

  let markAsDelivered = (shipment, currentVaultDate, branchTimeZone, callback, negative) => {
    let markAsDeliveredModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: markAsDeliveredTemplate,
      size: 'md',

      controller: ['$scope', 'DateUtil', ($scope, DateUtil) => {

        $scope.model = {
          shipment: shipment,
          loadedAmount: shipment.loadedAmount,
          date: '',
          vaultDate: currentVaultDate,
          comment: '',
          deliveryTime: '',
          branchTimeZone: branchTimeZone,
          amountExceeds: false,
          // sendDeliveryReceipt: false
        }

        const init = () => {
          const time = moment($scope.model.shipment.deliveryDate).tz($scope.model.branchTimeZone).format('HH:mm:ss');
          const deliveryTime = moment.utc($scope.model.shipment.deliveryDate).format('HH:mm:ss')
         
          if (deliveryTime === '00:00:00') {
            $scope.model.time = null;
            $scope.model.date = moment($scope.model.shipment.deliveryDate, 'YYYY-MM-DD').toDate();
          } else {
            $scope.model.time = DateUtil.getTime(time);
            const dateString = moment($scope.model.shipment.deliveryDate).tz($scope.model.branchTimeZone).format('YYYY-MM-DD');
            $scope.model.date = moment(dateString, 'YYYY-MM-DD').toDate();
          }

          $scope.minVaultDate = {
            maxDate: $scope.model.date
          }
        }

        $scope.getTime = (time) => {
          if (!time) {
            return time;
          }

          time = time.split(':');

          let d = new Date();

          d.setHours(+time[0]);
          d.setMinutes(time[1]);
          d.setSeconds(0);
          d.setMilliseconds(0);

          return d;
        }

        $scope.ok = () => {
          confirmSupervisor('mark-as-delivered', { trackingId: $scope.model.shipment.trackingId }, ({ modal, supId }) => {
            callback({
              modal: markAsDeliveredModal,
              supervisorId: supId,
              comment: $scope.model.comment,
              loadedAmount: $scope.model.loadedAmount,
              date: moment($scope.model.date).format('YYYY-MM-DD'),
              time: moment($scope.model.time).format('HH:mm:ss'),
              // sendDeliveryReceipt: $scope.model.sendDeliveryReceipt
            })
            modal.close();
          }, ({ modal }) => {
            modal.close();
          })
        }

        $scope.cancel = () => {
          negative({
            modal: markAsDeliveredModal
          })
        }

        $scope.validateLoadedAmount = () => {
          let loadShipmentAmount = $scope.model.shipment.amount;
          let loadedAmount = $scope.model.loadedAmount;
          if (loadedAmount > loadShipmentAmount) return $scope.model.amountExceeds = true;
          else $scope.model.amountExceeds = false;
        }

        init()
      }]
    })
    rejectModal(markAsDeliveredModal, negative);
  }

  let holdShipmentModal = (routeId, vaultDate, branch, callback, negative) => {
    let holdShipment = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: holdShipmentTemplate,
      size: 'md',

      controller: ['$scope', 'HoldService', '$state', 'Modal', 'Navigation', ($scope, HoldService, $state, Modal, Navigation) => {

        $scope.model = {
          routeId: routeId,
          date: vaultDate,
          branchId: branch,
          holdShipments: [],
          loading: false
        }

        const init = () => {
          $scope.model.loading = true;
          HoldService.holdShipmentList($scope.model.routeId, $scope.model.date, $scope.model.branchId)
            .then((data) => {
              $scope.model.holdShipments = data.results;
            })
            .catch((err) => {
              Modal.errorModal(err.data.message)
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.ok = () => {
          callback({
            modal: holdShipment
          });
          modal.close();
        }

        $scope.redirectToHold = () => {
          return $state.go('branchManagement.itemHolds');
        }

        $scope.cancel = () => {
          holdShipment.close();
        }

        $scope.goToItemHistory = (trackingId) => {
          return Navigation.goToItemHistory(trackingId, holdShipment);
        }

        init()
      }]
    })
  }

  let lastOrderDetails = (shipment, fundingSourceId, callback, negative) => {
    let lastOrderDetailsModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: lastOrderDetailsTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'DataCounter', '$state', 'OrderPackingService', ($scope, $translate, DataCounter, $state, OrderPackingService) => {

        $scope.model = {
          lastOrderDetails: [],
          shipment: shipment,
          loading: false,
          fundingSourceId: fundingSourceId
        };

        const init = () => {
          $scope.model.loading = true;
          OrderPackingService.getLastOrderInformation(shipment.toLocationId, null)
            .then((data) => {
              $scope.model.lastOrderDetails = data.results;
            })
            .catch((err) => {
              console.log(err)
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.goToOrderHistory = (data) => {
          lastOrderDetailsModal.close();
          const obj = {
            orderNo: data.orderNo,
            vaultDate: data.loadDeliveryDate,
            isRedirected: true,
            isCounted: data.residualIsCounted,
            isInProcess: !data.residualIsCounted,
            fundingSourceId: $scope.model.fundingSourceId
          }

          DataCounter.setData(obj);
          $state.go('branchManagement.orders');
        }

        $scope.cancel = () => {
          lastOrderDetailsModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: lastOrderDetailsModal
          });
          modal.close()
        }
        init()
      }]
    })
  }

  let serviceOrderDetail = (data, callback, negative) => {
    let serviceOrderDetailModal = $uibModal.open({
      template: serviceOrderDetailTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', '$translate', 'DateUtil', 'Navigation', 'User', 'UsersService', function ($scope, $q, $translate, DateUtil, Navigation, User, UsersService) {

        $scope.model = {
          details: data,
          loggedInUser: User.getUser().id,
          currentBranch: User.getUser().branchId
        };
        const init = () => { }
        $scope.convetToBrowserTimezone = (date) => {
          return DateUtil.convetToBrowserTimezone(date);
        }

        $scope.redirectToServiceHistory = (locationId) => {
          return Navigation.goToServiceHistory(locationId, null, true, serviceOrderDetailModal);
        }

        $scope.goToServiceHistory = () => {
          if ($scope.model.currentBranch === $scope.model.details.branchId) {
            $scope.redirectToServiceHistory($scope.model.details.locationId);
          }
          else {
            $scope.shiftBranch($scope.model.loggedInUser, $scope.model.details.branchId)
              .then(() => {
                $scope.redirectToServiceHistory($scope.model.details.locationId);
              })
          }
        }

        $scope.shiftBranch = (userId, branchId) => {
          var obj = {
            id: userId,
            branchId: branchId
          };
          const defer = $q.defer();
          UsersService.updateUserBranch(obj.id, obj)
            .then((data) => {
              User.setUser(data);
              defer.resolve();
            })
            .catch((err) => {
              err.data.errors.map((e) => {
                $scope.errorMessage += e.message + '<br/>'
              })
              errorModal($scope.errorMessage);
            });
          return defer.promise;
        }
        $scope.cancel = () => {
          negative({
            modal: serviceOrderDetailModal
          })
        }
        init()
      }]
    })
  }

    let serviceOrderNotes = (data, serviceHistory, callback, negative) => {
    let serviceOrderNotesModal = $uibModal.open({
      template: serviceOrderNotesTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', function ($scope, $q) {
        $scope.model = {
          details: data,
          systemNote: data.serviceOrderNote,
          serviceOrderUserNote: data.serviceOrderUserNote,
          serviceHistory: serviceHistory ? angular.copy(serviceHistory.filter(h => h.status)) : []
        };
        $scope.getBucketName = (status) => {
          switch (status) {
            case 'INCOMPLETED':
              return $translate.instant('serviceTickets.incomplete');
            case status:
              return $translate.instant('serviceTickets.status_' + status);
            default: return;
          }
        }
        const init = () => {
          focusElementById('service-order-user-note');
          focusElementById('system-note');
        }

        $scope.cancel = () => {
          serviceOrderNotesModal.close();
        }
        $scope.ok = () => {
          callback({
            modal: serviceOrderNotesModal,
            $scope: $scope,
            serviceOrderNote: $scope.model.systemNote,
            serviceOrderUserNote: $scope.model.serviceOrderUserNote,
            serviceOrderUserNotes: $scope.model.serviceHistory.filter(h => h.isEdited).map(h => ({ id: h.id, note: h.serviceOrderStatusNote, status: h.status }))
          });
        }
        init()
      }]
    })
  }

  let undoPackedOrder = (data, callback, negative) => {
    let undoPackedOrderModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: undoPackedOrderTemplate,
      size: 'md',

      controller: ['$scope', ($scope) => {

        $scope.model = {
          shipments: data,
          deleteOrder: false,
          deletedReason: null,
          loading: false
        }

        const init = () => { }

        $scope.setFocus = () => {
          setTimeout(() => {
            if ($scope.model.deleteOrder) focusElementById('deleted-reason');
          });
        }

        $scope.ok = () => {
          confirmSupervisor('order-packing-undo', { trackingId: $scope.model.shipments.trackingId }, ({ modal, supId }) => {
            $scope.model.loading = true;
            callback({
              modal: undoPackedOrderModal,
              supervisorId: supId,
              deleteOrder: $scope.model.deleteOrder,
              deletedReason: $scope.model.reason || null,
              $scope: $scope
            })
            modal.close();
          }, ({ modal }) => {
            modal.close();
          })
        }

        $scope.cancel = () => {
          negative({
            modal: undoPackedOrderModal
          });
        }

        init()
      }]
    })
    rejectModal(undoPackedOrderModal, negative);
  }

  let serviceOrderStatusUpdate = (data, allowSupervisorScan, customerId, userInfo, callback, negative) => {
    let serviceOrderStatusUpdateModal = $uibModal.open({
      template: serviceOrderStatusUpdateTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', '$translate', 'User', function ($scope, $q, $translate, User) {

        $scope.model = {
          details: data,
          note: data.serviceOrderUserNote,
          currentStatus: data.statusCode === 'INCOMPLETED' ? $translate.instant('serviceTickets.incomplete') : $translate.instant('serviceTickets.status_' + data.statusCode),
          newStatus: null,
          loading: false,
          allowSupervisorScan: allowSupervisorScan,
          userDetails: User.getUser(),
          customerId: customerId,
          statusList: [
            { label: 'Complete', value: 'COMPLETE' },
            { label: 'Incomplete', value: 'INCOMPLETED' },
            { label: 'Cancelled', value: 'CANCELLED' },
            { label: 'Assigned', value: 'ASSIGNED' },
            { label: 'Unassigned', value: 'UNASSIGNED' },
            { label: 'On-Route', value: 'ON_ROUTE' },
            { label: 'On-Site', value: 'ON_SITE' },
            { label: 'Hold', value: 'HOLD' },
            { label: 'Hold-Parts', value: 'HOLD_PARTS' }
          ]
        };

        const init = () => {
          if ($scope.model.details.externalProcessorId && !$scope.model.customerId) {
            const status = ['COMPLETE', 'INCOMPLETED', 'CANCELLED'];
            $scope.model.statusList = $scope.model.statusList.filter(s => status.includes(s.value));
          }
          else if ($scope.model.customerId) {
            const status = ['CANCELLED'];
            $scope.model.statusList = $scope.model.statusList.filter(s => status.includes(s.value));
          }
          $scope.model.statusList = $scope.model.statusList.filter(data => data.value !== $scope.model.details.statusCode);
        }

        $scope.validateSupervisorScan = () => {
          if ($scope.model.allowSupervisorScan) {
            let errorMsg = $translate.instant('users.supervisor_scan_error', {
              firstName: $scope.model.userDetails.firstName,
              lastName: $scope.model.userDetails.lastName
            })

            return confirm({
              header: $translate.instant('errorModal.title'),
              message: $translate.instant(errorMsg),
              callback: ({
                modal,
              }) => {
                $scope.ok();
                modal.close();
              },
              type: 'danger',
              buttons: ['common.ok']
            })
          }
          else {
            $scope.ok();
          }
        }

        $scope.ok = () => {
          // confirmSupervisor('service-order-status-update', null, ({ modal, supId }) => {
          // $scope.model.loading = true;
          verifySupervisorScan('shipment-hold-convert-CRV', null, $scope)
            .then((supervisorInfo) => {
              callback({
                modal: serviceOrderStatusUpdateModal,
                note: $scope.model.note,
                status: $scope.model.newStatus,
                supervisorId: supervisorInfo ? supervisorInfo.supId : userInfo.customerUser ? userInfo.id : null
              });
              // modal.close();
              if (supervisorInfo) supervisorInfo.modal.close();
              // }, ({ modal }) => {
              //   modal.close();
              // })
            })
        }

        $scope.cancel = () => {
          negative({
            modal: serviceOrderStatusUpdateModal
          })
        }

        init()
      }]
    })
    rejectModal(serviceOrderStatusUpdateModal, negative)
  }

  let serviceOrderAssign = (data, vaultDate, callback, negative) => {
    let serviceOrderAssignModal = $uibModal.open({
      template: serviceOrderAssignTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', 'ServiceOrderService', function ($scope, $q, ServiceOrderService) {

        $scope.model = {
          details: data,
          // routeId: data.routeId,
          statsObj: {
            route: 'route',
            user: 'user',
            external: 'external'
          },
          stats: 'route',
          routeList: [],
          vaultDate: vaultDate,
          // branchId: branchId,
          formattedDate: '',
          routeStatusInfo: {},
          serviceOrderinfo: {},
          serviceUserList: [],
          serviceZoneUserList: [],
          // userId: data.userId,
          loading: false,
          loadingRouteStatus: false,
          loadingServiceOrderDetails: false,
          updateInProcess: false,
          externalProcessorCode: null,
          serviceUserId: null
        };

        const init = () => {
          $scope.model.formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
          $scope.model.loading = true;

          if ($scope.model.details.defaultServiceTicketAssignment === 'EXTERNAL' && (!$scope.model.details.externalProcessorId && $scope.model.details.statusCode !== 'ACCEPTED')) {
            $scope.model.stats = $scope.model.statsObj.route;
          }
          else if ($scope.model.details.defaultServiceTicketAssignment) {
            $scope.model.stats = $scope.model.details.defaultServiceTicketAssignment.toLowerCase();
          }

          $q.all([
            ServiceOrderService.branchActiveRouteAndServiceUser($scope.model.details.branchId, $scope.model.formattedDate, moment.tz.guess()),
            (!$scope.model.details.externalProcessorId && $scope.model.details.statusCode === 'ACCEPTED') ? $scope.externalProcessorCode() : undefined
          ])
            .then((data) => {
              $scope.model.routeList = data[0].results.routeList;
              $scope.model.serviceUserList = data[0].results.serviceUserList;
              $scope.model.serviceZoneUserList = data[0].results.serviceZoneUserList;
              $scope.model.routeId = $scope.model.details.routeId;

              if ($scope.model.details.assignServiceZone) {
                const user = _.find($scope.model.serviceZoneUserList, { 'userId': $scope.model.details.userId });
                if (user) $scope.model.serviceZoneUserId = user.userId;
                else if (!user) $scope.model.serviceUserId = $scope.model.details.userId;
              }
              else {
                $scope.model.serviceUserId = $scope.model.details.userId;
              }
              // $scope.addServiceOrderRouteIdToList();
              $scope.routeStatus();
              $scope.serviceOrderDetails();
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.tabSelection = (selectedValue) => {
          $scope.model.stats = selectedValue;
        }

        $scope.routeStatus = () => {
          let route = $scope.model.routeList.find(data => data['routeId'] === $scope.model.routeId);

          if (route) {
            $scope.model.loadingRouteStatus = true;
            ServiceOrderService.getRouteStatus($scope.model.routeId, $scope.model.formattedDate)
              .then((data) => {
                $scope.model.routeStatusInfo = data.results;
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal('error.' + err.data.message);
                }
              })
              .finally(() => {
                $scope.model.loadingRouteStatus = false;
              })
          }
          else {
            $scope.model.routeId = null;
          }
        }

        $scope.serviceOrderDetails = () => {
          let routeId = $scope.model.details.routeId;
          let branchId = $scope.model.details.branchId;
          let userId = $scope.model.serviceUserId ? $scope.model.serviceUserId : $scope.model.serviceZoneUserId

          if (userId) {
            $scope.model.loadingServiceOrderDetails = true;
            ServiceOrderService.serviceOrderDetails(userId, routeId, branchId, $scope.model.formattedDate)
              .then((data) => {
                $scope.model.serviceOrderinfo = data.results;
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal(err.data.message);
                }
              })
              .finally(() => {
                $scope.model.loadingServiceOrderDetails = false;
              })
          }
          else {
            $scope.model.serviceUserId = null;
            $scope.model.serviceZoneUserId = null;
          }
        }

        $scope.externalProcessorCode = () => {
          let branchId = $scope.model.details.branchId;

          $scope.model.loadingExternalProcessorCode = true;
          ServiceOrderService.getExternalProcessorCode(branchId)
            .then((data) => {
              $scope.model.externalProcessorCodeList = data.results;
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.loadingExternalProcessorCode = false;
            })
        }

        $scope.addServiceOrderRouteIdToList = () => {
          let route = $scope.model.routeList.find(data => data['routeId'] === $scope.model.details.routeId);
          // console.log("route", route);

          if (!route) {
            $scope.model.routeList.push({
              routeId: $scope.model.details.routeId,
              routeName: $scope.model.details.routeName,
              arrTime: null
            })
          }
          // console.log($scope.model.routeList);
        }

        $scope.cancel = () => {
          negative({
            modal: serviceOrderAssignModal
          })
        }

        $scope.ok = () => {
          $scope.model.updateInProcess = true;
          callback({
            modal: serviceOrderAssignModal,
            routeId: $scope.model.routeId,
            userId: $scope.model.serviceUserId ? $scope.model.serviceUserId : $scope.model.serviceZoneUserId,
            externalProcessorCode: $scope.model.externalProcessorCode,
            currentStats: $scope.model.stats
          });
          serviceOrderAssignModal.close();
        }

        $scope.resendServiceTicketAssignment = () => {
          $scope.model.isSendingNotification = true;
          ServiceOrderService.resendServiceTicketAssignment($scope.model.details.encounterId, $scope.model.details.branchCurrentVaultDate, $scope.model.serviceUserId ? $scope.model.serviceUserId : $scope.model.serviceZoneUserId)
            .then(() => { })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.isSendingNotification = false;
            })
        }

        init()
      }]
    })
    rejectModal(serviceOrderAssignModal, negative)
  }

  let createServiceTicket = (data, callback, negative) => {
    let serviceOrderCreateModal = $uibModal.open({
      template: serviceOrderCreateTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$q', 'ServiceOrderService', 'User', 'UserService', 'LocationService', 'ActionCodeService', 'CommonLayoutService', 'SetupService', 'BranchService', function ($scope, $q, ServiceOrderService, User, UserService, LocationService, ActionCodeService, CommonLayoutService, SetupService, BranchService) {
        $scope.branchList = [];
        $scope.totalLocation = 0;
        $scope.locationList = [];
        $scope.actionCodeList = [];
        $scope.formSubmited = false;
        $scope.lockTypes = CommonLayoutService.lockTypes();
        $scope.stopPriorityList = CommonLayoutService.priorityList();
        $scope.requestedTimeframeOptions = [
          { label: 'ASAP', value: 'ASAP' },
          { label: '24 Hours', value: '24HR' },
          { label: '48 Hours', value: '48HR' },
          { label: '72 Hours', value: '72HR' },
          { label: 'Scheduled', value: 'SCHEDULED' }
        ];
        $scope.scheduledPriorityValue = 'SCHEDULED';
        $scope.model = {
          details: data,
          loading: false,
          customerId: data.customerId,
          billingReviewRequire: false,
          branchTimezone: null
        };

        // Assign permission check
        const acl = User.getACL('service_tickets') || [];
        $scope.hasAssignPermission = acl.indexOf('assign') > -1;

        // Assign section state
        $scope.assign = {
          statsObj: { route: 'route', user: 'user', external: 'external' },
          stats: 'route',
          routeList: [],
          serviceUserList: [],
          serviceZoneUserList: [],
          externalProcessorCodeList: [],
          routeId: null,
          serviceUserId: null,
          serviceZoneUserId: null,
          externalProcessorCode: null,
          routeStatusInfo: null,
          serviceOrderinfo: null,
          loading: false,
          loadingRouteStatus: false,
          loadingServiceOrderDetails: false,
          showExternal: false,
          assignServiceZone: false
        };

        const getSelectedBranchId = () => Array.isArray($scope.model.branchId) ? $scope.model.branchId[0] : $scope.model.branchId;

        $scope.reset = () => {
          let obj = {
            status: 'ACCEPTED',
            note: null,
            model: null,
            serialNumber: null,
            lockType: null,
            branchId: data.branch,
            locationId: null,
            actionCode: [],
            actionCodeNotes: null,
            locationZone: null,
            make: null,
            machineOwner: null,
            FLMProvider: null,
            SLMProvider: null,
            locationType: null,
            requestedTimeframe: null,
            targetScheduleDate: null,
            targetScheduleTime: null,
            targetTime: null,
            selectedFiles: []
          };
          $scope.locationType = null;
          Object.assign($scope.model, obj)
          if ($scope.model.targetTime) {
            $scope.model.targetScheduleDate = moment($scope.model.targetTime).toDate();
            $scope.model.targetScheduleTime = moment($scope.model.targetTime).toDate();
          }
        }

        const init = () => {
          $scope.reset();
          $scope.loadActionCode();
          if ($scope.model.branchId) {
            $scope.isLocationLoading = true;
            $scope.loadBranchLocation('', 0);
            BranchService.getBranchSetup(getSelectedBranchId())
              .then((branchSetup) => {
                $scope.model.branchTimezone = branchSetup && branchSetup.timezone ? branchSetup.timezone : moment.tz.guess();
              })
              .catch((err) => {
                console.log(err);
                $scope.model.branchTimezone = moment.tz.guess();
              })
          }
          $scope.model.billingReviewRequire = false;

          // Load branch setup for assign section
          if ($scope.hasAssignPermission) {
            const branchId = User.getUser().branchId;
            SetupService.get(branchId).then((setupData) => {
              $scope.assign.assignServiceZone = !!setupData.assignServiceZone;
              $scope.assign.showExternal = true; // newly created tickets are ACCEPTED, so external is available
              $scope.assign.currentVaultDate = setupData.currentVaultDate ? moment(setupData.currentVaultDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              $scope.assign.unassignedRouteId = setupData.unassignedRouteId || null;
              if (setupData.defaultServiceTicketAssignment) {
                $scope.assign.stats = setupData.defaultServiceTicketAssignment.toLowerCase();
              }
            });
          }
        }

        // $scope.formatFileSize = (bytes) => {
        //   return CommonLayoutService.formatFileSize(bytes);
        // }

        $scope.removeSelectedFiles = (index) => {
          if ($scope.model.selectedFiles) {
            $scope.model.selectedFiles.splice(index, 1);
          }
        }
        $scope.viewServiceTicketPictures = (data, stat, event) => {
          if (event && event.currentTarget) {
            event.currentTarget.blur();
          }
          previewTicketPictures(data, (index) => {
            $scope.removeSelectedFiles(index);
          }, ({ modal }) => {}, ({ modal }) => {
            modal.close();
          });
        }

        $scope.loadActionCode = () => {
          $scope.actionCodeList = [];
          ActionCodeService.all('', 0, 10000)
            .then((data) => {
              if (data.results && data.results.length) {
                $scope.actionCodeList = data.results;
              }
            })
        }

        $scope.loadUserBranch = () => {
          $scope.branchList = [];
          UserService.getUserBranchGroup(User.getUser().id).then((data) => {
            if (data && data.length) {
              data.forEach(item => {
                $scope.branchList.push({ id: item.branchId, name: item.branch.description });
              })
            }
          }, err => {
            console.log(err)
          })
        }

        $scope.loadBranchLocation = (searchText, offset) => {
          LocationService.getBranchLocationList(searchText, $scope.model.branchId, $scope.model.customerId, offset, AppConstant.defaultPageLimit)
            .then((data) => {
              if (!offset) {
                $scope.locationList = [];
                $scope.totalLocation = data.total;
              }
              $scope.locationList = _.unionBy($scope.locationList.concat(data.record), 'Value');
            }, err => {
              console.log(err);
            })
            .finally(() => {
              $scope.isLocationLoading = false;
            })
        }

        $scope.cancel = () => {
          negative({
            modal: serviceOrderCreateModal
          })
        }

        $scope.autoPopulateLocationData = () => {
          if ($scope.model.locationId) {
            $scope.model.branchId = User.getUser().branchId;
            $scope.locationType = $scope.model.locationId.locationType;
            $scope.model.stopPriority = $scope.model.locationId.stopPriority;
            $scope.model.model = $scope.model.locationId.model;
            $scope.model.serialNumber = $scope.model.locationId.serialNumber;
            $scope.model.make = $scope.model.locationId.make;
            if ($scope.locationType === 'ATM') {
              $scope.model.lockType = $scope.model.locationId.lockType;
              $scope.model.machineOwner = $scope.model.locationId.machineOwner || 'N/A';
              $scope.model.FLMProvider = $scope.model.locationId.FLMProvider || 'N/A';
              $scope.model.SLMProvider = $scope.model.locationId.SLMProvider || 'N/A';
            } else {
              $scope.model.lockType = null;
              $scope.model.machineOwner = null;
              $scope.model.FLMProvider = null;
              $scope.model.SLMProvider = null;
              $scope.model.locationZone = null;
              $scope.model.locationZonesList = [];
            }
            if ($scope.model.locationId.locationZone || $scope.model.locationId.locationZone == null) {
              LocationService.getLocationServiceZone($scope.model.details.branch, $scope.model.locationId.Value)
                .then((data) => {
                  if (data && data.result && data.result.length > 0) {
                    const locationZoneKeys = data.result.map(res => res.locationZoneKey);
                    $scope.model.locationZone = locationZoneKeys.join(', ');
                    $scope.model.locationZonesList = data.result.map(res => ({
                      ...res,
                      dayShort: res.dayOfWeek.substring(0, 3).toUpperCase()
                    }));
                  }
                  else {
                    $scope.model.locationZone = 'N/A'
                    $scope.model.locationZonesList = [];
                  }
                })
            }
            // Load assign data when location is selected
            $scope.loadAssignData();
          }
          else {
            $scope.model.branchId = User.getUser().branchId;
            $scope.model.lockType = null;
            $scope.model.stopPriority = null;
            $scope.model.model = null;
            $scope.model.serialNumber = null;
            $scope.model.locationZone = null;
            $scope.model.make = null;
            $scope.model.machineOwner = null;
            $scope.model.FLMProvider = null;
            $scope.model.SLMProvider = null;
            $scope.locationType = null;
            // Reset assign section when location is cleared
            $scope.assign.routeId = null;
            $scope.assign.serviceUserId = null;
            $scope.assign.serviceZoneUserId = null;
            $scope.assign.externalProcessorCode = null;
            $scope.assign.routeList = [];
            $scope.assign.serviceUserList = [];
            $scope.assign.serviceZoneUserList = [];
          }
        }

        // Load assign data when location is selected
        $scope.loadAssignData = () => {
          if (!$scope.hasAssignPermission || !$scope.model.locationId) return;
          const branchId = User.getUser().branchId;
          const vaultDate = $scope.assign.currentVaultDate || moment().format('YYYY-MM-DD');
          $scope.assign.loading = true;
          $scope.assign.routeId = null;
          $scope.assign.serviceUserId = null;
          $scope.assign.serviceZoneUserId = null;
          $scope.assign.externalProcessorCode = null;

          $q.all([
            ServiceOrderService.branchActiveRouteAndServiceUser(branchId, vaultDate, moment.tz.guess()),
            $scope.assign.showExternal ? ServiceOrderService.getExternalProcessorCode(branchId) : $q.resolve(null)
          ])
            .then((results) => {
              $scope.assign.routeList = results[0].results.routeList;
              $scope.assign.serviceUserList = results[0].results.serviceUserList;
              $scope.assign.serviceZoneUserList = results[0].results.serviceZoneUserList;
              if (results[1] && results[1].results) {
                $scope.assign.externalProcessorCodeList = results[1].results;
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.assign.loading = false;
            });
        }

        $scope.assignTabSelection = (selectedValue) => {
          $scope.assign.stats = selectedValue;
        }

        $scope.assignRouteStatus = () => {
          if (!$scope.assign.routeId) {
            $scope.assign.routeStatusInfo = null;
            return;
          }
          const vaultDate = $scope.assign.currentVaultDate || moment().format('YYYY-MM-DD');
          $scope.assign.loadingRouteStatus = true;
          ServiceOrderService.getRouteStatus($scope.assign.routeId, vaultDate)
            .then((data) => {
              $scope.assign.routeStatusInfo = data.results;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.assign.loadingRouteStatus = false;
            });
        }

        $scope.assignServiceOrderDetails = () => {
          const userId = $scope.assign.serviceUserId || $scope.assign.serviceZoneUserId;
          if (!userId) {
            $scope.assign.serviceUserId = null;
            $scope.assign.serviceZoneUserId = null;
            return;
          }
          const branchId = User.getUser().branchId;
          const vaultDate = $scope.assign.currentVaultDate || moment().format('YYYY-MM-DD');
          const routeId = $scope.assign.unassignedRouteId;
          $scope.assign.loadingServiceOrderDetails = true;
          ServiceOrderService.serviceOrderDetails(userId, routeId, branchId, vaultDate)
            .then((data) => {
              $scope.assign.serviceOrderinfo = data.results;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.assign.loadingServiceOrderDetails = false;
            });
        }

        $scope.ok = () => {
          if ($scope.formSubmited) return;
          if ($scope.model.requestedTimeframe === $scope.scheduledPriorityValue
            && (!$scope.model.targetScheduleDate || !$scope.model.targetScheduleTime)) return;
          $scope.formSubmited = true;
          const branchTimezone = $scope.model.branchTimezone || moment.tz.guess();
          const formattedTargetTime = $scope.model.requestedTimeframe === $scope.scheduledPriorityValue
            && $scope.model.targetScheduleDate && $scope.model.targetScheduleTime
            ? moment.tz(
              `${moment($scope.model.targetScheduleDate).format('YYYY-MM-DD')} ${moment($scope.model.targetScheduleTime).format('HH:mm:ss')}`,
              'YYYY-MM-DD HH:mm:ss',
              branchTimezone
            ).utc().format()
            : null;
          $scope.model.targetTime = formattedTargetTime;
          let actionCodes = [];
          $scope.model.actionCode.forEach((actionCode) => {
            if (actionCode.ticked) {
              actionCodes.push(actionCode.id)
            }
          })
          callback({
            modal: serviceOrderCreateModal,
            data: {
              encounterId: $scope.model.encounterId,
              note: $scope.model.note,
              model: $scope.model.model,
              serialNumber: $scope.model.serialNumber,
              lockType: $scope.model.lockType,
              stopPriority: $scope.model.stopPriority,
              branchId: $scope.model.branchId || null,
              locationId: $scope.model.locationId && $scope.model.locationId.Value ? $scope.model.locationId.Value : null,
              actionCode: actionCodes,
              actionCodeNotes: $scope.model.actionCodeNotes,
              targetTime: formattedTargetTime,
              requestedTimeframe: $scope.model.requestedTimeframe,
              billingReviewRequire: $scope.model.billingReviewRequire,
              selectedFiles: $scope.model.selectedFiles,
              $scope
            },
            assignData: $scope.hasAssignPermission ? {
              routeId: $scope.assign.stats === 'route' ? $scope.assign.routeId : null,
              userId: $scope.assign.stats === 'user' ? ($scope.assign.serviceUserId || $scope.assign.serviceZoneUserId) : null,
              externalProcessorCode: $scope.assign.stats === 'external' ? $scope.assign.externalProcessorCode : null,
              currentStats: $scope.assign.stats
            } : null
          });
        }
        init()
      }]
    })
    rejectModal(serviceOrderCreateModal, negative)
  }

  let shipmentList = (routeId, vaultDate, coinCheckOut, callback, negative) => {
    let shipmentListModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: shipmentListTemplate,
      size: 'lg',

      controller: ['$scope', 'ShipmentService', 'Navigation', '$translate', 'CommonLayoutService', '$state', ($scope, ShipmentService, Navigation, $translate, CommonLayoutService, $state) => {

        $scope.model = {
          routeId: routeId,
          vaultDate: vaultDate,
          coinCheckOut: coinCheckOut,
          formattedDate: '',
          loading: false,
          shipments: []
        }

        const init = () => {
          $scope.model.formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
          $scope.model.loading = true;

          ShipmentService.getShipmentsOnRoute($scope.model.routeId, $scope.model.vaultDate, $scope.model.coinCheckOut)
            .then((data) => {
              $scope.model.shipments = data.results;
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.ok = () => {
          callback({
            modal: shipmentListModal
          })
          modal.close();
        }

        $scope.cancel = () => {
          negative({
            modal: shipmentListModal
          });
        }

        $scope.goToServiceHistory = (data) => {
          return Navigation.goToServiceHistory(data.toLocationId, null, true, shipmentListModal);
        }

        $scope.goToItemHistory = (data) => {
          return Navigation.goToItemHistory(data.trackingId, shipmentListModal);
        }

        $scope.translateMsg = (status) => {
          if (status) return $translate.instant(`shipment.${status}`);
        }

        $scope.loadLocationTypeIcon = (locationType) => {
          return CommonLayoutService.loadLocationTypeIcon(locationType)
        }

        $scope.getLocationUrl = (data) => {
          return $state.href('branchManagement.locations', {
            locationId: data.toLocationId
          }, { absolute: true });
        };

        $scope.onLocationClick = (event, data) => {
          if (event.ctrlKey || event.metaKey || event.button === 1) {
            return;
          }
          event.preventDefault();
          $scope.goToServiceHistory(data);
        }

        init()
      }]
    })
    rejectModal(shipmentListModal, negative)
  }

  let routeStopList = (routeId, vaultDate, branchId, callback, negative) => {
    let routeStopListModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: routeStopListTemplate,
      size: 'lg',

      controller: ['$scope', 'RouteStopService', 'Navigation', 'CommonLayoutService','$state', ($scope, RouteStopService, Navigation, CommonLayoutService, $state) => {

        $scope.model = {
          routeId: routeId,
          vaultDate: vaultDate,
          branchId,
          formattedDate: '',
          loading: false,
          stops: []
        }

        const init = () => {
          $scope.model.formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
          $scope.model.loading = true;

          RouteStopService.routeStopList($scope.model.routeId, $scope.model.vaultDate, $scope.model.branchId)
            .then((data) => {
              $scope.model.stops = data.results;
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.ok = () => {
          callback({
            modal: routeStopListModal
          })
          modal.close();
        }

        $scope.cancel = () => {
          negative({
            modal: routeStopListModal
          });
        }

        $scope.goToServiceHistory = (data) => {
          return Navigation.goToServiceHistory(data.locationId, null, true, routeStopListModal);
        }
        $scope.getLocationUrl = (data) => {
          return $state.href('branchManagement.locations', {
            locationId: data.locationId
          }, { absolute: true });
        };

        $scope.onLocationClick = (event, data) => {
          if (event.ctrlKey || event.metaKey || event.button === 1) {
            return;
          }
          event.preventDefault();
          $scope.goToServiceHistory(data);
        }
        $scope.loadLocationTypeIcon = (locationType) => {
          return CommonLayoutService.loadLocationTypeIcon(locationType)
        }

        $scope.stopPriorityOrdinalSuffix = (stopPriority) => {
          return CommonLayoutService.ordinalSuffixOfStopPriority(stopPriority)
        }

        init()
      }]
    })
    rejectModal(routeStopListModal, negative)
  }

  // control supervisor scan on perfrom specific operation
  function verifySupervisorScan(event, extraData, $scope) {
    return new Promise((resolve, reject) => {
      if ($scope.model.allowSupervisorScan) {
        confirmSupervisor(event, extraData, ({ modal, supId }) => {
          let obj = { modal, supId };
          resolve(obj);
        }, ({ modal }) => {
          $scope.isLoading = false;
          modal.close();
        }, reject)
      }
      else resolve(void undefined);
    })
  }

  let createActionCode = (prioritiesList, pmSchedulesList, callback, negative) => {
    let createActionCodeModal = $uibModal.open({
      template: createActionCodeTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', 'User', 'LocationService', function ($scope, $q, User, LocationService) {

        $scope.model = {
          prioritiesList: prioritiesList,
          pmSchedulesList: pmSchedulesList,
          pmSearchList: (pmSchedulesList || []).map(pm => ({
            Key: pm.title + (pm.status === 'Suspended' ? ' (suspended)' : ''),
            Value: pm.id,
            isSuspended: pm.status === 'Suspended'
          })),
          totalPMRecords: (pmSchedulesList || []).length,
          loadPreventativeMaintenances: (searchKey, offset) => {
            searchKey = searchKey || '';
            return LocationService.getPreventativeMaintenanceList(10, offset, searchKey)
              .then((data) => {
                const pmList = (data.results || []).map(pm => ({
                  Key: pm.title + (pm.status === 'Suspended' ? ' (suspended)' : ''),
                  Value: pm.id,
                  isSuspended: pm.status === 'Suspended'
                }));
                if (offset === 0 || offset === undefined) {
                  $scope.model.totalPMRecords = data.total || 0;
                  $scope.model.pmSearchList = pmList;
                } else {
                  $scope.model.pmSearchList = $scope.model.pmSearchList.concat(pmList);
                }
              })
              .catch(err => console.error(err));
          },
          preventativeMaintenanceId: null,
          serviceActionPriorityId: null,
          serviceType: 'FLM',
          expectedCompletionTime: '',
          autoAssignable: false,
          actionCodeLabel: '',
          actionCode: '',
          minResponse: 0,
          maxResponse: 0,
          minRootCause: 0,
          maxRootCause: 0,
          thresholds: false,
          partsCapture: false,
          actionCodeData: {
            details: {
              responses: [],
              rootCauses: [],
            }
          },
          thresholdList: ['redThreshold', 'orangeThreshold', 'yellowThreshold', 'otherThreshold'],
          isDuplicate: false,
          acl: {},
          hasACL: {},
          permissionKey: 'setting-service-settings',
          requirePicture: false,
          openRequired: false,
          category: null,
          categoryList: [
            { label: 'FLM', value: 'FLM' },
            { label: 'SLM', value: 'SLM' }
          ],
          isPMSuspended: (val) => {
            if (!val) return false;
            if (val && typeof val === 'object' && val.isSuspended !== undefined) {
              return val.isSuspended;
            }
            const id = (val && typeof val === 'object') ? val.Value : val;
            const pm = ($scope.model.pmSearchList || []).find(p => p.Value === id);
            return pm && pm.isSuspended;
          }
        };

        const init = () => {
          $scope.loadPermission();
          $scope.model.loadPreventativeMaintenances('', 0);
          if ($scope.model.hasACL['create']) {
            $scope.model.actionCodeData.details.responses.push({
              id: '',
              label: '',
              sortOrder: 1,
            });
          }
        };

        $scope.loadPermission = () => {
          $scope.model.acl[$scope.model.permissionKey] = User.getACL($scope.model.permissionKey);
          $scope.model.acl[$scope.model.permissionKey].forEach((permission) => {
            $scope.model.hasACL[permission] = true;
          });
        };

        $scope.addNewServiceResponse = () => {
          $scope.model.actionCodeData.details.responses.push({
            id: '',
            label: '',
            sortOrder: $scope.model.actionCodeData.details.length + 1,
          });
        }

        $scope.addNewRootCause = () => {
          $scope.model.actionCodeData.details.rootCauses.push({
            id: "",
            label: "",
            sortOrder: $scope.model.actionCodeData.details.rootCauses.length + 1,
          });
        };
        $scope.cancel = () => {
          createActionCodeModal.close();
        }

        $scope.removeResolveCodes = (index) => {
          $scope.model.actionCodeData.details.responses.splice(index, 1);
        }

        $scope.removeRootCauses = index => {
          $scope.model.actionCodeData.details.rootCauses.splice(index, 1);
        };
        $scope.disableCodeUpdate = () => {
          let isEmpty = $scope.model.actionCodeData.details.responses.filter(item => !item.label);
          let isRootCausesEmpty = $scope.model.actionCodeData.details.rootCauses.filter(item => !item.label);
          let thresholds = $scope.model.thresholdList.map((d) => {
            return $scope.model[d] ? moment($scope.model[d]).format('HH:mm:00') : null
          })
          let duplicate = thresholds.reduce((acc, currentValue, index, array) => {
            if (currentValue) if (array.indexOf(currentValue) != index && !acc.includes(currentValue)) acc.push(currentValue);
            return acc;
          }, []);
          $scope.model.isDuplicate = duplicate.length;
          return (isEmpty.length || isRootCausesEmpty.length || $scope.model.isDuplicate) ? true : false;
        }

        $scope.ok = () => {
          callback({
            modal: createActionCodeModal,
            actionCodeLabel: $scope.model.actionCodeLabel,
            actionCode: $scope.model.actionCode,
            minResponse: $scope.model.minResponse,
            maxResponse: $scope.model.maxResponse,
            minRootCause: $scope.model.minRootCause,
            maxRootCause: $scope.model.maxRootCause,
            thresholds: $scope.model.thresholds,
            partsCapture: $scope.model.partsCapture,
            resolveCodes: $scope.model.actionCodeData.details.responses,
            rootCauses: $scope.model.actionCodeData.details.rootCauses,
            redThreshold: $scope.model.redThreshold ? moment($scope.model.redThreshold).format('HH:mm:00') : null,
            orangeThreshold: $scope.model.orangeThreshold ? moment($scope.model.orangeThreshold).format('HH:mm:00') : null,
            yellowThreshold: $scope.model.yellowThreshold ? moment($scope.model.yellowThreshold).format('HH:mm:00') : null,
            otherThreshold: $scope.model.otherThreshold ? moment($scope.model.otherThreshold).format('HH:mm:00') : null,
            requirePicture: $scope.model.requirePicture,
            openRequired: $scope.model.openRequired,
            category: $scope.model.category,
            serviceType: $scope.model.serviceType,
            expectedCompletionTime: $scope.model.expectedCompletionTime ? moment($scope.model.expectedCompletionTime).format('HH:mm:00') : null,
            autoAssignable: $scope.model.autoAssignable,
            serviceActionPriorityId: $scope.model.serviceActionPriorityId,
            preventativeMaintenanceId: $scope.model.preventativeMaintenanceId ? $scope.model.preventativeMaintenanceId.Value : null
          });
          // createActionCodeModal.close();
        }
        init()
      }]
    })
  }

  let createServiceChecklist = (pagination, callback, negative) => {
    let createServiceChecklistModal = $uibModal.open({
      template: createServiceChecklistTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', 'User', function ($scope, $q, User) {
        $scope.model = {
          serviceChecklistData: {
            details: {}
          },
          acl: {},
          hasACL: {},
          permissionKey: 'setting-service-checklist',
        };

        const init = () => {
          $scope.loadPermission();
          if ($scope.model.hasACL['create']) {
            $scope.model.serviceChecklistData.details = { label: '', sortOrder: pagination + 1, daySelection: 30 };
            focusElementById('service-check-list-name');
          }
        };

        $scope.loadPermission = () => {
          $scope.model.acl[$scope.model.permissionKey] = User.getACL($scope.model.permissionKey);
          $scope.model.acl[$scope.model.permissionKey].forEach((permission) => {
            $scope.model.hasACL[permission] = true;
          });
        };

        $scope.cancel = () => {
          createServiceChecklistModal.close();
        }

        $scope.disableCodeUpdate = () => {
          return !$scope.model.serviceChecklistData.details.label || !$scope.model.serviceChecklistData.details.daySelection;
        }

        $scope.ok = () => {
          callback({
            modal: createServiceChecklistModal,
            serviceChecklist: $scope.model.serviceChecklistData.details
          });
          // createServiceChecklistModal.close();
        }
        init()
      }]
    })
  }

  let createAtmMake = (callback, negative) => {
    let createAtmMakeModal = $uibModal.open({
      template: createAtmMakeTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', function ($scope) {
        $scope.model = {
          atmMakeData: {
            details: {}
          }
        };

        const init = () => {
          $scope.model.atmMakeData.details = { vendorName: '', active: true };
          focusElementById('atm-make-name');
        };

        $scope.cancel = () => {
          if (negative) {
            negative({ modal: createAtmMakeModal });
            return;
          }

          createAtmMakeModal.close();
        }

        $scope.disableCodeUpdate = () => {
          return !$scope.model.atmMakeData.details.vendorName;
        }

        $scope.ok = () => {
          callback({
            modal: createAtmMakeModal,
            atmMake: $scope.model.atmMakeData.details
          });
        }

        init()
      }]
    })
  }

  let createServiceActionPriority = (callback, negative) => {
    let createServiceActionPriorityModal = $uibModal.open({
      template: createServiceActionPriorityTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', function ($scope) {
        $scope.model = {
          priorityData: {
            details: {}
          }
        };

        const init = () => {
          $scope.model.priorityData.details = { priority: '', description: '', active: true };
          focusElementById('priority-name');
        };

        $scope.cancel = () => {
          if (negative) {
            negative({ modal: createServiceActionPriorityModal });
            return;
          }

          createServiceActionPriorityModal.close();
        }

        $scope.disableCodeUpdate = () => {
          return !$scope.model.priorityData.details.priority;
        }

        $scope.ok = () => {
          callback({
            modal: createServiceActionPriorityModal,
            priorityItem: $scope.model.priorityData.details
          });
        }

        init()
      }]
    })
  }

  let changeDestinationModal = (shipmentData, customerId, callback, negative) => {
    let changeDestination = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: changeDestinationTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'ShipmentService', 'LocationService', 'User', ($scope, $translate, ShipmentService, LocationService, User) => {

        $scope.model = {
          branch: User.getUser().branchId,
          locationList: [],
          comment: '',
          totalLocation: 0,
          shipmentData: shipmentData,
          location: '',
          errorMsg: '',
          customerId: customerId,
        }
        
        $scope.mappingLocations = (locations) => {
          return locations.map((loc) => {
            return {
              Key: loc.id + " | " + loc.name,
              Value: loc.id
            }
          });
        }

        const init = () => {
          $scope.model.loading = true;
          $scope.getCentralBankLocation('', 0);
          $scope.model.location = {
            Key: shipmentData.toLocationId + ' | ' + shipmentData.toLocationName,
            Value: shipmentData.toLocationId,
          }

        }

        $scope.getCentralBankLocation = (searchKey, offset) => {
          searchKey = searchKey || ''
          if ($scope.model.customerId) {
            return $scope.getDeliveryToLocationsAndShiptypes(searchKey, offset);
          }

          ShipmentService.getChangeDestinationLocations(
            shipmentData.trackingId,
            shipmentData.branchId,
            searchKey,
            offset,
            AppConstant.defaultPageLimit,
          )
            .then((data) => {
              if (!offset || offset === 0) {
                $scope.model.totalLocation = data.total
                $scope.model.locationList = $scope.mappingLocations(data.results)
              } else {
                const Locations = $scope.mappingLocations(data.results)
                $scope.model.locationList = $scope.model.locationList.concat(Locations)
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message)
              }
            })
            .finally(() => {
              $scope.model.loading = false
            })
        }

        $scope.getDeliveryToLocationsAndShiptypes = (searchKey, offset) => {
          LocationService.getDeliveryToLocationsAndShiptypes(shipmentData.toLocationId, searchKey)
            .then((data) => {
              const locations = data.results.destinationData;

              if (!offset || offset === 0) {
                const currentDestExists = locations.find(l => l.id === shipmentData.toLocationId);
                let totalLocation = data.totalRecords.destinationCount;
                if (!currentDestExists && !searchKey) {
                  locations.unshift({
                    id: shipmentData.toLocationId,
                    name: shipmentData.toLocationName
                  });
                  totalLocation++;
                }
                $scope.model.totalLocation = totalLocation;
                $scope.model.locationList = $scope.mappingLocations(locations)
              } else {
                const newLocations = $scope.mappingLocations(locations)
                $scope.model.locationList = $scope.model.locationList.concat(newLocations)
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message)
              }
            })
            .finally(() => {
              $scope.model.loading = false
            })
        }

        $scope.validateDestination = () => {
          if ($scope.model.location && ($scope.model.shipmentData.toLocationId === $scope.model.location.Value)) {
            $scope.model.errorMsg = $translate.instant('branch_mgmt.items.duplicate_destination_error', {
              trackingId: $scope.model.shipmentData.trackingId,
              locationId: $scope.model.location.Value
            })
          }
          else {
            delete $scope.model.errorMsg;
          }
        }

        $scope.cancel = () => {
          negative({
            modal: changeDestination
          });
        }

        $scope.ok = () => {
          if ($scope.model.customerId) {
             confirm({
              header: $translate.instant('common.confirm_title'),
                message: 'Are you sure you want to change the destination?',
                callback: ({ modal }) => {
                   callback({
                      modal: changeDestination,
                      comment: $scope.model.comment || null,
                      locationId: $scope.model.location.Value,
                      supervisorId: null
                    });
                    modal.close();
                },
                negative: ({ modal }) => {
                  modal.close();
                },
              type: 'success',
              buttons: ['common.yes', 'common.no']
             })
          } else {
            confirmSupervisor('change-destination', { trackingId: $scope.model.shipmentData.trackingId }, ({ model, supId }) => {
              callback({
                modal: changeDestination,
                comment: $scope.model.comment || null,
                locationId: $scope.model.location.Value,
                supervisorId: supId
              });
              modal.close();
            }, ({ modal }) => {
              modal.close();
            })
          }
        }

        init();
      }]
    })
    rejectModal(changeDestination, negative)
  }

  let serviceOrderActions = (serviceOrder, callback, negative) => {
    let serviceOrderActionsModal = $uibModal.open({
      template: serviceOrderActionsTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', 'ServiceOrderService', '$translate', 'DateUtil', 'ServiceTicketPartsService',
        function ($scope, $q, ServiceOrderService, $translate, DateUtil, ServiceTicketPartsService) {

          $scope.model = {
            loading: false,
            serviceOrder: serviceOrder,
            actionCodes: [],
            selectedResponses: {},
            // serviceOrderNote: serviceOrder.serviceOrderNote,
            errorMessage: null,
            isUpdate: false,
            isValid: false,
            serviceUserList: [],
            userId: null,
            completedTime: null,
            completedDate: null,
            completedDateError: null,
            selectedParts: {},
            lastArrivalTime: serviceOrder.lastArrivalTime,
            arrivedDate: null,
            arrivedTime: null,
            browserTimezone: moment.tz.guess()
          };

          const init = () => {
            $scope.model.loading = true;
            $scope.model.completedDate = moment().toDate();
            $scope.time = moment().format('HH:mm:ss');
            $scope.model.completedTime = $scope.getTime($scope.time);

            const lastArrivalDateTime = $scope.model.lastArrivalTime;

            if (!lastArrivalDateTime) {
              $scope.model.arrivedDate = moment().toDate();
              $scope.model.arrivedTime = $scope.getTime($scope.time);
            }
            else {
              const time = moment.utc(lastArrivalDateTime).tz($scope.model.browserTimezone).format('HH:mm:ss');
              $scope.model.arrivedDate = moment(lastArrivalDateTime);
              $scope.model.arrivedTime = DateUtil.getTime(time);
            }

            $scope.minVaultDate = {
              minDate: $scope.model.serviceOrder.firstAssignOn ? moment($scope.model.serviceOrder.firstAssignOn).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
              maxDate: moment().format('YYYY-MM-DD')
            }
            $scope.firstAssignedTime = $scope.model.serviceOrder.firstAssignOn ? moment($scope.model.serviceOrder.firstAssignOn).format('HH:mm') : moment().format('HH:mm')
            $scope.model.minTime = $scope.firstAssignedTime;
            $scope.model.maxTime = moment().format('HH:mm');

            $q.all([
              ServiceOrderService.getServiceOrderActionCodes($scope.model.serviceOrder.encounterId),
              $scope.getBranchServiceUser(),
              ServiceTicketPartsService.all(null, 0, 100)
            ])
              .then((data) => {
                $scope.model.userId = $scope.model.serviceOrder.userId;
                $scope.model.actionCodes = data[0].results;
                $scope.model.serviceTicketPartList = data[2].results;
                $scope.model.requireResolveCodesFor = data[0].requireResolveCodesFor;

                $scope.model.actionCodes.forEach(d => {
                  $scope.model.selectedResponses[d.serviceOrderActionId] = { responseCode: [], selectedParts: [], rootCauseCode: [], note: null, selectionMode: null, rootCauseSelectionMode: null, userNote: null }
                  $scope.model.selectedResponses[d.serviceOrderActionId].note = d.serviceOrderActionNote;
                  $scope.model.selectedResponses[d.serviceOrderActionId].selectionMode = d.maxResponses === 1 ? 'single' : 'multiple';
                  $scope.model.selectedResponses[d.serviceOrderActionId].rootCauseSelectionMode = d.maxRootCauses === 1 ? 'single' : 'multiple';
                  $scope.model.selectedResponses[d.serviceOrderActionId].userNote = d.serviceOrderActionUserNote;

                  d.responses.forEach(response => {
                    d.selectedResponseCodeIds.forEach(responseCodeIds => {
                      if (response.id == responseCodeIds) {
                        response.ticked = true;
                      }
                    })
                  })

                  d.rootCauses.forEach(rootCause => {
                    d.selectedRootCauseIds.forEach(rootCauseIds => {
                      if (rootCause.id == rootCauseIds) {
                        rootCause.ticked = true;
                      }
                    })
                  })

                  $scope.model.serviceTicketPartList.forEach(list => {
                    d.selectedPartIds.forEach(partId => {
                      if (list.id == partId) {
                        list.ticked = true;
                      }
                    })
                  })

                })
                $scope.validateUpdateButton();
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal(err.data.message);
                }
              })
              .finally(() => {
                $scope.model.loading = false;
              })
          }

          $scope.validateUpdateButton = () => {
            setTimeout(() => {
              let isValidResponse, verifyResponse = [];
              $scope.model.actionCodes.forEach(response => {
                isValidResponse = (((response.minResponses === 0 && !$scope.model.selectedResponses[response.serviceOrderActionId].responseCode.length) || $scope.model.selectedResponses[response.serviceOrderActionId].responseCode.length) && (response.minRootCauses ? $scope.model.selectedResponses[response.serviceOrderActionId].rootCauseCode.length : true) &&
                  $scope.model.selectedResponses[response.serviceOrderActionId].userNote) ? true : undefined;
                verifyResponse.push(isValidResponse);
              })
              if (verifyResponse.indexOf(false) >= 0 || verifyResponse.indexOf() !== -1) return $scope.model.isValid = false;
              else return $scope.model.isValid = true;
            });
          }

          $scope.cancel = () => {
            serviceOrderActionsModal.close();
          }

          $scope.translateMessage = (message) => {
            return $translate.instant(message);
          }

          $scope.ok = () => {
            let details = [];

            $scope.model.isUpdate = true;
            $scope.model.actionCodes.forEach(result => {
              if ($scope.model.selectedResponses[result.serviceOrderActionId]) {
                details.push({
                  serviceOrderActionId: result.serviceOrderActionId,
                  responses: $scope.model.selectedResponses[result.serviceOrderActionId].responseCode,
                  rootCauses: $scope.model.selectedResponses[result.serviceOrderActionId].rootCauseCode,
                  actionNote: $scope.model.selectedResponses[result.serviceOrderActionId].note || null,
                  userNote: $scope.model.selectedResponses[result.serviceOrderActionId].userNote || null,
                  actionCode: result.actionCodeId,
                  parts: $scope.model.selectedResponses[result.serviceOrderActionId].selectedParts
                })
              }
            })

            callback({
              modal: serviceOrderActionsModal,
              actionCodeData: details,
              // serviceOrderNote: $scope.model.serviceOrderNote,
              $scope: $scope,
              completedByUserId: $scope.model.userId,
              completedDate: moment($scope.model.completedDate).format('YYYY-MM-DD'),
              completedTime: moment($scope.model.completedTime).format('HH:mm:ss'),
              arrivedDate: moment($scope.model.arrivedDate).format('YYYY-MM-DD'),
              arrivedTime: moment($scope.model.arrivedTime).format('HH:mm:ss'),
            });
            // serviceOrderActionsModal.close();
          }

          $scope.getTime = (time) => {
            if (!time) {
              return time;
            }

            time = time.split(':');

            let d = new Date();

            d.setHours(+time[0]);
            d.setMinutes(time[1]);
            d.setSeconds(0);
            d.setMilliseconds(0);

            return d;
          }

          $scope.validateCompletedAt = () => {
            const formatDateTime = (date, time) => moment(date).format('YYYY-MM-DD').concat(' ', moment(time).format('HH:mm:ss'));
            const getTimestamp = (dateTime) => new Date(dateTime).getTime();

            $scope.completedAt = formatDateTime($scope.model.completedDate, $scope.model.completedTime);
            const completedAtTs = getTimestamp($scope.completedAt);
            const currentBrowserTime = Date.now();

            $scope.arrivedAt = formatDateTime($scope.model.arrivedDate, $scope.model.arrivedTime);
            const arrivedAtTs = getTimestamp($scope.arrivedAt);

            const { serviceOrder } = $scope.model;

            let baseTimestamp = null;
            let errorMessageKey = '';

            if (serviceOrder.firstAssignOn) {
              baseTimestamp = getTimestamp(moment(serviceOrder.firstAssignOn).format('YYYY-MM-DD HH:mm:ss'));
              errorMessageKey = 'serviceTickets.befor_first_assigned_on_err';
            } else if (serviceOrder.acceptedOn) {
              baseTimestamp = getTimestamp(moment(serviceOrder.acceptedOn).format('YYYY-MM-DD HH:mm:ss'));
              errorMessageKey = 'service_tickets.completed_time.before_first_accepted_on_err';
            }

            if (baseTimestamp && completedAtTs < baseTimestamp) {
              $scope.model.completedDateError = $translate.instant(errorMessageKey);
            } else if (completedAtTs > currentBrowserTime) {
              $scope.model.completedDateError = $translate.instant('serviceTickets.after_current_date_time_err');
            } else if (completedAtTs < arrivedAtTs) {
              $scope.model.completedDateError = $translate.instant('service_tickets.completed_date_time_is_before_arrived_time_err');
            } else {
              delete $scope.model.completedDateError;
            }
          };

          $scope.validateArrivedTime = () => {
            $scope.arrivedAt = moment($scope.model.arrivedDate).format('YYYY-MM-DD').concat(' ', moment($scope.model.arrivedTime).format('HH:mm:ss'));
            const currentBrowserTime = new Date().getTime();
            const convertArrivedAtToTs = new Date($scope.arrivedAt).getTime();

            $scope.completedAt = moment($scope.model.completedDate).format('YYYY-MM-DD').concat(' ', moment($scope.model.completedTime).format('HH:mm:ss'));
            const convertCompletedAtToTs = new Date($scope.completedAt).getTime();

            if ($scope.model.serviceOrder.firstAssignOn) {
              const firstAssignOn = moment($scope.model.serviceOrder.firstAssignOn).format('YYYY-MM-DD HH:mm:ss');
              const convertFirstAssignOnToTs = new Date(firstAssignOn).getTime();

              if (moment(convertArrivedAtToTs).isBefore(convertFirstAssignOnToTs)) {
                $scope.model.arrivedDateError = $translate.instant('service_tickets.arrived_time.befor_first_assigned_on_err');
              }
              else if (moment(convertArrivedAtToTs).isAfter(currentBrowserTime)) {
                $scope.model.arrivedDateError = $translate.instant('service_tickets.arrived_time.after_current_date_time_err');
              }
              else if (moment(convertArrivedAtToTs).isAfter(convertCompletedAtToTs)) {
                $scope.model.arrivedDateError = $translate.instant('service_tickets.arrived_time.after_completed_date_time_err');
              }
              else {
                delete $scope.model.arrivedDateError;
              }
            }
            else if ($scope.model.serviceOrder.acceptedOn) {
              const firstAcceptedOn = moment($scope.model.serviceOrder.acceptedOn).format('YYYY-MM-DD HH:mm:ss');
              const convertFirstAcceptedOnToTs = new Date(firstAcceptedOn).getTime();

              if (moment(convertArrivedAtToTs).isBefore(convertFirstAcceptedOnToTs)) {
                $scope.model.arrivedDateError = $translate.instant('service_tickets.arrived_time.before_first_accepted_on_err');
              }
              else if (moment(convertCompletedAtToTs).isAfter(currentBrowserTime)) {
                $scope.model.completedDateError = $translate.instant('serviceTickets.after_current_date_time_err');
              }
              else {
                delete $scope.model.arrivedDateError;
              }
            }
            else if (moment(convertArrivedAtToTs).isAfter(currentBrowserTime)) {
              $scope.model.arrivedDateError = $translate.instant('service_tickets.arrived_time.after_current_date_time_err');
            }
            else {
              delete $scope.model.arrivedDateError;
            }
          }

          $scope.getBranchServiceUser = () => {
            return ServiceOrderService.getServiceUser($scope.model.serviceOrder.branchId)
              .then((data) => {
                $scope.model.serviceUserList = data.results;
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  Modal.errorModal(err.data.message);
                }
              })
          }

          init()
        }]
    })
    rejectModal(serviceOrderActionsModal, negative)
  }

  let pendingCancelShipments = (branchId, routeId, vaultDate, callback, negative) => {
    let pendingCancelShipmentsModal = $uibModal.open({
      template: pendingCancelShipmentsTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', 'ShipmentService', '$state', 'Navigation', function ($scope, $q, ShipmentService, $state, Navigation) {

        $scope.model = {
          shipments: [],
          loading: false,
          errorMessage: '',
          branchId: branchId,
          routeId: routeId,
          vaultDate: vaultDate
        };

        const init = () => {
          $scope.model.loading = true;

          ShipmentService.getPendingCancelShipments($scope.model.branchId, 0, 1000, $scope.model.routeId, $scope.model.vaultDate)
            .then((data) => {
              $scope.model.shipments = data.results;
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                $scope.model.errorMessage = err.data.message;
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.goToItemHistory = (trackingId) => {
          pendingCancelShipmentsModal.close();
          $state.go('branchManagement.items', { id: trackingId });
        }

        $scope.goToServiceHistory = (locationId) => {
          return Navigation.goToServiceHistory(locationId, null, true, pendingCancelShipmentsModal)
        }

        $scope.goToOrderHistory = (data) => {
          return Navigation.goToOrderHistory(data.orderNo, data.vaultDate, true, false, true, false, pendingCancelShipmentsModal);
        }

        $scope.goToBulkCash = () => {
          pendingCancelShipmentsModal.close();
          $state.go('bulkCashManagement');
        }

        $scope.cancel = () => {
          pendingCancelShipmentsModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: pendingCancelShipmentsModal
          });
          pendingCancelShipmentsModal.close();
        }
        init()
      }]
    })
    rejectModal(pendingCancelShipmentsModal, negative)
  }

  let bagoutListModal = (branchId, destinationLocation, bagOutId, infoFor, callback, negative) => {
    let bagoutList = $uibModal.open({
      template: bagoutListTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', 'BagoutService', 'Navigation', '$state', function ($scope, BagoutService, Navigation, $state) {

        $scope.model = {
          branchId: branchId,
          destinationLocationId: destinationLocation ? destinationLocation.Value : null,
          destinationLocation: destinationLocation ? destinationLocation.Key : null,
          bagoutList: [],
          infoFor: infoFor,
          bagOutId: bagOutId,
          totalRecords: 0,
          loading: false
        };

        $scope.pagination = {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }

        const init = () => {
          $scope.loadBagoutList();
        }

        $scope.loadBagoutList = () => {
          let promise = Promise.resolve();
          promise = $scope.model.infoFor === 'remainingBagout' ?
            BagoutService.getRemainingBagoutList($scope.model.branchId, $scope.model.destinationLocationId, ($scope.pagination.page - 1) * $scope.pagination.pageLimit, $scope.pagination.pageLimit) :
            BagoutService.getTotalItemsInBagoutList($scope.model.bagOutId, ($scope.pagination.page - 1) * $scope.pagination.pageLimit, $scope.pagination.pageLimit)

          $scope.model.loading = true;

          return promise.then((res) => {
            $scope.model.bagoutList = res.results;
            $scope.model.totalRecords = res.totalRecords;
          })
            .catch((err) => {
              console.log(err);
              if (err && err.data && err.data.message) {
                Modal.errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.pageChange = () => {
          $scope.loadBagoutList();
        }

        $scope.goToServiceHistory = (locationId) => {
          return Navigation.goToServiceHistory(locationId, null, true, bagoutList);
        }

        $scope.goToItemHistory = (trackingId) => {
          bagoutList.close();
          $state.go('branchManagement.items', {
            id: trackingId,
          });
        }

        $scope.cancel = () => {
          bagoutList.close();
        }

        init();
      }]
    })
    rejectModal(bagoutList, negative);
  }

  let bulkCashAdjustComment = (data, callback, negative) => {
    let bulkCashAdjustCommentModal = $uibModal.open({
      template: bulkCashAdjustCommentTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', function ($scope, $q) {

        $scope.model = {
          comment: '',
          bulkCashData: data,
          loading: false
        };

        const init = () => {
          focusElementById('bulk-cash-adjust-comment');
        }

        $scope.ok = () => {
          // $scope.model.loading = true;
          callback({
            modal: bulkCashAdjustCommentModal,
            comments: $scope.model.comment,
          });
          bulkCashAdjustCommentModal.close();
        }

        $scope.cancel = () => {
          negative({
            modal: bulkCashAdjustCommentModal
          })
        }

        init()
      }]
    })
    rejectModal(bulkCashAdjustCommentModal, negative)
  }

  let shipmentImageModal = (shipments, trackingId, stats, modal, callback) => {
    let shipmentImage = $uibModal.open({
      template: shipmentImageTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', function ($scope, $q) {
        $scope.model = {
          shipmentData: shipments,
          trackingId: trackingId,
          stats: stats,
          image: stats === 'pickup' ? shipments.pickupImageName : shipments.deliveryImageName
        };
  
        $scope.zoomLevel = 350;
        $scope.maxZoom = 600;
        $scope.minZoom = 200;
  
        $scope.zoomIn = function () {
          if ($scope.zoomLevel < $scope.maxZoom) {
            $scope.zoomLevel += 50;
          }
        };
  
        $scope.zoomOut = function () {
          if ($scope.zoomLevel > $scope.minZoom) {
            $scope.zoomLevel -= 50;
          }
        };
        const init = () => { }
        $scope.ok = () => {
          callback({
            modal: shipmentImage
          })
          shipmentImage.close();
        }
        $scope.cancel = () => {
          shipmentImage.close();
        }
        init()
      }]
    })
  }

  let bagoutsOnHoldModal = (callback, negative) => {
    let bagoutsOnHold = $uibModal.open({
      template: bagoutsOnHoldTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$q', 'User', 'HoldService', function ($scope, $q, User, HoldService) {
        $scope.model = {
          bagoutData: [],
          branchId: User.getUser().branchId,
          loading: false
        };

        const init = () => {
          $scope.model.loading = true;
          HoldService.getBagoutsOnHold($scope.model.branchId)
            .then((data) => {
              $scope.model.bagoutData = data.results;
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.ok = () => {
          confirmSupervisor('solf-delete-bagouts-on-hold', null, ({ model, supId }) => {
            callback({
              modal: bagoutsOnHold,
              supervisorId: supId
            })
            model.close();
          }, ({ modal }) => {
            modal.close();
          })
        }

        $scope.cancel = () => {
          negative({
            modal: bagoutsOnHold
          })
        }

        init()
      }]
    })
    rejectModal(bagoutsOnHold, negative)
  }

  let saveLocationLaterModal = (routeAssignment, deliveryToLocation, locationId, locationStatus, locationBranch, defaultBranch, batchImport,
    bagoutExport, routeLikeRegular, recurringRouteAssignment, denomination, scheduleRecurringLoad, fundingSource, callback, negative) => {
    let saveLater = $uibModal.open({
      template: saveLocationLaterTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$q', 'DateUtil', '$translate', function ($scope, $q, DateUtil, $translate) {
        $scope.model = {
          deliveryToLocation: deliveryToLocation,
          routeAssignment: routeAssignment,
          locationId: locationId,
          date: null,
          time: null,
          currentDateTime: moment.utc().format(),
          dateError: null,
          locationStatus: locationStatus,
          locationBranch: locationBranch,
          defaultBranch: defaultBranch,
          batchImport: batchImport,
          bagoutExport: bagoutExport,
          routeLikeRegular: routeLikeRegular,
          recurringRouteAssignment: recurringRouteAssignment,
          denomination: denomination,
          scheduleRecurringLoad: scheduleRecurringLoad,
          fundingSource: fundingSource,
        };

        const init = () => {
          $scope.minVaultDate = {
            minDate: moment().format('YYYY-MM-DD')
          }
        }

        $scope.calculateDuration = (startDate, endDate) => {
          let ms = moment(endDate).diff(startDate);
          return ms.valueOf();
        }

        $scope.validateDate = () => {
          const futureDate = $scope.formatDate();

          if (!futureDate) return;

          if (!moment(futureDate).isAfter($scope.model.currentDateTime)) $scope.model.dateError = $translate.instant('location.date_error');
          else delete $scope.model.dateError;
        }

        $scope.formatDate = () => {
          if (!$scope.model.date || !$scope.model.time) return;

          const date = moment($scope.model.date).format('YYYY-MM-DD');
          const time = moment($scope.model.time).format('HH:mm:ss');
          const formattedDate = date.concat(' ', time);
          const dateTime = moment(formattedDate).utc().format();

          return dateTime;
        }

        $scope.ok = () => {
          const futureDate = $scope.formatDate();
          const duration = $scope.calculateDuration($scope.model.currentDateTime, futureDate);

          callback({
            modal: saveLater,
            duration: duration,
            dateTime: futureDate
          })
          saveLater.close();
        }

        $scope.cancel = () => {
          saveLater.close();
        }

        init()
      }]
    })
    rejectModal(saveLater, negative)
  }


  let saveRouteChangesLaterModal = (tankerAssignment, routeId, callback, negative) => {
    let saveLater = $uibModal.open({
      template: saveRouteChangesLaterTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$translate', function ($scope, $translate) {
        $scope.model = {
          tankerAssignment: tankerAssignment,
          routeId: routeId,
          date: null,
          time: null,
          currentDateTime: moment.utc().format(),
          dateError: null
        };

        const init = () => {
          $scope.minVaultDate = {
            minDate: moment().format('YYYY-MM-DD')
          }
        }

        $scope.calculateDuration = (startDate, endDate) => {
          let ms = moment(endDate).diff(startDate);
          return ms.valueOf();
        }

        $scope.validateDate = () => {
          const futureDate = $scope.formatDate();

          if (!futureDate) return;

          if (!moment(futureDate).isAfter($scope.model.currentDateTime)) $scope.model.dateError = $translate.instant('location.date_error');
          else delete $scope.model.dateError;
        }

        $scope.formatDate = () => {
          if (!$scope.model.date || !$scope.model.time) return;

          const date = moment($scope.model.date).format('YYYY-MM-DD');
          const time = moment($scope.model.time).format('HH:mm:ss');
          const formattedDate = date.concat(' ', time);
          const dateTime = moment(formattedDate).utc().format();

          return dateTime;
        }

        $scope.ok = () => {
          const futureDate = $scope.formatDate();
          const duration = $scope.calculateDuration($scope.model.currentDateTime, futureDate);

          callback({
            modal: saveLater,
            duration: duration,
            dateTime: futureDate
          })
          saveLater.close();
        }

        $scope.cancel = () => {
          saveLater.close();
        }

        init()
      }]
    })
    rejectModal(saveLater, negative)
  }

  let billingContractRulesModal = (data, isEdit, contractRules = [], callback, negative) => {
    let billingContractRules = $uibModal.open({
      template: billingContractRulesTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$q', 'User', 'CurrencyService', 'Modal', '$translate', 'SetupService', function ($scope, $q, User, CurrencyService, Modal, $translate, SetupService) {
        $scope.model = {
          branchId: User.getUser().branchId,
          loading: false,
          billingEventOptions: [
            {
              label: 'Shipment Delivery',
              key: 'shipment-delivered'
            },
            {
              label: 'Shipment Pickup',
              key: 'shipment-pickup'
            },
            // {
            //   label: 'ATM Service',
            //   key: 'ATM_service'
            // },
            // {
            //   label: 'ATM Count',
            //   key: 'ATM_count'
            // },
            // {
            //   label: 'Order Pack',
            //   key: 'order_pack'
            // },
            // {
            //   label: 'Shipment Deposit',
            //   key: 'shipment_deposit'
            // },
            // {
            //   label: 'Repair/Maintenance',
            //   key: 'repair_maintenance'
            // },
            // {
            //   label: 'Part Charge',
            //   key: 'part_charge'
            // },
            // {
            //   label: 'Fuel Surcharge',
            //   key: 'fuel_surcharge'
            // }
          ],
          locationTypeOptions: [
            {
              label: 'Any',
              value: 'ANY'
            },
            {
              label: 'ATM',
              value: 'ATM'
            },
            {
              label: 'Regular',
              value: 'REGULAR'
            },
            {
              label: 'NSNG',
              value: 'NSNG'
            },
            {
              label: 'On Call',
              value: 'ON_CALL'
            }
          ],
          orderTypeOptionsChildren: {
            'common': [{
              label: 'Any',
              value: 'ANY'
            },
            {
              label: 'Scheduled',
              value: 'SCHEDULED'
            },
            {
              label: 'Unscheduled',
              value: 'UNSCHEDULED'
            },
            {
              label: 'Seasonal',
              value: 'SEASONAL'
            },
            {
              label: 'On Call',
              value: 'ON_CALL'
            }],
            'ATM': [{
              label: 'ATM Any Service',
              value: 'ATM_ANY_SERVICE'
            },
            {
              label: 'ATM Add',
              value: 'ATM_ADD'
            },
            {
              label: 'ATM Swap',
              value: 'ATM_SWAP'
            },
            {
              label: 'ATM ICL',
              value: 'ATM_ICL'
            },
            {
              label: 'ATM CCL',
              value: 'ATM_CCL'
            },
            {
              label: 'ATM Recash',
              value: 'ATM_RECASH'
            },
            {
              label: 'ATM Decash',
              value: 'ATM_DECASH'
            }],
            'services': [{
              label: 'Service Order',
              value: 'SERVICE_ORDER'
            }]
          },
          billingTypeOptions: [
            {
              label: 'Fixed',
              value: 'FIXED'
            },
            {
              label: 'Per Item',
              value: 'PER_ITEM'
            },
            {
              label: 'Item Range',
              value: 'ITEM_RANGE'
            },
            {
              label: 'Amount Range',
              value: 'AMOUNT_RANGE'
            },
            {
              label: 'Time Range',
              value: 'TIME_RANGE'
            },
            // {
            //   label: 'Percentage',
            //   value: 'percentage'
            // }
          ],
          billingRateOptionsChildren: {
            'without_rate': [
              {
                label: 'Currency',
                value: 'CURRENCY'
              },
              {
                label: 'Rate Above',
                value: 'RATE_ABOVE'
              },
              {
                label: 'Rate Equal Below',
                value: 'RATE_EQUAL_BELOW'
              },
              {
                label: 'Rate Percentage',
                value: 'RATE_PERCENTAGE'
              },
              {
                label: 'Percentage',
                value: 'PERCENTAGE'
              },
            ],
            'item_options': [
              {
                label: 'Item Limit',
                value: 'ITEM_LIMIT'
              },
              {
                label: 'Value Increment',
                value: 'VALUE_INCREMENT'
              },
            ],
            'value_options': [
              {
                label: 'Value Limit',
                value: 'VALUE_LIMIT'
              },
              {
                label: 'Item Increment',
                value: 'ITEM_INCREMENT'
              }
            ],
            'time_options': [
              {
                label: 'Value Limit',
                value: 'VALUE_LIMIT'
              },
              {
                label: 'Item Increment',
                value: 'ITEM_INCREMENT'
              }
            ],
            'rate_options': [
              {
                label: 'Rate',
                value: 'RATE'
              },
            ]
          },
          contractRulesOptions: [],
          existingBillingRules: data,
          isEdit: isEdit,
          isValidItemRange: true,
          duplicateObj: {},
          itemRangeError: ''
        };

        const init = () => {
          if (!$scope.model.existingBillingRules) {
            $scope.model.contractRulesOptions.push({
              billingEvent: null,
              locationType: null,
              orderType: null,
              billingTypeObj: {},
              billingRateObj: {},
              billingTypeOptions: $scope.model.billingTypeOptions
            })
          }
          else if ($scope.model.isEdit && $scope.model.existingBillingRules.id) {
            const existingBillingRulesObj = $scope.model.existingBillingRules;

            $scope.model.contractRulesOptions.push({
              billingEvent: _.find($scope.model.billingEventOptions, { 'key': existingBillingRulesObj.billingEvent }),
              locationType: _.find($scope.model.locationTypeOptions, { 'value': existingBillingRulesObj.locationType }),
              billingTypeObj: {},
              billingRateObj: {},
              billingTypeOptions: $scope.model.billingTypeOptions
            })

            $scope.model.contractRulesOptions.forEach((obj, index) => {
              $scope.orderTypeOptionChanged(obj, index);
              obj.orderType = _.find(obj.options, { 'value': existingBillingRulesObj.orderType });
              obj.billingTypeObj.billingType = _.find(obj.billingTypeOptions, { 'value': existingBillingRulesObj.billingType });
              obj.billingTypeObj.min = existingBillingRulesObj.minQty;
              obj.billingTypeObj.max = existingBillingRulesObj.maxQty;
              obj.billingTypeObj.minAmount = existingBillingRulesObj.minAmount;
              obj.billingTypeObj.maxAmount = existingBillingRulesObj.maxAmount;
              obj.billingTypeObj.beginTime = existingBillingRulesObj.beginTime ? $scope.getTime(existingBillingRulesObj.beginTime) : null;
              obj.billingTypeObj.endTime = existingBillingRulesObj.endTime ? $scope.getTime(existingBillingRulesObj.endTime) : null;
              // $scope.billingRateOptionChanged(obj, index);
              obj.billingRateOptions = $scope.model.billingRateOptionsChildren['rate_options'];
              obj.billingRateObj.billingRate = obj.billingRateOptions[0];
              obj.billingRateObj.rate = existingBillingRulesObj.billingRate;
              obj.billingRateObj.currency = existingBillingRulesObj.currencyId;
            })
          }
          else {
            $scope.model.contractRulesOptions.push(_.cloneDeep($scope.model.existingBillingRules));
          }

          // CurrencyService.all(null, 0, 100)
          //   .then((data) => {
          //     $scope.model.currencyList = data.results;
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //     if (err && err.data && err.data.message) {
          //       Modal.errorModal(err.data.message);
          //     }
          //   })

          $scope.model.loading = true;
          SetupService.get($scope.model.branchId)
            .then((data) => {
              $scope.model.contractRulesOptions.forEach((cr) => {
                cr.billingRateObj.currency = data.currencyId;
              })
            })
            .finally(() => {
              $scope.model.loading = false;
            });
        }

        $scope.orderTypeOptionChanged = (orderTypeOption, index) => {
          let selectedService = orderTypeOption.billingEvent.key;

          if (selectedService.startsWith('ATM_')) orderTypeOption.options = $scope.model.orderTypeOptionsChildren['ATM'];
          else if (selectedService === 'repair_maintenance' || selectedService === 'part_charge') orderTypeOption.options = $scope.model.orderTypeOptionsChildren['services'];
          else orderTypeOption.options = $scope.model.orderTypeOptionsChildren['common'];
        };

        $scope.billingRateOptionChanged = (obj, index) => {
          obj.billingRateOptions = $scope.model.billingRateOptionsChildren['rate_options'];

          // let selectedBillingType = obj.billingTypeObj.billingType.value;

          // if (selectedBillingType === 'flat' || selectedBillingType === 'PER_ITEM') {
          //   obj.billingRateOptions = [...$scope.model.billingRateOptionsChildren['without_rate'], ...$scope.model.billingRateOptionsChildren['rate_options']]
          // }
          // else if (selectedBillingType === 'ITEM_LIMIT') {
          //   obj.billingRateOptions = [...$scope.model.billingRateOptionsChildren['without_rate'], ...$scope.model.billingRateOptionsChildren['item_options']]
          // }
          // else if (selectedBillingType === 'VALUE_LIMIT') {
          //   obj.billingRateOptions = [...$scope.model.billingRateOptionsChildren['without_rate'], ...$scope.model.billingRateOptionsChildren['value_options']]
          // }
          // else if (selectedBillingType === 'time_limit') {
          //   obj.billingRateOptions = [...$scope.model.billingRateOptionsChildren['without_rate'], ...$scope.model.billingRateOptionsChildren['time_options']]
          // }
          $scope.validateBillingType(obj, index);
        };

        $scope.validateBillingType = (obj, index) => {
          obj.billingTypeObj.minAmount = null;
          obj.billingTypeObj.maxAmount = null;
          obj.billingTypeObj.beginTime = null;
          obj.billingTypeObj.endTime = null;
          obj.billingTypeObj.min = null;
          obj.billingTypeObj.max = null;
          delete $scope.model.billingRangeError;
        }

        $scope.validateBillingTypeRange = (obj, index) => {
          const billingTypeObj = obj.billingTypeObj;

          if (billingTypeObj.min && billingTypeObj.max && (billingTypeObj.min > billingTypeObj.max)) {
            $scope.model.billingRangeError = $translate.instant('billableEvents.value_range_error');
          }
          else if (billingTypeObj.minAmount && billingTypeObj.maxAmount && (billingTypeObj.minAmount > billingTypeObj.maxAmount)) {
            $scope.model.billingRangeError = $translate.instant('billableEvents.amount_range_error');
          }
          else if (billingTypeObj.beginTime && billingTypeObj.endTime && (billingTypeObj.beginTime > billingTypeObj.endTime)) {
            $scope.model.billingRangeError = $translate.instant('billableEvents.time_range_error');
          }
          else {
            delete $scope.model.billingRangeError;
          }
        }

        $scope.validateItemRange = () => {

          let eq;
          contractRules = _.map(contractRules, (mainObj, mainObjIndex) => {
            mainObj.duplicate = false;
            mainObj.locationType = mainObj.locationType ? mainObj.locationType : null;
            mainObj.orderType = mainObj.orderType ? mainObj.orderType : null;

            eq = _.find($scope.model.contractRulesOptions, (compareObject, compareObjIndex) => {
              const orderType = compareObject.orderType ? compareObject.orderType.value : null;
              const locationType = compareObject.locationType ? compareObject.locationType.value : null;

              if (mainObjIndex >= compareObjIndex) {
                return (orderType == mainObj.orderType && locationType == mainObj.locationType);
              }
            });

            if (eq) {
              $scope.model.duplicateObj = Object.assign({}, eq);
            }

            if (eq) {
              mainObj.duplicate = true;
              return mainObj;
            } else {
              return mainObj;
            }
          });

          let checkAndValidate = contractRules.map((obj) => {
            if (obj.duplicate) return true;
          })

          $scope.model.isValidItemRange = checkAndValidate.indexOf(true) >= 0 ? false : true;
          if (!$scope.model.isValidItemRange) {
            const findItemRange = _.filter(contractRules, {
              'orderType': $scope.model.duplicateObj.orderType.value,
              'locationType': $scope.model.duplicateObj.locationType.value,
              'billingType': 'ITEM_RANGE'
            });

            const itemRange = findItemRange.reduce(function (p, v) {
              return (p < v ? p : v);
            });

            if (($scope.model.duplicateObj.billingTypeObj.min && $scope.model.duplicateObj.billingTypeObj.min) <= itemRange.maxQty) {
              $scope.model.itemRangeError = $translate.instant('billableEvents.itemRangeError', {
                value: itemRange.maxQty
              });
            }
            else {
              delete $scope.model.itemRangeError;
            }
          }
          else {
            delete $scope.model.itemRangeError;
          }
        }

        $scope.getTime = (time) => {
          if (!time) {
            return time;
          }

          time = time.split(':');

          let d = new Date();

          d.setHours(+time[0]);
          d.setMinutes(time[1]);
          d.setSeconds(time[2]);
          d.setMilliseconds(0);

          return d;
        }

        $scope.ok = () => {
          callback({
            contractRulesOptions: $scope.model.contractRulesOptions,
            modal: billingContractRules
          })
        }

        $scope.cancel = () => {
          negative({
            modal: billingContractRules
          })
        }

        init()
      }]
    })
    rejectModal(billingContractRules, negative)
  }

  let approveBillingRecords = (data, callback, negative) => {
    let approveBillingRecordsModal = $uibModal.open({
      keyboard: false,
      template: approveBillingRecordsTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      type: 'success',
      controller: ['$scope', '$q', '$translate', 'User', 'BillingRecordsService', function ($scope, $q, $translate, User, BillingRecordsService) {

        $scope.model = {
          totalBillingRecords: data.totalRecords,
          totalAmount: data.totalAmount,
          customer: data.customer,
          approvalMessage: '',
          loading: false,
          loggedInUser: User.getUser().id,
          surchargeLoading: true,
          hasSurcharge: false,
          totalSurcharge: 0,
          surchargeBreakdown: []
        };

        $scope.type = 'success';

        const init = () => {
          const bold = (value) => `<b>${value}</b>`;

          const setApprovalMessage = () => {
            const total = ($scope.model.totalAmount || 0)
              + ($scope.model.hasSurcharge ? $scope.model.totalSurcharge : 0);

            $scope.model.approvalMessage = $translate.instant('branch_mgmt.billing_approval.approval_message', Object.assign({},
              $scope.model.totalBillingRecords > 0
                ? { totalRecords: bold(Number($scope.model.totalBillingRecords).toLocaleString('en-US')) }
                : null,
              {
                totalAmount: bold(total.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                }))
              }
            ));
          };

          setApprovalMessage();

          const selection = data.surchargeSelection;
          if (!selection || !selection.customerId) {
            $scope.model.surchargeLoading = false;
            return;
          }

          BillingRecordsService.surchargePreview(selection.billingRecordIds, selection.isApproveAllRecords,
            selection.startDate, selection.endDate, selection.customerId, selection.locationId, selection.billingCategoryId)
            .then((res) => {
              $scope.model.totalSurcharge = (res && res.totalSurcharge) || 0;
              $scope.model.surchargeBreakdown = ((res && res.surcharges) || []).map((surcharge) => ({
                type: surcharge.type,
                labelKey: SURCHARGE_LABEL_KEYS[surcharge.type],
                intervalLabelKey: SURCHARGE_INTERVAL_LABEL_KEYS[surcharge.interval] || '',
                percentage: surcharge.percentage,
                maxPercentage: surcharge.maxPercentage,
                amount: surcharge.amount
              }));
              $scope.model.hasSurcharge = $scope.model.surchargeBreakdown.length > 0;
            })
            .catch(() => {
              $scope.model.hasSurcharge = false;
            })
            .finally(() => {
              setApprovalMessage();
              $scope.model.surchargeLoading = false;
            });
        };

        $scope.cancel = () => {
          approveBillingRecordsModal.close();
        }

        $scope.ok = () => {
          // confirmSupervisor('approve-billing-records', null, ({ model, supId }) => {
          callback({
            supervisorId: $scope.model.loggedInUser,
            modal: approveBillingRecordsModal,
            $scope
          })
          // model.close();
          // }, ({ modal }) => {
          //   // $scope.model.loading = false;
          //   modal.close();
          // })
        }
        init()
      }]
    })
    rejectModal(approveBillingRecordsModal, negative);
  }

  let billableEventLogDetails = (data, callback, negative) => {
    let billableEventLogModal = $uibModal.open({
      template: billableEventLogTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', 'BillingRecordsService', '$translate', '$state', '$q','Navigation', 'CommonLayoutService', ($scope, BillingRecordsService, $translate, $state, $q, Navigation, CommonLayoutService) => {

        $scope.model = {
          billingRecordDetails: data,
          loading: false,
          searchText: data.searchText,
          entryType: data.billableEvent,
          branchId: data.branchId,
          startDate: data.startDate,
          endDate: data.endDate,
          errorMsg: null,
          logDetails: [],
          recordType: data.recordType,
          locationId: data.locationId,
          vaultDate: data.vaultDate ? moment.utc(data.vaultDate).format('YYYY-MM-DD') : null
        };

        const init = () => {
          $scope.model.loading = true;
          let promises = null;

          if ($scope.model.recordType == 'MANUAL') {
            promises = BillingRecordsService.manuallyCreatedBillingRecordsLog($scope.model.billingRecordDetails.billingRecordId);
          }
          else if ($scope.model.entryType === 'stop-completed') {
            promises = BillingRecordsService.getEventLogs('create-route-progress', $scope.model.locationId, $scope.model.vaultDate, $scope.model.branchId);
          }
          else {
            promises = BillingRecordsService.billableEventLogDetails(($scope.model.searchText.trackingId || $scope.model.searchText.serviceOrderId), $scope.model.entryType, $scope.model.branchId, $scope.model.startDate, $scope.model.endDate);
          }
          
          promises
            .then((data) => {
              $scope.model.logDetails = data.results;

              $scope.model.logDetails.forEach((log) => {
                if (log.entryData.hasOwnProperty('rate')) log.entryData.rate = CommonLayoutService.formatAmount(log.entryData.rate);
                if (log.entryData.hasOwnProperty('amount')) log.entryData.amount = CommonLayoutService.formatAmount(log.entryData.amount);
                if (log.entryData.hasOwnProperty('loadedAmount')) log.entryData.loadedAmount = CommonLayoutService.formatAmount(log.entryData.loadedAmount);
                if (log.entryData.hasOwnProperty('amountDue')) log.entryData.amountDue = CommonLayoutService.formatAmount(log.entryData.amountDue);
                log.readableEntryType = $translate.instant('entry_type.' + log.entryType)
                if (log.entryData) {
                  log.extraDetails = Object.entries(log.entryData).map((entry) => {
                    return {
                      key: entry[0],
                      value: typeof entry[1] === 'object' ? JSON.stringify(entry[1]) : entry[1]
                    };
                  });
                }
              });
            })
            .catch((err) => {
              console.error(err);
              if (err && err.data && err.data.message) {
                $scope.model.errorMsg = err.data.message;
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            });
        }

        $scope.translateMessage = (prefix, key) => {
          if (!key) return;
          else if (key === 'shipment-delivered') return $translate.instant('itemHolds.shipment_delivery');
          return $translate.instant(prefix.concat(key));
        }

        $scope.showShipmentReceipt = (log, stats) => {
          let shipmentObj = {};

          log.forEach((details) => {
            Object.assign(shipmentObj, new Object({ [details.key]: details.value }))
          })

          document.getElementById('shipment-image').blur();
          shipmentImageModal(shipmentObj, shipmentObj.trackingId, stats, ({ modal }) => {
          }, ({ modal }) => {
            modal.close();
          });
        }

        $scope.goToContractRuleTab = (contractId) => {
          $state.go('contract.edit', ({
            id: contractId
          }))
        }

        $scope.ok = () => {
          callback({
            modal: billableEventLogModal
          })
          model.close();
        }

        $scope.cancel = () => {
          negative({
            modal: billableEventLogModal
          });
        }

        $scope.goToItemHistory = (searchText) => {
          if (searchText.trackingId) {
            return Navigation.goToItemHistory(searchText.trackingId, billableEventLogModal)
          }
          if (searchText.encounterId) {
            return Navigation.goToServiceTicket(searchText.encounterId, billableEventLogModal)
          }
        }
        init()
      }]
    });
    rejectModal(billableEventLogModal, negative)
  }

  let stopComments = (routeId, vaultDate, locationId, callback, negative) => {
    let stopCommentsModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: stopCommentsTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'RouteProgressService', '$q', 'Navigation', ($scope, $translate, RouteProgressService, DataCounter, Navigation) => {

        $scope.model = {
          vaultDate: vaultDate,
          routeId: routeId,
          loading: false,
          locationId: locationId,
          transactionDetails: [],
          errorMessage: null
        };

        const init = () => {
          $scope.model.loading = true;
          RouteProgressService.getStopComments($scope.model.routeId, $scope.model.vaultDate, $scope.model.locationId)
            .then((data) => {
              $scope.model.transactionDetails = data.results;
            })
            .catch((err) => {
              console.log(err);
              $scope.model.errorMessage = err.data.message;
              console.log('errorMessage', $scope.model.errorMessage);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.goToItemHistory = (trackingId) => {
          return Navigation.goToItemHistory(trackingId, stopCommentsModal);
        }

        $scope.translateTransactionType = (transactionType) => {
          return $translate.instant(`shipment.${transactionType}`).toUpperCase();
        }

        $scope.cancel = () => {
          stopCommentsModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: stopCommentsModal
          });
          modal.close()
        }
        init()
      }]
    })
    rejectModal(stopCommentsModal, negative)
  }

  let createLanguageMessage = (messageObj, messageTypes, selectedLanguage, selectedMessageType, callback, negative) => {
    let createLanguageMessageModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: createLanguageMessageTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'MessageService', 'User', 'LanguageService', ($scope, $translate, MessageService, User, LanguageService) => {

        $scope.model = {
          messageObj: messageObj,
          loading: false,
          errorMessage: null,
          branchId: User.getUser().branchId,
          languages: null,
          languageMessageObj: {
            description: {},
            messageId: null,
            type: selectedMessageType
          },
          messageTypes: messageTypes,
          selectedLanguage: selectedLanguage,
          isCreate: false
        };

        const init = () => {
          $scope.model.loading = true;
          LanguageService.all()
            .then((response) => {
              $scope.model.languages = response.results;
              $scope.model.languages.map((language) => {
                $scope.model.languageMessageObj.description[language.id] = '';
              });
            }).catch((err) => {
              console.log(err);
              $scope.model.errorMessage = err.data.message;
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.cancel = () => {
          createLanguageMessageModal.close();
        }

        $scope.ok = () => {
          $scope.model.isCreate = true;
          MessageService.create($scope.model.selectedLanguage, $scope.model.languageMessageObj, $scope.model.branchId)
            .then(() => {
              callback({
                modal: createLanguageMessageModal
              });
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.isCreate = false;
            })
        }
        init()
      }]
    })
    rejectModal(createLanguageMessageModal, negative)
  }

  let FuelSurchargeCustomer = (messageObj, callback, negative) => {
    let FuelSurchargeCustomerModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: fuelSurchargeCustomersTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'User', 'FuelSurchargeService', ($scope, $translate, User, FuelSurchargeService) => {
        $scope.customers = [];
        $scope.model = {
          messageObj: messageObj,
          loading: false,
          errorMessage: null,
          branchId: User.getUser().branchId,
          isCreate: false,
          customer: null
        };

        const init = () => {
          $scope.model.loading = true;
          $scope.loadCustomers()
        }


        $scope.loadCustomers = () => {
          $scope.customers = [];
          FuelSurchargeService.fuelSurchagePendingCustomers().then(res => {
            if (res.result && res.result.length) {
              $scope.customers = res.result;
            }
          })
            .catch(err => {
              console.log(err)
            })
          $scope.isLoading = false;
        }
        $scope.cancel = () => {
          // FuelSurchargeCustomerModal.close();
          negative({
            modal: FuelSurchargeCustomerModal
          })
        }

        $scope.ok = () => {
          $scope.model.isLoading = true;

          callback({
            customer: Object.assign($scope.model.customer, { isNew: true }),
            modal: FuelSurchargeCustomerModal
          });
        }
        init()
      }]
    })
    rejectModal(FuelSurchargeCustomerModal, negative)
  }

  let FuelSurchargeLocations = (fuelSurcharge, customerId, callback, negative) => {
    let FuelSurchargeLocationModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: fuelSurchargeLocationTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'User', 'FuelSurchargeService', '$state', 'Navigation', ($scope, $translate, User, FuelSurchargeService, $state, Navigation) => {
        $scope.locations = [];
        $scope.totalLocations = 0;
        $scope.reverseSort = false;
        $scope.sortColumn = 'name';
        $scope.model = {
          fuelSurcharge: fuelSurcharge,
          customerId: customerId,
          loading: false,
          errorMessage: null,
          branchId: User.getUser().branchId,
        };
        $scope.icon = {
          'REGULAR': 'regular.png',
          'ATM': 'atm.png',
          'BANK': 'bank.png',
          'NO_SHIP_NO_GO': 'nsng.png',
          'INTERNAL': 'internal.png',
          'TRUCK': 'truck.png',
          'TANKER': 'tanker.png',
          'WINDOW': 'window.png',
          'ON_CALL': 'oncall.png',
          'CARRIER': 'carrier.png',
          'LOCKER': 'locker.png',
          'VAULT': 'vault.png',
          'DELIVERY': 'delivery.png'
        }

        $scope.loadImage = function (image) {
          let imgURL = this.icon[image]
          return require('../../../assets/images/' + imgURL);
        }

        $scope.filter = {
          // fuelSurchargeId: fuelSurcharge.id,
          customerId: $scope.model.customerId,
          sortingKey: $scope.sortColumn,
          sortingDir: $scope.reverseSort,
          limit: 10,
          page: 1
        }
        const init = () => {
          $scope.model.loading = true;
          $scope.loadLocations()
        }
        $scope.sortData = (column) => {
          $scope.reverseSort = ($scope.sortColumn == column) ? !$scope.reverseSort : false;
          $scope.sortColumn = column;

          $scope.loadLocations();
        }
        $scope.loadLocations = () => {
          $scope.model.isLoading = true;
          $scope.locations = [];
          FuelSurchargeService.fuelSurchargeLocations({
            'customerId': $scope.filter.customerId,
            'sortingKey': $scope.sortColumn,
            'sortingDir': $scope.reverseSort,
            'limit': $scope.filter.limit,
            'offset': ($scope.filter.page - 1) * $scope.filter.limit
          })
            .then(({ data, count }) => {
              $scope.totalLocations = count;
              $scope.locations = data;
              $scope.model.isLoading = false;
            })
            .catch((err) => {
              $scope.model.errorMessage = err.message;
              $scope.model.isLoading = false;
            })
        }

        $scope.cancel = () => {
          negative({
            modal: FuelSurchargeLocationModal
          })
        }

        $scope.gotoLocation = (locationId) => {
          Navigation.goToLocationTab(locationId, FuelSurchargeLocationModal);
        }

        $scope.ok = () => {
          $scope.model.isLoading = true;

          callback({
            modal: FuelSurchargeLocationModal
          });
        }
        init()
      }]
    })
    rejectModal(FuelSurchargeLocationModal, negative)
  }

  let routesInfoModal = (routeObj, supervisorScan, callback, negative) => {
    let routesInfo = $uibModal.open({
      template: routesInfoTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', 'UsersService', 'User', 'RouteDetailService', 'TruckService', '$q', 'DateUtil', function ($scope, UsersService, User, RouteDetailService, TruckService, $q, DateUtil) {

        $scope.model = {
          routeId: routeObj.routeId,
          routeDate: moment.utc(routeObj.routeDate).format('YYYY-MM-DD'),
          lastReleasedDate: '',
          truck: null,
          messenger: null,
          branchId: routeObj.branchId,
          routeData: '',
          allowSupervisorScan: supervisorScan,
          leaveTime: '',
          arriveTime: '',
          begMiles: '',
          endMiles: '',
          currentTime: moment().format("HH:mm:ss"),
          curCheckoutTime: '',
          curLeaveTime: '',
          curArriveTime: '',
          curBegMiles: '',
          curEndMiles: '',
          leaveDate: '',
          arriveDate: '',
          curLeaveDate: '',
          curArriveDate: '',
          currentDate: moment(),
          curComplTime: '',
          curComplDate: '',
          complTime: '',
          complDate: '',
          restrictToTruck: false,
          restrictTruck: null,
        };

        const userSearchObj = (searchKey, displayAppUserOnly = undefined) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: "branchId",
                  condition: "=",
                  data: $scope.model.branchId
                },
                {
                  group: {
                    rules: [
                      {
                        field: "id",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "firstName",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "lastName",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      }
                    ],
                    operator: "OR"
                  }
                }
              ],
              operator: 'AND',
            }
          }
          if (searchKey) {
            searchObj.orderBy = {
              order: [
                ['id', 'ASC']
              ]
            }
          }
          if (displayAppUserOnly) {
            searchObj.queryJSON.rules.push({
              field: "downloadToHHT",
              condition: "=",
              data: true
            })
          }
          return searchObj.queryJSON.rules.length ? searchObj : null;
        };

        const routeSearchObj = {
          queryJSON: {
            rules: [
              {
                field: "branchId",
                condition: "=",
                data: $scope.model.branchId
              },
              {
                field: "routeId",
                condition: "=",
                data: $scope.model.routeId
              },
              {
                field: "routeDate",
                condition: "=",
                data: $scope.model.routeDate
              },
            ],
            operator: 'AND',
          }
        };

        const init = () => {
          $scope.loading = true;
          $q.all([
            RouteDetailService.all(routeSearchObj, 0, 1000)
          ])
        .then((data) => {
              $scope.getTruckData('', 0);
              $scope.getMessangerData('', 0);
              $scope.routeDetailsData = data[0].results;

              $scope.routeDetailsData.forEach((routeData) => {
                $scope.model.routeData = routeData;
                $scope.model.restrictToTruck = routeData.route ? routeData.route.restrictToTruck : false;
                $scope.model.restrictTruck = routeData.route ? routeData.route.restrictTruck : null;

                const hasVehicle = routeData.vehicleId && routeData.vehicle;
                const hasRestrictTruck = $scope.model.restrictToTruck && $scope.model.restrictTruck && $scope.model.restrictTruck.id;

                if (hasVehicle && hasRestrictTruck && routeData.vehicleId.trim() === $scope.model.restrictTruck.id.trim()) {
                    // Both available and the same — map Key/Value as normal
                    routeData.vehicle.Key = routeData.vehicleId.trim() + " | " + routeData.vehicle.make;
                    routeData.vehicle.Value = routeData.vehicleId.trim();
                    $scope.model.truckMismatch = false;
                } else if (hasRestrictTruck && (!hasVehicle || routeData.vehicleId.trim() !== $scope.model.restrictTruck.id.trim())) {
                    // restrictToTruck is true but assigned truck differs (or missing) — override and warn user to save
                    routeData.vehicle = {
                        Key: $scope.model.restrictTruck.id.trim() + " | " + $scope.model.restrictTruck.make,
                        Value: $scope.model.restrictTruck.id.trim()
                    };
                    $scope.model.truckMismatch = true;
                } else if (hasVehicle) {
                    // Normal case — no restriction, just map vehicle
                    routeData.vehicle.Key = routeData.vehicleId.trim() + " | " + routeData.vehicle.make;
                    routeData.vehicle.Value = routeData.vehicleId.trim();
                    $scope.model.truckMismatch = false;
                }
                $scope.model.truck = routeData.vehicle;
                $scope.model.messenger = mapData(routeData.messenger);
                $scope.model.lastReleasedDate = routeData.updatedAt;
                $scope.model.curCheckoutTime = routeData.checkoutTime ? new Date(routeData.checkoutTime) : null;
                $scope.model.curLeaveTime = routeData.leaveTime ? new Date(routeData.leaveTime) : null;
                $scope.model.curArriveTime = routeData.arrTime ? new Date(routeData.arrTime) : null;
                $scope.model.curBegMiles = routeData.begMiles;
                $scope.model.curEndMiles = routeData.endMiles;
                $scope.model.leaveTime = $scope.model.curLeaveTime ? $scope.getTime(moment($scope.model.curLeaveTime).format('HH:mm:ss')) : null;
                $scope.model.arriveTime = $scope.model.curArriveTime ? $scope.getTime(moment($scope.model.curArriveTime).format('HH:mm:ss')) : null;
                $scope.model.begMiles = $scope.model.curBegMiles;
                $scope.model.endMiles = $scope.model.curEndMiles;
                $scope.model.leaveDate = $scope.model.curLeaveTime ? moment($scope.model.curLeaveTime) : null;
                $scope.model.arriveDate = $scope.model.curArriveTime ? moment($scope.model.curArriveTime) : null;
                $scope.model.checkOutDate = routeData.checkoutTime ? moment(routeData.checkoutTime).format('DD-MMM-YYYY') : null;
                $scope.model.checkOutTime = routeData.checkoutTime ? moment(routeData.checkoutTime).format('hh:mm A') : null;
                $scope.model.curComplTime = routeData.complTime ? new Date(routeData.complTime) : null;
                $scope.model.complTime = $scope.model.curComplTime ? $scope.getTime(moment($scope.model.curComplTime).format('HH:mm:ss')) : null;
                $scope.model.complDate = $scope.model.curComplTime ? moment($scope.model.curComplTime) : null;

                $scope.maxDate = {
                  maxDate: $scope.model.currentDate,
                  minDate: routeData.routeDate
                }
              })
            })
            .finally(() => {
              $scope.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        }

        const mapData = (item) => {
          if (item == null) return item;

          item.Key = item.id + " | " + item.firstName + ' ' + item.lastName;
          item.Value = item.id;
          return item;
        }

        const mappingUserData = (items, searchKey, model) => {
          let itemArray = [];
          items.map((item) => {
            item.Key = item.id + " | " + item.firstName + ' ' + item.lastName;
            item.Value = item.id;
            if (!searchKey) {
              if (model) {
                if (item.id !== model.Value) {
                  itemArray.push(item);
                }
              } else {
                itemArray.push(item);
              }
            } else {
              itemArray.push(item);
            }
          });
          return itemArray;
        }

        $scope.getMessangerData = (searchKey, offset) => {
          let searchObj = userSearchObj(searchKey, true);
          // if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
          //   offset = offset - 1;
          // }
          UsersService.all(searchObj, offset, 100)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.messangerTotalRecord = data.total;
                $scope.messangerData = mappingUserData(data.results, searchKey, $scope.model.messenger);
                if (!searchKey && $scope.model.messenger) {
                  $scope.messangerData.unshift($scope.model.messenger);
                }
              }
              else {
                const messanger = mappingUserData(data.results, searchKey, $scope.model.messenger);
                $scope.messangerData = $scope.messangerData.concat(messanger);
              }
            })
        }

        $scope.messengerSelected = () => {
          if ($scope.model.messenger == null) {
            $scope.model.driver = null;
          } else {
            if ($scope.model.messenger && $scope.model.driver) {
              if ($scope.model.messenger.id == $scope.model.driver.id) {
                $scope.model.driver = null;
              }
            }
          }
        }

        $scope.getTruckData = (searchKey, offset) => {
          searchKey = searchKey || '';


          if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
            offset = offset - 1;
          }

          TruckService.getAllTrucks(searchKey, $scope.model.branchId, $scope.model.routeId, $scope.model.routeDate, AppConstant.defaultPageLimit, offset)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.totalRecord = data.total;
                $scope.truckData = mappingTruckData(data.results, searchKey);
                if (!searchKey && $scope.model.truck) {
                  $scope.truckData.unshift($scope.model.truck);
                }
              }
              else {
                const truckData = mappingTruckData(data.results, searchKey);
                $scope.truckData = $scope.truckData.concat(truckData);
              }
            })
        }

        const mappingTruckData = (trucks, searchKey) => {
          let truckArray = [];
          trucks.map((truck) => {
            truck.Key = truck.id + " | " + truck.make;
            truck.Value = truck.id;
            if (!searchKey) {
              if ($scope.model.truck) {
                if (truck.id !== $scope.model.truck.Value) {
                  truckArray.push(truck);
                }
              } else {
                truckArray.push(truck);
              }
            } else {
              truckArray.push(truck);
            }
          });
          return truckArray;
        }

        $scope.getTime = (time) => {
          if (!time) {
            return time;
          }

          time = time.split(':');

          let d = new Date();

          d.setHours(+time[0]);
          d.setMinutes(time[1]);
          d.setSeconds(0);
          d.setMilliseconds(0);

          return d;
        }

        $scope.cancel = () => {
          negative({
            modal: routesInfo
          })
        }

        $scope.clearLeaveFields = () => {
          $scope.model.leaveDate = null;
          $scope.model.leaveTime = null;
          $scope.model.curLeaveTime = null;
          delete $scope.leaveDateError;
          delete $scope.leaveTimeError;
          delete $scope.arriveDateError;
          delete $scope.arriveTimeError;
          $scope.validateArriveDate();
          $scope.validateArriveTime();
        }

        $scope.clearArriveFields = () => {
          $scope.model.arriveDate = null;
          $scope.model.arriveTime = null;
          $scope.model.curArriveTime = null;
          delete $scope.arriveDateError;
          delete $scope.arriveTimeError;
          delete $scope.complDateError;
          delete $scope.complTimeError;
          $scope.validateComplDate();
          $scope.validateComplTime();
        }

        $scope.getLeaveTime = () => {
          if (!$scope.model.leaveTime) return;

          const lvTime = $scope.model.leaveTime ? moment($scope.model.leaveTime).format('HH:mm:ss') : null;
          const lvDate = $scope.model.leaveDate ? moment($scope.model.leaveDate).format('YYYY-MM-DD') : null;
          const dt = `${lvDate} ${lvTime}`;
          return dt;
        }

        $scope.getArriveTime = () => {
          if (!$scope.model.arriveTime) return;

          const arrTime = $scope.model.arriveTime ? moment($scope.model.arriveTime).format('HH:mm:ss') : null;
          const arrDate = $scope.model.arriveDate ? moment($scope.model.arriveDate).format('YYYY-MM-DD') : null;
          const arrDt = `${arrDate} ${arrTime}`;
          return arrDt;
        }

        $scope.validateLeaveTime = () => {
          let leaveDateTime = $scope.getLeaveTime();
          let arriveDateTime = $scope.getArriveTime();
          let leaveMoment = moment(leaveDateTime, 'YYYY-MM-DD HH:mm:ss').seconds(0).milliseconds(0);
          let checkoutMoment = moment($scope.model.curCheckoutTime).seconds(0).milliseconds(0);
          let leaveTime = leaveMoment.valueOf();
          let checkoutTime = checkoutMoment.valueOf();
          if (leaveTime < checkoutTime) {
            delete $scope.arriveTimeError;
            $scope.leaveTimeError = $translate.instant('routeControl.leave_time_error')
          } else if ($scope.model.arriveTime && leaveTime > moment(arriveDateTime, 'YYYY-MM-DD HH:mm:ss').valueOf()) {
            delete $scope.arriveTimeError;
            $scope.leaveTimeError = $translate.instant('routeControl.leave_time_greater_than_arrive_time_error')
          } else {
            delete $scope.leaveTimeError;
          }

          if ($scope.model.arriveDate) $scope.validateArriveDate();
        }

        $scope.validateArriveTime = () => {
          let leaveDateTime = $scope.getLeaveTime();
          let arriveDateTime = $scope.getArriveTime();
          let curArriveTime = moment(arriveDateTime).valueOf();
          let leaveTime = moment(leaveDateTime).valueOf();

          if ($scope.model.arriveTime && !$scope.model.leaveTime) {
            $scope.arriveTimeError = $translate.instant('routeControl.leave_time_error');
          } else if ($scope.model.arriveTime && curArriveTime < leaveTime) {
            delete $scope.leaveTimeError;
            $scope.arriveTimeError = $translate.instant('routeControl.arrive_time_error');
          }
          else delete $scope.arriveTimeError;
        }

        $scope.validateMileage = () => {
          let begMiles = $scope.model.begMiles;
          let endMiles = $scope.model.endMiles;

          if ((endMiles !== undefined && endMiles !== null) && endMiles < begMiles) $scope.mileageError = $translate.instant('routeControl.miles_error');
          else delete $scope.mileageError;
        }

        $scope.validateLeaveDate = () => {
          if (!$scope.model.leaveDate) return;

          let checkoutDate = moment($scope.model.curCheckoutTime).format('YYYY-MM-DD');
          let leaveDate = moment($scope.model.leaveDate).format('YYYY-MM-DD');

          if (leaveDate < checkoutDate) $scope.leaveDateError = $translate.instant('routeControl.leave_date_error');
          else delete $scope.leaveDateError;
          $scope.validateLeaveTime();
        }

        $scope.validateArriveDate = () => {
          if (!$scope.model.arriveDate) return;

          let curArriveDate = moment($scope.model.arriveDate).format('YYYY-MM-DD');
          let leaveDate = moment($scope.model.leaveDate).format('YYYY-MM-DD');

          if (!$scope.model.leaveDate) {
            $scope.arriveDateError = $translate.instant('routeControl.leave_date_error');
          } else if (curArriveDate < leaveDate) {
            $scope.arriveDateError = $translate.instant('routeControl.arrive_date_error');
          } else {
            delete $scope.arriveDateError;
          }
          $scope.validateArriveTime();
        }

        $scope.getComplTime = () => {
          if (!$scope.model.complTime) return;

          const complTime = $scope.model.complTime ? moment($scope.model.complTime).format('HH:mm:ss') : null;
          const complDate = $scope.model.complDate ? moment($scope.model.complDate).format('YYYY-MM-DD') : null;
          const dt = `${complDate} ${complTime}`;
          return dt;
        }

        $scope.validateComplTime = () => {
          let arriveDateTime = $scope.getArriveTime();
          let curArriveTime = moment(arriveDateTime).valueOf();
          let complDateTime = $scope.getComplTime();
          let curComplTime = moment(complDateTime).valueOf();

          if ($scope.model.complTime && curComplTime < curArriveTime) {
            delete $scope.leaveTimeError;
            delete $scope.arriveTimeError;
            delete $scope.complDateError;
            $scope.complTimeError = $translate.instant('routeControl.compl_time_error');
          }
          else delete $scope.complTimeError;
        }

        $scope.validateComplDate = () => {
          if (!$scope.model.complDate) return;

          let curComplDate = moment($scope.model.complDate).format('YYYY-MM-DD');
          let arriveDate = moment($scope.model.arriveDate).format('YYYY-MM-DD');

          if (!$scope.model.curArriveTime && !$scope.model.arriveTime) return;
          else if (curComplDate < arriveDate) $scope.complDateError = $translate.instant('routeControl.compl_date_error');
          else delete $scope.complDateError;
          $scope.validateComplTime();
        }

        $scope.isError = () => {
          return $scope.leaveTimeError || $scope.arriveTimeError || $scope.mileageError || $scope.leaveDateError || $scope.arriveDateError ||
            $scope.complDateError || $scope.complTimeError;
        }

        $scope.validateRouteDetailForm = () => {
          return (($scope.model.leaveDate && !$scope.model.leaveTime) || ($scope.model.arriveDate && !$scope.model.arriveTime) ||
            ($scope.model.arriveDate && $scope.model.arriveTime && !$scope.model.endMiles) ||
            ($scope.model.leaveDate && $scope.model.leaveTime && !$scope.model.truck))
        }

        $scope.ok = (err) => {
          const leaveDate = $scope.model.leaveDate && $scope.model.leaveTime ? moment($scope.model.leaveDate).format('YYYY-MM-DD') : null;
          let leaveTime = $scope.model.leaveDate && $scope.model.leaveTime ? moment($scope.model.leaveTime).format('HH:mm:ss') : null;
          const arriveDate = $scope.model.arriveDate && $scope.model.arriveTime ? moment($scope.model.arriveDate).format('YYYY-MM-DD') : null;
          let arriveTime = $scope.model.arriveDate && $scope.model.arriveTime ? moment($scope.model.arriveTime).format('HH:mm:ss') : null;
          const complDate = $scope.model.complDate && $scope.model.complTime ? moment($scope.model.complDate).format('YYYY-MM-DD') : null;
          const complTime = $scope.model.arriveDate && $scope.model.complTime ? moment($scope.model.complTime).format('HH:mm:ss') : null;

          if (leaveDate && leaveTime && $scope.model.curCheckoutTime) {
            const leaveMoment = moment(`${leaveDate} ${leaveTime}`, 'YYYY-MM-DD HH:mm:ss')
            const checkoutMoment = moment($scope.model.curCheckoutTime)
            if ( leaveMoment.isValid() && checkoutMoment.isValid() && leaveMoment.format('YYYY-MM-DD HH:mm') === checkoutMoment.format('YYYY-MM-DD HH:mm')) {
              leaveMoment.seconds(checkoutMoment.seconds())
              leaveTime = leaveMoment.format('HH:mm:ss')
            }
          }

          if (arriveDate && arriveTime && leaveDate && leaveTime) {
            const arriveMoment = moment(`${arriveDate} ${arriveTime}`, 'YYYY-MM-DD HH:mm:ss')
            const leaveMoment = moment(`${leaveDate} ${leaveTime}`, 'YYYY-MM-DD HH:mm:ss')
            if ( arriveMoment.isValid() && leaveMoment.isValid() && arriveMoment.format('YYYY-MM-DD HH:mm') === leaveMoment.format('YYYY-MM-DD HH:mm') && arriveMoment.seconds() === 0) {
              arriveMoment.seconds(leaveMoment.seconds())
              arriveTime = arriveMoment.format('HH:mm:ss')
            }
          }

          const leaveDateTime = leaveDate ? `${leaveDate} ${leaveTime}` : null;
          const arriveDateTime = arriveDate ? `${arriveDate} ${arriveTime}` : null;
          const complDateTime = complDate ? `${complDate} ${complTime}` : null;
          $scope.model.allowSupervisorScan = supervisorScan || ($scope.model.curComplTime && ($scope.model.begMiles !== $scope.model.curBegMiles || $scope.model.endMiles !== $scope.model.curEndMiles));

          $scope.isLoading = true;
          verifySupervisorScan('route-details', null, $scope)
            .then((supervisorInfo) => {
              $scope.loading = true;
              callback({
                truck: $scope.model.truck ? $scope.model.truck.Value : $scope.model.truck,
                messenger: $scope.model.messenger ? $scope.model.messenger.Value : $scope.model.messenger,
                leaveTime: leaveDateTime,
                arriveTime: arriveDateTime,
                complTime: complDateTime,
                begMiles: $scope.model.begMiles,
                endMiles: $scope.model.endMiles,
                supervisorId: supervisorInfo ? supervisorInfo.supId : null,
                modal: routesInfo
              });

              $scope.isLoading = false;
              if (supervisorInfo) supervisorInfo.modal.close();
            })
        }
        init()
      }]
    })

    routesInfo.result.then(() => {
    }, function () {
      negative({
        modal: routesInfo
      });
    })
  }

  let editDeliveryShipment = (data, branchTimezone, callback, negative) => {
    let editDeliveryShipmentModal = $uibModal.open({
      template: editDeliveryShipmentTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', 'RouteService', 'ShiptypeService','DateUtil', 'LocationService', 'DenominationService', function ($scope, $q, RouteService, ShiptypeService ,DateUtil, LocationService, DenominationService) {

        $scope.model = {
          shipment: data,
          loading: false,
          routeListObj: {
            routeList: [],
            totalRecords: 0
          },
          locationListObj: {
            locationList: [],
            totalRecords: 0,
            loadLocations: true
          },
          shipTypeListObj: {
            shipTypeList: [],
            totalRecords: 0,
            loadShipTypes: true
          },
          denomObj: {
            denomList: [],
            totalRecords: 0,
            loadDenoms: true
          },
          shipmentUpdateObj: {
            oldTrackingId: data.trackingId,
            newTrackingId: data.trackingId,
            vaultDate: DateUtil.convertToDate(data.vaultDate),
            selectedRoute: null,
            fromLocationId: null,
            toLocationId: null,
            deliveryDate: null,
            deliveryTime: null,
            amount: data.amount,
            loadedAmount: data.loadedAmount,
            qty: data.qty ? data.qty : 1,
            comments: null,
            undoDelivery: false,
            shiptypeId: null
          },
          amountExceeds: false,
          deliveryDateTimeRequired: false,
          branchTimezone: branchTimezone
        };

        const init = () => {
          $scope.model.loading = true;
          $q.all([
            $scope.getRouteList('', 0),
            $scope.getShipTypeList('', 0),
            $scope.getLocationList('',0),
            $scope.getDenominationList()
          ])
            .then(() => {
              var shipmentDetail = $scope.model.shipment;
              var deliveryDate = shipmentDetail.deliveryDate;

              $scope.model.minVaultDate = {
                minDate: shipmentDetail.vaultDate
              };

              $scope.model.minDeliveryDate = {
                minDate: deliveryDate
              };

              $scope.model.shipmentUpdateObj.selectedRoute = {
                Key: shipmentDetail.routeName,
                Value: shipmentDetail.routeId
              };

              $scope.model.shipmentUpdateObj.fromLocationId = {
                Key: shipmentDetail.fromLocationId + ' | '+ shipmentDetail.fromLocationName,
                Value: shipmentDetail.fromLocationId,
              };

              $scope.model.shipmentUpdateObj.toLocationId = {
                Key: shipmentDetail.toLocationId + ' | '+ shipmentDetail.toLocationName,
                Value: shipmentDetail.toLocationId,
              };

              $scope.model.shipmentUpdateObj.selectedShipType = {
                Key: shipmentDetail.shiptypeId + ' | '+ shipmentDetail.shipTypeDescription,
                Value: shipmentDetail.shiptypeId,
                faceValue: shipmentDetail.orderNo ? shipmentDetail.DenomFaceValue : shipmentDetail.shipTypeFaceValue
              };

              if (deliveryDate) {
                const time = moment(deliveryDate).tz($scope.model.branchTimezone).format('HH:mm:ss');
                const validatationTime = moment.utc(deliveryDate).format('HH:mm:ss')
                if (validatationTime === '00:00:00') {
                  $scope.model.shipmentUpdateObj.deliveryTime = null;
                  $scope.model.shipmentUpdateObj.deliveryDate = moment(deliveryDate, 'YYYY-MM-DD').toDate();
                } else {
                  $scope.model.shipmentUpdateObj.deliveryTime = DateUtil.getTime(time);
                  const dateString = moment(deliveryDate).tz($scope.model.branchTimezone).format('YYYY-MM-DD');
                  $scope.model.shipmentUpdateObj.deliveryDate = moment(dateString, 'YYYY-MM-DD').toDate();
                }
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                Modal.errorModal(err.data.message);
              }
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.getDenominationList = () =>{
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'currencyId',
                  condition: '=',
                  data: 'USD'
                }
              ],
              operator: 'AND'
            }
          }

          DenominationService.all(searchObj, 0, 1000)
          .then((res) => {
            $scope.model.denomObj.denomList = res.results
            $scope.model.denomObj.totalRecords = res.total;
          }).catch((err) => {
            console.log(err);
          })


        }

        $scope.getRouteList = (searchKey, offset) => {
          searchKey = searchKey || '';

          const routeSearchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'branchId',
                  condition: '=',
                  data: $scope.model.shipment.branchId
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND'
            }
          };

          return RouteService.all(routeSearchObj, offset, 100)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.routeListObj.totalRecords = data.total;
                $scope.model.routeListObj.routeList = $scope.mapData(data.results);
              } else {
                const routes = $scope.mapData(data.results);
                $scope.model.routeListObj.routeList = $scope.model.routeListObj.routeList.concat(routes);
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                Modal.errorModal(err.data.message);
              }
            })
        }

        $scope.mapData = (routes) => {
          return routes.map((route) => {
            return {
              Key: route.name,
              Value: route.id
            }
          });
        }

        $scope.getShipTypeList = (searchKey, offset) => {
          searchKey = searchKey || '';

          const shipTypeSearchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'status',
                        condition: '=',
                        data: true
                    },
                    {
                        field: 'coinFlag',  // Add coinFlag condition
                        condition: '=',
                        data: true
                    },
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'description',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            }
        };

          // $scope.model.shipTypeListObj.loadShipTypes = true;
          return ShiptypeService.all(shipTypeSearchObj, offset, 100)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.shipTypeListObj.totalRecords = data.total;
                $scope.model.shipTypeListObj.shipTypeList = $scope.shipTypeDataMapping(data.results);
              } else {
                const shipTypes = $scope.shipTypeDataMapping(data.results);
                $scope.model.shipTypeListObj.shipTypeList = $scope.model.shipTypeListObj.shipTypeList.concat(shipTypes);
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                Modal.errorModal(err.data.message);
              }
            })
          // .finally(() => {
          //   $scope.model.shipTypeListObj.loadShipTypes = false;
          // })
        }

        $scope.shipTypeDataMapping = (shipTypes) => {
          return shipTypes.map((shipType) => {
            return {
              Key: shipType.id + ' | ' + shipType.description,
              Value: shipType.id,
              faceValue : shipType.amountFlag ? shipType.amount : shipType.unitValue
            }
          });
        }

        $scope.getLocationList = (searchKey, offset) => {
          searchKey = searchKey || '';

          const locationSearchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'active',
                  condition: '=',
                  data: true
                },
                {
                  field: 'branchId',
                  condition: '=',
                  data: $scope.model.shipment.branchId
                },
                {
                  field: 'locationType',
                  condition: 'IN',
                  data: ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'INTERNAL', 'CARRIER', 'ON_CALL', 'LOCKER', 'VAULT', 'DELIVERY']
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND'
            }
          };

          $scope.model.locationListObj.loading = true;
          return LocationService.all(locationSearchObj, offset, AppConstant.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.locationListObj.totalRecords = data.total;
                  $scope.model.locationListObj.locationList = $scope.locationMapping(data.results);
                } else {
                    const location = $scope.locationMapping(data.results);
                    $scope.model.locationListObj.locationList = $scope.model.locationListObj.locationList.concat(location);
                }
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                $scope.model.locationListObj.loading = false;
            })
        }

        $scope.locationMapping = (location) => {
          return location.map((loc) => {
            return {
              Key: loc.id + ' | ' + loc.name,
              Value: loc.id
            }
          });
        }

        $scope.$watch('model.shipmentUpdateObj.selectedShipType', function (newValue, oldValue) {
          if (newValue !== oldValue) {
              $scope.validateLoadedAmount();
          }
      });

        $scope.validateLoadedAmount = () => {
          let loadShipmentAmount = null
          if($scope.model.shipment.coinFlag && $scope.model.shipment.shiptypeId !== 'C' && !$scope.model.shipment.orderNo && $scope.model.shipmentUpdateObj.selectedShipType){
            loadShipmentAmount = $scope.model.shipmentUpdateObj.qty * $scope.model.shipmentUpdateObj.selectedShipType.faceValue;
            $scope.model.shipmentUpdateObj.amount = loadShipmentAmount;
          } else if ($scope.model.shipment.coinFlag && $scope.model.shipment.shiptypeId !== 'C' && $scope.model.shipment.orderNo && $scope.model.shipmentUpdateObj.selectedShipType) {
            const matchingDenom = $scope.model.denomObj.denomList.find(denom => denom.id === $scope.model.shipmentUpdateObj.selectedShipType.Value);
            if (matchingDenom) {
              loadShipmentAmount = $scope.model.shipmentUpdateObj.qty * matchingDenom.faceValue;
              $scope.model.shipmentUpdateObj.amount = loadShipmentAmount;
            }
          }
          else {
            loadShipmentAmount = $scope.model.shipmentUpdateObj.amount;
          }
          let loadedAmount = $scope.model.shipmentUpdateObj.loadedAmount;
          if (loadedAmount > loadShipmentAmount) return $scope.model.amountExceeds = true;
          else $scope.model.amountExceeds = false;
        }

        $scope.validateEditDeliveryForm = () => {
          const shipmentObj = $scope.model.shipmentUpdateObj;
          return (!shipmentObj.newTrackingId || !shipmentObj.vaultDate || !shipmentObj.selectedRoute
            || shipmentObj.amount === null || !shipmentObj.comments || !shipmentObj.fromLocationId || !shipmentObj.toLocationId || !shipmentObj.qty || !shipmentObj.selectedShipType)
        }

        $scope.removeDeliveryDate = () => {
          setTimeout(() => {
            if ($scope.model.shipmentUpdateObj.undoDelivery) {
              $scope.model.shipmentUpdateObj.deliveryDate = null;
              $scope.model.shipmentUpdateObj.deliveryTime = null;
              $scope.model.shipmentUpdateObj.loadedAmount = null;
            }
            else if ($scope.model.shipment.deliveryDate && !$scope.model.shipmentUpdateObj.undoDelivery) {
              const time = moment($scope.model.shipment.deliveryDate).format('HH:mm:ss');
              $scope.model.shipmentUpdateObj.deliveryDate = $scope.model.shipment.deliveryDate;
              $scope.model.shipmentUpdateObj.deliveryTime = DateUtil.getTime(time);
              $scope.model.shipmentUpdateObj.loadedAmount = $scope.model.shipment.loadedAmount;
            }
            $scope.$apply();
          }, 100)
        }

        $scope.restrictShipmentUpdate = (shipmentVaultDate, branchCurrentVaultDate) => {
          return moment(shipmentVaultDate).isBefore(branchCurrentVaultDate);
        }

        $scope.validateDeliveryDateTime = () => {
          if ($scope.model.deliveryDateTimeRequired === true) {
            $scope.model.deliveryDateTimeRequired = $scope.model.shipment.status === 'shipment.hold' &&
            (!$scope.model.shipmentUpdateObj.deliveryDate || !$scope.model.shipmentUpdateObj.deliveryTime)
          }
        }

        $scope.ok = (updateState) => {
          let shipmentObj = $scope.model.shipment;
          let shipmentUpdateObj = _.cloneDeep($scope.model.shipmentUpdateObj);
          if(updateState === 'mark_delivered' && (!$scope.model.shipmentUpdateObj.deliveryDate || !$scope.model.shipmentUpdateObj.deliveryTime)){
            $scope.model.deliveryDateTimeRequired = true;
            return
          } else {
            $scope.model.deliveryDateTimeRequired = false;
          }
          confirmSupervisor('update-delivery-shipment', { trackingId: $scope.model.trackingId }, ({ modal, supId }) => {
            shipmentUpdateObj.updatedDeliveryDate = shipmentUpdateObj.deliveryDate ? moment(shipmentUpdateObj.deliveryDate).format('YYYY-MM-DD') : null;
            shipmentUpdateObj.updatedDeliveryTime = shipmentUpdateObj.deliveryTime ? moment(shipmentUpdateObj.deliveryTime).format('HH:mm:ss') : null;
            shipmentUpdateObj.updatedVaultDate = moment(shipmentUpdateObj.vaultDate).format('YYYY-MM-DD');
            shipmentUpdateObj.previousDeliveryDate = shipmentObj.deliveryDate;
            shipmentUpdateObj.previousVaultDate = moment.utc(shipmentObj.vaultDate).format('YYYY-MM-DD');
            shipmentUpdateObj.previousRouteId = shipmentObj.routeId;
            shipmentUpdateObj.previousShipmentAmount = shipmentObj.amount;
            shipmentUpdateObj.updatedShipmentAmount = shipmentUpdateObj.amount;
            shipmentUpdateObj.previousLoadedAmount = shipmentObj.loadedAmount;
            shipmentUpdateObj.updatedLoadedAmount = !(shipmentUpdateObj.loadedAmount === '' || shipmentUpdateObj.loadedAmount === undefined) ? shipmentUpdateObj.loadedAmount : null;
            shipmentUpdateObj.branchTimezone = $scope.model.branchTimezone;
            shipmentUpdateObj.branchId = shipmentObj.branchId;
            shipmentUpdateObj.updateRouteId = shipmentUpdateObj.selectedRoute ? shipmentUpdateObj.selectedRoute.Value : null;
            shipmentUpdateObj.supervisorUserId = supId;
            shipmentUpdateObj.fromLocationId = shipmentUpdateObj.fromLocationId ? shipmentUpdateObj.fromLocationId.Value : null;
            shipmentUpdateObj.toLocationId = shipmentUpdateObj.toLocationId ? shipmentUpdateObj.toLocationId.Value : null;
            shipmentUpdateObj.status = shipmentObj.status;
            shipmentUpdateObj.shiptypeId = shipmentUpdateObj.selectedShipType ? shipmentUpdateObj.selectedShipType.Value : null;
            shipmentUpdateObj.browserTimezone = moment.tz.guess();
            shipmentUpdateObj.qty = Number(shipmentObj.coinFlag 
              ? (shipmentUpdateObj.qty ? shipmentUpdateObj.qty : 1)
              : (shipmentObj.qty ? shipmentObj.qty : 1));

            callback({
              modal: editDeliveryShipmentModal,
              shipments: shipmentUpdateObj,
              updateState,
              $scope
            });

            modal.close();

          }, ({ modal }) => {
            modal.close()
          })
        }

        $scope.cancel = () => {
          negative({
            modal: editDeliveryShipmentModal,
            $scope
          })
        }

        init()
      }]
    })
    rejectModal(editDeliveryShipmentModal, negative)
  }

  let sendStopReceipt = (locationEmail, callback, negative) => {
    let printStopReceiptModal = $uibModal.open({
      template: sendStopReceiptTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', function ($scope) {
        $scope.model = {
          providedEmail: locationEmail,
          loading: false
        }

        const init = () => {
          focusElementById('email');
        }

        $scope.ok = () => {
          $scope.model.loading = true;
          callback({
            modal: printStopReceiptModal,
            providedEmail: $scope.model.providedEmail,
            $scope
          })
        }

        $scope.cancel = () => {
          negative({
            modal: printStopReceiptModal,
            $scope
          })
        }
        init()
      }]
    })
    rejectModal(printStopReceiptModal, negative)
  }

  let editPickupShipment = (data, branchTimezone, callback, negative) => {
    let editPickupShipmentModal = $uibModal.open({
      template: editPickupShipmentTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', 'RouteService', 'DateUtil', 'ShiptypeService', 'LocationService', function ($scope, $q, RouteService, DateUtil, ShiptypeService, LocationService) {

        $scope.model = {
          shipment: data,
          loading: false,
          routeListObj: {
            routeList: [],
            totalRecords: 0,
            loadRoutes: true
          },
          shipTypeListObj: {
            shipTypeList: [],
            totalRecords: 0,
            loadShipTypes: true
          },
          locationListObj: {
            locationList: [],
            totalRecords: 0,
            loadLocations: true
          },
          shipmentUpdateObj: {
            oldTrackingId: data.trackingId,
            newTrackingId: data.trackingId,
            vaultDate: DateUtil.convertToDate(data.vaultDate),
            selectedRoute: null,
            selectedShipType: null,
            fromLocationId: null,
            toLocationId: null,
            pickupDate: null,
            pickupTime: null,
            amount: data.amount,
            comments: null,
          },
          amountExceeds: false,
          branchTimezone: branchTimezone
        };

        const init = () => {
          $q.all([
            $scope.getRouteList('', 0),
            $scope.getShipTypeList('', 0),
            $scope.getLocationList('',0)
          ])
            .then(() => {
              var shipmentDetail = $scope.model.shipment;
              var pickupDate = shipmentDetail.pickupDate;

              $scope.model.routeListObj.loadRoutes = false;
              $scope.model.shipTypeListObj.loadShipTypes = false;
              $scope.model.locationListObj.loadLocations = false;

              $scope.model.minVaultDate = {
                minDate: shipmentDetail.vaultDate
              };

              $scope.model.minPickupDate = {
                minDate: pickupDate
              };

              $scope.model.shipmentUpdateObj.selectedRoute = {
                Key: shipmentDetail.routeName,
                Value: shipmentDetail.routeId
              }

              $scope.model.shipmentUpdateObj.selectedShipType = {
                Key: shipmentDetail.description,
                Value: shipmentDetail.shiptypeId
              }

              $scope.model.shipmentUpdateObj.fromLocationId = {
                Key: shipmentDetail.fromLocationId + ' | '+ shipmentDetail.fromLocationName,
                Value: shipmentDetail.fromLocationId,
              };

              $scope.model.shipmentUpdateObj.toLocationId = {
                Key: shipmentDetail.toLocationId + ' | '+ shipmentDetail.toLocationName,
                Value: shipmentDetail.toLocationId,
              };

              // if (pickupDate) {
              //   const time = moment(pickupDate).format('HH:mm:ss');
              //   $scope.model.shipmentUpdateObj.pickupDate = pickupDate;
              //   $scope.model.shipmentUpdateObj.pickupTime = DateUtil.getTime(time);
              // }
              if (pickupDate) {
                const time = moment(pickupDate).tz($scope.model.branchTimezone).format('HH:mm:ss');
                const validatationTime = moment.utc(pickupDate).format('HH:mm:ss')
                if(validatationTime === '00:00:00') {
                  $scope.model.shipmentUpdateObj.pickupTime = null;
                  $scope.model.shipmentUpdateObj.pickupDate = moment(pickupDate, 'YYYY-MM-DD').toDate();
                } else {
                  $scope.model.shipmentUpdateObj.pickupTime = DateUtil.getTime(time);
                  const dateString = moment(pickupDate).tz($scope.model.branchTimezone).format('YYYY-MM-DD');
                  $scope.model.shipmentUpdateObj.pickupDate = moment(dateString, 'YYYY-MM-DD').toDate();
                }
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                Modal.errorModal(err.data.message);
              }
            })
        }

        $scope.getRouteList = (searchKey, offset) => {
          searchKey = searchKey || '';

          const routeSearchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'branchId',
                  condition: '=',
                  data: $scope.model.shipment.branchId
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND'
            }
          };

          // $scope.model.routeListObj.loadRoutes = true;
          return RouteService.all(routeSearchObj, offset, 100)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.routeListObj.totalRecords = data.total;
                $scope.model.routeListObj.routeList = $scope.routeDataMapping(data.results);
                // if (!searchKey && $scope.model.shipmentUpdateObj.selectedRoute) {
                //   $scope.model.routeListObj.routeList.unshift($scope.model.shipmentUpdateObj.selectedRoute);
                // }
              } else {
                const routes = $scope.routeDataMapping(data.results);
                $scope.model.routeListObj.routeList = $scope.model.routeListObj.routeList.concat(routes);
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                Modal.errorModal(err.data.message);
              }
            })
          // .finally(() => {
          //   $scope.model.routeListObj.loadRoutes = false;
          // })
        }

        $scope.routeDataMapping = (routes) => {
          return routes.map((route) => {
            return {
              Key: route.name,
              Value: route.id
            }
          });
        }

        $scope.getShipTypeList = (searchKey, offset) => {
          searchKey = searchKey || '';

          const shipTypeSearchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'status',
                  condition: '=',
                  data: true
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'description',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND'
            }
          };

          // $scope.model.shipTypeListObj.loadShipTypes = true;
          return ShiptypeService.all(shipTypeSearchObj, offset, 100)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.shipTypeListObj.totalRecords = data.total;
                $scope.model.shipTypeListObj.shipTypeList = $scope.shipTypeDataMapping(data.results);
              } else {
                const shipTypes = $scope.shipTypeDataMapping(data.results);
                $scope.model.shipTypeListObj.shipTypeList = $scope.model.shipTypeListObj.shipTypeList.concat(shipTypes);
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.message) {
                Modal.errorModal(err.data.message);
              }
            })
          // .finally(() => {
          //   $scope.model.shipTypeListObj.loadShipTypes = false;
          // })
        }

        $scope.shipTypeDataMapping = (shipTypes) => {
          return shipTypes.map((shipType) => {
            return {
              Key: shipType.description,
              Value: shipType.id
            }
          });
        }

        $scope.getLocationList = (searchKey, offset) => {
          searchKey = searchKey || '';

          const locationSearchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'active',
                  condition: '=',
                  data: true
                },
                {
                  field: 'branchId',
                  condition: '=',
                  data: $scope.model.shipment.branchId
                },
                {
                  field: 'locationType',
                  condition: 'IN',
                  data: ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'INTERNAL', 'CARRIER', 'ON_CALL', 'LOCKER', 'VAULT', 'DELIVERY']
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND'
            }
          };

          $scope.model.locationListObj.loading = true;
          return LocationService.all(locationSearchObj, offset, AppConstant.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.locationListObj.totalRecords = data.total;
                  $scope.model.locationListObj.locationList = $scope.locationMapping(data.results);
                } else {
                    const location = $scope.locationMapping(data.results);
                  $scope.model.locationListObj.locationList = $scope.model.locationListObj.locationList.concat(location);
                }
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                $scope.model.locationListObj.loading = false;
            })
        }

        $scope.locationMapping = (location) => {
          return location.map((loc) => {
            return {
              Key:  loc.id + ' | ' + loc.name,
              Value: loc.id
            }
          });
        }

        $scope.validateEditPickupForm = () => {
          const shipmentObj = $scope.model.shipmentUpdateObj;
          return (!shipmentObj.newTrackingId || !shipmentObj.vaultDate || !shipmentObj.selectedRoute || !shipmentObj.pickupDate || !shipmentObj.pickupTime
            || shipmentObj.amount === null || !shipmentObj.comments || !shipmentObj.selectedShipType || !shipmentObj.fromLocationId || !shipmentObj.toLocationId)
        }

        $scope.ok = () => {
          let shipmentObj = $scope.model.shipment;
          let shipmentUpdateObj = _.cloneDeep($scope.model.shipmentUpdateObj);

          confirmSupervisor('update-pickup-shipment', { trackingId: $scope.model.trackingId }, ({ modal, supId }) => {
            shipmentUpdateObj.updatedPickupDate = moment(shipmentUpdateObj.pickupDate).format('YYYY-MM-DD');
            shipmentUpdateObj.updatedPickupTime = moment(shipmentUpdateObj.pickupTime).format('HH:mm:ss');
            shipmentUpdateObj.updatedVaultDate = moment(shipmentUpdateObj.vaultDate).format('YYYY-MM-DD');
            shipmentUpdateObj.previousPickupDate = shipmentObj.pickupDate;
            shipmentUpdateObj.previousVaultDate = moment.utc(shipmentObj.vaultDate).format('YYYY-MM-DD');
            shipmentUpdateObj.previousRouteId = shipmentObj.routeId;
            shipmentUpdateObj.previousShipmentAmount = shipmentObj.amount;
            shipmentUpdateObj.previousShipTypeId = shipmentObj.shiptypeId;
            shipmentUpdateObj.updatedShipmentAmount = shipmentUpdateObj.amount;
            shipmentUpdateObj.previousLoadedAmount = shipmentObj.loadedAmount;
            shipmentUpdateObj.updatedLoadedAmount = !(shipmentUpdateObj.loadedAmount === '' || shipmentUpdateObj.loadedAmount === undefined) ? shipmentUpdateObj.loadedAmount : null;
            shipmentUpdateObj.branchTimezone = $scope.model.branchTimezone;
            shipmentUpdateObj.browserTimezone = moment.tz.guess();
            shipmentUpdateObj.branchId = shipmentObj.branchId;
            shipmentUpdateObj.updateRouteId = shipmentUpdateObj.selectedRoute ? shipmentUpdateObj.selectedRoute.Value : null;
            shipmentUpdateObj.supervisorUserId = supId;
            shipmentUpdateObj.updatedShipTypeId = shipmentUpdateObj.selectedShipType ? shipmentUpdateObj.selectedShipType.Value : null;
            shipmentUpdateObj.fromLocationId = shipmentUpdateObj.fromLocationId ? shipmentUpdateObj.fromLocationId.Value : null;
            shipmentUpdateObj.toLocationId = shipmentUpdateObj.toLocationId ? shipmentUpdateObj.toLocationId.Value : null;  

            callback({
              modal: editPickupShipmentModal,
              shipments: shipmentUpdateObj,
              $scope
            });

            modal.close();

          }, ({ modal }) => {
            modal.close()
          })
        }

        $scope.cancel = () => {
          negative({
            modal: editPickupShipmentModal,
            $scope
          })
        }

        init()
      }]
    })
    rejectModal(editPickupShipmentModal, negative)
  }

  let shipmentAssociateToTanker = (shipmentAssociateToTankerList, scannedTankerId, callback, negative) => {
    let shipmentAssociateToTankerModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: shipmentAssociateToTankerTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', ($scope, $translate) => {

        $scope.model = {
          shipmentAssociateToTankerList: shipmentAssociateToTankerList,
          tankerId: scannedTankerId,
          loading: false,
        };

        const init = () => { };

        $scope.cancel = () => {
          shipmentAssociateToTankerModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: shipmentAssociateToTankerModal,
            $scope
          });
        }

        init()
      }]
    })
  }

  let uploadFiles = (callback, negative) => {
    let uploadFilesModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: uploadFilesTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'ShipmentService', ($scope, $translate, ShipmentService) => {

        $scope.model = {
          loading: false,
          selectedFiles: []
        };

        const init = () => { };

        $scope.cancel = () => {
          uploadFilesModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: uploadFilesModal,
            data: $scope.model.selectedFiles.filter((d) => delete d._file)
          });
          uploadFilesModal.close()
        }

        $scope.removeSelectedFiles = (index) => {
          $scope.model.selectedFiles.splice(index, 1);
        }


        $scope.downloadFile = () => {
          $scope.model.isDownloading = true;
          return ShipmentService.getBatchTemplateFile()
            .then((data) => {
              const a = document.createElement("a");
              document.body.appendChild(a);
              const file = new Blob([data.results], { type: 'text/csv' });
              const fileURL = window.URL.createObjectURL(file);
              a.href = fileURL;
              a.download = data.fileName;
              a.click();
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.isDownloading = false;
            })
        };

        init()
      }]
    })
    rejectModal(uploadFilesModal, negative)
  }

  let uploadContractDocuments = (stat, selectedFiles, callback, negative) => {
    let uploadDocumentModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      keyboard: false,
      template: uploadContractDocumentTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'CustomerService', 'CommonLayoutService', 'Modal',
        ($scope, $translate, CustomerService, CommonLayoutService, Modal) => {

          $scope.model = {
            loading: false,
            selectedFiles,
            stat: stat,
          };

          const init = () => {
            return $scope.model.stat === 'create' ? 'Save' : 'Upload';
          };

          $scope.cancel = () => {
            $scope.model.selectedFiles = [];
            negative({
              modal: uploadDocumentModal,
              data: $scope.model.selectedFiles
            })
          }

          $scope.ok = () => {
            $scope.model.loading = true;
            callback({
              modal: uploadDocumentModal,
              data: $scope.model.selectedFiles,
              $scope
            });
          }

          $scope.removeSelectedFiles = (index) => {
            $scope.model.selectedFiles.splice(index, 1);
          }

          $scope.formatFileSize = (bytes, decimalPoint) => {
            return CommonLayoutService.formatFileSize(bytes);
          }

          init()
        }]
    })
    rejectModal(uploadDocumentModal, negative)
  }

  let viewContractDocuments = (customerId, callback, negative) => {
    let customerDocumentModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      keyboard: false,
      template: viewContractDocumentTemplate,
      size: 'md',

      controller: ['$scope', '$translate', 'CustomerService', 'CommonLayoutService', 'Modal', 'User',
                  ($scope, $translate, CustomerService, CommonLayoutService, Modal, User) => {

        $scope.model = {
          loading: false,
          selectedFile: '',
          uploadedFiles: [],
          customerId,
          isDeleting: false,
          isDownloading: false,
          isPrint: false,
          branchId: User.getUser().branchId
        };


        const init = () => {
          $scope.model.loading = true;
          CustomerService.getUploadedDocument($scope.model.customerId)
            .then((res) => {
              $scope.model.uploadedFiles = res.files;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        };

        $scope.cancel = () => {
          negative({
            modal: customerDocumentModal,
            data: $scope.model.uploadedFiles
          });
        }

        $scope.ok = () => {
          callback({
            modal: customerDocumentModal,
            data: $scope.model.uploadedFiles
          });
          customerDocumentModal.close()
        }

        $scope.displaySelectedFiles = (fileName) => {
          $scope.model.isPrint = true;
          CustomerService.viewContractDocument($scope.model.customerId, fileName)
            .then(() => { })
            .catch((err) => {
              console.log(err)
            })
            .finally(() => {
              $scope.model.isPrint = false;
            })
        }

        $scope.downloadSelectedFiles = (fileName) => {
          $scope.model.isDownloading = true;
          CustomerService.downloadContractDocument($scope.model.customerId, fileName)
            .then(() => {
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.isDownloading = false;
            })
        }

        $scope.removeSelectedFiles = (fileName, index) => {
          Modal.confirm({
            header: $translate.instant('common.confirm_delete_title'),
            message: $translate.instant('common.confirm_delete_message'),
            callback: (({
              modal,
            }) => {
              $scope.model.isDeleting = true;
              CustomerService.deleteContractDocument($scope.model.customerId, fileName, $scope.model.branchId)
                .then(() => {
                  $scope.model.uploadedFiles.splice(index, 1);
                })
                .catch((err) => {
                  console.log(err);
                })
                .finally(() => {
                  $scope.model.isDeleting = false;
                  modal.close();
                })
            }),
            negative: (({
              modal,
            }) => {
              modal.close();
            }),
            type: 'danger'
          })
        }

        $scope.formatFileSize = (bytes, decimalPoint) => {
          return CommonLayoutService.formatFileSize(bytes);
        }

        init()
      }]
    })
    rejectModal(customerDocumentModal, negative)
  }

  let markUndeliveredWithCRV = (data, callback, negative) => {
    let markUndeliveredWithCRVModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: markUndeliveredWithCRVTemplate,
      size: 'md',

      controller: ['$scope', ($scope) => {

        $scope.model = {
          shipments: data,
          convertToCRV: false,
          loading: false,
          reason: '' 
        }

        const init = () => { };

        $scope.ok = () => {
          callback({
            modal: markUndeliveredWithCRVModal,
            convertToCRV: $scope.model.convertToCRV,
            reason: $scope.model.reason,
            $scope: $scope
          })
        }

        $scope.cancel = () => {
          negative({
            modal: markUndeliveredWithCRVModal
          });
        }

        init()
      }]
    })
    rejectModal(markUndeliveredWithCRVModal, negative);
  }

  let viewAppLogo = (data, stat, modal, callback) => {
    let appLogoModal = $uibModal.open({
      template: appLogoTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'sm',
      controller: ['$scope', 'CommonLayoutService', function ($scope, CommonLayoutService) {
        $scope.model = {
          base64String: null,
          header: stat
        };

        const init = () => {
          if (data.length && !data[0].hasOwnProperty('base64Data')) {
            $scope.base64String = CommonLayoutService.generateObjectURL(data);
          }
          else {
            const arrayBuffer = Buffer.from(data[0].base64Data, 'base64').toString('binary');
            $scope.base64String = CommonLayoutService.generateObjectURL(arrayBuffer);
          }
        }

        $scope.ok = () => {
          callback({
            modal: appLogoModal
          })
          appLogoModal.close();
        }

        $scope.cancel = () => {
          appLogoModal.close();
        }
        init()
      }]
    })
  }

  let previewTicketPictures = (selectedFiles, removeCallback, callback, negative, showRemove = true) => {
    let previewModal = $uibModal.open({
      template: previewTicketPicturesTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', function ($scope) {
        $scope.model = {
          results: []
        };
        $scope.showRemove = showRemove && typeof removeCallback === 'function';

        const init = () => {
          if (selectedFiles && selectedFiles.length) {
            $scope.model.results = [].concat(selectedFiles);
          }
        };

        $scope.getImageSrc = (file) => {
          if (!file) return '';
          if (file.imageUrl) {
            return file.imageUrl;
          }
          if (!file.base64Data) {
            return '';
          }
          if (file.base64Data.startsWith('data:') || file.base64Data.startsWith('blob:')) {
            return file.base64Data;
          }
          return 'data:' + file.type + ';base64,' + file.base64Data;
        };

        $scope.download = (image) => {
          if (image.imageUrl) {
            fetch(image.imageUrl)
              .then(response => {
                return response.blob();
              })
              .then(blob => {
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = image.fileName || 'download';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
              })
              .catch(err => {
                console.error('Error downloading image via fetch:', err);
              });
          }
        };

        $scope.remove = (index) => {
          $scope.model.results.splice(index, 1);
          removeCallback(index);
          if ($scope.model.results.length === 0) {
            previewModal.close();
          }
        };

        $scope.close = () => {
          previewModal.close();
        };

        init();
      }]
    });
    rejectModal(previewModal, negative);
  }

  // let scheduledATMShipment = (callback, negative) => {
  //   let scheduledATMShipmentModal = $uibModal.open({
  //     template: scheduledATMShipmentTemplate,
  //     animation: true,
  //     ariaLabelledBy: 'modal-title-top',
  //     ariaDescribedBy: 'model-body-top',
  //     backdrop: 'static',
  //     size: 'md',
  //     controller: ['$scope', 'LocationService', 'User', 'RouteService', 'DenominationService', function ($scope, LocationService, User, RouteService, DenominationService) {
  //       $scope.model = {
  //         location: null,
  //         days: [{
  //           label: 'Sunday',
  //           DOW: 0,
  //           ticked: false
  //         },
  //         {
  //           label: 'Monday',
  //           DOW: 1,
  //           ticked: false
  //         },
  //         {
  //           label: 'Tuesday',
  //           DOW: 2,
  //           ticked: false
  //         },
  //         {
  //           label: 'Wednesday',
  //           DOW: 3,
  //           ticked: false
  //         },
  //         {
  //           label: 'Thursday',
  //           DOW: 4,
  //           ticked: false
  //         },
  //         {
  //           label: 'Friday',
  //           DOW: 5,
  //           ticked: false
  //         },
  //         {
  //           label: 'Saturday',
  //           DOW: 6,
  //           ticked: false
  //         }],
  //         frequency: [{
  //           label: 'Every Week',
  //           value: 'every_week'
  //         },
  //         {
  //           label: 'Every 2nd Week',
  //           value: 'every_second_week'
  //         },
  //         {
  //           label: 'Every 3rd Week',
  //           value: 'every_third_week'
  //         },
  //         {
  //           label: 'Every 4th Week',
  //           value: 'every_fourth_week'
  //         }],
  //         selectedFrequency: null,
  //         route: null,
  //         amount: null,
  //         denomination: null,
  //         ABWS: 0,
  //         startDate: null,
  //         nextDate: null,
  //         endDate: null,
  //         locationListObj: {
  //           results: [],
  //           totalLocation: 0
  //         },
  //         routeListObj: {
  //           results: [],
  //           totalLocation: 0
  //         },
  //         branchId: User.getUser().branchId,
  //         selectedDays: [],
  //         denominationObj: {
  //           results: []
  //         },
  //         selectedDenom: null,
  //         startDate: moment(),
  //         nextDate: null,
  //         endDate: null
  //       };

  //       const init = () => {
  //         $scope.loadLocation('', 0);
  //         $scope.getRoutes('', 0);
  //         $scope.loadDenomination();
  //       }

  //       $scope.locationSearchObj = (searchKey) => {
  //         searchKey = searchKey || '';
  //         const searchObj = {
  //           queryJSON: {
  //             rules: [
  //               {
  //                 field: 'branchId',
  //                 condition: '=',
  //                 data: $scope.model.branchId
  //               },
  //               {
  //                 field: 'active',
  //                 condition: '=',
  //                 data: true
  //               },
  //               {
  //                 group: {
  //                   rules: [{
  //                     field: 'id',
  //                     condition: 'like',
  //                     data: '%' + searchKey + '%'
  //                   },
  //                   {
  //                     field: 'name',
  //                     condition: 'like',
  //                     data: '%' + searchKey + '%'
  //                   }
  //                   ],
  //                   operator: 'OR'
  //                 }
  //               }, {
  //                 group: {
  //                   rules: [
  //                     {
  //                       field: 'locationType',
  //                       condition: '=',
  //                       data: 'ATM'
  //                     },
  //                   ],
  //                   operator: 'OR'
  //                 }
  //               }
  //             ],
  //             operator: 'AND'
  //           },
  //         };

  //         return searchObj.queryJSON.rules.length ? searchObj : null;
  //       }

  //       $scope.loadLocation = (searchKey, offset) => {
  //         searchKey = searchKey || '';
  //         const locationSearchObj = $scope.locationSearchObj(searchKey);
  //         LocationService.all(locationSearchObj, offset, AppConstant.defaultPageLimit)
  //           .then((res) => {
  //             if (offset === 0) {
  //               $scope.model.locationListObj.totalLocation = res.total;
  //               $scope.model.locationListObj.results = $scope.mappingData(res.results);
  //             } else {
  //               const locations = $scope.mappingData(res.results);
  //               $scope.model.locationListObj.results = $scope.model.locationListObj.results.concat(locations);
  //             }
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //           })
  //       }

  //       $scope.mappingData = (list) => {
  //         return list.map((item) => {
  //           return {
  //             Key: item.id + ' | ' + item.name,
  //             Value: item.id
  //           }
  //         });
  //       }

  //       $scope.getRoutes = (searchKey, offset) => {
  //         searchKey = searchKey || '';

  //         const routeSearchObj = {
  //           queryJSON: {
  //             rules: [
  //               {
  //                 field: 'branchId',
  //                 condition: '=',
  //                 data: $scope.model.branchId
  //               },
  //               {
  //                 field: 'active',
  //                 condition: '=',
  //                 data: true
  //               },
  //               {
  //                 group: {
  //                   rules: [{
  //                     field: 'id',
  //                     condition: 'like',
  //                     data: '%' + searchKey + '%'
  //                   },
  //                   {
  //                     field: 'name',
  //                     condition: 'like',
  //                     data: '%' + searchKey + '%'
  //                   }
  //                   ],
  //                   operator: 'OR'
  //                 }
  //               }
  //             ],
  //             operator: 'AND'
  //           }
  //         }

  //         return RouteService.all(routeSearchObj, 0, AppConstant.defaultPageLimit)
  //           .then((res) => {
  //             if (offset === 0) {
  //               $scope.model.routeListObj.totalLocation = res.total;
  //               $scope.model.routeListObj.results = $scope.mappingData(res.results);
  //             } else {
  //               const routes = $scope.mappingData(res.results);
  //               $scope.model.routeListObj.results = $scope.model.routeListObj.results.concat(routes);
  //             }
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //           })
  //       }

  //       $scope.loadDenomination = () => {
  //         return DenominationService.all(null, 0, 30)
  //           .then((res) => {
  //             $scope.model.denominationObj.results = res.results;
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //           })
  //       }

  //       $scope.ok = () => {
  //         callback({
  //           modal: scheduledATMShipmentModal,
  //           location: $scope.model.location.Value,
  //           selectedDays: $scope.model.selectedDays,
  //           selectedFrequency: $scope.model.selectedFrequency,
  //           route: $scope.model.route.Value,
  //           amount: $scope.model.amount,
  //           denomination: $scope.model.denomination
  //         })
  //         scheduledATMShipmentModal.close();
  //       }

  //       $scope.cancel = () => {
  //         scheduledATMShipmentModal.close();
  //       }
  //       init()
  //     }]
  //   })
  //   rejectModal(scheduledATMShipmentModal, negative);
  // }

  let atmLoadShipment = (shipment, nextOrderNo, branchVaultDate, stats, callback) => {
    let atmLoadShipmentModal = $uibModal.open({
      template: atmLoadShipmentTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$q', 'BranchFundingSourceService', 'User', 'LocationService', 'CommonLayoutService', 'OrderViewService', 'RouteService',
        'DenominationService', function ($scope, $q, BranchFundingSourceService, User, LocationService, CommonLayoutService, OrderViewService, RouteService,
          DenominationService) {
          $scope.model = {
            fundingSourceObj: {
              branchFundingSource: [],
              totalBranchFundingSource: 0,
              loading: false
            },
            locationObj: {
              locationList: [],
              totalLocation: 0
            },
            routeObj: {
              routeList: [],
              totalRoutes: 0
            },
            isGettingLocationRoutes: false,
            vaultDate: new Date(branchVaultDate),
            orderTypes: [],
            branchId: User.getUser().branchId,
            customerUser: User.getUser().customerUser ? User.getUser().customerId : null,
            orderTypes: CommonLayoutService.orderTypes(),
            denominationAllType: [],
            denominations: [],
            orderNo: nextOrderNo,
            shipment: shipment,
            loading: false,
            stats: stats,
            isValidBillCount: true
          };

          $scope.generateSearchObj = (searchKey) => {
            searchKey = searchKey || '';

            const obj = {
              queryJSON: {
                rules: [
                  {
                    field: "branchId",
                    condition: "=",
                    data: $scope.model.branchId
                  },
                  {
                    group: {
                      rules: [
                        {
                          field: "id",
                          condition: "like",
                          data: "%" + searchKey + "%"
                        },
                        {
                          field: "sourceName",
                          condition: "like",
                          data: "%" + searchKey + "%"
                        }
                      ],
                      operator: "OR"
                    }
                  }
                ],
                operator: "AND"
              }
            }
            return obj.queryJSON.rules.length ? obj : null;
          }

          $scope.getAllFundingSource = (searchKey, offset) => {
            $scope.model.fundingSourceObj.loading = true;
            const searchObj = $scope.generateSearchObj(searchKey);

            BranchFundingSourceService.all(searchObj, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.fundingSourceObj.totalBranchFundingSource = data.total;
                  $scope.model.fundingSourceObj.branchFundingSource = $scope.mappingData(data.results, 'sourceName', 'id');
                }
                else {
                  const fundingSource = $scope.mappingData(data.results, 'sourceName', 'id');
                  $scope.model.fundingSourceObj.branchFundingSource = $scope.model.fundingSourceObj.branchFundingSource.concat(fundingSource);
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.fundingSourceObj.loading = false;
              })
          }

          $scope.mappingData = (arr, label, value) => {
            return arr.map((item) => {
              return {
                Key: item[value] + ' | ' + item[label],
                Value: item[value],
                dataObj: item
              };
            });
          }

          $scope.locationSearchObj = (searchKey) => {
            searchKey = searchKey || '';
            const searchObj = {
              queryJSON: {
                rules: [{
                  field: 'branchId',
                  condition: '=',
                  data: $scope.model.branchId
                },
                {
                  field: 'active',
                  condition: '=',
                  data: true
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }, {
                  group: {
                    rules: [
                      {
                        field: 'locationType',
                        condition: '=',
                        data: 'ATM'
                      },
                      {
                        field: 'locationType',
                        condition: '=',
                        data: 'REGULAR'
                      },
                      {
                        field: 'locationType',
                        condition: '=',
                        data: 'DELIVERY'
                      },
                    ],
                    operator: 'OR'
                  }
                }
                ],
                operator: 'AND'
              },
            };

            if ($scope.model.customerUser) {
              searchObj.queryJSON.rules.push({
                field: 'customerId',
                condition: '=',
                data: $scope.model.customerUser
              })
            }

            return searchObj.queryJSON.rules.length ? searchObj : null;
          }

          $scope.loadLocation = (searchKey, offset) => {
            searchKey = searchKey || '';
            const locationSearchObj = $scope.locationSearchObj(searchKey);
            LocationService.all(locationSearchObj, offset, AppConstant.defaultPageLimit)
              .then((res) => {
                if (offset === 0) {
                  $scope.model.locationObj.totalLocation = res.total;
                  $scope.model.locationObj.locationList = $scope.mappingData(res.results, 'name', 'id');
                } else {
                  const locations = $scope.mappingData(res.results, 'name', 'id');
                  $scope.model.locationObj.locationList = $scope.model.locationObj.locationList.concat(locations);
                }
              })
              .catch((err) => {
                console.log(err);
              })
          }

          $scope.getLocationNextRoute = () => {
            $scope.model.isGettingLocationRoutes = true;
            OrderViewService.findLocationRoute($scope.model.toLocation.Value, $scope.getFormattedVaultDate($scope.model.vaultDate))
              .then((res) => {
                const routeId = res.results.routeId;
                const findRoute = _.find($scope.model.routeObj.routeList, { 'Value': routeId });
                if (findRoute) $scope.model.routeId = findRoute;
                else $scope.model.routeId = null;
                
                if ($scope.model.fundingSource && $scope.model.fundingSource.Value) {
                  $scope.loadDenominations();
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.isGettingLocationRoutes = false;
              })
          }

          $scope.getActiveRoutes = (searchKey, offset) => {
            searchKey = searchKey || '';

            const routeSearchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'branchId',
                    condition: '=',
                    data: $scope.model.branchId
                  },
                  {
                    group: {
                      rules: [{
                        field: 'id',
                        condition: 'like',
                        data: '%' + searchKey + '%'
                      },
                      {
                        field: 'name',
                        condition: 'like',
                        data: '%' + searchKey + '%'
                      }
                      ],
                      operator: 'OR'
                    }
                  }
                ],
                operator: 'AND'
              }
            }

            // this.RouteService.getActiveRoutes(this.branchId, selectedDate)
            return RouteService.all(routeSearchObj, 0, AppConstant.defaultPageLimit)
              .then((res) => {
                const routes = $scope.mappingData(res.results, 'name', 'id');
                $scope.model.routeObj.routeList = routes;
                $scope.model.routeObj.totalRoutes = routes.length;

              }).catch((err) => {
                console.log(err);
              })
          }

          $scope.loadDenominations = () => {
            if ($scope.model.fundingSource && $scope.model.fundingSource.Value) {
              const locationId = $scope.model.toLocation ? $scope.model.toLocation.Value : null;
              OrderViewService.getFundingSourceDenomination($scope.model.fundingSource.Value, locationId)
                .then((res) => {
                  $scope.model.denominationAllType = res.results.length ? res.results.filter(d => d.shiptypeId == 'C') : [];
                  $scope.removeAlreadyUsedDenom();
                  $scope.addNewDenominations();
                }).catch((err) => {
                  console.log(err);
                })
            } else {
              const searchObj = {
                queryJSON: {
                  rules: [
                    {
                      field: 'currencyId',
                      condition: '=',
                      data: 'USD'
                    }
                  ],
                  operator: 'AND'
                }
              }

              DenominationService.all(searchObj, 0, 1000)
                .then((res) => {
                  $scope.model.denominationAllType = res.results.length ? res.results.filter(d => d.shiptypeId == 'C') : [];
                  $scope.removeAlreadyUsedDenom();
                  $scope.addNewDenominations();
                }).catch((err) => {
                  console.log(err);
                })
            }
          }

          $scope.getFormattedVaultDate = (date) => {
            if (!date) return;
            return moment(date).format('YYYY-MM-DD');
          }

          $scope.addNewDenominations = () => {
            $scope.model.denominations = [];

            if (!$scope.model.shipment) {
              for (var i = 0; $scope.model.denominations.length < 4; i++) {
                $scope.model.denominations.push({
                  isEnabled: i == 0 ? true : false,
                  icon: i == 0 ? 'USD20' : $scope.model.remainingDenominations[0].id,
                  faceValue: i == 0 ? 20 : $scope.model.remainingDenominations[0].faceValue,
                  amount: null,
                  template: 'atm-loads-denomination-selection.html',
                  dollorFlag: true,
                  duplicate: false
                });
                $scope.removeAlreadyUsedDenom();
              }
            }
            else {
              let keys = [], denoms = [];
              keys = Object.keys($scope.model.shipment.denominations);
              keys.forEach((key) => {
                denoms.push($scope.model.shipment.denominations[key]);
              })

              for (var i = 0; $scope.model.denominations.length < 4; i++) {
                let isValid = denoms[i] && $scope.model.shipment.denominations[denoms[i].denominationId];
                $scope.model.denominations.push({
                  isEnabled: isValid ? true : false,
                  icon: isValid ? $scope.model.shipment.denominations[denoms[i].denominationId].denominationId : null,
                  faceValue: isValid ? $scope.model.shipment.denominations[denoms[i].denominationId].faceValue : null,
                  amount: isValid ? $scope.model.shipment.denominations[denoms[i].denominationId].amount : null,
                  billCount: isValid ? $scope.model.shipment.denominations[denoms[i].denominationId].billCount : null,
                  template: 'atm-loads-denomination-selection.html',
                  dollorFlag: true,
                  duplicate: false,
                  isValid: true
                });
              }
              $scope.removeAlreadyUsedDenom();
            }
          }

          $scope.changeDenomType = (event, index, denomination) => {
            $scope.model.denominations[index].icon = denomination.id;
            $scope.model.denominations[index].faceValue = denomination.faceValue;
            $scope.model.denominations[index].isOpen = false;
            $scope.checkAmount(index, $scope.model.denominations[index].billCount, denomination.faceValue);
            $scope.removeAlreadyUsedDenom();
          }

          $scope.removeAlreadyUsedDenom = () => {
            $scope.model.remainingDenominations = $scope.model.denominationAllType.filter(type => {
              let isValid = true;
              $scope.model.denominations.forEach((data) => {
                isValid = (!(data.icon === type.id && data.isEnabled)) && isValid
              })
              return isValid;
            });
          }

          $scope.checkAmount = (denominationIndex, billCount, faceValue) => {
            const orderTypes = ['P', 'T'];
            let amount = 0; amount = billCount >= 0 ? billCount * faceValue : 0;
            if ($scope.model.denominations[denominationIndex].isEnabled && (amount % faceValue > 0 || billCount == 0) && !orderTypes.includes($scope.model.orderType)) {
              $scope.model.denominations[denominationIndex].isValid = false;
              $scope.model.isValidBillCount = false;
            }
            else if (amount != null && amount % faceValue == 0) {
              $scope.model.denominations[denominationIndex].isValid = true;
              $scope.model.isValidBillCount = true;
            }
            $scope.model.denominations[denominationIndex].amount = amount;
          }

          $scope.turnOffDenom = (denomination, denomIndex) => {
            denomination.isEnabled = false;
            denomination.billCount = null;

            let cursor = 0;
            $scope.model.denominations.forEach((d) => {
              if (!d.isEnabled) cursor++;
              else cursor = 0;
            })
            if ($scope.model.denominations.length === cursor) {
              $scope.model.isValidBillCount = true;
            }

            $scope.removeAlreadyUsedDenom();
          }

          $scope.handleDenomination = (denomination) => {
            denomination.isEnabled = !denomination.isEnabled
            if (!denomination.isEnabled) {
              denomination.icon = '';
              denomination.amount = '';
              denomination.faceValue = '';
            } else {
              let isEnabled = $scope.model.denominationAllType.filter(() => denomination.isEnabled)
              let icon = isEnabled.length == 1 ? 'USD20' : $scope.model.remainingDenominations[0].id,
                faceValue = 0;
              $scope.model.denominationAllType.forEach((denomData) => {
                if (denomData.id == icon) {
                  faceValue = denomData.faceValue;
                }
              });
              denomination.icon = icon;
              denomination.faceValue = faceValue;
            }
            $scope.removeAlreadyUsedDenom();
          }

          $scope.validateATMOrderCreateBtn = () => {
            const orderTypes = ['P', 'T']; let cursor = 0;
            var disableButton = $scope.model.denominations.map((denom) => {
              if (denom.isEnabled) return ((orderTypes.includes($scope.model.orderType) ? denom.amount >= 0 : denom.amount > 0)
                && denom.isValid !== undefined && denom.isValid) || 'isEmpty'
            })

            disableButton.forEach((d) => {
              if (d == undefined) cursor++;
              else cursor = 0;
            })
            return disableButton.indexOf('isEmpty') !== -1 || $scope.model.denominations.length === cursor;;
          }

          $scope.validateBillCount = () => {
            const orderTypes = ['P', 'T'];
            $scope.model.denominations.map((denom) => {
              if (denom.isEnabled && (denom.amount % denom.faceValue > 0 || denom.billCount == 0) && !orderTypes.includes($scope.model.orderType)) {
                denom.isValid = false;
                $scope.model.isValidBillCount = false;
              }
              else if (denom.amount !== null && denom.amount >= 0 && denom.amount % denom.faceValue == 0) {
                denom.isValid = true;
                $scope.model.isValidBillCount = true;
              }
            })
          }

          const init = () => {
            $scope.model.loading = true;
            $q.all([
              $scope.getAllFundingSource('', 0),
              $scope.loadLocation('', 0),
              $scope.getActiveRoutes(0, ''),
              $scope.loadDenominations()
            ])
              .then(() => {
                $scope.minVaultDate = {
                  minDate: new Date($scope.model.vaultDate)
                }

                if ($scope.model.shipment && typeof $scope.model.shipment == 'object') {
                  const obj = $scope.model.shipment;
                  $scope.model.fundingSource = obj.fundingSource;
                  $scope.model.orderNo = obj.orderNo;
                  $scope.model.toLocation = obj.location;
                  $scope.model.routeId = obj.route;
                  $scope.model.vaultDate = obj.vaultDate;
                  $scope.model.orderType = obj.orderType;
                  
                  if ($scope.model.fundingSource && $scope.model.fundingSource.Value) {
                    $scope.loadDenominations();
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.loading = false;
              })
          }

          $scope.ok = () => {
            let denominations = {};
            $scope.model.denominations.forEach(d => {
              if (d.isEnabled && d.amount >= 0) {
                Object.assign(denominations, {
                  [d.icon]: {
                    denominationId: d.icon,
                    amount: d.amount,
                    faceValue: d.faceValue,
                    billCount: d.billCount
                  }
                })
              }
            });

            callback({
              modal: atmLoadShipmentModal,
              fundingSource: $scope.model.fundingSource,
              orderNo: $scope.model.orderNo,
              location: $scope.model.toLocation,
              route: $scope.model.routeId,
              vaultDate: $scope.model.vaultDate,
              orderType: $scope.model.orderType,
              denominations: denominations
            })
          }

          $scope.cancel = () => {
            atmLoadShipmentModal.close()
          }

          $scope.$watch('model.fundingSource', (newVal, oldVal) => {
            if (newVal && newVal.Value && newVal.Value !== (oldVal && oldVal.Value)) {
              $scope.loadDenominations();
            }
          }, true);

          init()
        }]
    })
  }

  let pickupDeliveryShipments = (branchId, routeId, vaultDate, flagType, callback, negative) => {
    let pickupDeliveryShipmentModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: pickupDeliveryShipmentTemplate,
      size: 'lg',

      controller: ['$scope', 'RouteDetailService', 'Navigation', ($scope, RouteDetailService, Navigation) => {

        $scope.model = {
          pickupShipmentList: [],
          routeId,
          branchId,
          vaultDate,
          flagType,
          loading: false
        };

        const init = () => {
          $scope.model.loading = true;
          RouteDetailService.pickupDeliveryShipments($scope.model.branchId, $scope.model.routeId, $scope.model.vaultDate , $scope.model.flagType)
            .then((data) => {
              $scope.model.pickupShipmentList = data.results;
            })
            .catch((err) => {
              console.log(err)
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.cancel = () => {
          pickupDeliveryShipmentModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: pickupDeliveryShipmentModal
          });
          modal.close()
        }

        $scope.goToItemHistory = (trackingId) => {
          return Navigation.goToItemHistory(trackingId, pickupDeliveryShipmentModal);
        }

        $scope.goToServiceHistory = (locationId, date, isRedirected = true) => {
          return Navigation.goToServiceHistory(locationId, date, isRedirected, pickupDeliveryShipmentModal);
        }

        init()
      }]
    })
  }

  let notDeliveredResolution = (trackingId, notDeliveredResolution, callback, negative) => {
    let notDeliveredResolutionModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: notDeliveredResolutionTemplate,
      size: 'lg',

      controller: ['$scope', ($scope) => {

        $scope.model = {
          data: notDeliveredResolution,
          trackingId
        };

        const init = () => { }

        $scope.cancel = () => {
          notDeliveredResolutionModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: notDeliveredResolutionModal
          });
          modal.close()
        }
        init()
      }]
    })
    rejectModal(notDeliveredResolutionModal, negative)
  }

  let pickupHoldRelease = (shipment, allowSupervisorScan, callback, negative) => {
    let pickupHoldReleaseModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: pickupHoldReleaseTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', '$location', 'SetupService', 'BranchService', 'MessageService', 'User', 'ShipmentService', '$q', 'HoldService', 'LocationService',
        ($scope, $translate, $location, SetupService, BranchService, MessageService, User, ShipmentService, $q, HoldService, LocationService) => {

          $scope.loading = false;
          $scope.model = {
            trackingId: '',
            holdDate: '',
            deliveryDate: '',
            shipments: '',
            toLocationRoute: '',
            fromLocationRoute: '',
            toLocationRouteId: '',
            toLocationRouteSeq: '',
            toLocationRouteDate: '',
            fromLocationRouteId: '',
            fromLocationRouteSeq: '',
            fromLocationRouteDate: '',
            branchId: shipment.branchId ? shipment.branchId : User.getUser().branchId,
            vaultDate: '',
            nextRouteData: '',
            nextRouteDetails: '',
            routeList: [],
            routeSequence: null,
            routeIds: '',
            totalRoutes: '',
            date: '',
            toLocationId: '',
            loadRouteList: false,
            routeTransfered: '',
            lastSelectedRoute: null,
            allowSupervisorScan: allowSupervisorScan,
            userDetails: User.getUser()
          };

          $scope.model.trackingId = shipment.trackingId;
          $scope.model.shipment = shipment.toLocation;
          $scope.model.toLocationId = shipment.toLocationId ? shipment.toLocationId : null;
          $scope.model.toLocationName = shipment.toLocationName ? shipment.toLocationName : null;

          const init = () => {
            $scope.loading = true;
            SetupService.get($scope.model.branchId)
              .then((data) => {
                $scope.model.vaultDate = moment.utc(data.currentVaultDate).format('YYYY-MM-DD');
                $scope.minVaultDate = {
                  minDate: $scope.model.vaultDate
                }
                return data;
              })
              .then((data) => {
                $scope.loadLocations().then(() => {
                  $scope.model.location = {
                    Key: ($scope.model.toLocationId ? $scope.model.toLocationId : shipment.toLocation.id)
                      + ' | ' + ($scope.model.toLocationName ? $scope.model.toLocationName : shipment.toLocation.name), Value: ($scope.model.toLocationId ? $scope.model.toLocationId : shipment.toLocation.id)
                  }
                });
                return getNextAvailableRoutes(ShipmentService, $scope, $scope.model.toLocationId, $location, $q, BranchService, data.unassignedRoute, HoldService)
              })
              .finally(() => {
                $scope.loading = false;
              });

            $scope.routeSequenceChanged = () => {
              const routeId = $scope.model.routeId ? $scope.model.routeId : $scope.model.lastSelectedRoute;
              $scope.model.totalRoutes.map(data => {
                $scope.model.routeSequence = data.routeId === routeId ? 0 : $scope.model.routeSequence;
              });
              $scope.model.routeInfo = _.find($scope.model.totalRoutes, { 'routeId': routeId })
            }
          }

          $scope.mappingLocations = (locations) => {
            return locations.map((data) => {
              return {
                Key: data.id + " | " + data.name,
                Value: data.id
              }
            });
          }

          $scope.loadLocations = (searchKey, offset) => {
            searchKey = searchKey || '';
            const searchObj = {
              queryJSON: {
                rules: [{
                  field: "branchId",
                  condition: "=",
                  data: $scope.model.branchId
                },
                {
                  field: "active",
                  condition: "=",
                  data: true
                },
                // {
                //   group: {
                //     rules: [{
                //       field: "locationType",
                //       condition: "NOTIN",
                //       data: ['TANKER, VAULT, WINDOW, CARRIER, TRUCK']
                //     }],
                //     operator: 'AND'
                //   }
                // },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }],
                operator: "AND"
              }
            };

            return LocationService.all(searchObj, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.totalLocation = data.total;
                  $scope.model.locations = $scope.mappingLocations(data.results);
                }
                else {
                  const Locations = $scope.mappingLocations(data.results);
                  $scope.model.locations = $scope.model.locations.concat(Locations);
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.loading = false;
              })
          }

          $scope.cancel = () => {
            negative({
              modal: pickupHoldReleaseModal
            })
          }

          $scope.validateSupervisorScan = () => {
            if ($scope.model.allowSupervisorScan) {
              let errorMsg = $translate.instant('users.supervisor_scan_error', {
                firstName: $scope.model.userDetails.firstName,
                lastName: $scope.model.userDetails.lastName
              })

              return confirm({
                header: $translate.instant('errorModal.title'),
                message: $translate.instant(errorMsg),
                callback: ({
                  modal,
                }) => {
                  $scope.ok();
                  modal.close();
                },
                type: 'danger',
                buttons: ['common.ok']
              })
            }
            else {
              $scope.ok();
            }
          }

          $scope.ok = () => {
            $scope.isLoading = true;
            verifySupervisorScan('pickup-hold-release', { trackingId: shipment.trackingId }, $scope)
              .then((supervisorInfo) => {
                $scope.model.supervisorId = supervisorInfo ? supervisorInfo.supId : null
                $scope.model.loading = true;

                callback({
                  supervisorId: supervisorInfo ? supervisorInfo.supId : null,
                  comment: $scope.model.comment ? $scope.model.comment : null,
                  shipmentAssignedTo: $scope.model.routeId,
                  selectedDate: $scope.model.date,
                  routeInfo: $scope.model.routeInfo,
                  locationId: $scope.model.location.Value,
                  modal: pickupHoldReleaseModal
                });
                if (supervisorInfo) supervisorInfo.modal.close();
              })
          }
          init()
        }]
    })
    rejectModal(pickupHoldReleaseModal, negative)
  }

  let duplicateRouteStopList = (routeId, routeStops, callback, negative) => {
    let duplicateRouteStopListModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: duplicateRouteStopTemplate,
      size: 'lg',

      controller: ['$scope', '$state', 'Navigation', 'CommonLayoutService', ($scope, $state, Navigation, CommonLayoutService) => {

        $scope.model = {
          routeId: routeId,
          stops: routeStops
        }

        const init = () => { };

        $scope.ok = () => {
          callback({
            modal: duplicateRouteStopListModal
          })
          modal.close();
        }

        $scope.cancel = () => {
          negative({
            modal: duplicateRouteStopListModal
          });
        }

        $scope.goToServiceHistory = (data) => {
          // return Navigation.goToServiceHistory(data.locationId, null, true, duplicateRouteStopListModal);
          return $state.go('location.edit', {
            id: data.locationId
          });
        }

        $scope.loadLocationTypeIcon = (locationType) => {
          return CommonLayoutService.loadLocationTypeIcon(locationType)
        }

        init()
      }]
    })
    rejectModal(duplicateRouteStopListModal, negative)
  }

  let branchMgmtBagoutClose = (bagoutObj, callback, negative) => {
    let closeBagoutModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: branchMgmtBagoutCloseTemplate,
      size: 'md',

      controller: ['$scope', '$state', '$q', 'LocationService', 'BagoutService', ($scope, $state, $q, LocationService, BagoutService) => {

        $scope.model = {
          routeId: null,
          loading: false,
          bagoutObj,
          deliveryDate: bagoutObj.deliveryDate,
          holdRouteId: bagoutObj.holdRouteId
        };

        const init = () => {
          $scope.model.loading = true;

          const dayIndex = moment($scope.model.deliveryDate).day();
          const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

          $q.all([
            LocationService.getVisitingRoutes($scope.model.bagoutObj.locationId, weekDays[dayIndex]),
            BagoutService.getDeliveryRoutes($scope.model.bagoutObj.branchId, moment($scope.model.deliveryDate).format('YYYY-MM-DD'))
          ])
            .then((data) => {
              $scope.model.routeList = data[1].results ? data[1].results.slice() : [];

              if ($scope.model.holdRouteId) {
                $scope.model.routeList.push({ id: $scope.model.holdRouteId, name: $scope.model.holdRouteId });
              }

              if (data[0].results) {
                if (data[0].results.length === 0 && $scope.model.holdRouteId) {
                  $scope.model.routeId = $scope.model.routeList[_.findIndex(_this5.routes, { id: _this5.holdRoute.id })];;
                }
                else if (data[0].results.length === 1) {
                  let selectedIndex = _.findIndex($scope.model.routeList, { id: data[0].results[0].id });
                  $scope.model.routeId = selectedIndex >= 0 ?
                    $scope.model.routeList[selectedIndex] :
                    $scope.model.routeList[_.findIndex($scope.model.routeList, { id: $scope.model.holdRouteId })];
                }
              }
              else if ($scope.model.holdRouteId) {
                const route = $scope.model.routeList[_.findIndex($scope.model.routeList, { id: $scope.model.holdRouteId })];
                $scope.model.routeId = route.id
              }
            })
            .catch(err => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        };

        $scope.ok = () => {
          callback({
            modal: closeBagoutModal,
            routeId: $scope.model.routeId,
            deliveryDate: $scope.model.deliveryDate,
            $scope
          })
        }

        $scope.cancel = () => {
          negative({
            modal: closeBagoutModal
          });
        }

        init()
      }]
    })
    rejectModal(closeBagoutModal, negative)
  }

  let makeDeliverable = (shipmentObj, callback, negative) => {
    let makeDeliverableModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: makeDeliverableTemplate,
      size: 'md',

      controller: ['$scope', 'RouteService', 'DateUtil', ($scope, RouteService, DateUtil) => {

        $scope.model = {
          routeId: null,
          loading: false,
          shipmentObj,
          routeObj: {
            results: [],
            totalRecords: 0
          },
          vaultDate: DateUtil.convertToDate(shipmentObj.date),
          branchId: shipmentObj.branchId,
          trackingId: shipmentObj.trackingId
        };

        const init = () => {
          $scope.loadRoutes('', 0);
          $scope.model.route = {
            Key: shipmentObj.routeId + ' | ' + shipmentObj.routeName,
            Value: shipmentObj.routeId
          }
        };

        $scope.loadRoutes = (searchKey, offset) => {
          searchKey = searchKey || '';

          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'branchId',
                  condition: '=',
                  data: $scope.model.branchId
                },
                {
                  group: {
                    rules: [
                      {
                        field: "id",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "name",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      }
                    ],
                    operator: "OR"
                  }
                }
              ],
              operator: 'AND'
            }
          };

          $scope.model.loading = true;
          RouteService.all(searchObj, offset, 10)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.routeObj.totalRecords = data.total;
                $scope.model.routeObj.results = $scope.mapData(data.results);
              } else {
                const routes = $scope.mapData(data.results);
                $scope.model.routeObj.results = $scope.model.routeObj.results.concat(routes)
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.mapData = (routes) => {
          return routes.map((route) => {
            return {
              Key: route.id + ' | ' + route.name,
              Value: route.id
            }
          });
        }

        $scope.ok = () => {
          callback({
            modal: makeDeliverableModal,
            routeId: $scope.model.route.Value,
            vaultDate: moment($scope.model.vaultDate).format('YYYY-MM-DD'),
            $scope
          })
        }

        $scope.cancel = () => {
          negative({
            modal: makeDeliverableModal
          });
        }

        init()
      }]
    })
    rejectModal(makeDeliverableModal, negative)
  }

  let rescheduleDeliveries = (routeObj, callback, negative) => {
    let rescheduleDeliveriesModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: rescheduleDeliveriesTemplate,
      size: 'lg',

      controller: ['$scope', 'RouteService', 'DateUtil', 'VaultOperationsService', 'Navigation', ($scope, RouteService, DateUtil, VaultOperationsService, Navigation) => {

        $scope.model = {
          routeId: null,
          loading: false,
          fromRouteId: routeObj.routeId,
          fromVaultDate: DateUtil.convertToDate(routeObj.routeDate),
          routeObj: {
            results: [],
            totalRecords: 0
          },
          vaultDate: moment(DateUtil.convertToDate(routeObj.routeDate)).add(1, 'days').toDate(),
          branchId: routeObj.branchId,
          shipments: [],
          fetchingShipments: false,
          shuttleRoute: true
        };

        const init = () => {
          $scope.loadRoutes('', 0);
          $scope.minVaultDate = {
            minDate: moment(DateUtil.convertToDate(routeObj.branchVaultDate)).add(1, 'days').toDate(),
          };
          $scope.model.fetchingShipments = true;
          VaultOperationsService.getNotDeliveredShipments(routeObj.routeId, moment.utc(routeObj.routeDate).format('YYYY-MM-DD'), routeObj.branchId)
            .then(res => {
              if (res && res.status) {
                $scope.model.shipments = res.data;
              }
            })
            .catch(err => {
              console.error('Error fetching shipments', err);
            })
            .finally(() => {
              $scope.model.fetchingShipments = false;
            });
        };

        $scope.loadRoutes = (searchKey, offset) => {
          searchKey = searchKey || '';
          $scope.model.loading = true;

          RouteService.getAvailableRoutes($scope.model.branchId, moment($scope.model.vaultDate).format('YYYY-MM-DD'), offset || 0, 10, searchKey, $scope.model.shuttleRoute)
            .then((data) => {
              const filteredResults = data.results;
              if (offset === 0 || offset == undefined) {
                $scope.model.routeObj.totalRecords = data.total;
                $scope.model.routeObj.results = $scope.mapData(filteredResults);
              } else {
                const routes = $scope.mapData(filteredResults);
                $scope.model.routeObj.results = $scope.model.routeObj.results.concat(routes)
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        let lastVaultDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
        $scope.onVaultDateChange = () => {
          const currentDate = $scope.model.vaultDate ? moment($scope.model.vaultDate).format('YYYY-MM-DD') : null;
          if (currentDate && currentDate === lastVaultDate) return;
          lastVaultDate = currentDate;

          $scope.model.route = null;
          if ($scope.model.vaultDate) {
            $scope.loadRoutes('', 0);
          }
        }

        $scope.setShuttleRoute = (shuttleRoute) => {
          if ($scope.model.shuttleRoute === shuttleRoute) return;
          $scope.model.shuttleRoute = shuttleRoute;
          $scope.model.route = null;
          $scope.loadRoutes('', 0);
        }

        $scope.mapData = (routes) => {
          return routes.map((route) => {
            return {
              Key: route.id + ' | ' + route.name,
              Value: route.id
            }
          });
        }

        $scope.ok = () => {
          confirmSupervisor('reschedule-deliveries', { routeId: routeObj.routeId }, ({ modal: supModal, supId }) => {
            callback({
              modal: rescheduleDeliveriesModal,
              routeId: $scope.model.route.Value,
              vaultDate: moment($scope.model.vaultDate).format('YYYY-MM-DD'),
              shipments: $scope.model.shipments,
              supervisorId: supId,
              $scope
            });
            supModal.close();
          }, ({ modal: supModal }) => {
            supModal.close();
          });
        }

        $scope.cancel = () => {
          negative({
            modal: rescheduleDeliveriesModal
          });
        }

        $scope.goToItemHistory = (trackingId) => {
          return Navigation.goToItemHistory(trackingId, rescheduleDeliveriesModal);
        }

        $scope.goToServiceHistory = (locationId) => {
          return Navigation.goToServiceHistory(locationId, null, true, rescheduleDeliveriesModal);
        }

        init()
      }]
    })
    rejectModal(rescheduleDeliveriesModal, negative)
  }

  let logisticItemAssignModal = (data, callback, negative) => {
    let logisticItemAssignModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: logisticItemAssignTemplate,
      size: 'md',

      controller: ['$scope', 'RouteService', 'ItemService', 'UsersService', ($scope, RouteService, ItemService, UsersService) => {

        $scope.pagination = {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }
        
        $scope.model = {
          branchId: data.branchId,
          barcode: data.barcode,
          userId: null,
          routeId: data.status == 'available' ? null : data.routeId,
          notes: data.AssignmentNotes,
          routeList: [],
          // userKey: data.status == 'available' ? null : data.userKey,
          userKey: data.status == 'available' ? null : data.userKey? {"Key": data.userKey + " | " + data.firstName + " " + data.lastName, "Value": data.userKey}: '',
          userList: [],
          loading: false,

          totalRecord: 0,
          allRoutes: [],
          date: '',
          route: data.status == 'available' ? null : data.routeId? {"Key": data.routeId + " | " + data.routeName, "Value": data.routeId}: '',
        };

        const init = () => {
          $scope.model.loading = true;

          /* let searchObj = userSearchObj('', true);
          UsersService.all(searchObj, 0, 100)
          .then((data) => {
              let arr = data.results.map((item) => {
                  const arrayObject = {
                      Key: item.id + ' | ' + item.firstName + ' ' + item.lastName,
                      Value: item.id
                  };
                  return arrayObject;
              });
              $scope.model.totalUsers = data.results.length;
              $scope.model.userList = arr;
          })
          .catch((err) => {
            console.log(err);
          }) */

          ItemService.availableRoutes($scope.model.branchId)
            .then((data) => {
              $scope.model.routeList = data.results;
              $scope.model.totalRoutes = data.results.length;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })

            $scope.loadUsers('', 0);
            $scope.loadRoutes('', 0);
        }

        $scope.selectItem = () => {
          console.log('selectItem = ')
          /* if ($scope.loading) return;
          $scope.loading = true;
          confirmSupervisor('checkin-item-selected', ({ modal, supId }) => {
            callback({
              modal: selectionModal,
              selected: choices[$scope.selectedIndex],
              supervisorId: supId
            });
            modal.close()
          }, ({ modal }) => {
            $scope.loading = false;
            modal.close()
          }) */
        }

        $scope.loadUsers = (searchKey, offset) => {
          searchKey = searchKey || '';
          let searchObj = userSearchObj(searchKey, true);

          UsersService.all(searchObj, offset, $scope.pagination.pageLimit)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.totalUsers = data.total;
                $scope.model.userList = $scope.userDataMap(data.results);
              } else {
                const userList = $scope.userDataMap(data.results);
                $scope.model.userList = $scope.model.userList.concat(userList)
              }
          })
          .catch((err) => {
            console.log(err);
          })
        }

        $scope.userDataMap = (users) => {
          return users.map((item) => {
            return {
              Key: item.id + ' | ' + item.firstName + ' ' + item.lastName,
              Value: item.id
            };
          });
        }

        $scope.loadRoutes = (searchKey, offset) => {
          searchKey = searchKey || '';

          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: 'branchId',
                  condition: '=',
                  // data: $scope.model.branch
                  data: $scope.model.branchId
                },
                {
                  group: {
                    rules: [
                      {
                        field: "id",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "name",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      }
                    ],
                    operator: "OR"
                  }
                }
              ],
              operator: 'AND'
            }
          };

          RouteService.all(searchObj, offset, $scope.pagination.pageLimit)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.totalRecord = data.total;
                $scope.model.allRoutes = $scope.mapData(data.results);
              } else {
                const routes = $scope.mapData(data.results);
                $scope.model.allRoutes = $scope.model.allRoutes.concat(routes)
              }
            })
            .catch((err) => {
              console.log(err);
            })
        }

        $scope.mapData = (routes) => {
          return routes.map((route) => {
            return {
              Key: route.id + ' | ' + route.name,
              Value: route.id
            }
          });
        }

        const userSearchObj = (searchKey, displayAppUserOnly = undefined) => {
          searchKey = searchKey || '';
          const searchObj = {
            queryJSON: {
              rules: [
                {
                  field: "branchId",
                  condition: "=",
                  data: $scope.model.branchId
                },
                {
                  group: {
                    rules: [
                      {
                        field: "id",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "firstName",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      },
                      {
                        field: "lastName",
                        condition: "like",
                        data: "%" + searchKey + "%"
                      }
                    ],
                    operator: "OR"
                  }
                }
              ],
              operator: 'AND',
            }
          }
          if (searchKey) {
            searchObj.orderBy = {
              order: [
                ['id', 'ASC']
              ]
            }
          }
          if (displayAppUserOnly) {
            searchObj.queryJSON.rules.push({
              field: "downloadToHHT",
              condition: "=",
              data: true
            })
          }
          return searchObj.queryJSON.rules.length ? searchObj : null;
        };

        $scope.cancel = () => {
          logisticItemAssignModal.close();
        }

        $scope.itemAssignmentChanged = (itemAssignmentModel, index, changeIn) => {
          if (changeIn == 'route' && $scope.model.route) $scope.model.userKey = null;
          else if (changeIn == 'user' && $scope.model.userKey) $scope.model.route = null;
        }

        $scope.ok = () => {
          callback({
            modal: logisticItemAssignModal,
            barcode: $scope.model.barcode,
            routeId: $scope.model.route? $scope.model.route.Value: null,
            notes: $scope.model.notes,
            userKey: $scope.model.userKey? $scope.model.userKey.Value: null
          });
          logisticItemAssignModal.close()
        }
        init()
      }]
    })
    rejectModal(logisticItemAssignModal, negative)
  }

  let logisticItemList = (routeId, itemList, stat, callback, negative) => {
    let logisticItemListModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: logisticItemListTemplate,
      size: 'md',

      controller: ['$scope', '$translate', ($scope, $translate) => {

        $scope.model = {
          itemList, routeId, stat
        };

        const init = () => { }

        $scope.cancel = () => {
          logisticItemListModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: logisticItemListModal
          });
          modal.close()
        }

        init()
      }]
    })
  }

  let logisticItemHoldReleaseModal = (data, callback, negative) => {
    let logisticItemHoldRelease = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: logisticItemHoldReleaseTemplate,
      size: 'md',

      controller: ['$scope', 'ItemService', 'UsersService', ($scope, ItemService, UsersService) => {

        $scope.model = {
          branchId: data.branchId,
          barcode: data.barcode,
          userId: null,
          // routeId: null,
          notes: null,
          // routeList: [],
          loading: false
        };

        const init = () => {
          // $scope.model.loading = true;
          // ItemService.availableRoutes($scope.model.branchId)
          //   .then((data) => {
          //     $scope.model.routeList = data.results;
          //     $scope.model.totalRoutes = data.results.length;
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   })
          //   .finally(() => {
          //     $scope.model.loading = false;
          //   })
        }

        $scope.cancel = () => {
          logisticItemHoldRelease.close();
        }

        $scope.ok = () => {
          callback({
            modal: logisticItemHoldRelease,
            barcode: $scope.model.barcode,
            // routeId: $scope.model.routeId, 
            notes: $scope.model.notes
          });
          logisticItemHoldRelease.close()
        }
        init()
      }]
    })
    rejectModal(logisticItemHoldRelease, negative)
  }

  let serviceTicketResolveImage = (picturesObj, callback) => {
    let serviceTicketResolveImageModal = $uibModal.open({
      template: serviceTicketResolveImageTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', 'CommonLayoutService', function ($scope, CommonLayoutService) {
        $scope.model = {
          picturesObj,
          loading: false,
          results: []
        };

        const init = () => {
          const images = $scope.model.picturesObj.pictures.images;
          images.forEach((imageObj) => {
            const arrayBuffer = Buffer.from(imageObj.metadata.data, 'base64').toString('binary');
            const base64String = CommonLayoutService.generateObjectURL(arrayBuffer);
            $scope.model.results.push({base64String, name: imageObj.name});
          })
        }

        $scope.download = (imageBase64, name, index) => {
          document.getElementById(`service-ticket-resolve-image-${index}`).blur();
          let a = document.createElement("a");
          a.href = imageBase64;
          a.download = name;
          a.click();
        }

        $scope.cancel = () => {
          serviceTicketResolveImageModal.close();
        }

        init()
      }]
    })
  }

  let updateBillingRecords = (data, currentStat, callback, negative) => {
    let updateBillingRecordsModal = $uibModal.open({
      template: updateBillingRecordsTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'model-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', 'CommonLayoutService', 'LocationService', 'CustomerService', 'BillingCategoryService', '$q', 'User', 'BillableEventsService','$translate',
        function ($scope, CommonLayoutService, LocationService, CustomerService, BillingCategoryService, $q, User, BillableEventsService, $translate) {
          $scope.model = {
            locationObj: {
              results: [],
              totalRecords: 0,
              selectedLocation: null,
              loading: false
            },
            customerObj: {
              results: [],
              totalRecords: 0,
              selectedCustomer: null,
              loading: false
            },
            billingCategoryObj: {
              results: [],
              totalRecords: 0,
              selectedCategory: null,
              loading: false
            },
            billableEventsObj: {
              results: [],
              totalRecords: 0,
              selectedEvent: null,
              loading: false
            },
            billingTypeList: CommonLayoutService.billingTypeOptions() || [],
            amount: data.rate,
            amountDue: data.amountDue,
            loading: false,
            billingCategory: data.billingCategory,
            billingType: data.billingType ? data.billingType.toLowerCase() : null,
            billingRecordId: data.billingRecordId,
            billableEventId: data.billableEventId,
            billableEvent:  $translate.instant('entry_type.'.concat(data.billableEventType)),
            currentStat,
            isApproved: false,
            locationCustomerId: data.locationCustomerId,
            locationCustomerData: data.locationCustomerData,
            staticBillingOptions: ['Pre Bill', 'Post Bill'],
            loggedInUserId: User.getUser().id,
            billableEventType: data.billableEventType
          };

          const init = () => {
            $scope.model.loading = true;
            $q.all([
              $scope.getLocationList(),
              $scope.getCustomerList(),
              $scope.getBillingCategory(),
              $scope.getBillableEvents()
            ])
              .then(() => {
                if (data.locationId) {
                  if ((data.customerId == null && data.locationCustomerId !== null)) {
                    $scope.model.customerObj.selectedCustomer = {
                      Key: $scope.model.locationCustomerData,
                      Value: $scope.model.locationCustomerId
                    }
                  }

                  $scope.model.locationObj.selectedLocation = {
                    Key: data.locationId + ' | ' + data.locationName,
                    Value: data.locationId,
                    Obj: { customerObj: { id: $scope.model.locationCustomerId } }
                  }
                }

                if (data.customerId) {
                  $scope.model.customerObj.selectedCustomer = {
                    Key: data.customerId + ' | ' + data.customerName,
                    Value: data.customerId
                  }
                }
                $scope.setBillingCatergory();
                $scope.billingTypeOptionChoice(data);

                if (data.billableEventType.toLowerCase() == 'coin-conversion') {
                  let perItemOption = $scope.model.billingTypeList.find(bt => bt.value === 'per_item');
                  $scope.billingTypeList = [perItemOption];
                }
                else if (data.billableEventType.toLowerCase() == 'atm-residual-count') {
                  const options = $scope.model.billingTypeList.filter(bt => ['fixed', 'per_item', 'percentage_fee'].includes(bt.value));
                  $scope.billingTypeList = options;
                }
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.loading = false;
              })
          }

          $scope.billingTypeOptionChoice = (data) => {
            const selectedBillingEvent = data.billingCategory ? data.billingCategory : null;
            if (!selectedBillingEvent) return;
            
            if ($scope.model.staticBillingOptions.includes(selectedBillingEvent)) {
              let fixedOption = $scope.model.billingTypeList.find(bt => bt.label === 'Fixed');
              $scope.billingTypeList = [fixedOption];
            } 
            else if (data.billableEvent && data.billableEvent.toLowerCase() == 'coin conversion') {
              let perItemOption = $scope.model.billingTypeList.find(bt => bt.value === 'per_item');
              $scope.billingTypeList = [perItemOption];
            }
            else if (data.billableEvent && data.billableEvent.toLowerCase() == 'atm residual count') {
  						const options = $scope.model.billingTypeList.filter(bt => ['fixed', 'per_item', 'percentage_fee'].includes(bt.value));
              $scope.billingTypeList = options;
            }
            else {
              $scope.billingTypeList = $scope.model.billingTypeList;
            }
          }

          $scope.translateMessage = (prefix, key) => {
            if (!key) return;
            return $translate.instant(prefix.concat(key));
          }

          $scope.setBillingType = (data) => {
            if ($scope.model.staticBillingOptions.includes(data.billingCategory)) {
              $scope.model.billingType = "fixed";
            } 
            else if (data.billableEventType === 'coin-conversion') {
              $scope.model.billingType = "per_item";
            }
            else {
              $scope.model.billingType = null;
            }
          }

          $scope.getLocationList = (searchKey, offset) => {
            searchKey = searchKey || '';

            const locationSearchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'locationType',
                    condition: 'IN',
                    data: ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'INTERNAL', 'CARRIER', 'ON_CALL', 'DELIVERY']
                  },
                  {
                    group: {
                      rules: [{
                        field: 'id',
                        condition: 'like',
                        data: '%' + searchKey + '%'
                      },
                      {
                        field: 'name',
                        condition: 'like',
                        data: '%' + searchKey + '%'
                      }
                      ],
                      operator: 'OR'
                    }
                  }
                ],
                operator: 'AND'
              }
            };

            $scope.model.locationObj.loading = true;
            return LocationService.all(locationSearchObj, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.locationObj.totalRecords = data.total;
                  $scope.model.locationObj.results = $scope.locationMapping(data.results);
                } else {
                  const location = $scope.locationMapping(data.results);
                  $scope.model.locationObj.results = $scope.model.locationObj.results.concat(location);
                }
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal(err.data.message);
                }
              })
              .finally(() => {
                $scope.model.locationObj.loading = false;
              })
          }

          $scope.getBillingCategory = (searchKey, offset) => {
            searchKey = searchKey || '';

            $scope.model.billingCategoryObj.loading = true;
            BillingCategoryService.all(searchKey, offset, 100)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.billingCategoryObj.totalRecords = data.total;
                  $scope.model.billingCategoryObj.results = $scope.billingCategoryMap(data.results);
                }
                else {
                  const results = $scope.billingCategoryMap(data.results);
                  $scope.model.billingCategoryObj.results = $scope.model.billingCategoryObj.results.concat(results);
                }
              })
              .catch((err) => {
                errorModal(err.data.message);
              })
              .finally(() => {
                $scope.model.billingCategoryObj.loading = false;
              })
          }

          $scope.getBillableEvents = (searchKey, offset) => {
            searchKey = searchKey || '';

            $scope.model.billableEventsObj.loading = true;
            BillableEventsService.all(searchKey, offset, 100)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.billableEventsObj.totalRecords = data.total;
                  $scope.model.billableEventsObj.results = $scope.billableEventsMap(data.results);
                }
                else {
                  const results = $scope.billableEventsMap(data.results);
                  $scope.model.billableEventsObj.results = $scope.model.billableEventsObj.results.concat(results);
                }
              })
              .catch((err) => {
                errorModal(err.data.message);
              })
              .finally(() => {
                $scope.model.billableEventsObj.loading = false;
              })
          }

          $scope.locationMapping = (location) => {
            return location.map((loc) => {
              return {
                Key: loc.id + ' | ' + loc.name,
                Value: loc.id,
                Obj: loc,
              }
            });
          }

          $scope.getCustomerList = (searchKey, offset) => {
            searchKey = searchKey || '';

            const searchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'isEnabled',
                    condition: '=',
                    data: true
                  },
                  {
                    group: {
                      rules: [{
                        field: 'id',
                        condition: 'like',
                        data: '%' + searchKey + '%'
                      },
                      {
                        field: 'name',
                        condition: 'like',
                        data: '%' + searchKey + '%'
                      }
                      ],
                      operator: 'OR'
                    }
                  }
                ],
                operator: 'AND'
              }
            };

            return CustomerService.all(searchObj, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.customerObj.totalRecords = data.total;
                  $scope.model.customerObj.results = $scope.customerMapping(data.results);
                } else {
                  const location = $scope.customerMapping(data.results);
                  $scope.model.customerObj.results = $scope.model.customerObj.results.concat(location);
                }
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal(err.data.message);
                }
              })
              .finally(() => {
                $scope.model.customerObj.loading = false;
              })
          }

          $scope.customerMapping = (mapArray) => {
            return mapArray.map((obj) => {
              return {
                Key: obj.id + ' | ' + obj.name,
                Value: obj.id
              }
            });
          }

          $scope.billingCategoryMap = (events) => {
            return events.map((data) => {
              return {
                Key: data.name,
                Value: data.id
              }
            });
          }

          $scope.billableEventsMap = (events) => {
            return events.map((ev) => {
              return {
                Key: $scope.translateMessage('entry_type.', ev.type),
                Value: ev.id,
                billingCategoryId: ev.billingCategoryId,
                type: ev.type
              }
            });
          }

          $scope.autoPopulateLocationDetails = () => {
            if ($scope.model.locationObj.selectedLocation) {
              const customerObj = $scope.model.locationObj.selectedLocation.Obj.customerObj;
              if (customerObj && customerObj.id) {
                $scope.model.customerObj.selectedCustomer = {
                  Key: customerObj.id + ' | ' + customerObj.name,
                  Value: customerObj.id
                }
              }
              else {
                $scope.model.customerObj.selectedCustomer = null;
              }
            }
            else {
              $scope.model.customerObj.selectedCustomer = null;
            }
          }

          $scope.approved = () => {
            $scope.model.isApproved = true;
          }

          $scope.update = () => {
            $scope.model.isApproved = false;
          }

          $scope.ok = () => {
            $scope.isLoading = true;

            if ($scope.model.isApproved) {
              $scope.model.allowSupervisorScan = true;
            }
            else {
              $scope.model.allowSupervisorScan = false;
            }

            // verifySupervisorScan('approve-billing-record', null, $scope)
            //   .then((supervisorInfo) => {
            callback({
              modal: updateBillingRecordsModal,
              locationId: $scope.model.locationObj.selectedLocation ? $scope.model.locationObj.selectedLocation.Value : null,
              customerId: $scope.model.customerObj.selectedCustomer ? $scope.model.customerObj.selectedCustomer.Value : null,
              billingCategory: $scope.model.billingCategory,
              billingType: $scope.model.billingType ? $scope.model.billingType.toUpperCase() : null,
              amount: $scope.model.amount,
              amountDue: $scope.model.amountDue,
              isApproved: $scope.model.isApproved,
              userId: $scope.model.loggedInUserId,
              $scope
            // });
            // if (supervisorInfo) supervisorInfo.modal.close();
              })
          }

          $scope.cancel = () => {
            negative({ modal: updateBillingRecordsModal })
          }

          $scope.setBillingCatergory = () => {
            const findEvt = $scope.model.billableEventsObj.results.find(evt => evt.Key === $scope.model.billableEvent);
            if(!findEvt) return;
            const findBillingCatergory = $scope.model.billingCategoryObj.results.find(ct => ct.Value === findEvt.billingCategoryId);
            if(!findBillingCatergory) return
            $scope.model.billingCategory = findBillingCatergory.Key;
            $scope.model.billableEventId = findEvt.Value; //
          }
          init()
        }]
    })
    rejectModal(updateBillingRecordsModal, negative)
  }

  let bulkImportLocation = (data, callback, negative) => {
    let bulkImportLocationModal = $uibModal.open({
      keyboard: false,
      template: bulkImportLocationTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', 'ContractService', function ($scope, ContractService) {

        $scope.model = {
          contractName: data.name,
          locations: null,
          loading: false
        };

        const init = () => { };

        $scope.cancel = () => {
          bulkImportLocationModal.close();
        }

        $scope.ok = () => {
          const locations = $scope.model.locations ? JSON.parse($scope.model.locations).replace(/\s/g, "").split(',') : null
          if (!locations) return;

          $scope.model.loading = true;
          ContractService.assertLocationIds(locations, data.contractId, data.useCustomerOnBillingRules, data.showAll === false ?data.locationDistanceId:null)
            .then((data) => {
              if (data.results.inValidLocationIds.length === 0) {
                callback({
                  modal: bulkImportLocationModal,
                  locationList: data.results.validLocationIds
                });
                bulkImportLocationModal.close();
              }

              if (data.results.inValidLocationIds.length === 1) {
                $scope.model.errorMessage = `The provided locationId (${data.results.inValidLocationIds.toString()}) is invalid.`
              }
              else {
                $scope.model.errorMessage = `The provided locationIds (${data.results.inValidLocationIds.toString().replace(/,/g, ', ')}) are "invalid" or "suspended".`
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }
        init()
      }]
    })
  }

  let itemHistory = (data, callback, negative) => {
    let itemHistoryModal = $uibModal.open({
      template: itemHistoryTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', 'ItemService', '$state', 'CommonLayoutService', ($scope, ItemService, $state, CommonLayoutService) => {

        $scope.model = {
          loading: false,
          itemId: data.itemId,
          itemLabel: data.label,
          sortColumn: "createdAt",
          reverseSort: true,
          result: []
        };

        $scope.pagination = {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        };

        const init = () => {
          $scope.loadData();
        };

        $scope.loadData = () => {
          $scope.model.loading = true;
          ItemService.getItemHistory($scope.model.itemId, $scope.pagination.pageLimit, ($scope.pagination.page - 1) * $scope.pagination.pageLimit, $scope.model.reverseSort, $scope.model.sortColumn)
            .then((data) => {
              $scope.model.result = data;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        };

        $scope.pageChange = () => {
          $scope.loadData();
        };

        $scope.translateItemHistoryMsg = (entryType) => {
          return CommonLayoutService.translateItemHistoryMessage(entryType);
        };

        $scope.sortData = (column) => {
          $scope.model.reverseSort = ($scope.model.sortColumn == column) ? !$scope.model.reverseSort : false;
          $scope.model.sortColumn = column;
          $scope.pageChange();
        }

        $scope.exportItemHistoryData = () => {
          if ($scope.exportLoading) return;
          $scope.exportLoading = true;

          ItemService.exportItemHistory($scope.model.itemId, $scope.model.reverseSort, $scope.model.sortColumn)
            .then((data) => {
              $scope.exportLoading = false;
              if (data.reportData && data.reportData.length) {
                $scope.downloadFile(`Item_History_(${$scope.model.itemLabel})`, data.reportData)
              }
            })
            .catch((err) => {
              $scope.exportLoading = false;
              console.log(err);
            })
        };

        $scope.downloadFile = (filename, reportData) => {
          const fileName = filename.concat('.csv');
          const a = document.createElement("a");
          document.body.appendChild(a);
          const file = new Blob([reportData], { type: 'application/csv' });
          const fileURL = window.URL.createObjectURL(file);
          a.href = fileURL;
          a.download = fileName;
          a.click();
        };

        $scope.generateItemHistoryPrint = () => {
          ItemService.getItemHistory($scope.model.itemId, null, null, $scope.model.reverseSort, $scope.model.sortColumn)
            .then((data) => {
              const path = $state.href('printItemHistory');
              window.w = window.open(path, '_blank');
              window.w.printData = {
                results: data.results, itemId: $scope.model.itemId, label: $scope.model.itemLabel
              };
            })
            .catch((err) => {
              console.log(err);
            })
        };

        $scope.cancel = () => {
          itemHistoryModal.close();
        };

        init();
      }]
    })
  }

  let nextScheduledOccurences = (data) => {
    let nextScheduleOccurenceModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: nextScheduledOccurencesTemplate,
      size: 'md',

      controller: ['$scope', ($scope) => {

        $scope.model = {
          nextOccurrence: data.nextOccurrence,
          data: data
        }

        const init = () => { };

        $scope.cancel = () => {
          nextScheduleOccurenceModal.close();
        }

        init();
      }]
    })
  }

  let bagRemoveConfirmation = (data, callback, negative) => {
    let bagRemoveConfirmationModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: bagRemoveConfirmationTemplate,
      size: 'md',

      controller: ['$scope', ($scope) => {

        $scope.model = { data };

        const init = () => { };

        $scope.cancel = () => {
          bagRemoveConfirmationModal.close();
        }
        
        $scope.supervisorConfirmed = (supervisorId) => {
          $scope.isSupervisorConfirmed = true;
          $scope.errorMessage = '';
          $scope.supervisor = supervisorId;
          callback({ modal: bagRemoveConfirmationModal, $scope })
        }

        $scope.supervisorCancelled = (err) => {
          $scope.isSupervisorConfirmed = false;
          $scope.errorMessage = err.toString();
          bagRemoveConfirmationModal.close()
        }

        init();
      }]
    })
  }

  let postBillingRecord = (callback, negative) => {
    let postBillingRecordModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: postBillingRecordTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'ContractService', ($scope, $translate, ContractService) => {

        $scope.model = {
          loading: false,
          month: [
            { label: 'Jan', value: 'January' },
            { label: 'Feb', value: 'February' },
            { label: 'Mar', value: 'March' },
            { label: 'Apr', value: 'April' },
            { label: 'May', value: 'May' },
            { label: 'Jun', value: 'June' },
            { label: 'Jul', value: 'July' },
            { label: 'Aug', value: 'August' },
            { label: 'Sep', value: 'September' },
            { label: 'Oct', value: 'October' },
            { label: 'Nov', value: 'November' },
            { label: 'Dec', value: 'December' }
          ],
          contractList: [],
          totalRecords: 0,
          selectedMonth: null,
          selectedContract: null
        };

        const init = () => {
          $scope.model.loading = true;
          $scope.loadContract('', 0);
        };

        $scope.loadContract = (searchKey, offset) => {
          searchKey = searchKey || '';
          const filterObj = {
            queryJSON: {
              rules: [
                {
                  field: 'status',
                  condition: '=',
                  data: true
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'contractName',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
              ],
              operator: 'AND'
            }
          }

          ContractService.all(filterObj, offset, AppConstant.defaultPageLimit)
            .then((data) => {
              if (offset === 0 || offset == undefined) {
                $scope.model.contractList = $scope.mappingContractDatas(data.results);
                $scope.model.totalRecords = data.total;
              } else {
                const contractList = $scope.mappingContractDatas(data.results);
                $scope.model.contractList = $scope.model.contractList.concat(contractList);
                $scope.model.totalRecords = data.total;
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.mappingContractDatas = (contracts) => {
          return contracts.map((contract) => {
            return {
              Key: contract.id + ' | ' + contract.contractName,
              Value: contract.id
            };
          })
        }

        $scope.toggleMonth = (month) => {
          $scope.model.selectedMonth = month.value;
        }

        $scope.cancel = () => {
          postBillingRecordModal.close();
        }

        $scope.ok = () => {
          $scope.isLoading = true;
          callback({
            modal: postBillingRecordModal,
            month: $scope.model.selectedMonth,
            contractId: $scope.model.selectedContract ? $scope.model.selectedContract.Value : null,
            $scope
          })
        }

        init();
      }]
    })
  }

  let createBillingRecords = (callback, negative) => {
    let createBillingRecordsModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: createBillingRecordsTemplate,
      size: 'md',

      controller: ['$scope', 'CommonLayoutService', 'User', '$q', 'LocationService', 'CustomerService', 'BillingCategoryService', 'BillableEventsService', 'BillingRecordsService', '$translate',
        ($scope, CommonLayoutService, User, $q, LocationService, CustomerService, BillingCategoryService, BillableEventsService, BillingRecordsService, $translate) => {

          $scope.model = {
            billingStatus: null,
            vaultDate: null,
            billingStatusList: [{
              Key: 'Pending',
              Value: 'PENDING'
            },
            {
              Key: 'Pre Bill',
              Value: 'PRE_BILL'
            },
            {
              Key: 'Post Bill',
              Value: 'POST_BILL'
            }],
            rate: null,
            amountDue: null,
            billingCategory: null,
            billingType: null,
            locationObj: {
              results: [],
              totalRecords: 0,
              selectedLocation: null,
              loading: false
            },
            customerObj: {
              results: [],
              totalRecords: 0,
              selectedCustomer: null,
              loading: false
            },
            billingCategoryObj: {
              loading: false
            },
            billableEventObj: {
              results: [],
              loading: false
            },
            contractObj: {
              results: [],
              totalRecords: 0,
              selectedContract: null,
              loading: false
            },
            contractRuleObj: {
              results: [],
              totalRecords: 0,
              selectedContractRule: null,
              loading: false
            },
            billingTypeList: CommonLayoutService.billingTypeOptions(),
            staticBillingOptions: ['Pre Bill', 'Post Bill'],
            loggedInUserId: User.getUser().id,
            scheduleTypeOptions: [
              {
                label: 'Any',
                value: 'any'
              },
              {
                label: 'Scheduled',
                value: 'scheduled'
              },
              {
                label: 'Unscheduled',
                value: 'unscheduled'
              },
            ],
            currentMonthDateOptions: {
              maxDate: moment().endOf('month')
            }
          };

          const init = () => {
            $scope.model.loading = true;
            $q.all([
              $scope.getLocationList(),
              $scope.getBillingCategory(),
              $scope.loadAllEvents()
            ])
              .then(() => {
                // $scope.billingTypeOptionChoice(data);
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.loading = false;
              })
          }

          $scope.billingTypeOptionChoice = (data) => {
            const selectedBillingEvent = data.selectedBillingCategory ? data.selectedBillingCategory.label : null;
            if (!selectedBillingEvent) return;

            if ($scope.model.staticBillingOptions.includes(selectedBillingEvent)) {
              let fixedOption = $scope.model.billingTypeList.find(bt => bt.label === 'Fixed');
              $scope.billingTypeList = [fixedOption];
            } else {
              $scope.billingTypeList = $scope.model.billingTypeList;
            }
          }

          $scope.setBillingType = (data) => {
            if ($scope.model.staticBillingOptions.includes(data.selectedBillingCategory.label)) {
              $scope.model.billingType = "fixed";
            } else {
              $scope.model.billingType = null;
            }
          }

          $scope.getLocationList = (searchKey, offset) => {
            searchKey = searchKey || '';

            const locationSearchObj = {
              queryJSON: {
                rules: [
                  {
                    field: 'active',
                    condition: '=',
                    data: true
                  },
                  {
                    field: 'locationType',
                    condition: 'IN',
                    data: ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'INTERNAL', 'CARRIER', 'ON_CALL', 'DELIVERY']
                  },
                  {
                    group: {
                      rules: [{
                        field: 'id',
                        condition: 'like',
                        data: '%' + searchKey + '%'
                      },
                      {
                        field: 'name',
                        condition: 'like',
                        data: '%' + searchKey + '%'
                      }
                      ],
                      operator: 'OR'
                    }
                  }
                ],
                operator: 'AND'
              }
            };

            $scope.model.locationObj.loading = true;
            return LocationService.all(locationSearchObj, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.locationObj.totalRecords = data.total;
                  $scope.model.locationObj.results = $scope.locationMapping(data.results);
                } else {
                  const location = $scope.locationMapping(data.results);
                  $scope.model.locationObj.results = $scope.model.locationObj.results.concat(location);
                }
              })
              .catch((err) => {
                if (err && err.data && err.data.message) {
                  errorModal(err.data.message);
                }
              })
              .finally(() => {
                $scope.model.locationObj.loading = false;
              })
          }

          $scope.getBillingCategory = (searchKey, offset) => {
            searchKey = searchKey || '';

            $scope.model.billingCategoryObj.loading = true;
            BillingCategoryService.all(searchKey, offset, 100)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.billingCategoryObj.totalRecords = data.total;
                  $scope.model.billingCategoryObj.results = $scope.billingCategoryMap(data.results);
                }
                else {
                  const results = $scope.billingCategoryMap(data.results);
                  $scope.model.billingCategoryObj.results = $scope.model.billingCategoryObj.results.concat(results);
                }
              })
              .catch((err) => {
                errorModal(err.data.message);
              })
              .finally(() => {
                $scope.model.billingCategoryObj.loading = false;
              })
          }

          $scope.locationMapping = (location) => {
            return location.map((loc) => {
              return {
                Key: loc.id + ' | ' + loc.name,
                Value: loc.id,
                Obj: loc,
              }
            });
          }

          $scope.billingCategoryMap = (events) => {
            return events.map((data) => {
              return {
                Key: data.name,
                Value: data.id
              }
            });
          }

          $scope.autoPopulateLocationDetails = () => {
            if ($scope.model.locationObj.selectedLocation) {
              const customerObj = $scope.model.locationObj.selectedLocation.Obj.customerObj;
              if (customerObj && customerObj.id) {
                $scope.model.customerObj.selectedCustomer = {
                  Key: customerObj.id + ' | ' + customerObj.name,
                  Value: customerObj.id
                }
              }
              else {
                $scope.model.customerObj.selectedCustomer = null;
              }
            }
            else {
              $scope.model.customerObj.selectedCustomer = null;
            }
          }

          $scope.loadAllEvents = () => {
            $scope.model.preBillingEventOptions = [];
            $scope.model.postBillingEventOptions = [];
            $scope.model.billingCategoryOptions = [];
            $scope.model.billableEventObj.loading = true;

            BillableEventsService.all(null, 0, 30)
              .then((events) => {
                const billableEvents = events.results.reduce((acc, result) => {
                  const categoryName = result.billingCategory.name;
                  acc[categoryName] = acc[categoryName] || {
                    billingEvents: [],
                    billingCategoryId: result.billingCategoryId,
                  };
                  acc[categoryName].billingEvents.push({
                    id: result.id,
                    label: $translate.instant(`entry_type.${result.type}`),
                    value: result.type
                  });
                  return acc;
                }, {});

                $scope.model.billingCategoryOptions = Object.keys(billableEvents).map(key => {
                  return {
                    label: key,
                    billingCategoryId: billableEvents[key].billingCategoryId,
                    billingEvents: billableEvents[key].billingEvents
                  }
                })

              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => {
                $scope.model.billableEventObj.loading = false;
              })
          }

          $scope.getBillingEventsByCategory = (obj, index) => {
            $scope.model.billableEventObj.results = obj.billingEvents;
          }

          $scope.findCustomerContractByLocation = () => {
            if (!$scope.model.locationObj.selectedLocation) {
              $scope.resetData();
              return;
            };

            $scope.model.contractObj.loading = true;
            BillingRecordsService.findCustomerContractByLocation($scope.model.locationObj.selectedLocation.Value)
              .then((data) => {
                $scope.contractData = data.results;
                $scope.model.contractObj.results = $scope.mapContractData(data.results);
                $scope.model.contractObj.totalRecords = $scope.model.contractObj.results.length;
              })
              .catch((err) => {
                $scope.Modal.errorModal(err.data.message);
              })
              .finally(() => {
                $scope.model.contractObj.loading = false;
              })
          }

          $scope.resetData = () => {
            $scope.model.contractObj = {
              results: [],
              totalRecords: 0,
              selectedContract: null,
              loading: false
            };
            $scope.model.contractRuleObj = {
              results: [],
              totalRecords: 0,
              selectedContractRule: null,
              loading: false
            };
            $scope.model.customerObj = {
              results: [],
              totalRecords: 0,
              selectedCustomer: null,
              loading: false
            };
            $scope.applyContractRuleRate();
          }

          $scope.mapContractData = (data) => {
            return data.map((contract) => {
              return {
                Key: contract.contractId.concat(' | ', contract.contractDescription ? contract.contractDescription : 'N/A'),
                Value: contract.contractId
              };
            })
          }

          $scope.findContractRuleAndCustomerByContractId = () => {
            $scope.model.contractRuleObj.selectedContractRule = null;
            $scope.applyContractRuleRate();
            $scope.model.customerObj.selectedCustomer = null;
            const selectedContract = $scope.model.contractObj.selectedContract ? $scope.model.contractObj.selectedContract.Value : null;
            $scope.model.contractRuleObj.results = $scope.mapContractRuleData($scope.contractData, selectedContract);
            $scope.model.customerObj.results = $scope.customerMapping($scope.contractData, selectedContract);
            $scope.model.customerObj.totalRecords = $scope.model.customerObj.results.length;
            $scope.model.contractRuleObj.totalRecords = $scope.model.contractRuleObj.results.length;
          }

          $scope.mapContractRuleData = (data, selectedContract) => {
            if (!selectedContract) return [];

            const contractRule = data.find((d) => d.contractId === selectedContract).contractRules;
            return contractRule.map((d) => {
              return {
                Key: d.id + ' | ' + d.contractRuleName,
                Value: d.id,
                dollarRate: d.dollarRate
              };
            })
          }

          $scope.applyContractRuleRate = () => {
            const selectedRule = $scope.model.contractRuleObj.selectedContractRule;
            const ruleRate = selectedRule && selectedRule.dollarRate !== null && selectedRule.dollarRate !== undefined && selectedRule.dollarRate !== ''
              ? parseFloat(selectedRule.dollarRate)
              : null;

            if (ruleRate !== null && !isNaN(ruleRate)) {
              $scope.model.rate = ruleRate;
              $scope.model.amountDue = ruleRate;
              $scope.model.rateFromRule = true;
            }
            else if ($scope.model.rateFromRule) {
              $scope.model.rate = null;
              $scope.model.rateFromRule = false;
            }
          }

          $scope.customerMapping = (data, selectedContract) => {
            if (!selectedContract) return [];

            const contractRule = data.find((d) => d.contractId === selectedContract).customerList;

            return contractRule.map((obj) => {
              return {
                Key: obj.id + ' | ' + obj.name,
                Value: obj.id
              }
            });
          }

          $scope.cancel = () => {
            createBillingRecordsModal.close();
          }

          $scope.ok = () => {
            $scope.isLoading = true;
            callback({
              modal: createBillingRecordsModal,
              // billingStatus: $scope.model.billingStatus,
              billingStatus: 'PENDING',
              vaultDate: moment($scope.model.vaultDate).format('YYYY-MM-DD'),
              rate: $scope.model.rate,
              amountDue: $scope.model.amountDue,
              billableEventId: $scope.model.selectedbillableEvent,
              billingCategory: $scope.model.selectedBillingCategory ? $scope.model.selectedBillingCategory.label : null,
              billingType: $scope.model.billingType.toUpperCase(),
              scheduleType: $scope.model.scheduleType,
              locationId: $scope.model.locationObj.selectedLocation.Value,
              branchId: $scope.model.locationObj.selectedLocation.Obj.branchId,
              customerContractId: $scope.model.contractObj.selectedContract.Value,
              contract: $scope.model.contractObj.selectedContract.Key,
              customerId: $scope.model.customerObj.selectedCustomer.Value,
              contractRuleId: $scope.model.contractRuleObj.selectedContractRule.Value,
              contractRule: $scope.model.contractRuleObj.selectedContractRule.Key,
              $scope
            })
          }

          init();
        }]
    })
  }

  let locationLogs = (locationId, callback, negative) => {
    let locationLogsModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: locationLogsTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'LocationService', ($scope, $translate, LocationService) => {
        $scope.model = {
          lid: locationId,
          locationLogs: [],
          dateRange: {
            startDate: '',
            endDate: ''
          },
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10,
          searchText: '',
          logsOf: '',
          entryTypes: []
        };
        const init = () => {
          $scope.setDateRange(moment().format('YYYY-MM-DD'));
          $scope.model.dateRange.startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
          $scope.model.dateRange.endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
          $scope.loadData($scope.model.dateRange);
        };

        $scope.generateSearchObj = () => {
          return {
            logsOf: $scope.model.logsOf,
            entryType: $scope.model.entryType,
            queryText: $scope.model.searchText,
            isQuery: false,
            startDate: moment($scope.model.dateRange.startDate).startOf('day').format('YYYY-MM-DD 00:00:00'),
            endDate: moment($scope.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          }
        }

        $scope.setDateRange = (date) => {
          let currentVaultDate = date || moment();
          $scope.model.dateRangPickerOptions = {
            autoApply: true,
            eventHandlers: {
              'apply.daterangepicker': () => {
                $scope.model.page = 1;
                $scope.loadData($scope.model.dateRange);
              }
            },
            ranges: {
              'Today': [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
              ],
              'Current Week': [
                moment().startOf('week').format('YYYY-MM-DD'),
                moment().endOf('week').format('YYYY-MM-DD')
              ],
              'Current Month': [
                moment().startOf('month').format('YYYY-MM-DD'),
                moment().endOf('month').format('YYYY-MM-DD')
              ]
            }
          }
        }

        $scope.pageChange = () => {
          $scope.model.locationLogsLoading = true;
          $scope.loadData();
        }

        $scope.search = () => {
          $scope.model.page = 1;
          $scope.model.locationLogsLoading = true;
          $scope.loadData();
        }

        $scope.refresh = () => {
          $scope.model.locationLogsLoading = true;
          $scope.loadData();
        }

        $scope.loadData = () => {
          $scope.model.locationLogsLoading = true;

          const searchObj = $scope.generateSearchObj();

          LocationService.getLocationLogs($scope.model.lid, searchObj, ($scope.model.page - 1) * $scope.model.pageLimit, $scope.model.pageLimit)
            .then((data) => {
              $scope.model.total = data.total
              $scope.model.locationLogs = data.results.map(log => {
                log.readableEntryType = $translate.instant('entry_type.' + log.entryType);
                if (log.entryData) {
                  log.extraDetails = Object.entries(log.entryData).map(([key, value]) => ({
                    key,
                    value: typeof value === 'object' ? JSON.stringify(value) : value
                  }));
                }
                return log;
              });

              if (data.allEntryTypes.length > 0 && !$scope.model.entryType) {
                $scope.model.entryTypes = data.allEntryTypes.map((entryType) => {
                  return {
                    label: $translate.instant('entry_type.' + entryType),
                    value: entryType
                  };
                });
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.locationLogsLoading = false;
            })
        }

        $scope.cancel = () => {
          locationLogsModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: locationLogsModal,
            $scope
          })
        }
        init();
      }]

    })
    rejectModal(locationLogsModal, negative)
  }

  let branchFundingSourceDenominations = (selectedDenominations, callback, negative, currencyId) => {
    let orderPackReturnModal = $uibModal.open({
      template: branchFundingSourceDenominationsTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$q', 'BranchFundingSourceService', '$http', function ($scope, $q, BranchFundingSourceService, $http) {

        $scope.model = {
          denominationObj: { results: [] },
          fundingSourceDenominations: selectedDenominations
        };
        $scope.selectAll = false;
        $scope.loading = true;

        $scope.isMultiDenomAllowed = (denom) => {
          if (!denom.coinFlag) {
            return true;
          }
          if (denom.coinPackaging && ['INDIVIDUAL','ROLLED'].includes(denom.coinPackaging)) {
            return true;
          }
          return false;
        }

        const init = () => {
          return BranchFundingSourceService.getDenominations()
            .then((res) => {
              // Filter denominations based on currency ID if provided
              let filteredDenominations = res.denominations;
              if (currencyId) {
                filteredDenominations = {};
                Object.keys(res.denominations).forEach(key => {
                  const denominations = res.denominations[key];
                  const filtered = denominations.filter(denom => denom.currencyId === currencyId);
                  if (filtered.length > 0) {
                    filteredDenominations[key] = filtered;
                  }
                });
              }
              
              $scope.model.denominationObj.results = filteredDenominations;
              $scope.model.denominationObj.results = $scope.updateDenominationSelection(filteredDenominations, $scope.model.fundingSourceDenominations);
              
              for (const key in $scope.model.denominationObj.results) {
                if (Array.isArray($scope.model.denominationObj.results[key])) {
                  $scope.model.denominationObj.results[key].forEach(denom => {
                    if (!$scope.isMultiDenomAllowed(denom)) {
                      denom.multiDenomAllowed = false;
                    }
                  });
                }
              }
              
              $scope.updateSelectAllState();
              $scope.loading = false;
            })
            .catch((err) => {
              console.log(err);
              $scope.loading = false;
            })
        }

        $scope.toggleMultiDenom = (obj) => {
          if ($scope.isMultiDenomAllowed(obj)) {
            obj.multiDenomAllowed = !obj.multiDenomAllowed;
          }
        }

        $scope.toggleCustomerOrderable = (obj) => {
          obj.customerOrderable = !obj.customerOrderable;
        }

        $scope.validateMultiDenom = (obj) => {
          setTimeout(() => {
            if (!obj.isDenomSelected) {
              obj.multiDenomAllowed = false;
              obj.customerOrderable = false;
            } else {
              if (!$scope.isMultiDenomAllowed(obj)) {
                obj.multiDenomAllowed = false;
              }
            }
            $scope.$apply();
          });
        }

        $scope.toggleSelectAll = () => {
          for (const key in $scope.model.denominationObj.results) {
            if (Array.isArray($scope.model.denominationObj.results[key])) {
              $scope.model.denominationObj.results[key].forEach(denom => {
                denom.isDenomSelected = $scope.selectAll;
                // Reset multiDenomAllowed when deselecting
                if (!denom.isDenomSelected) {
                  denom.multiDenomAllowed = false;
                  denom.customerOrderable = false;
                } else {
                  if (!$scope.isMultiDenomAllowed(denom)) {
                    denom.multiDenomAllowed = false;
                  }
                }
              });
            }
          }
        }

        $scope.hasDenominations = () => {
          if (!$scope.model.denominationObj || !$scope.model.denominationObj.results) {
            return false;
          }
          
          for (const key in $scope.model.denominationObj.results) {
            if (Array.isArray($scope.model.denominationObj.results[key]) && $scope.model.denominationObj.results[key].length > 0) {
              return true;
            }
          }
          return false;
        }

        $scope.updateSelectAllState = () => {
          let totalDenoms = 0;
          let selectedDenoms = 0;
          
          for (const key in $scope.model.denominationObj.results) {
            if (Array.isArray($scope.model.denominationObj.results[key])) {
              $scope.model.denominationObj.results[key].forEach(denom => {
                totalDenoms++;
                if (denom.isDenomSelected) {
                  selectedDenoms++;
                }
              });
            }
          }
          
          if (totalDenoms === 0) {
            $scope.selectAll = false;
          } else {
            $scope.selectAll = selectedDenoms === totalDenoms;
          }
        }

        $scope.updateDenominationSelection = (target, source) => {
          if (!source || typeof source !== "object" || (Array.isArray(source) && !source.length)) return target;

          for (const key in source) {
            if (Array.isArray(source[key]) && Array.isArray(target[key]) && source[key].length > 0) {
              source[key].forEach(sourceItem => {
                target[key].forEach(targetItem => {
                  if (targetItem.id == sourceItem.id) {
                    targetItem.isDenomSelected = sourceItem.hasOwnProperty("isDenomSelected") ? sourceItem.isDenomSelected : targetItem.isDenomSelected;
                    // Enforce coin packaging rules when updating multiDenomAllowed
                    if (sourceItem.hasOwnProperty("multiDenomAllowed")) {
                      // If coin with BOXED/BAGGED, force to false
                      if (!$scope.isMultiDenomAllowed(targetItem)) {
                        targetItem.multiDenomAllowed = false;
                      } else {
                        targetItem.multiDenomAllowed = sourceItem.multiDenomAllowed;
                      }
                    } else {
                      targetItem.multiDenomAllowed = targetItem.multiDenomAllowed;
                    }
                    if (sourceItem.hasOwnProperty("customerOrderable")) {
                      targetItem.customerOrderable = sourceItem.customerOrderable;
                    } else {
                      targetItem.customerOrderable = targetItem.customerOrderable;
                    }
                    if (sourceItem.hasOwnProperty("expectedResidualPercentage")) {
                      targetItem.expectedResidualPercentage = sourceItem.expectedResidualPercentage;
                    }
                  }
                });
              });
            }
          }
          return target;
        }

        $scope.ok = () => {
          let result = {}, data = $scope.model.denominationObj.results;
          let deletedDenominations = [];
    
          // Get selected denominations
          for (const key in data) {
            if (Array.isArray(data[key])) {
              result[key] = data[key].filter(item => item.isDenomSelected === true);
            }
          }
          
          
          for (const key in $scope.model.fundingSourceDenominations) {
            if (Array.isArray($scope.model.fundingSourceDenominations[key])) {
              $scope.model.fundingSourceDenominations[key].forEach(originalDenom => {
                
                const existsInResult = result[key] && result[key].find(item => item.id === originalDenom.id);
                if (!existsInResult && originalDenom.branchFundingSourceDenominationId) {
                  deletedDenominations.push({
                    id: originalDenom.branchFundingSourceDenominationId,
                    multiDenomAllowed: originalDenom.multiDenomAllowed || false,
                    currencyId: originalDenom.currencyId,
                    coinFlag: originalDenom.coinFlag,
                    denominationId: originalDenom.id,
                  });
                }
              });
            }
          }

          callback({
            modal: orderPackReturnModal,
            denominations: result,
            deletedDenominations: deletedDenominations,
            $scope
          })

          orderPackReturnModal.close();
        }

        $scope.cancel = () => {
          orderPackReturnModal.close();
        }

        init()
      }]
    })
  }

  let deliveryServiceTransaction = (locationId, branchId, formattedDate, trackingId, callback, negative) => {
    let deliveryServiceTransactionModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: deliveryServiceTransactionTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'ShipmentService', '$q', 'Navigation', ($scope, $translate, ShipmentService, DataCounter, Navigation) => {

        $scope.model = {
          locationId: locationId,
          branchId: branchId,
          formattedDate: formattedDate,
          trackingId: trackingId,
          loading: false,
          transactionDetails: [],
          errorMessage: null
        };

        const init = () => {
          $scope.model.loading = true;
          ShipmentService.getDeliveryServiceTransaction($scope.model.locationId, $scope.model.branchId, $scope.model.formattedDate, $scope.model.trackingId)
            .then((data) => {
              $scope.model.transactionDetails = data.data;
            })
            .catch((err) => {
              console.log(err);
              $scope.model.errorMessage = err.data.message;
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        }

        $scope.goToItemHistory = (trackingId) => {
          return Navigation.goToItemHistory(trackingId, deliveryServiceTransactionModal);
        }

        $scope.translateTransactionType = (transactionType) => {
          if (transactionType == 'HOLD') return $translate.instant(`shipment.hold`).toUpperCase();
          else return $translate.instant(`shipment.${transactionType}`).toUpperCase();
        }

        $scope.cancel = () => {
          deliveryServiceTransactionModal.close();
        }

        $scope.ok = () => {
          callback({
            modal: deliveryServiceTransactionModal
          });
          modal.close()
        }
        init()
      }]
    })
    rejectModal(deliveryServiceTransactionModal, negative)
  }
  let verifyBagoutCashCount = (bagId, fundingSource, branchId, callback, negative) => {// negative bagoutContent
    let verifyBagoutCashCountModal = $uibModal.open({
      keyboard: false,
      template: verifyBagoutCashCountTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', '$translate', 'AtmResidualService', 'User', 'Sound', ($scope, $translate, AtmResidualService, User, Sound) => {

        $scope.model = {
          bagId: bagId,
          fundingSource: fundingSource,
          branchId: branchId,
          amount: 0,
          bagoutId: null,
          loading: false,
          trackingId: null,
        };
        const loggedInUser = User.getUser().id;
        $scope.completeBagout = false;

        const init = () => {
          $scope.model.loading = true;
          AtmResidualService.getBagoutContent($scope.model.bagId)
            .then((data) => {
              $scope.model.bagoutContent = data.shipment;

              $scope.model.bagoutContent.forEach((d) => {
                $scope.model.amount += d.amount;
                d.status = 'Pending';
                $scope.model.trackingId = d.trackingId;
                $scope.model.routeId = d.routeId;
              })
            })
            .catch((err) => {
              console.log("err", err);
            })
            .finally(() => {
              $scope.model.loading = false;
            })
        };

        $scope.scanBagoutTrackingId = ($event) => {
          const bagoutId = $scope.model.bagoutId;
          let found = false;
          let isVerified = false;
          $scope.model.bagoutContent.forEach((data) => {
            if (data.trackingId === bagoutId) {
              if (data.status === 'Verified') {
                isVerified = true;
              }
              else {
                data.status = 'Verified';
                Sound.PlayErrorBeep("#scanner_beep");
                $scope.status = data.status;
                found = true;
                $scope.model.lastBagoutScanned = null;
              }
            }
          });
          if (isVerified) {
            $scope.model.lastBagoutScanned = $scope.model.bagoutId;
            $scope.model.isVerifiedMessage = true;
            $scope.model.bagoutId = null;
          }
          else if (!found) {
            Sound.PlayErrorBeep("#scanner_beep");
            $scope.model.lastBagoutScanned = $scope.model.bagoutId;
            $scope.model.isVerifiedMessage = false;
            $scope.model.bagoutId = null;
          }
          else {
            $scope.model.lastBagoutScanned = null;
            $scope.model.isVerifiedMessage = false;
            $scope.model.bagoutId = null;
          }
        };

        $scope.completeBagoutShipments = () => {
          $scope.completeBagout = true;
          const trackingIds = $scope.model.bagoutContent.map(data => data.trackingId);

          confirm({
            header: $translate.instant('completeBagoutShipment.completeBagout'),
            message: $translate.instant(`verifyCompleteBagoutShipment.completeBagoutShipment`),
            callback: ({ modal: confirmModal }) => {

              AtmResidualService.updateShipmentBagseal(trackingIds, $scope.model.bagId, null, $scope.model.fundingSource, loggedInUser, $scope.model.routeId)
                .then((data) => {
                  callback({
                    modal: verifyBagoutCashCountModal
                  });
                })
                .catch((err) => {
                  console.log("err", err);
                })
                .finally(() => {
                  $scope.completeBagout = false;
                });
              confirmModal.close();
              verifyBagoutCashCountModal.close();
            }
          });
        };

        $scope.override = () => {
          $scope.completeBagout = true;
          const trackingIds = $scope.model.bagoutContent.map(data => data.trackingId);

          confirm({
            header: $translate.instant('overrideBagoutShipment.overrideBagout'),
            message: $translate.instant(`verifyOverrideBagoutShipment.overrideBagoutShipment`),
            callback: ({ modal: confirmModal }) => {

              confirmSupervisor('verify-bagout-cash-count', null, ({ modal, supId }) => {
                if (parseInt(supId) === loggedInUser) {
                  errorModal(`LoggedIn User doesn't have permission to override bagout shipment`);
                  modal.close();
                  return;
                }

                AtmResidualService.updateShipmentBagseal(trackingIds, $scope.model.bagId, supId, $scope.model.fundingSource, loggedInUser, $scope.model.routeId)
                  .then((data) => {
                    callback({
                      modal: verifyBagoutCashCountModal
                    });
                  })
                  .catch((err) => {
                    console.log("err", err);
                  })
                  .finally(() => {
                    $scope.completeBagout = false;
                  });

                callback({
                  modal: verifyBagoutCashCountModal,
                  supervisorId: supId,
                  $scope: $scope
                });
                modal.close();
              }, ({ modal }) => {
                modal.close();
              });


              confirmModal.close();
              verifyBagoutCashCountModal.close();
            }
          });
        };

        $scope.bagoutStatusesVerified = () => {
          return $scope.model.bagoutContent.every(data => data.status === 'Verified');
        };

        $scope.cancel = () => {
          verifyBagoutCashCountModal.close();
        };
        init();
      }]
    })
    // rejectModal(verifyBagoutCashCountModal,negative)
  }

  let editScheduledOrders = (data, callback, negative) => {
    let editScheduledOrdersModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: editScheduledOrdersTemplate,
      size: 'lg',
      controller: ['$scope', '$q', 'LocationService', 'CommonLayoutService', '$translate', 'RouteService', 'OrderViewService',
                  ($scope, $q, LocationService, CommonLayoutService, $translate, RouteService, OrderViewService) => {
          $scope.model = {
            data,
            combinedRoutes: [],
            days: [{
              label: $translate.instant('location.mon'),
              value: 'Mon'
            },
            {
              label: $translate.instant('location.tues'),
              value: 'Tue'
            },
            {
              label: $translate.instant('location.wed'),
              value: 'Wed'
            },
            {
              label: $translate.instant('location.thurs'),
              value: 'Thu'
            },
            {
              label: $translate.instant('location.fri'),
              value: 'Fri'
            },
            {
              label: $translate.instant('location.sat'),
              value: 'Sat'
            },
            {
              label: $translate.instant('location.sun'),
              value: 'Sun'
            },
            // {
            //   label: $translate.instant('location.hol'),
            //   value: 'Hol'
            // }
            ],
            combinedRouteIntervals: CommonLayoutService.combinedRouteIntervals(),
            dayMap: CommonLayoutService.dayMap(),
            deletedRecurringStops: [],
            dayArray: []
          }

          const init = () => {
            $scope.loading = true;
            $q.all([
              LocationService.get($scope.model.data.toLocationId),
            ])
              .then((res) => {
                $scope.model.locationDetails = res[0];
                console.log($scope.model.locationDetails)
                $scope.model.locationBranches = $scope.model.locationDetails.locationBranches;
                $scope.model.locationScheduleRecurringData = $scope.model.locationDetails.locationScheduleRecurringData;
                console.log($scope.model.locationScheduleRecurringData);
                $scope.loadRoutes('', 0);
                $scope.createCombinedRoutes($scope.mappingObjKeyVal($scope.model.locationDetails.defRecurringRouteHol));
              })
              .catch((err) => {
                console.log(err);
              })
            .finally(() => {
              $scope.loading = false;
            });
          };

          $scope.cancel = () => {
            editScheduledOrdersModal.close();
          }

          $scope.createCombinedRoutes = (defRecurringRouteHolId) => {
            $scope.model.combinedRoutes = [];
            $scope.model.days.forEach(day => {
              const matchedRoute = _.find($scope.model.locationScheduleRecurringData, { dayOfWeek: day.value });
              let anchorDate = null;
              if (matchedRoute) {
                anchorDate = new Date(matchedRoute.anchorDate);
                anchorDate.setMinutes(anchorDate.getMinutes() + anchorDate.getTimezoneOffset());
              }
              $scope.model.combinedRoutes.push({
                combinedRouteIntervals: [...$scope.model.combinedRouteIntervals],
                id: matchedRoute ? matchedRoute.id : null,
                frequency: matchedRoute ? matchedRoute.frequency : null,
                sequence: matchedRoute ? matchedRoute.sequence : 99,
                day: day,
                route: day.value === 'Hol' ? defRecurringRouteHolId : matchedRoute ? matchedRoute.route : null,
                interval: matchedRoute ? $scope.getCombinedRouteInterval(matchedRoute.interval, matchedRoute.frequency) : null,
                anchorDate: matchedRoute ? anchorDate : null,
                isVisible: day.value === 'Hol' ? false : true,
                locationId: matchedRoute ? matchedRoute.locationId : null,
                nextOccurrence: matchedRoute ? matchedRoute.nextOccurrence : null,
                locationScheduleRecurringLoadData: matchedRoute ? matchedRoute.locationScheduleRecurringLoadData : [],
                hasRouteAssignment: matchedRoute ? true : false
              })
            })
          }

          $scope.getCombinedRouteInterval = (interval, frequency) => {
            return $scope.model.combinedRouteIntervals.find(ci => ci.interval === interval && ci.frequency === frequency);
          }

          $scope.recheckMonthlyOccurences = (anchorDate, day, index) => {
            if (!anchorDate) return;
            const selectedDate = new Date(anchorDate);
            const month = selectedDate.getMonth() + 1;
            const year = selectedDate.getFullYear();
            let occurrences = $scope.countOccurrencesInMonth(year, month, $scope.model.dayMap[day.value]);

            switch (occurrences) {
              case 2:
                $scope.model.combinedRoutes[index].combinedRouteIntervals = [...$scope.model.combinedRouteIntervals].slice(0, -3);
                break;
              case 3:
                $scope.model.combinedRoutes[index].combinedRouteIntervals = [...$scope.model.combinedRouteIntervals].slice(0, -2);
                break;
              case 4:
                $scope.model.combinedRoutes[index].combinedRouteIntervals = [...$scope.model.combinedRouteIntervals].slice(0, -1);
                break;
              default:
                $scope.model.combinedRoutes[index].combinedRouteIntervals = [...$scope.model.combinedRouteIntervals];
                break;
            }
            if ($scope.model.combinedRoutes[index].interval && $scope.model.combinedRoutes[index].interval.interval === "MONTHOC" && $scope.model.combinedRoutes[index].interval.frequency > occurrences) {
              $scope.model.combinedRoutes[index].interval = null;
            }
          }

          $scope.countOccurrencesInMonth = (year, month, targetDay) => {
            let count = 0;
            const startDate = new Date(year, month - 1, 1);
            const endDate = new Date(year, month, 0);

            for (let currentDate = startDate; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
              if (currentDate.getDay() === targetDay) {
                count++;
              }
            }

            return count;
          }

          $scope.mappingObjKeyVal = (obj) => {
            if (obj == null) return obj;
            obj.Key = obj.name + ' (' + obj.branchId + ')';
            obj.Value = obj.id;
            return obj;
          }

          $scope.loadRoutes = (searchKey, offset) => {
            $scope.model.total = [];
            $scope.model.dayArray = [];
            let selectedBranch = $scope.model.locationBranches.map((branch) => branch)
            searchKey = searchKey || '';
            const routeSearchObj = {
              queryJSON: {
                rules: [{
                  field: 'branchId',
                  condition: 'IN',
                  data: selectedBranch
                },
                {
                  field: 'holdRoute',
                  condition: '=',
                  data: false
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
                ],
                operator: 'AND'
              }
            }

            if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
              offset = offset - 1;
            }
            return RouteService.all(routeSearchObj, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                $scope.model.currentlyAssignedRoutes = {};
                $scope.model.days.forEach((day, index) => {
                  // let selectedVal = $scope.model.locationDetails[day.value].routeId ? $scope.model.locationDetails[day.value].routeId.Value : '';
                  if (offset == 0 || offset == undefined) {
                    $scope.model.total.push({
                      [day.value]: {
                        total: data.total
                      }
                    });

                    $scope.model.dayArray.push({
                      [day.value]: $scope.mapRoutes(data.results, searchKey, null)
                    })

                    // if (!searchKey) {
                    //   $scope.model.dayArray[index][day.value].unshift($scope.model.locationDetails[day.value].routeId);
                    // }

                    // if ($scope.model.locationDetails[day.value].routeId) Object.assign($scope.model.currentlyAssignedRoutes, new Object({ [day.value]: $scope.model.locationDetails[day.value].routeId.Value }))
                  }
                });
              });
          }

          // $scope.mapRoutes = (routes, searchKey, selectedVal) => {
          //   return $scope.model.dayArray[index][day.value].find(d => d.id === routeId)
          // }

          $scope.mapRoutes = (mapArray, searchKey, originalVal) => {
            let newArray = [];
            mapArray.map((obj) => {
              obj.Key = obj.name + ' (' + obj.branchId + ')';
              obj.Value = obj.id;
              if (!searchKey && originalVal) {
                if (obj.id !== originalVal) {
                  newArray.push(obj);
                }
              } else {
                newArray.push(obj);
              }
            });
            return newArray;
          }

          $scope.loadDaysRoutes = (searchKey, offset, index, dayOfData) => {
            let selectedBranch = $scope.model.locationBranches.map((branch) => branch)
            searchKey = searchKey || '';
            const routeSearchObj = {
              queryJSON: {
                rules: [{
                  field: 'branchId',
                  condition: 'IN',
                  data: selectedBranch
                },
                {
                  field: 'holdRoute',
                  condition: '=',
                  data: false
                },
                {
                  group: {
                    rules: [{
                      field: 'id',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    },
                    {
                      field: 'name',
                      condition: 'like',
                      data: '%' + searchKey + '%'
                    }
                    ],
                    operator: 'OR'
                  }
                }
                ],
                operator: 'AND'
              }
            }
            
            if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
              offset = offset - 1;
            }

            return RouteService.all(routeSearchObj, offset, AppConstant.defaultPageLimit)
              .then((data) => {
                if (offset === 0 || offset == undefined) {
                  $scope.model.total[index][dayOfData] = {
                    total: data.total
                  };

                  $scope.model.dayArray[index][dayOfData] = $scope.mapRoutes(data.results, searchKey, null);
                } else {

                  const newDayData = $scope.mapRoutes(data.results, searchKey, null);
                  $scope.model.dayArray[index][dayOfData] = $scope.model.dayArray[index][dayOfData].concat(newDayData);
                }
              });
          }

          $scope.validateRouteAssignment = () => {
            const routeMap = new Map();
            $scope.model.combinedRoutes.forEach((route) => {
              if (route.route && route.sequence && route.anchorDate && route.interval) {
                routeMap.set(route.day.value, route);
              }
            });
          }

          $scope.disableDays = (currentDate, mode, enableDay) => {
            if (enableDay.value === "Hol") return false;
            return mode === 'day' && (currentDate.getDay() !== $scope.model.dayMap[enableDay.value]);
          };

          $scope.recheckMonthlyOccurences = (anchorDate, day, index) => {
            if (!anchorDate) return;
            const selectedDate = new Date(anchorDate);
            const month = selectedDate.getMonth() + 1;
            const year = selectedDate.getFullYear();
            let occurrences = $scope.countOccurrencesInMonth(year, month, $scope.model.dayMap[day.value]);

            switch (occurrences) {
              case 2:
                $scope.model.combinedRoutes[index].combinedRouteIntervals = [...$scope.model.combinedRouteIntervals].slice(0, -3);
                break;
              case 3:
                $scope.model.combinedRoutes[index].combinedRouteIntervals = [...$scope.model.combinedRouteIntervals].slice(0, -2);
                break;
              case 4:
                $scope.model.combinedRoutes[index].combinedRouteIntervals = [...$scope.model.combinedRouteIntervals].slice(0, -1);
                break;
              default:
                $scope.model.combinedRoutes[index].combinedRouteIntervals = [...$scope.model.combinedRouteIntervals];
                break;
            }
            if ($scope.model.combinedRoutes[index].interval && $scope.model.combinedRoutes[index].interval.interval === "MONTHOC" && $scope.model.combinedRoutes[index].interval.frequency > occurrences) {
              $scope.model.combinedRoutes[index].interval = null;
            }
          }

          $scope.showNextScheduledOccurences = (data) => {
            $scope.calculateAndUpdateDayOccurrences(data)
          }

          $scope.calculateAndUpdateDayOccurrences = (route) => {
            const params = {
              locationId: route.locationId || this.model.id,
              dayOfWeek: route.day.value,
              anchorDate: moment(route.anchorDate).format('YYYY-MM-DD'),
              interval: route.interval.interval,
              frequency: route.interval.frequency || route.frequency,
              sequence: route.sequence,
              branchId: $scope.model.locationDetails.branchId
            };

            LocationService.calculateDayOccurrences(params.locationId, params.dayOfWeek, params.anchorDate, params.interval, params.frequency, params.sequence, params.branchId)
            .then((data) => {
              nextScheduledOccurences(data);	
            }).catch((error) => {
              console.error('Error recalculating occurrences:', error);	
            })
          }

          $scope.deleteCombinedRoute = (selectedRoute) => {
            $scope.model.combinedRoutes = $scope.model.combinedRoutes.map(route => {
              if (route.id === selectedRoute.id) {
                return {
                  ...route,
                  id: null,
                  anchorDate: null,
                  frequency: null,
                  sequence: 99, // Default sequence value as a placeholder
                  route: null,
                  interval: null,
                  locationId: null,
                  nextOccurrence: null,
                };
              }
              return route;
            });

            $scope.model.deletedRecurringStops.push({
              locationScheduleRecurringId: selectedRoute.id,
              dayOfWeek: selectedRoute.day.label,
              routeId: selectedRoute.route.Value,
              anchorDate: moment.utc(selectedRoute.anchorDate).format('YYYY-MM-DD'),
              interval: selectedRoute.interval.interval
            });

            $scope.validateRouteAssignment();
          }

          $scope.ok = () => {
            const combinedRoutes = [];
            $scope.model.isUpdating = true;
            $scope.model.combinedRoutes.forEach((r) => {
              if (r.route && r.sequence && r.anchorDate && r.interval) {
                combinedRoutes.push({
                  id: r.id ? r.id : null,
                  description: `${r.day.value} ${r.locationId ? r.locationId : $scope.model.data.toLocationId} CombinedRoute`,
                  anchorDate: moment(r.anchorDate).format('YYYY-MM-DD'),
                  interval: r.interval.interval,
                  frequency: r.interval.frequency,
                  effectiveTillDate: null,
                  sequence: r.sequence,
                  dayOfWeek: r.day.value,
                  locationId: r.locationId ? r.locationId : $scope.model.data.toLocationId,
                  routeId: r.route.Value,
                  route: r.route,
                  nextOccurrence: r.nextOccurrence
                })
              }
            });
            callback({
              modal: editScheduledOrdersModal,
              $scope,
              combinedRoutes,
              deletedRecurringStops: $scope.model.deletedRecurringStops
            });
          }

          init();
        }]
    })
  }

  let pendingShipmentTransfer = (routeObj, routeDate, unassignedRouteId, callback, negative) => {
    let pendingShipmentTransferModal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: pendingShipmentTransferTemplate,
      size: 'lg',

      controller: ['$scope', '$translate', 'ShipmentService', '$q', '$location', 'DataCounter', 'Navigation', 'BranchService',
        ($scope, $translate, ShipmentService, $q, $location, DataCounter, Navigation, BranchService) => {

          $scope.model = {
            pendingShipmentTransfer: [],
            loading: false,
            routeId: routeObj.routeId,
            branchId: routeObj.branchId,
            unassignedRouteId
          };

          const init = () => {
            $scope.model.loading = true;
            ShipmentService.pendingShipmentTransferDetails($scope.model.routeId, routeDate, $scope.model.branchId)
              .then((data) => {
                $scope.model.pendingShipmentTransfer = data.results;
                $scope.model.extraDetails = data;
              })
              .catch((err) => {
                console.log(err);
                errorModal(err.data.message);
              })
              .finally(() => {
                $scope.model.loading = false;
              })
          }

          $scope.resendShipmentTransfer = () => {
            const trackingIds = $scope.model.pendingShipmentTransfer.map(d => d.trackingId);
            const shipmentTransferIds = $scope.model.pendingShipmentTransfer.map(d => d.shipmentTransferId);
            const { userId: transferOutUserId, routeId: transferOutRouteId, branchId: transferOutBranchId, vehicleId: transferOutTruckId, transferOutVaultDate = null } = $scope.model.extraDetails.transferOutRouteDetails;
            const { userId: transferInUserId, routeId: transferInRouteId, branchId: transferInBranchId, vehicleId: transferInTruckId, transferInVaultDate = null } = $scope.model.extraDetails.transferInRouteDetails;
            const { comment } = $scope.model.extraDetails;

            $scope.model.isSending = true;
            ShipmentService.resendShipmentTransfer(trackingIds, transferOutUserId, transferInUserId, transferOutRouteId, transferInRouteId, transferOutBranchId,
              transferInBranchId, transferOutTruckId, transferInTruckId, comment, transferInVaultDate, transferOutVaultDate, shipmentTransferIds)
              .then((res) => {
                pendingShipmentTransferModal.close();
                confirm({
                  header: $translate.instant('Success'),
                  message: res.message,
                  callback: (({
                    modal
                  }) => {
                    modal.close();
                  }),
                  negative: (({
                    modal,
                  }) => {
                    modal.close();
                  }),
                  buttons: ['common.ok'],
                  type: 'success'
                })
              })
              .catch((err) => {
                console.log(err);
                errorModal(err.data.message);
              })
              .finally(() => {
                $scope.model.isSending = false;
              })
          }

          $scope.cancel = () => {
            pendingShipmentTransferModal.close();
          }

          // $scope.cancel = () => {
          //   negative({
          //     modal: pendingShipmentTransferModal
          //   });
          // }

          $scope.ok = () => {
            callback({
              modal: pendingShipmentTransferModal,
              message: ''
            });
            modal.close()
          }

          $scope.goToItemHistory = (trackingId) => {
            return Navigation.goToItemHistory(trackingId, pendingShipmentTransferModal);
          }

          $scope.goToServiceHistory = (locationId) => {
            Navigation.goToServiceHistory(locationId, null, true, pendingShipmentTransferModal);
          }

          $scope.cancelShipmentTransfer = () => {
            const shipments = $scope.model.pendingShipmentTransfer.map((data) => {
              return {
                shipmentId: data.shipmentId,
                trackingId: data.trackingId,
                fromLocationId: data.fromLocationId,
                toLocationId: data.toLocationId,
                routeId: data.transferOutRouteId,
                branchId: $scope.model.branchId,
                vaultDate: moment.utc(routeDate).format('YYYY-MM-DD')
              }
            })

            confirmSupervisor('cancel-shipment-transfer', null, ({ modal, supId }) => {
              $scope.isCancelTransferLoading = true;
              BranchService.cancelShipmentTransfer(shipments, 'all', $scope.model.branchId)
                .then(() => {
                  callback({
                    modal: pendingShipmentTransferModal,
                    message: 'TRNASFER_CANCELLED'
                  });
                })
                .catch((err) => {
                  if (err && err.data && err.data.message) {
                    errorModal('error.' + err.data.message);
                  }
                })
                .finally(() => {
                  modal.close();
                  $scope.isCancelTransferLoading = false;
                })
            }, ({ modal }) => {
              if (modal) modal.close()
            })
          }

          init()
        }]
    })
  }

  let updateServiceHistory = (data, callback, negative) => {
    let modal = $uibModal.open({
      template: updateServiceHistoryTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      windowClass: 'update-service-history-modal',
      controller: ['$scope', '$uibModalInstance', 'DateUtil', '$translate', function ($scope, $uibModalInstance, DateUtil, $translate) {
        $scope.deletedItems = [];
        const getBucketName = (status) => {
          switch (status) {
            case 'INCOMPLETED':
              return $translate.instant('serviceTickets.incomplete');
            case status:
              return $translate.instant('serviceTickets.status_' + status);
            default: return;
          }
        };
        const translateEntryType = (type) => {
          return $translate.instant('entry_type.' + type);
        };

        $scope.model = {
          DateUtil: DateUtil,
          isLoading: false,
          serviceHistoryData: data.map(item => {
            let m = moment(item.timestamp);

            // Replicate Label Logic
            let label = [];
            if (item.statusUpdate) {
              label = item.statusUpdate;
            } else if (item.status && !item.entryType) {
              label = [getBucketName(item.status)];
            } else if (item.entryType && !item.status && !item.statusUpdate) {
              label = [translateEntryType(item.entryType)];
            }

            let notes = item.serviceOrderStatusNote || (item.entryData && item.entryData.note) || '';
            const originalTimestampString = m.format('YYYY-MM-DD HH:mm:ss');
            return {
              ...item,
              tempDate: m.toDate(),
              tempTime: m.toDate(),
              originalTimestamp: m.clone(),
              oldTimestamp: originalTimestampString,
              oldNote: notes,
              displayLabel: label,
              tempNotes: notes,
              isDeletedFlag: false
            };
          })
        };

        const getEditedTimestamp = (record) => {
          if (!record) return null;
          const date = moment(record.tempDate).format('YYYY-MM-DD');
          const time = moment(record.tempTime).format('HH:mm:ss');
          return moment(date + ' ' + time);
        };

        $scope.validateAll = () => {
          let previousInternalTimestamp = null;
          let previousWasInvalid = false;

          $scope.model.serviceHistoryData.forEach((item, index) => {
            item.errorMessage = null;
            item.isTimeInvalid = false;
            item.isDateInvalid = false;
            item.timeError = null;

            const statusMoment = getEditedTimestamp(item);
            const now = moment();

            if (statusMoment.isAfter(now)) {
              if (statusMoment.startOf('day').isAfter(now.startOf('day'))) {
                item.isDateInvalid = true;
              } else {
                item.isTimeInvalid = true;
              }
              item.timeError = 'Time cannot be in future';
              previousInternalTimestamp = statusMoment;
              previousWasInvalid = true;
              return;
            }

            if (previousWasInvalid) {
              previousInternalTimestamp = statusMoment;
              return;
            }

            if (index > 0 && previousInternalTimestamp) {
              if (statusMoment.isBefore(previousInternalTimestamp)) {
                const prevDate = previousInternalTimestamp.clone().startOf('day');
                const currDate = statusMoment.clone().startOf('day');

                if (currDate.isBefore(prevDate)) {
                  item.isDateInvalid = true;
                } else {
                  item.isTimeInvalid = true;
                }
                item.timeError = 'Time must be after previous log';
                previousWasInvalid = true;
                return;
              }
            }
            previousInternalTimestamp = statusMoment;
          });
        };

        $scope.showRemoveButton = (historyItem, index) => {
          if (!historyItem.status) return false;
          const firstIndex = _.findIndex($scope.model.serviceHistoryData, (item) => ((item.status === 'ON_ROUTE' || item.status === 'ON_SITE') && item.status === historyItem.status));
          return firstIndex !== -1 && firstIndex < index;
        };

        $scope.hasAnyRemovableItems = () => {
          return _.some($scope.model.serviceHistoryData, (item, index) => $scope.showRemoveButton(item, index));
        };

        $scope.confirmAndRemoveHistoryItem = (historyItem, index) => {
          confirm({
            header: $translate.instant('common.confirm_title'),
            message: 'Are you sure you want to delete this service order status?',
            callback: ({ modal }) => {
              historyItem.isDeletedFlag = true;
              const timestamp = getEditedTimestamp(historyItem);
              const item = {
                id: historyItem.id,
                logId: historyItem.logId,
                status: historyItem.status,
                entryType: historyItem.entryType,
                timestamp: timestamp.format('YYYY-MM-DD HH:mm:ss'),
                notes: historyItem.tempNotes,
                oldTimestamp: historyItem.oldTimestamp,
                oldNote: historyItem.oldNote,
                isExternal: !!historyItem.externalProcessorId,
                serviceOrderId: historyItem.serviceOrderId,
                isFirstAccepted: !!historyItem.isFirstAccepted,
                userId: historyItem.userId,
                isDeletedFlag: true
              };

              callback({
                modal: $uibModalInstance,
                history: [item],
                $scope,
                isSingleAction: true,
                onSuccess: () => {
                  $scope.model.serviceHistoryData.splice(index, 1);
                  $scope.validateAll();
                }
              });
              modal.close();
            },
            negative: ({ modal }) => {
              modal.close();
            },
            type: 'danger'
          });
        };

        $scope.saveHistoryItem = (historyItem) => {
          $scope.saveErrorMessage = null;
          const index = _.findIndex($scope.model.serviceHistoryData, { id: historyItem.id });
          const timestamp = getEditedTimestamp(historyItem);

          const neighbors = [
            { item: $scope.model.serviceHistoryData[index - 1], isBefore: true, error: 'Time must be after previous log' },
            { item: $scope.model.serviceHistoryData[index + 1], isBefore: false, error: $translate.instant('serviceTickets.time_subsequent_error') }
          ];

          for (const { item, isBefore, error } of neighbors) {
            if (item && item.originalTimestamp) {
              const neighborTs = item.originalTimestamp;
              const isInvalid = isBefore ? timestamp.isBefore(neighborTs) : timestamp.isAfter(neighborTs);
              if (isInvalid) {
                historyItem.isDateInvalid = timestamp.clone().startOf('day').isSame(neighborTs.clone().startOf('day')) ? false : true;
                historyItem.isTimeInvalid = !historyItem.isDateInvalid;
                historyItem.timeError = error;
                return;
              }
            }
          }

          const lastCompleteIndex = _.findLastIndex($scope.model.serviceHistoryData, { status: 'COMPLETE' });
          const item = {
            id: historyItem.id,
            logId: historyItem.logId,
            status: historyItem.status,
            entryType: historyItem.entryType,
            timestamp: timestamp.format('YYYY-MM-DD HH:mm:ss'),
            notes: historyItem.tempNotes,
            oldTimestamp: historyItem.oldTimestamp,
            oldNote: historyItem.oldNote,
            isLastCompleted: index === lastCompleteIndex,
            isExternal: !!historyItem.externalProcessorId,
            serviceOrderId: historyItem.serviceOrderId,
            userId: historyItem.userId,
            isFirstAccepted: !!historyItem.isFirstAccepted,
            isDeletedFlag: false
          };
          callback({
            modal: $uibModalInstance,
            history: [item],
            $scope,
            isSingleAction: true,
            onSuccess: (updatedItems) => {
              if (updatedItems && updatedItems.length) {
                const updatedItem = updatedItems[0];
                historyItem.originalTimestamp = moment(updatedItem.timestamp);
                historyItem.oldTimestamp = updatedItem.timestamp;
                historyItem.oldNote = updatedItem.notes;
              }
              $scope.validateAll();
            }
          });
        };

        $scope.validateAll();

        $scope.getFirstError = () => {
          const itemWithError = _.find($scope.model.serviceHistoryData, item => !!item.errorMessage);
          return itemWithError ? itemWithError.errorMessage : null;
        };

        $scope.hasErrors = () => {
          return _.some($scope.model.serviceHistoryData, item => !!item.errorMessage || item.isTimeInvalid || item.timeError);
        };

        $scope.ok = () => {
          let history = [];
          const lastCompleteIndex = _.findLastIndex($scope.model.serviceHistoryData, { status: 'COMPLETE' });
          $scope.model.serviceHistoryData.forEach((item, index) => {
            const timestamp = getEditedTimestamp(item);
            history.push({
              id: item.id,
              logId: item.logId,
              status: item.status,
              entryType: item.entryType,
              timestamp: timestamp.format('YYYY-MM-DD HH:mm:ss'),
              notes: item.tempNotes,
              oldTimestamp: item.oldTimestamp,
              oldNote: item.oldNote,
              isLastCompleted: index === lastCompleteIndex,
              isExternal: !!item.externalProcessorId,
              serviceOrderId: item.serviceOrderId,
              userId: item.userId,
              isFirstAccepted: !!item.isFirstAccepted
            })
          })

          callback({
            modal,
            history,
            $scope
          });
        };
        $scope.cancel = () => {
          negative({ modal: $uibModalInstance });
        };
      }]
    })
  }

  let denominationBreakdownModal = (items, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: denominationBreakdownTemplate,
      size: 'md',
      controller: [
        '$scope',
        function ($scope) {
          $scope.items = items
          $scope.type = 'primary'
          $scope.cancel = () => {
            modal.close()
          }
        },
      ],
    })
    rejectModal(modal, negative)
  }

  let routeServiceTicketsModal = (routeData, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: routeServiceTicketsTemplate,
      size: 'lg',
      controller: ['$scope', '$state', 'ServiceOrderService', 'DataCounter', 'Navigation', 'DateUtil', function ($scope, $state, ServiceOrderService, DataCounter, Navigation, DateUtil) {
        $scope.DateUtil = DateUtil;
        $scope.model = {
          loading: true,
          tickets: [],
          routeData: routeData
        };

        $scope.getBucketName = (status) => {
          switch (status) {
            case 'INCOMPLETED':
              return $translate.instant('serviceTickets.incomplete');
            case status:
              return $translate.instant('serviceTickets.status_' + status);
            default: return;
          }
        }

        $scope.calculateHours = (date) => {
          let startDate = new Date();
          let endDate = new Date(date);
          let diff = moment(startDate).diff(endDate);
          return diff;
        };

        $scope.getTime = (time) => {
          let ms = moment.duration(time).valueOf();
          return ms;
        };

        $scope.getPriorityDurationHours = (requestedTimeframe) => {
          const priorityHours = {
            '24HR': 24,
            '48HR': 48,
            '72HR': 72
          };

          return priorityHours[requestedTimeframe] || null;
        };

        $scope.getPriorityReferenceTime = (serviceTicket) => {
          return serviceTicket.createdAt;
        };

        $scope.formatPriorityRemaining = (ms, overdueLabel = 'Overdue') => {
          const absoluteMs = Math.abs(ms);
          const duration = moment.duration(absoluteMs);
          const totalMinutes = Math.max(Math.floor(duration.asMinutes()), 0);
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;
          const compactDuration = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;

          return ms < 0 ? `${overdueLabel} ${compactDuration}` : `${compactDuration} left`;
        };

        $scope.decoratePriorityDetails = (serviceTicket) => {
          const branchTimezone = serviceTicket.branchTimezone || (routeData && routeData.timezone) || moment.tz.guess();
          const requestedTimeframe = serviceTicket.requestedTimeframe || null;
          const referenceTime = $scope.getPriorityReferenceTime(serviceTicket);
          const comparisonTime = moment().tz(branchTimezone);

          let effectiveRequestedTimeframe = requestedTimeframe;
          let priorityRemaining = null;
          let isOverdue = false;

          if (requestedTimeframe === 'SCHEDULED' && serviceTicket.targetTime) {
            const targetMoment = moment.tz(serviceTicket.targetTime, branchTimezone);
            const remainingMs = targetMoment.diff(comparisonTime);
            isOverdue = remainingMs <= 0;
            priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : $scope.formatPriorityRemaining(remainingMs);
            serviceTicket.targetTimeDisplay = targetMoment.format('MM/DD/YYYY | HH:mm:ss');
          }
          else {
            const priorityHours = $scope.getPriorityDurationHours(requestedTimeframe);

            if (priorityHours && referenceTime) {
              const deadlineMoment = moment.tz(referenceTime, branchTimezone).add(priorityHours, 'hours');
              const remainingMs = deadlineMoment.diff(comparisonTime);
              isOverdue = remainingMs <= 0;

              priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : $scope.formatPriorityRemaining(remainingMs);
              serviceTicket.targetTimeDisplay = deadlineMoment.format('MM/DD/YYYY | HH:mm:ss');
              serviceTicket.targetTime = deadlineMoment.toISOString();
            }
            else if (requestedTimeframe === 'ASAP') {
              if (referenceTime) {
                const asapMoment = moment.tz(referenceTime, branchTimezone);
                const remainingMs = asapMoment.diff(comparisonTime);
                priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : $scope.formatPriorityRemaining(remainingMs);
                serviceTicket.targetTimeDisplay = asapMoment.format('MM/DD/YYYY | HH:mm:ss');
                serviceTicket.targetTime = asapMoment.toISOString();
              } else {
                priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : 'Immediate';
              }
            }
          }

          if (isOverdue && ['24HR', '48HR', '72HR', 'SCHEDULED'].includes(requestedTimeframe)) {
            effectiveRequestedTimeframe = 'ASAP';
          }

          serviceTicket.displayRequestedTimeframe = effectiveRequestedTimeframe;
          serviceTicket.priorityRemaining = priorityRemaining;
          serviceTicket.priorityEscalated = requestedTimeframe !== 'ASAP' && effectiveRequestedTimeframe === 'ASAP';
          serviceTicket.isPriorityAlert = effectiveRequestedTimeframe === 'ASAP' || requestedTimeframe === '24HR';
        };

        $scope.decorateServiceTicket = (serviceTicket) => {
          if (serviceTicket.completed) {
            let timeDiff = moment(serviceTicket.completedAt).diff(serviceTicket.createdAt);
            let duration = moment.duration(timeDiff);
            let timePending = Math.floor(duration.asHours());
            serviceTicket.timeOpen = timePending + ':' + moment.utc(duration.asMilliseconds()).format('mm:ss');
          }

          if (serviceTicket.cancelled) {
            let timeDiff = moment(serviceTicket.cancelledAt).diff(serviceTicket.createdAt);
            let duration = moment.duration(timeDiff);
            let timePending = Math.floor(duration.asHours());
            serviceTicket.timeOpen = timePending + ':' + moment.utc(duration.asMilliseconds()).format('mm:ss');
          }

          $scope.decoratePriorityDetails(serviceTicket);
        };

        $scope.serviceOrderThresolds = {
          routeTickets: {
            totalRedThreshold: 0, totalOrangeThreshold: 0, totalYellowThreshold: 0, redThresholdIds: [],
            orangeThresholdIds: [], yellowThresholdIds: []
          }
        };

        $scope.calculateThresholds = () => {
          $scope.indexMap = {};
          $scope.serviceOrderThresolds.routeTickets = {
            totalRedThreshold: 0, totalOrangeThreshold: 0, totalYellowThreshold: 0, redThresholdIds: [],
            orangeThresholdIds: [], yellowThresholdIds: []
          };

          if ($scope.model.tickets && $scope.model.tickets.length) {
            $scope.model.tickets.forEach((serviceTickets) => {
              if (serviceTickets.thresholds && serviceTickets.thresholds.length) {
                serviceTickets.thresholds.forEach((threshold) => {
                  if (threshold.redThreshold) {
                    if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.redThreshold)) && $scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('06:00:00')) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                        $scope.serviceOrderThresolds.routeTickets.redThresholdIds.push(serviceTickets.encounterId);
                        $scope.serviceOrderThresolds.routeTickets.totalRedThreshold++;
                      }
                    }
                    else if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.redThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('04:00:00') && $scope.calculateHours(serviceTickets.createdAt) < $scope.getTime('06:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                        $scope.serviceOrderThresolds.routeTickets.orangeThresholdIds.push(serviceTickets.encounterId);
                        $scope.serviceOrderThresolds.routeTickets.totalOrangeThreshold++;
                      }
                    }
                    else if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.redThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('02:00:00') && $scope.calculateHours(serviceTickets.createdAt) < $scope.getTime('04:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length
                        $scope.serviceOrderThresolds.routeTickets.yellowThresholdIds.push(serviceTickets.encounterId)
                        $scope.serviceOrderThresolds.routeTickets.totalYellowThreshold++;
                      }
                    }
                  }
                  if (threshold.orangeThreshold) {
                    if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.orangeThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('06:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                        $scope.serviceOrderThresolds.routeTickets.redThresholdIds.push(serviceTickets.encounterId);
                        $scope.serviceOrderThresolds.routeTickets.totalRedThreshold++;
                      }
                    }
                    else if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.orangeThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('04:00:00') && $scope.calculateHours(serviceTickets.createdAt) < $scope.getTime('06:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length
                        $scope.serviceOrderThresolds.routeTickets.orangeThresholdIds.push(serviceTickets.encounterId)
                        $scope.serviceOrderThresolds.routeTickets.totalOrangeThreshold++;
                      }
                    }
                    else if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.orangeThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('02:00:00') && $scope.calculateHours(serviceTickets.createdAt) < $scope.getTime('04:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                        $scope.serviceOrderThresolds.routeTickets.yellowThresholdIds.push(serviceTickets.encounterId);
                        $scope.serviceOrderThresolds.routeTickets.totalYellowThreshold++;
                      }
                    }
                  }
                  if (threshold.yellowThreshold) {
                    if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.yellowThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('06:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length
                        $scope.serviceOrderThresolds.routeTickets.redThresholdIds.push(serviceTickets.encounterId)
                        $scope.serviceOrderThresolds.routeTickets.totalRedThreshold++;
                      }
                    }
                    else if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.yellowThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('04:00:00') && $scope.calculateHours(serviceTickets.createdAt) < $scope.getTime('06:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                        $scope.serviceOrderThresolds.routeTickets.orangeThresholdIds.push(serviceTickets.encounterId);
                        $scope.serviceOrderThresolds.routeTickets.totalOrangeThreshold++;
                      }
                    }
                    else if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.yellowThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('02:00:00') && $scope.calculateHours(serviceTickets.createdAt) < $scope.getTime('04:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length
                        $scope.serviceOrderThresolds.routeTickets.yellowThresholdIds.push(serviceTickets.encounterId)
                        $scope.serviceOrderThresolds.routeTickets.totalYellowThreshold++;
                      }
                    }
                  }
                  if (threshold.otherThreshold) {
                    if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.otherThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('06:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                        $scope.serviceOrderThresolds.routeTickets.redThresholdIds.push(serviceTickets.encounterId);
                        $scope.serviceOrderThresolds.routeTickets.totalRedThreshold++;
                      }
                    }
                    else if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.otherThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('04:00:00') && $scope.calculateHours(serviceTickets.createdAt) < $scope.getTime('06:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                        $scope.serviceOrderThresolds.routeTickets.orangeThresholdIds.push(serviceTickets.encounterId);
                        $scope.serviceOrderThresolds.routeTickets.totalOrangeThreshold++;
                      }
                    }
                    else if (($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime(threshold.otherThreshold)) && ($scope.calculateHours(serviceTickets.createdAt) > $scope.getTime('02:00:00') && $scope.calculateHours(serviceTickets.createdAt) < $scope.getTime('04:00:00'))) {
                      if (!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                        $scope.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                        $scope.serviceOrderThresolds.routeTickets.yellowThresholdIds.push(serviceTickets.encounterId);
                        $scope.serviceOrderThresolds.routeTickets.totalYellowThreshold++;
                      }
                    }
                  }
                });
              }
            });
          }
        };
        $scope.goToServiceHistory = (data) => {
          return Navigation.goToServiceHistory(data.locationId, null, true, modal);
        }
        $scope.getLocationUrl = (data) => {
          return $state.href('branchManagement.locations', {
            locationId: data.locationId
          }, { absolute: true });
        };

        $scope.onLocationClick = (event, data) => {
          if (event.ctrlKey || event.metaKey || event.button === 1) {
            return;
          }
          event.preventDefault();
          $scope.goToServiceHistory(data);
        }
        const init = () => {
          const branchIds = [routeData.branchId || routeData.routeBranchId];
          const timezone = moment.tz.guess();
          const allBuckets = ['UNACCEPTED', 'UNASSIGNED', 'PENDING_ASSIGN', 'CANT_COMPLETE_BUCKET', 'ASSIGNED_PENDING_MESSENGER_ACCEPT', 'ASSIGNED', 'HOLD', 'ON_ROUTE', 'ON_SITE', 'COMPLETE', 'CANCELLED'];
          let displayBuckets = allBuckets;
          if (routeData.vaultDate && moment(routeData.vaultDate).startOf('day').isAfter(moment().startOf('day'))) {
            displayBuckets = ['UNACCEPTED', 'UNASSIGNED', 'PENDING_ASSIGN', 'CANT_COMPLETE_BUCKET', 'ASSIGNED_PENDING_MESSENGER_ACCEPT', 'ASSIGNED', 'HOLD', 'ON_ROUTE', 'ON_SITE'];
          }
          const dateRange = {};
          const startDate = moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
          const endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
          allBuckets.forEach((b) => {
            let _startDate = startDate;
            if (b === 'COMPLETE' || b === 'CANCELLED') {
              _startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
            }
            dateRange[b] = { startDate: _startDate, endDate, columnName: null, sortAsc: null };
          });
          const filter = { pageLimit: 100, pageOffset: 0, searchKey: null, dateRange };
          const userId = routeData.userId || null;
          ServiceOrderService.getServiceOrder(branchIds, null, routeData.routeId, userId, null, '', filter, timezone, null, null)
            .then((data) => {
              const results = data.results || {};
              const tickets = [];
              displayBuckets.forEach((bucket) => {
                if (results[bucket] && results[bucket].items) {
                  results[bucket].items.forEach((item) => {
                    const createdAt = item.createdAt ? new Date(item.createdAt) : null;
                    const now = new Date();
                    let timeOpenMs = createdAt ? (now.getTime() - createdAt.getTime()) : 0;
                    item.timeOpenMs = timeOpenMs;
                    const hours = Math.floor(timeOpenMs / 3600000);
                    const minutes = Math.floor((timeOpenMs % 3600000) / 60000);
                    const seconds = Math.floor((timeOpenMs % 60000) / 1000);

                    item.timeOpenDisplay = hours + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
                    if (item.timeOpen === undefined) {
                      let duration = moment.duration(timeOpenMs);
                      let timePending = Math.floor(duration.asHours());
                      item.timeOpen = timePending + ':' + moment.utc(duration.asMilliseconds()).format('mm:ss');
                    }

                    item.actionCodes = item.actionCodes || (item.actionCodeId ? [{ actionCodeId: item.actionCodeId }] : []);

                    $scope.decorateServiceTicket(item);

                    tickets.push(item);
                  });
                }
              });
              $scope.model.tickets = tickets;
              $scope.calculateThresholds();
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              $scope.model.loading = false;
            });
        }

        $scope.sortColumn = 'encounterId';
        $scope.reverseSort = false;

        $scope.sortBy = (column) => {
          if ($scope.sortColumn === column) {
            $scope.reverseSort = !$scope.reverseSort;
          } else {
            $scope.sortColumn = column;
            $scope.reverseSort = false;
          }
        };

        $scope.getServiceTicketUrl = (encounterId) => {
          return $state.href('serviceTickets', {
            encounterId: encounterId
          }, { absolute: true });
        };

        $scope.onServiceTicketClick = (event, encounterId) => {
          if (event.ctrlKey || event.metaKey || event.button === 1) {
            return;
          }
          event.preventDefault();
          $scope.goToServiceTicket(encounterId);
        }

        $scope.goToServiceTicket = (encounterId) => {
          return Navigation.goToServiceTicket(encounterId, modal);
        }

        $scope.cancel = () => {
          modal.close();
        }

        init();
      }]
    });
    rejectModal(modal, negative);
  }

    let masterCashOrderDetailsModal = (date, orders, totalAmount, denomTotals) => {
      let modal = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-top',
        ariaDescribedBy: 'modal-body-top',
        backdrop: 'static',
        template: masterCashOrderDetailsTemplate,
        windowClass: 'master-cash-orders-modal',
        size: 'lg',
        controller: ['$scope', '$translate', '$state', '$filter', 'Navigation', function ($scope, $translate, $state, $filter, Navigation) {
          $scope.date = date;
          $scope.formattedDate = moment(date).format('MMMM Do, YYYY');
          $scope.count = orders.length;
          $scope.totalAmount = totalAmount;
          $scope.denomTotals = denomTotals;
          $scope.orders = orders;

          $scope.cancel = () => {
            modal.close();
          };

          $scope.goToLocation = (locationId) => {
            modal.close();
            Navigation.goToServiceHistory(locationId, date, true, null);
          };

          $scope.goToShipment = (trackingId) => {
            modal.close();
            $state.go('branchManagement.items', { id: trackingId });
          };

          $scope.goToOrderHistory = (orderNo,fundingSourceId) => {
            modal.close();
            Navigation.goToOrderHistory(orderNo, date, true, false, true, false, null, fundingSourceId);
          };

          $scope.printData = () => {
              const path = $state.href('printMasterCashSchedule');
              window.w = window.open(path, '_blank');
              window.w.printData = { 
                  date: date, 
                  formattedDate: $scope.formattedDate,
                  orders: orders,
                  totalAmount: totalAmount,
                  denomTotals: denomTotals
              };
          };

          $scope.exportData = () => {
            let csvContent = "";
            if (denomTotals && denomTotals.length) {
              csvContent += "#,Denomination,Amount\n";
              denomTotals.forEach((denom, index) => {
                csvContent += `"${index + 1}","${denom.id}","${$filter('currency')(denom.amount || 0, '$', 2)}"\n`;
              });
              csvContent += "\n\n";
            }
            csvContent += "Tracking ID,Location ID,Location Name,Order Type,Order No,Amount,Denominations\n";
            orders.forEach(order => {
              let orderNo = order.orderNo || 'N/A';
              let trackingIds = order.parentTrackingId ? order.parentTrackingId : (order.trackingIds && order.trackingIds.length > 0 ? order.trackingIds.join(" | ") : "N/A");
              let locationId = `${order.toLocationId || ''}`;
              let locationName = `${order.toLocationName || ''}`;
              let orderType = order.orderType ? $translate.instant('atm_residual.order_type_' + order.orderType) : (order.shiptypeId ? $translate.instant(order.shiptypeId) : $translate.instant('common.n_a'));
              let amountStr = $filter('currency')(order.amount || 0, '$', 2);
              let amount = `"${amountStr}"`;
              let denoms = (order.denominations || []).map(d => `${d.id}: ${$filter('currency')(d.amount || 0, '$', 2)}`).join(" | ");
              let row = `"${trackingIds}","${locationId}","${locationName}","${orderType}","${orderNo}",${amount},"${denoms}"`;
              csvContent += row + "\n";
            });
            const file = new Blob([csvContent], { type: 'text/csv' });
            const fileURL = URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = fileURL;
            a.target = '_blank';
            a.download = `Order_Details_${date}.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
          };
        }]
      });
    };

  let bulkUpdateUserPermissionsModal = (positive, negative, currentBranchId) => {
    let modal = $uibModal.open({
      template: bulkUpdateUserPermissionsTemplate,
      size: 'lg',
      backdrop: 'static',
      controller: ['$scope', '$translate', 'UsersService', 'BranchService', '$q', 'UserService', 'Auth', 'User', '$timeout', 'CustomerService', 'UserBranchFundingSourceService', 'BranchFundingSourceService', 'SetupService', function ($scope, $translate, UsersService, BranchService, $q, UserService, Auth, User, $timeout, CustomerService, UserBranchFundingSourceService, BranchFundingSourceService, SetupService) {
        $scope.model = {
          isCustomerUser: true,
          selectPermission: false,
          updatePassword: false,
          updateFundingSource: false,
          cloneFromUserId: null,
          cloneToUsers: [],
          branch: [],
          branchId: currentBranchId || null,
          password: '',
          cnfPassword: '',
          customer: null,
          sameForAll: false,
          applySamePermission: false,
          branchPermission: null,
          currentBranchId: currentBranchId || null
        };

        $scope.aclPermissions = {};
        $scope.fromUsersObj = { results: [], totalRecords: 0, pageLimit: 10 };
        $scope.toUsersObj = { results: [], totalRecords: 0, pageLimit: 10 };
        $scope.branchData = [];
        $scope.customerList = [];
        $scope.cloneFromFundingSources = [];
        $scope.branchFundingSourceGrouped = [];
        $scope.model.selectedFundingSource = [];
        $scope.customerPermissions = [
          'service_tickets', 'branch_mgmt', 'branch_mgmt_locations', 'branch_mgmt_items', 'branch_mgmt_orders', 'master_cash_schedule', 'branch_mgmt_cash_transactions',
          'setting', 'setting-location', 'branch_mgmt_customer_pickup_reports', 'on_demand_call', 'pickup_request_management',
          'branch_mgmt_deposit_reports',
          'tnt_react_app',
          'branch_mgmt_daily_balance_sheet',
          'branch_mgmt_cancelled_shipments',
          'branch_mgmt_billing_approval',
          'branch_mgmt_contact_request',
          'branch_mgmt_stop_scheduling',
          'branch_mgmt_bin_manifest',
          'branch_mgmt_average_daily_balance',
          'bulk_cash_management',
          'cash_activity',
          'shipment_batch',
          'ach_management',
          'branch_mgmt_billing_approval_create_billing_record',
          'branch_mgmt_billing_approval_approve_billing_record',
          'branch_mgmt_billing_approval_edit_billing_record',
          'branch_mgmt_billing_approval_delete_billing_record',
          'tnt_billing',
          'tnt_billing_billable_events',
          'tnt_billing_billing_category',
          'tnt_billing_contract',
          'tnt_billing_customer',
          'tnt_billing_location_distance',
          'tnt_billing_fuel_surcharges',
          'price_point',
          'tnt_billing_contract_type',
        ];
        $scope.permissionLoading = false;
        $scope.permissions = {};
        $scope.localLang = {
          selectAll: $translate.instant('common.selectall'),
          selectNone: $translate.instant('common.selectnone'),
          reset: $translate.instant('shipmentBatch.reset'),
          search: $translate.instant('common.search'),
          nothingSelected: $translate.instant('common.noneselected')
        };

        $scope.autoSelectSameForAll = () => {
          $scope.model.sameForAll = $scope.model.branch && $scope.model.branch.length > 1;
          if ($scope.model.branch && $scope.model.branch.length > 0) {
            if (!$scope.model.branchId || !$scope.model.branch.find(b => b.id === $scope.model.branchId)) {
              $scope.model.branchId = $scope.model.branch[0].id;
            }
            $scope.model.branchPermission = $scope.model.branchId;
          } else {
            $scope.model.branchId = undefined;
            $scope.model.branchPermission = undefined;
          }
          $scope.getBranchPermission();
          if ($scope.model.updateFundingSource) {
            $scope.getFundingSource();
          }
        };

        $scope.assignPermissions = () => {
          if ($scope.model.sameForAll) {
            $scope.model.branchPermission = $scope.model.branchId;
            $scope.getBranchPermission();
          }
        };

        let init = () => {
          $scope.onUserTypeChange();
          $q.all([
            BranchService.all(null, 0, 1000),
            SetupService.all(null, 0, 1000)
          ]).then((data) => {
            const branchesWithExistingSetupRecord = (data[1].results || []).map(s => s.branchId);
            $scope.branchData = (data[0].results || [])
              .filter(b => branchesWithExistingSetupRecord.includes(b.id))
              .map(b => ({ id: b.id, name: b.id + ' | ' + (b.description || b.name), ticked: false }));

            if (currentBranchId) {
              $scope.model.branch = $scope.branchData.filter(b => b.ticked);
              if ($scope.model.branch.length) {
                $scope.model.branchId = $scope.model.branch[0].id;
                $scope.model.branchPermission = $scope.model.branchId;
                $scope.getBranchPermission();
              }
            }
          });
        };

        $scope.isOnlyPasswordUpdate = () => {
          return $scope.model.updatePassword && !$scope.model.selectPermission && !$scope.model.updateFundingSource;
        };

        $scope.checkAndLoadToUsers = () => {
          const hasAction = $scope.model.selectPermission || $scope.model.updatePassword || $scope.model.updateFundingSource;
          if (!$scope.model.cloneFromUserId || !$scope.model.cloneFromUserId.id) {
            if (hasAction) {
              $scope.toUsersObj.results = [];
              $scope.getToUsersList(null, 1);
            } else {
              $scope.model.cloneToUsers = [];
              $scope.toUsersObj.results = [];
              $scope.toUsersObj.totalRecords = 0;

              // Clear branches and related data if no action and no source
              $scope.model.branch = [];
              $scope.model.branchId = null;
              if ($scope.branchData) {
                $scope.branchData.forEach(b => b.ticked = false);
              }
              $scope.model.customer = null;
              $scope.model.selectedFundingSource = [];
              $scope.branchFundingSourceGrouped = [];
              $scope.aclPermissions = {};
            }
          }
        };

        $scope.setUserType = (isCustomerUser) => {
          if ($scope.currentIsCustomerUser !== isCustomerUser) {
            $scope.currentIsCustomerUser = isCustomerUser;
            $scope.model.isCustomerUser = isCustomerUser;
            $scope.onUserTypeChange();
          }
        };

        $scope.onUserTypeChange = () => {
          $scope.currentIsCustomerUser = $scope.model.isCustomerUser;
          const hadCloneFrom = !!($scope.model.cloneFromUserId && $scope.model.cloneFromUserId.id);
          $scope.fromUsersObj.results = [];
          $scope.fromUsersObj.totalRecords = 0;
          $scope.toUsersObj.results = [];
          $scope.toUsersObj.totalRecords = 0;
          $scope.toUsersSearchKey = undefined;
          $scope.model.cloneFromUserId = null;
          $scope.model.cloneToUsers = [];
          $scope.model.branch = [];
          $scope.model.branchId = null;
          $scope.model.customer = null;
          $scope.model.selectedFundingSource = [];
          $scope.branchFundingSourceGrouped = [];
          $scope.cloneFromFundingSources = [];
          $scope.aclPermissions = {};
          if ($scope.branchData) {
            $scope.branchData.forEach(b => b.ticked = false);
          }
          $scope.customerList = [];
          if ($scope.model.updateFundingSource && $scope.model.isCustomerUser) {
            $scope.getCustomer(null, 0);
          }
          const showFromUsers = !$scope.model.selectPermission && !$scope.isOnlyPasswordUpdate();
          if (showFromUsers) {
            $scope.getFromUsersList(null, 0);
          }
          $scope.updateVisiblePermissions();

          if (!hadCloneFrom) {
            const hasAction = $scope.model.selectPermission || $scope.model.updatePassword || $scope.model.updateFundingSource;
            if (hasAction) {
              $scope.getToUsersList(null, 1);
            }
          }
        };

        $scope.updateVisiblePermissions = () => {
          let allPerms = Auth.permission();
          if ($scope.model.isCustomerUser) {
            let filterLevel = (obj) => {
              let res = {};
              angular.forEach(obj, (item, key) => {
                if ($scope.customerPermissions.indexOf(key) >= 0) {
                  let newItem = angular.copy(item);
                  if (newItem.child) {
                    newItem.child = filterLevel(newItem.child);
                    if (Object.keys(newItem.child).length === 0) {
                      delete newItem.child;
                    }
                  }
                  res[key] = newItem;
                }
              });
              return res;
            };
            $scope.permissions = filterLevel(allPerms);
          } else {
            $scope.permissions = allPerms;
          }
        };

        $scope.getFromUsersList = (searchKey, offset) => {
          $scope.fromUsersObj.loading = true;
          const searchText = searchKey || '';
          const recordOffset = offset || 0;

          const trimmedSearch = searchText.trim();
          const searchTerms = trimmedSearch ? (/\s{2,}/.test(trimmedSearch) ? [trimmedSearch] : trimmedSearch.split(/\s+/)) : [''];
          const nameGroupRules = searchTerms.map(term => ({
            group: {
              rules: [
                { field: 'firstName', condition: 'like', data: `%${term}%` },
                { field: 'lastName', condition: 'like', data: `%${term}%` },
                { field: 'id', condition: 'like', data: `%${term}%` },
              ],
              operator: 'OR'
            }
          }));

          const searchObj = {
            queryJSON: {
              rules: [
                { field: 'branchId', condition: '=', data: $scope.model.currentBranchId },
                ...nameGroupRules,
                ...($scope.model.isCustomerUser ? [
                  { field: 'customerUser', condition: '=', data: true }
                ] : [
                  { field: 'email', condition: '!=', data: null },
                  { field: 'customerUser', condition: '=', data: false }
                ])
              ],
              operator: 'AND'
            },
            extraDetails: {
              searchText: searchText,
              status: $scope.model.isCustomerUser ? 'customerUser' : 'web',
              branchId: $scope.model.currentBranchId,
              offset: recordOffset
            }
          };

          UsersService.all(searchObj, recordOffset, $scope.fromUsersObj.pageLimit)
            .then((data) => {
              const users = data.results.map(u => ({ ...u, value: u.id, Value: u.id, Key: u.id + ' | ' + u.firstName + ' ' + u.lastName }));
              if (recordOffset === 0) {
                $scope.fromUsersObj.results = users;
                $scope.fromUsersObj.totalRecords = data.total;
              } else {
                $scope.fromUsersObj.results = _.uniqBy($scope.fromUsersObj.results.concat(users), 'Value');
              }
            }).finally(() => {
              $scope.fromUsersObj.loading = false;
            });
        };

        $scope.toUsersSearchKey = undefined;
        $scope.getToUsersList = (searchKey, offset) => {
          const hasAction = $scope.model.selectPermission || $scope.model.updatePassword || $scope.model.updateFundingSource;
          if (!hasAction && (!$scope.model.cloneFromUserId || !$scope.model.cloneFromUserId.id)) {
            $scope.toUsersObj.results = [];
            $scope.toUsersObj.totalRecords = 0;
            return;
          }

          const searchText = searchKey || '';
          const recordOffset = (offset && offset > 1) ? (offset - 1) * $scope.toUsersObj.pageLimit : 0;

          if (recordOffset === 0 && $scope.toUsersSearchKey === searchText && $scope.toUsersObj.results.length > 0) {
            return;
          }
          $scope.toUsersSearchKey = searchText;
          $scope.toUsersObj.loading = true;

          const trimmedSearch = searchText.trim();
          const searchTerms = trimmedSearch ? (/\s{2,}/.test(trimmedSearch) ? [trimmedSearch] : trimmedSearch.split(/\s+/)) : [''];
          const nameGroupRules = searchTerms.map(term => ({
            group: {
              rules: [
                { field: 'firstName', condition: 'like', data: `%${term}%` },
                { field: 'lastName', condition: 'like', data: `%${term}%` },
                { field: 'id', condition: 'like', data: `%${term}%` },
              ],
              operator: 'OR'
            }
          }));

          const searchObj = {
            queryJSON: {
              rules: [
                { field: 'branchId', condition: '=', data: $scope.model.currentBranchId },
                ...nameGroupRules,
                ...($scope.model.isCustomerUser ? [
                  { field: 'customerUser', condition: '=', data: true }
                ] : [
                  { field: 'email', condition: '!=', data: null },
                  { field: 'customerUser', condition: '=', data: false }
                ])
              ],
              operator: 'AND'
            },
            extraDetails: {
              searchText: searchText,
              status: $scope.model.isCustomerUser ? 'customerUser' : 'web',
              branchId: $scope.model.currentBranchId,
              offset: recordOffset
            }
          };

          if ($scope.model.cloneFromUserId && $scope.model.cloneFromUserId.id) {
            searchObj.queryJSON.rules.push({
              field: 'id',
              condition: '!=',
              data: $scope.model.cloneFromUserId.id
            });
          }

          UsersService.all(searchObj, recordOffset, $scope.toUsersObj.pageLimit)
            .then((data) => {
              const users = data.results.map(u => ({ ...u, value: u.id, Value: u.id, Key: u.id + ' | ' + u.firstName + ' ' + u.lastName }));
              if (recordOffset === 0) {
                $scope.toUsersObj.results = users;
                $scope.toUsersObj.totalRecords = data.total;
              } else {
                $scope.toUsersObj.results = _.uniqBy($scope.toUsersObj.results.concat(users), 'Value');
              }
            }).finally(() => {
              $scope.toUsersObj.loading = false;
            });
        };

        $scope.onCloneFromUserChange = () => {
          if ($scope.model.cloneFromUserId && $scope.model.cloneFromUserId.id) {
            $scope.toUsersObj.results = [];
            $scope.toUsersSearchKey = undefined;
            $scope.getToUsersList(null, 1);
            $scope.permissionLoading = true;
            $scope.getBranchPermission();
            $q.all({
              userData: UsersService.get($scope.model.cloneFromUserId.id),
              branches: UserService.getUserBranchGroup($scope.model.cloneFromUserId.id),
              customers: CustomerService.all(),
              fundingSources: UserBranchFundingSourceService.all(JSON.stringify({
                queryJSON: {
                  rules: [{
                    field: 'userId',
                    condition: '=',
                    data: $scope.model.cloneFromUserId.id
                  }],
                  operator: 'AND'
                }
              }), 0, 1000)
            }).then(({ userData, branches, customers, fundingSources }) => {
              $scope.model.branchId = userData.branchId;
              if (userData.customer) {
                $scope.model.customer = userData.customer ? {
                  Key: userData.customer.id + ' | ' + userData.customer.name,
                  Value: userData.customer.id
                } : null;
              }
              $scope.cloneFromUserBranches = (branches || []).map(b => ({ id: b.branchId }));

              $scope.branchData.forEach(b => {
                b.ticked = !!(branches || []).find(ub => ub.branchId === b.id);
              });
              $scope.model.branch = $scope.branchData.filter(b => b.ticked);

              $scope.customerList = (customers.results || []).map(c => ({
                Key: c.id + ' | ' + c.name,
                Value: c.id
              }));
              $scope.totalCustomer = customers.total;
              $scope.cloneFromFundingSources = fundingSources.results || [];
              $scope.getFundingSource();

              if ($scope.model.branchId) {
                $timeout(() => {
                  $scope.model.branchPermission = $scope.model.branchId;
                  $scope.getBranchPermission();
                });
              } else if ($scope.cloneFromUserBranches.length > 0) {
                $timeout(() => {
                  $scope.model.branchPermission = $scope.cloneFromUserBranches[0].id;
                  $scope.getBranchPermission();
                });
              }
            }).finally(() => {
              $scope.permissionLoading = false;
            });
          } else {
            $scope.model.branch = [];
            $scope.model.branchId = null;
            $scope.model.customer = null;
            $scope.model.selectedFundingSource = [];
            $scope.branchFundingSourceGrouped = [];
            $scope.cloneFromFundingSources = [];
            $scope.branchData.forEach(b => b.ticked = false);
            $scope.aclPermissions = {};
            $scope.toUsersSearchKey = undefined;
            $scope.checkAndLoadToUsers();
          }
        };

        let getBranchPermissionTimeout;
        $scope.getBranchPermission = () => {
          if (getBranchPermissionTimeout) $timeout.cancel(getBranchPermissionTimeout);
          getBranchPermissionTimeout = $timeout(() => {
            if ($scope.model.cloneFromUserId && $scope.model.cloneFromUserId.id) {
              $scope.permissionLoading = true;
              UserService.acl($scope.model.cloneFromUserId.id, $scope.model.branchPermission)
                .then((data) => {
                  $scope.aclPermissions[$scope.model.branchPermission] = data || {};
                }).finally(() => {
                  $scope.permissionLoading = false;
                });
            }
          }, 100);
        };

        $scope.getCustomer = (searchKey, offset) => {
          const searchText = searchKey || '';
          const recordOffset = offset || 0;
          const searchObj = {
            queryJSON: {
              rules: [
                { field: 'id', condition: 'like', data: `%${searchText}%` },
                { field: 'name', condition: 'like', data: `%${searchText}%` }
              ],
              operator: 'OR'
            }
          };

          CustomerService.all(searchObj, recordOffset, 10).then((data) => {
            const customers = (data.results || []).map(c => ({
              Key: c.id + ' | ' + c.name,
              Value: c.id
            }));
            if (recordOffset === 0) {
              $scope.customerList = customers;
              $scope.totalCustomer = data.total;
            } else {
              $scope.customerList = _.uniqBy($scope.customerList.concat(customers), 'Value');
            }
          });
        };

        $scope.getFundingSource = () => {
          let selectedBranch = ($scope.model.branch || []).map(b => b.id);
          const searchObj = {
            queryJSON: {
              rules: [],
              operator: 'AND'
            }
          };
          if (selectedBranch.length > 0) {
            searchObj.queryJSON.rules.push({
              field: 'branchId',
              condition: 'IN',
              data: selectedBranch
            });
          }

          const customerId = ($scope.model.customer && $scope.model.customer.Value) ? $scope.model.customer.Value : null;

          BranchFundingSourceService.all(searchObj, 0, 1000, customerId).then((data) => {
            $scope.branchFundingSourceGrouped = [];
            let grouped = _.groupBy(data.results, 'branchId');
            let keys = Object.keys(grouped);
            let indexMap2 = {};
            const indexMap = {}, addHeader = {};

            keys.forEach(k => {
              delete indexMap2[k];
              grouped[k].forEach(g => {
                if (!addHeader.hasOwnProperty('header')) {
                  addHeader['header'] = true;
                  $scope.branchFundingSourceGrouped.push({
                    label: '<strong>All Branch Funding Source</strong>',
                    msGroup: true
                  });
                }
                if (!indexMap.hasOwnProperty(g.branchId)) {
                  indexMap[g.branchId] = grouped[k].length;
                  $scope.branchFundingSourceGrouped.push({
                    label: `<strong>${k}</strong>`,
                    msGroup: true
                  });
                }
                $scope.branchFundingSourceGrouped.push({
                  id: g.id,
                  name: g.sourceName,
                  branch: g.branchId,
                  fundingSourceId: g.id,
                  label: g.sourceName + ' | ' + '(' + (g.locationId || 'N/A') + ')',
                  ticked: false
                });
              });
              if (!indexMap2.hasOwnProperty(k)) {
                indexMap2[k] = 0;
                $scope.branchFundingSourceGrouped.push({
                  msGroup: false
                });
              }
            });
            $scope.branchFundingSourceGrouped.push({ msGroup: false });

            // Auto select FS from cloneFromUser if any
            if ($scope.cloneFromFundingSources) {
              const cloneFromFsIds = ($scope.cloneFromFundingSources || []).map(fs => fs.branchFundingSourceId);
              $scope.branchFundingSourceGrouped.forEach(fs => {
                if (fs.id) {
                  fs.ticked = cloneFromFsIds.includes(fs.id);
                }
              });
            }
          });
        };

        $scope.onSelectPermissionChange = () => {
          if ($scope.model.selectPermission) {
            $scope.model.cloneFromUserId = null;
          }
          $scope.onCloneFromUserChange();
        };
        $scope.onUpdatePasswordChange = () => {
          $scope.checkAndLoadToUsers();
        };

        $scope.onUpdateFundingSourceChange = () => {
          $scope.checkAndLoadToUsers();
          if ($scope.model.updateFundingSource) {
            if ($scope.customerList.length === 0) {
              $scope.getCustomer(null, 0);
            }
            $scope.getFundingSource();
          }
        };
        $scope.onToUsersChange = () => { };


        $scope.getSetupDetails = () => { };
        $scope.validateAutoChekInChekOut = () => { };
        $scope.getBranchCounters = () => { };

        $scope.isOnlyPasswordUpdate = () => {
          const hasPermissionSource = $scope.model.selectPermission || ($scope.model.cloneFromUserId && $scope.model.cloneFromUserId.id);
          return $scope.model.updatePassword && !$scope.model.updateFundingSource && !hasPermissionSource;
        };

        $scope.hasPerm = (key, parentKey) => {
          const branchPerms = $scope.aclPermissions[$scope.model.branchPermission] || {};
          const permissionObj = branchPerms[parentKey];
          return permissionObj ? permissionObj.includes(key) : false;
        };

        $scope.allowSettings = (key, parentKey) => {
          if ($scope.model.cloneFromUserId && $scope.model.cloneFromUserId.id) return;
          if (!$scope.aclPermissions[$scope.model.branchPermission]) $scope.aclPermissions[$scope.model.branchPermission] = {};
          let branchPerms = $scope.aclPermissions[$scope.model.branchPermission];

          const hasSetting = branchPerms['setting'] && branchPerms['setting'].includes('all');
          const settingChild = $scope.permissions.setting ? $scope.permissions.setting.child : {};
          const resources = Object.keys(settingChild);
          const isSelected = resources.find(d => d === parentKey);

          if (isSelected && !hasSetting) {
            if (!branchPerms['setting']) branchPerms['setting'] = [];
            if (!branchPerms['setting'].includes('all')) branchPerms['setting'].push('all');
          }
        };

        $scope.togglePerm = (key, parentKey) => {
          if ($scope.model.cloneFromUserId && $scope.model.cloneFromUserId.id) return;
          if (!$scope.aclPermissions[$scope.model.branchPermission]) $scope.aclPermissions[$scope.model.branchPermission] = {};
          let branchPerms = $scope.aclPermissions[$scope.model.branchPermission];
          if (!branchPerms[parentKey]) branchPerms[parentKey] = [];

          if (parentKey === 'cash_activity' && !$scope.hasPerm(key, parentKey)) {
            const otherKey = key === 'customer' ? 'funding_source' : 'customer';
            branchPerms[parentKey] = branchPerms[parentKey].filter(k => k !== otherKey);
          }

          let allow = false;
          if (branchPerms[parentKey].includes(key)) {
            branchPerms[parentKey] = branchPerms[parentKey].filter(k => k !== key);
            allow = false;
            // Auto-clear default_redirect if no real perms remain
            const activePerms = branchPerms[parentKey].filter(k => k !== 'default_redirect');
            if (activePerms.length === 0 && branchPerms[parentKey].includes('default_redirect')) {
              branchPerms[parentKey] = branchPerms[parentKey].filter(k => k !== 'default_redirect');
              
              // Shift redirect back to parent category
              const parentCategory = $scope.getParentCategoryKey(parentKey);
              if (parentCategory) {
                if (!branchPerms[parentCategory]) {
                  branchPerms[parentCategory] = [];
                }
                if (!branchPerms[parentCategory].includes('default_redirect')) {
                  branchPerms[parentCategory] = [...branchPerms[parentCategory], 'default_redirect'];
                }
              }
            }
          } else {
            branchPerms[parentKey].push(key);
            allow = true;
          }

          if (allow && parentKey === 'cash_activity') {
            const otherKey = key === 'customer' ? 'funding_source' : 'customer';
            if ($scope.hasPerm(otherKey, parentKey)) {
              $scope.togglePerm(otherKey, parentKey);
            }
          }

          // Cascading permissions logic
          if (parentKey === 'branch_mgmt') {
            const branchMgmtChild = $scope.permissions.branch_mgmt ? $scope.permissions.branch_mgmt.child : {};
            const resources = Object.keys(branchMgmtChild);
            resources.forEach((resource) => {
              if ($scope.model.isCustomerUser && $scope.customerPermissions.indexOf(resource) < 0) return;
              if (!branchPerms[resource]) branchPerms[resource] = [];
              if (allow) {
                if (!branchPerms[resource].includes('all')) branchPerms[resource].push('all');
              } else {
                branchPerms[resource] = branchPerms[resource].filter(k => k !== 'all');
              }
            });
          } else if (['branch_mgmt_deposit_reports', 'branch_mgmt_bin_manifest'].includes(parentKey)) {
            const resourcesToUpdate = ['tnt_react_app'];
            resourcesToUpdate.forEach((resource) => {
              if (!branchPerms[resource]) branchPerms[resource] = [];
              if (allow) {
                if (!branchPerms[resource].includes(key)) branchPerms[resource].push(key);
              } else {
                branchPerms[resource] = branchPerms[resource].filter(k => k !== key);
              }
            });
          } else if (parentKey === 'branch_mgmt_billing_approval') {
            const childPermission = ($scope.permissions.branch_mgmt && $scope.permissions.branch_mgmt.child && $scope.permissions.branch_mgmt.child.branch_mgmt_billing_approval) ? $scope.permissions.branch_mgmt.child.branch_mgmt_billing_approval.child : {};
            const resources = Object.keys(childPermission);
            resources.forEach((resource) => {
              if ($scope.model.isCustomerUser && $scope.customerPermissions.indexOf(resource) < 0) return;
              if (!branchPerms[resource]) branchPerms[resource] = [];
              if (allow) {
                if (!branchPerms[resource].includes('allow')) branchPerms[resource].push('allow');
              } else {
                branchPerms[resource] = branchPerms[resource].filter(k => k !== 'allow');
              }
            });
          } else if (['setting', 'branch_mgmt', 'tnt_billing', 'tnt_control', 'reporting', 'order_packing'].indexOf(parentKey) >= 0) {
            const childPermission = $scope.permissions[parentKey].child || {};
            const resources = Object.keys(childPermission);
            resources.forEach((resource) => {
              if ($scope.model.isCustomerUser && $scope.customerPermissions.indexOf(resource) < 0) return;
              if (!branchPerms[resource]) branchPerms[resource] = [];
              const permissionsToToggle = Object.keys(childPermission[resource].permission || {}).filter(p => p !== 'default_redirect');
              if (allow) {
                permissionsToToggle.forEach(p => {
                  if ($scope.model.isCustomerUser && resource === 'setting-location' && p !== 'view' && p !== 'edit') return;
                  if (!branchPerms[resource].includes(p)) branchPerms[resource].push(p);
                });
              } else {
                branchPerms[resource] = branchPerms[resource].filter(p => !permissionsToToggle.includes(p));
              }
            });
          }

          $scope.cleanupOrphanedDefaultRedirects();
        };

        $scope.cleanupOrphanedDefaultRedirects = () => {
          const branchPerms = $scope.aclPermissions[$scope.model.branchPermission];
          if (!branchPerms) return;
          Object.keys(branchPerms).forEach((resource) => {
            const perms = branchPerms[resource];
            if (Array.isArray(perms) && perms.includes('default_redirect') && !$scope.hasAnyPerm(resource)) {
              branchPerms[resource] = perms.filter(p => p !== 'default_redirect');
              if (branchPerms[resource].length === 0) {
                delete branchPerms[resource];
              }
            }
          });
        };

        $scope.findResourceNode = (resource) => {
          if ($scope.permissions[resource]) return $scope.permissions[resource];
          for (const topVal of Object.values($scope.permissions)) {
            if (topVal.child && topVal.child[resource]) return topVal.child[resource];
            if (topVal.child) {
              for (const childVal of Object.values(topVal.child)) {
                if (childVal.child && childVal.child[resource]) return childVal.child[resource];
              }
            }
          }
          return null;
        };

        $scope.hasAnyPerm = (resource) => {
          const branchPerms = $scope.aclPermissions[$scope.model.branchPermission] || {};
          const permissionObj = branchPerms[resource];
          if (Array.isArray(permissionObj) && permissionObj.some(p => p !== 'default_redirect')) {
            return true;
          }
          const node = $scope.findResourceNode(resource);
          if (node && node.child) {
            return Object.keys(node.child).some(childKey => $scope.hasAnyPerm(childKey));
          }
          return false;
        };

        $scope.hasChildDefaultRedirect = (parentKey) => {
          const parentPerm = $scope.permissions[parentKey];
          if (!parentPerm || !parentPerm.child) return false;
          return Object.keys(parentPerm.child).some(childKey =>
            $scope.hasPerm('default_redirect', childKey)
          );
        };

        $scope.getParentCategoryKey = (resource) => {
          if (resource.startsWith('setting-')) return 'setting';
          if (resource.startsWith('branch_mgmt_')) return 'branch_mgmt';
          if (resource.startsWith('tnt_billing_')) return 'tnt_billing';
          if (resource.startsWith('tnt_control_')) return 'tnt_control';
          if (resource.startsWith('reporting_')) return 'reporting';
          return null;
        };

        $scope.toggleDefaultRedirect = (resource) => {
          if ($scope.model.cloneFromUserId && $scope.model.cloneFromUserId.id) return;
          if (!$scope.aclPermissions[$scope.model.branchPermission])
            $scope.aclPermissions[$scope.model.branchPermission] = {};
          const branchPerms = $scope.aclPermissions[$scope.model.branchPermission];
          const isCurrentlyChecked = $scope.hasPerm('default_redirect', resource) || $scope.hasChildDefaultRedirect(resource);

          // Clear default_redirect on ALL resources (radio-style — only one can be default)
          Object.keys(branchPerms).forEach(res => {
            if (Array.isArray(branchPerms[res])) {
              branchPerms[res] = branchPerms[res].filter(p => p !== 'default_redirect');
            }
          });

          let nextResourceToSet = null;
          if (!isCurrentlyChecked) {
            nextResourceToSet = resource;
          } else {
            // If we uncheck a child/grandchild redirect, shift it back to parent category
            const parentCategory = $scope.getParentCategoryKey(resource);
            if (parentCategory) {
              nextResourceToSet = parentCategory;
            }
          }

           if (nextResourceToSet) {
            if (!branchPerms[nextResourceToSet]) branchPerms[nextResourceToSet] = [];
            if (!branchPerms[nextResourceToSet].includes('default_redirect')) {
              branchPerms[nextResourceToSet] = [...branchPerms[nextResourceToSet], 'default_redirect'];
            }
          }
        };

        $scope.hasActiveAncestors = (resource) => {
          if ($scope.permissions[resource]) {
            return true;
          }

          let parentKey = null;
          for (const [topKey, topVal] of Object.entries($scope.permissions)) {
            if (topVal.child && topVal.child[resource]) {
              parentKey = topKey;
              break;
            }
            if (topVal.child) {
              for (const [childKey, childVal] of Object.entries(topVal.child)) {
                if (childVal.child && childVal.child[resource]) {
                  parentKey = childKey;
                  break;
                }
              }
              if (parentKey) break;
            }
          }

          if (!parentKey) return true;

          if (!$scope.hasAnyPerm(parentKey)) {
            return false;
          }

          return $scope.hasActiveAncestors(parentKey);
        };

        $scope.disabledPermissions = (parent, child) => {
          if (parent === 'branch_mgmt_restore_route_assignments') return true;
          if ($scope.model.isCustomerUser) {
            if (child) {
              if (parent === 'setting-location' && ['create', 'importLocations', 'clone', 'editCustomer'].indexOf(child) >= 0) return true;
              if (parent === 'bulk_cash_management' && child !== 'view' && child !== 'export') return true;
            }
            return ($scope.customerPermissions.indexOf(parent) < 0);
          }
          return false;
        };

        $scope.format = (key) => {
          if (typeof key === 'string') {
            key = key.replace('_', '-');
            key = (key !== 'assign' && key !== 'export') ? key.charAt(0).toUpperCase() + key.slice(1) : key;
            key = $translate.instant('common.' + key);
          }
          return key;
        };

        $scope.expanded = {};
        $scope.toggleExpand = (key) => { $scope.expanded[key] = !$scope.expanded[key]; };
        $scope.expand = (key) => { return $scope.expanded[key] || false; };

        $scope.ok = () => {
          if ($scope.model.updatePassword && $scope.model.password !== $scope.model.cnfPassword) {
            return alert('Passwords do not match');
          }
          let payload = {
            isCustomerUser: $scope.model.isCustomerUser,
            cloneToUsers: $scope.model.cloneToUsers,
            cloneFromUserId: $scope.model.cloneFromUserId ? $scope.model.cloneFromUserId.id : null,
            updatePassword: $scope.model.updatePassword,
            password: $scope.model.password,
            updateBranch: !$scope.isOnlyPasswordUpdate(),
            branch: $scope.model.branch.map(b => ({ id: b.id })),
            branchId: $scope.model.branchId,
            updateFundingSource: $scope.model.updateFundingSource,
            customerId: ($scope.model.customer && $scope.model.updateFundingSource) ? $scope.model.customer.Value : null,
            fundingSources: $scope.model.updateFundingSource ? ($scope.model.selectedFundingSource || []).map(fs => fs.id || fs.fundingSourceId) : [],
            aclPermissions: $scope.aclPermissions,
            sameForAll: $scope.model.sameForAll,
            applySamePermission: $scope.model.applySamePermission
          };
          modal.close(payload);
        };

        $scope.$watch('model.cloneFromUserId', (newVal, oldVal) => {
          if (newVal === oldVal) return;
          $scope.onCloneFromUserChange();
        });

        $scope.cancel = () => { modal.dismiss(); };
        init();
      }]
    });
    return modal.result.then(positive, negative);
  };

  let markAllDeliveredListModal = (routeId, vaultDate, branchId, VaultOperationsService, callback, negative) => {
    let modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: markAllDeliveredListTemplate,
      size: 'md',
      controller: ['$scope', 'Navigation', '$state', 'DataCounter', function ($scope, Navigation, $state, DataCounter) {
        $scope.routeId = routeId;
        $scope.shipments = [];
        $scope.loading = true;

        VaultOperationsService.getNotDeliveredShipments(routeId, vaultDate, branchId)
          .then((res) => {
            $scope.shipments = res.data || [];
            $scope.loading = false;
          })
          .catch((err) => {
            $scope.loading = false;
            $scope.errorMessage = (err && err.data && err.data.message) ? err.data.message : 'Error fetching shipments';
          });

        $scope.goToServiceHistory = (locationId) => {
          Navigation.goToServiceHistory(locationId, null, true, modal);
        }
        $scope.goToItemHistory = (trackingId) => {
          Navigation.goToItemHistory(trackingId, modal);
        }
        $scope.confirm = () => {
          callback({ modal, shipments: $scope.shipments });
        };
        $scope.cancel = () => {
          negative({ modal });
        };
      }]
    });
    modal.result.then(() => {}, () => {
      negative({ modal: null });
    });
    return modal;
  }

  // Shared label maps so the approval preview renders the same names as the grid.
  const SURCHARGE_LABEL_KEYS = {
    INSURANCE: 'customer.surcharge_insurance',
    FUEL: 'customer.surcharge_fuel',
    SECURITY: 'customer.surcharge_security',
    LIABILITY: 'customer.surcharge_liability'
  };
  const SURCHARGE_INTERVAL_LABEL_KEYS = {
    WEEKLY: 'customer.surcharge_interval_weekly',
    BI_WEEKLY: 'customer.surcharge_interval_bi_weekly',
    MONTHLY: 'customer.surcharge_interval_monthly',
    QUARTERLY: 'customer.surcharge_interval_quarterly'
  };

  // onTheseRecords=true is the Approved tab: the fee on exactly the records on screen, so the
  // accrual columns (interval, covers, the quarterly note) do not apply and the table is just
  // Surcharge / Fee / Amount. Every other tab shows the accrual-period view unchanged.
  let surchargeDetails = ({ customer, periodLabel, filterAligned, onTheseRecords = false }) => {
    let modal = $uibModal.open({
      template: surchargeDetailsTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', '$translate', function ($scope, $translate) {
        $scope.customer = customer;
        $scope.periodLabel = periodLabel;
        $scope.onTheseRecords = onTheseRecords === true;
        $scope.filterAligned = filterAligned !== false;
        // Separate from filterAligned: a quarterly surcharge counts back beyond the selected month
        // whatever the date filter says, so this note appears even when the filter is aligned.
        $scope.widerWindowNote = (!$scope.onTheseRecords && customer && customer.widerSurchargeWindowStart)
          ? $translate.instant('surchargeDetailsModal.quarterlyNote', { start: customer.widerSurchargeWindowStart })
          : '';

        $scope.cancel = () => {
          modal.close();
        }
      }]
    });
    return modal;
  }

  let storedSurchargeDetails = ({ customer, labelKeys }) => {
    let modal = $uibModal.open({
      template: storedSurchargeDetailsTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'md',
      controller: ['$scope', function ($scope) {
        $scope.customer = customer;
        $scope.breakdown = ((customer && customer.storedSurchargeBreakdown) || []).map((row) => ({
          type: row.type,
          labelKey: labelKeys[row.type],
          amount: Number(row.amount) || 0,
          minPercentage: Number(row.minPercentage) || 0,
          maxPercentage: Number(row.maxPercentage) || 0
        }));

        $scope.cancel = () => {
          modal.close();
        }
      }]
    });
    return modal;
  }

  let surchargeHistory = ({ customerName, rows, labelKeys, eventLabels }) => {
    const toLabel = (date) => (date ? moment(date, 'YYYY-MM-DD').format('MM-DD-YYYY') : '');
    const sameEvents = (a, b) => a.length === b.length && a.every((id, i) => id === b[i]);

    const groups = Object.keys(labelKeys)
      .map((type) => {
        const typeRows = (rows || []).filter((row) => row.type === type);
        return {
          type,
          labelKey: labelKeys[type],
          rows: typeRows.map((row, index) => {
            const previous = typeRows[index + 1];
            const eventIds = (row.billableEventIds || []).slice().sort((a, b) => a - b);
            const previousEventIds = previous ? (previous.billableEventIds || []).slice().sort((a, b) => a - b) : null;
            const percentage = row.percentage === null || row.percentage === undefined ? null : Number(row.percentage);
            return {
              id: row.id,
              enabled: row.enabled,
              percentage,
              intervalLabelKey: SURCHARGE_INTERVAL_LABEL_KEYS[row.interval] || null,
              eventLabels: eventIds.map((id) => eventLabels[id] || `#${id}`),
              changedBy: row.changedBy,
              isCurrent: !row.effectiveTo,
              fromLabel: toLabel(row.effectiveFrom),
              toLabel: toLabel(row.effectiveTo),
              changed: previous ? {
                enabled: row.enabled !== previous.enabled,
                percentage: percentage !== (previous.percentage === null || previous.percentage === undefined ? null : Number(previous.percentage)),
                interval: row.interval !== previous.interval,
                events: !sameEvents(eventIds, previousEventIds)
              } : {}
            };
          })
        };
      })
      .filter((group) => group.rows.length);

    let modal = $uibModal.open({
      template: surchargeHistoryTemplate,
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      size: 'lg',
      controller: ['$scope', function ($scope) {
        $scope.customerName = customerName;
        $scope.groups = groups;
        $scope.selectedType = null;

        $scope.selectType = (type) => {
          $scope.selectedType = type;
        };

        $scope.cancel = () => {
          modal.close();
        };
      }]
    });
    return modal;
  }

  let uncoveredLocations = () => {
    return $uibModal.open({
      animation: true,
      size: 'lg',
      template: uncoveredLocationsTemplate,
      controller: ['$scope', '$uibModalInstance', 'ContractService', '$state', function ($scope, $uibModalInstance, ContractService, $state) {
        $scope.locations = [];
        $scope.totalRecords = 0;
        $scope.pagination = {
          page: 1,
          pageLimit: LIMIT
        };
        $scope.loading = false;
        $scope.error = '';

        $scope.load = () => {
          $scope.loading = true;
          $scope.error = '';

          const offset = ($scope.pagination.page - 1) * $scope.pagination.pageLimit;
          return ContractService.getUncoveredOnCallLocations(offset, $scope.pagination.pageLimit)
            .then((data) => {
              $scope.locations = data.results;
              $scope.totalRecords = data.totalRecords;
            })
            .catch((err) => {
              $scope.error = err && err.data && err.data.message
                ? err.data.message
                : err.message;
            })
            .finally(() => {
              $scope.loading = false;
            });
        };

        $scope.goToLocation = (locationId) => {
          $scope.close();
          $state.go('location.edit', { id: locationId });
        };

        $scope.close = () => $uibModalInstance.close();
        $scope.load();
      }]
    });
  }

  return {
    confirm,
    alert,

    checkedInShipmentSelectionModal,
    checkedOutShipmentSelectionModal,
    routeThrowShipmentListModal,
    routeThrowShipmentSelectionModal,
    confirmSupervisor,
    markAllDeliveredListModal,
    checkedInForceAddBag,
    checkedInAdHocCheckin,
    checkedoutForceAddBag,
    forceCheckin,
    forceCloseRoute,
    itemNotDelivered,
    closeRoute,

    addLocation,

    selectDeliveryLocation,
    closeBagout,

    commitSuccessModal,
    uploadedFileSelection,

    verifyHoldShipments,
    forceCloseHold,

    errorModal,
    holdReleases,
    returnItems,
    itemHoldLogDetails,
    routeDetails,
    routeMessenger,
    locationHoldRelease,
    bulkVerifyComment,
    translateMessage,
    routeTransfer,
    orderPack,
    orderPackHold,
    orderPackReturn,
    checkoutAddItems,

    residualComments,
    changePassword,
    holdReason,
    convertToCrv,
    deletedReason,
    atmResidualReceipt,
    balanceSheetInfo,
    deliveryRouteInfo,
    coinShiptypeList,
    routeStopTransfer,
    routeSequenceModal,
    remainingResiduals,
    remainingToThrow,
    routeCheckoutInfo,
    routeCheckinInfo,
    remainingToPack,
    branchTransferModal,
    internalDeliveryModal,
    depositPackingInfoModal,
    lockStatusModal,
    ledgerTransactionLogModal,
    // createCompanyModal,
    atmCodesInfoModal,
    moveShipmentModal,
    updateShipmentTrackingId,
    autoOpenLocksModal,
    successModal,
    checkinForceCloseRoute,
    markAsDelivered,
    holdShipmentModal,
    lastOrderDetails,
    serviceOrderDetail,
    serviceOrderNotes,
    undoPackedOrder,
    serviceOrderStatusUpdate,
    serviceOrderAssign,
    createServiceTicket,
    shipmentList,
    routeStopList,
    createActionCode,
    changeDestinationModal,
    serviceOrderActions,
    pendingCancelShipments,
    bagoutListModal,
    bulkCashAdjustComment,
    shipmentImageModal,
    bagoutsOnHoldModal,
    saveLocationLaterModal,
    saveRouteChangesLaterModal,
    billingContractRulesModal,
    approveBillingRecords,
    billableEventLogDetails,
    stopComments,
    createLanguageMessage,
    FuelSurchargeCustomer,
    FuelSurchargeLocations,
    routesInfoModal,
    editDeliveryShipment,
    editPickupShipment,
    shipmentAssociateToTanker,
    uploadFiles,
    markUndeliveredWithCRV,
    viewAppLogo,
    previewTicketPictures,
    // scheduledATMShipment
    atmLoadShipment,
    pickupDeliveryShipments,
    notDeliveredResolution,
    pickupHoldRelease,
    duplicateRouteStopList,
    branchMgmtBagoutClose,
    makeDeliverable,
    logisticItemAssignModal,
    logisticItemList,
    logisticItemHoldReleaseModal,
    serviceTicketResolveImage,
    uploadContractDocuments,
    viewContractDocuments,
    updateBillingRecords,
    sendStopReceipt,
    changeShiptypeId,
    bulkImportLocation,
    itemHistory,
    createServiceChecklist,
    createAtmMake,
    nextScheduledOccurences,
    timeoutCountdown,
    bagRemoveConfirmation,
    postBillingRecord,
    createBillingRecords,
    locationLogs,
    branchFundingSourceDenominations,
    deliveryServiceTransaction,
    verifyBagoutCashCount,
    editScheduledOrders,
    pendingShipmentTransfer,
    updateServiceHistory,
    denominationBreakdownModal,
    shipmentNotPickedUp,
    createServiceActionPriority,
    routeServiceTicketsModal,
    masterCashOrderDetailsModal,
    bulkUpdateUserPermissionsModal,
    rescheduleDeliveries,
    surchargeDetails,
    storedSurchargeDetails,
    surchargeHistory,
    uncoveredLocations
  }
}

ModalFactory.$inject = ['$uibModal', '$translate'];

export default ModalFactory;



// WEBPACK FOOTER //
// ./client/app/common/ui/modal/modal.factory.js